/**
 *
 * WARNING!!! This is an auto-generated file. Any changes to this file will be lost
*/
import { GraphQLClient } from 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};


export type ActiveCompetitionByTypeInput = {
  eventId: Scalars['String'];
  competitionType: CompetitionType;
};

export type Activity = {
  __typename?: 'Activity';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The user that an activity belongs to */
  user: User;
  /** order:creation */
  type: Scalars['String'];
  /** Origin of activities */
  origin: ActivityOrigin;
  /** Detail is relevant to the action that cant be captured just by the refId and refType */
  detail: Scalars['JSON'];
  fingerPrint?: Maybe<Scalars['JSON']>;
  /** Target entity */
  refName?: Maybe<Scalars['String']>;
  /** Target entity id */
  refId?: Maybe<Scalars['String']>;
  /** human readable description of what has gone */
  description?: Maybe<Scalars['String']>;
  /** The admin that make this activity */
  admin?: Maybe<User>;
};

export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  pageInfo: PageInfo;
  edges: Array<ActivityEdge>;
  totalCount: Scalars['Int'];
};

export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  cursor: Scalars['String'];
  node: Activity;
};

/** Origin of activities */
export enum ActivityOrigin {
  User = 'User',
  System = 'System',
  Admin = 'Admin'
}

export type ActivityWhereInput = {
  userId: Scalars['String'];
};

/** Represents additional info to be included with digital event or membership emails. */
export type AdditionalEmailInfoInput = {
  /** Additional info to be included with digital event or membership emails. */
  text?: Maybe<Scalars['String']>;
  /** The text that will be displayed on the action button. Required if buttonUrl is provided. */
  buttonText?: Maybe<Scalars['String']>;
  /** The url that the action button will link to. Required if buttonText is provided. */
  buttonUrl?: Maybe<Scalars['String']>;
};

export type AddonUnion = EventAddon | MembershipAddon;

export type AddPosTransactionInput = {
  /** Selected payment method (allowed: cash, eftpos, cc). */
  method: PaymentProvider;
  amount: Scalars['Float'];
  returned?: Maybe<Scalars['Float']>;
};

export type AddReminderToScoutCommunicationUserInput = {
  remindAt: Scalars['DateTime'];
  message?: Maybe<Scalars['String']>;
};

/** Address details. */
export type Address = {
  __typename?: 'Address';
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  formattedAddress?: Maybe<Scalars['String']>;
};

/** Address details. */
export type AddressInput = {
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  formattedAddress?: Maybe<Scalars['String']>;
};

export type AddUnsubscribeReasonInput = {
  userId: Scalars['String'];
  unsubscribeReason: UnsubscribeReason;
  otherUnsubscribeReason?: Maybe<Scalars['String']>;
};

export type AdobeExperiencePlatformIntegration = {
  __typename?: 'AdobeExperiencePlatformIntegration';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tenant: Scalars['String'];
  sandboxName: Scalars['String'];
  /** Also known as the API key */
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  imsOrgId: Scalars['String'];
  technicalAccountId: Scalars['String'];
  privateKeyBase64: Scalars['String'];
  customerEndpoint?: Maybe<Scalars['String']>;
  customerSchemaRefId?: Maybe<Scalars['String']>;
  customerDatasetId?: Maybe<Scalars['String']>;
  ticketEndpoint?: Maybe<Scalars['String']>;
  ticketSchemaRefId?: Maybe<Scalars['String']>;
  ticketDatasetId?: Maybe<Scalars['String']>;
  scanEndpoint?: Maybe<Scalars['String']>;
  scanSchemaRefId?: Maybe<Scalars['String']>;
  scanDatasetId?: Maybe<Scalars['String']>;
};

export type AdobeExperiencePlatformIntegrationInput = {
  tenant: Scalars['String'];
  sandboxName: Scalars['String'];
  /** Also known as the API key */
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  imsOrgId: Scalars['String'];
  technicalAccountId: Scalars['String'];
  privateKeyBase64: Scalars['String'];
  customerEndpoint?: Maybe<Scalars['String']>;
  customerSchemaRefId?: Maybe<Scalars['String']>;
  customerDatasetId?: Maybe<Scalars['String']>;
  scanEndpoint?: Maybe<Scalars['String']>;
  scanSchemaRefId?: Maybe<Scalars['String']>;
  scanDatasetId?: Maybe<Scalars['String']>;
  ticketEndpoint?: Maybe<Scalars['String']>;
  ticketSchemaRefId?: Maybe<Scalars['String']>;
  ticketDatasetId?: Maybe<Scalars['String']>;
};

export type AgeBreakDownOutput = {
  __typename?: 'AgeBreakDownOutput';
  seg1: Scalars['Float'];
  seg2: Scalars['Float'];
  seg3: Scalars['Float'];
  seg4: Scalars['Float'];
  seg5: Scalars['Float'];
  seg6: Scalars['Float'];
  seg7: Scalars['Float'];
};

export type ApplyPromoCode = {
  promoCode: Scalars['String'];
};

export type AppTicket = {
  __typename?: 'AppTicket';
  id: Scalars['String'];
  ticketNumber: Scalars['String'];
  parentTicketNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  status: TicketStatus;
  gateIds: Array<Scalars['String']>;
  isHold: Scalars['Boolean'];
  ticketTypeName?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  seatZone?: Maybe<Scalars['String']>;
  buyerInformation?: Maybe<AppTicketUserDetails>;
  user?: Maybe<AppTicketUserDetails>;
  scans: Array<AppTicketScan>;
};

export type AppTicketScan = {
  __typename?: 'AppTicketScan';
  id: Scalars['String'];
  scannedAt: Scalars['DateTime'];
  direction: Scalars['String'];
  type: Scalars['String'];
};

export type AppTicketUserDetails = {
  __typename?: 'AppTicketUserDetails';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type AssignScoutCommunicationUsersToAgentInput = {
  scoutCommunicationId: Scalars['String'];
  agentUserId: Scalars['String'];
  scoutCommunicationUserIds: Array<Scalars['String']>;
};

export type AudienceCountInput = {
  transactionalType: BroadcastTransactionalType;
  audience?: Maybe<BroadcastAudience>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  ticketTypeId?: Maybe<Array<Scalars['String']>>;
  zoneId?: Maybe<Array<Scalars['String']>>;
  releaseId?: Maybe<Array<Scalars['String']>>;
  addonId?: Maybe<Array<Scalars['String']>>;
};

/** Id of the broadcast audience. One broadcast only has one id. */
export type AudienceData = {
  __typename?: 'AudienceData';
  ticketTypeId?: Maybe<Array<Scalars['String']>>;
  zoneId?: Maybe<Array<Scalars['String']>>;
  releaseId?: Maybe<Array<Scalars['String']>>;
  addonId?: Maybe<Array<Scalars['String']>>;
};

/** Id of the broadcast audience. One broadcast only has one id. */
export type AudienceDataInput = {
  ticketTypeId?: Maybe<Array<Scalars['String']>>;
  zoneId?: Maybe<Array<Scalars['String']>>;
  releaseId?: Maybe<Array<Scalars['String']>>;
  addonId?: Maybe<Array<Scalars['String']>>;
};

export type Automation = {
  __typename?: 'Automation';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  /** When to send the email */
  automationType: AutomationType;
  /** Id of Mailchimp template */
  templateId?: Maybe<Scalars['Float']>;
  /** Id of Mailchimp audience */
  listId?: Maybe<Scalars['String']>;
  /** Subject of email */
  subject?: Maybe<Scalars['String']>;
  /** Used to show what we are targeting */
  targetSource: ReportingFilterSource;
  /** Id of source */
  targetSourceId?: Maybe<Scalars['String']>;
  /** Release Id of the source */
  targetReleaseId?: Maybe<Scalars['String']>;
  /** Active status. */
  isActive: Scalars['Boolean'];
  /** send time for a birthday email, only hour and minute are used */
  timeOfDay?: Maybe<Scalars['DateTime']>;
  /** Postmark template name */
  templateName?: Maybe<Scalars['String']>;
};

export enum AutomationType {
  OrderAbandoned = 'orderAbandoned',
  Birthday = 'birthday'
}

export type BarchartOutput = {
  __typename?: 'BarchartOutput';
  range: Scalars['String'];
  value: Scalars['Float'];
};

export type BrandingInput = {
  /** Organization logo. */
  logo?: Maybe<Scalars['Upload']>;
  /** Organization mobile logo. */
  mobileLogo?: Maybe<Scalars['Upload']>;
  /** Organization favicon. */
  favicon?: Maybe<Scalars['Upload']>;
  /** Organization background image. */
  background?: Maybe<Scalars['Upload']>;
  /** Organization background image. */
  fullBackground?: Maybe<Scalars['Upload']>;
  /** Primary color. */
  primaryColor: Scalars['String'];
  /** Secondary color. */
  secondaryColor: Scalars['String'];
  /** Grey scale option. */
  greyScale?: Maybe<GreyScale>;
};

export type BrandingOutputBase = {
  __typename?: 'BrandingOutputBase';
  /** Organization logo. */
  logo?: Maybe<ExtendedFile>;
  /** Organization mobile logo. */
  mobileLogo?: Maybe<ExtendedFile>;
  /** Organization favicon. */
  favicon?: Maybe<ExtendedFile>;
  /** Organization background image. */
  background?: Maybe<ExtendedFile>;
  /** Organization full background image. */
  fullBackground?: Maybe<ExtendedFile>;
  /** Primary color. */
  primaryColor: Scalars['String'];
  /** Secondary color. */
  secondaryColor: Scalars['String'];
  /** Grey scale option. */
  greyScale?: Maybe<GreyScale>;
};

export type Broadcast = {
  __typename?: 'Broadcast';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  subject: Scalars['String'];
  fromName: Scalars['String'];
  /** When to send the email */
  audienceType?: Maybe<BroadcastAudience>;
  /** The rich text object */
  message: Scalars['String'];
  event?: Maybe<Event>;
  membership?: Maybe<Membership>;
  scheduledAt: Scalars['DateTime'];
  status: BroadcastStatus;
  /** Array an object with the error responses from Postmark */
  errors?: Maybe<Scalars['JSON']>;
  count?: Maybe<Scalars['Float']>;
  audienceData: AudienceData;
  type: BroadcastType;
  marketingType?: Maybe<BroadcastMarketingType>;
  transactionalType?: Maybe<BroadcastTransactionalType>;
  marketingFilters?: Maybe<Array<BroadcastMarketingFilters>>;
  /** The Broadcast email delivery stats from postmark */
  stats?: Maybe<PostmarkEmailStatsOverviewOutput>;
};

/** Type of broadcast audience */
export enum BroadcastAudience {
  TicketBuyers = 'TICKET_BUYERS',
  TicketType = 'TICKET_TYPE',
  Zone = 'ZONE',
  Release = 'RELEASE',
  Addon = 'ADDON'
}

export type BroadcastConnection = {
  __typename?: 'BroadcastConnection';
  pageInfo: PageInfo;
  edges: Array<BroadcastEdge>;
  totalCount: Scalars['Int'];
};

export type BroadcastEdge = {
  __typename?: 'BroadcastEdge';
  cursor: Scalars['String'];
  node: Broadcast;
};

export type BroadcastFilterCountInput = {
  filters: Array<MarketingFiltersInput>;
};

export enum BroadcastFilterCriteria {
  Is = 'is',
  Not = 'not'
}

export enum BroadcastFilterType {
  Waitlist = 'waitlist',
  TicketBuyer = 'ticketBuyer',
  Tag = 'tag',
  Region = 'region'
}

export type BroadcastMarketingFilters = {
  __typename?: 'BroadcastMarketingFilters';
  ids: Array<Scalars['String']>;
  criteria?: Maybe<BroadcastFilterCriteria>;
  filterType: BroadcastFilterType;
};

export enum BroadcastMarketingType {
  OptIn = 'optIn',
  Custom = 'custom'
}

export type BroadcastReportingOpenInput = {
  userId?: Maybe<Scalars['String']>;
  waitlistUserId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  broadcastId: Scalars['String'];
};

export type BroadcastReportingOrderInput = {
  userId?: Maybe<Scalars['String']>;
  waitlistUserId?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  broadcastId: Scalars['String'];
  orderId: Scalars['String'];
};

export type BroadcastReportingOutput = {
  __typename?: 'BroadcastReportingOutput';
  clicksOpened: Scalars['Float'];
  revenue: Scalars['Float'];
  conversions: Scalars['Float'];
  spamReported: Scalars['Float'];
};

export type BroadcastReportingSpamInput = {
  userId?: Maybe<Scalars['String']>;
  waitlistUserId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  broadcastId: Scalars['String'];
};

export type BroadcastReportingStatsInput = {
  broadcastId: Scalars['String'];
  type: BroadcastType;
};

export enum BroadcastStatus {
  Scheduled = 'SCHEDULED',
  Draft = 'DRAFT',
  Sent = 'SENT',
  Test = 'TEST'
}

export enum BroadcastTransactionalType {
  Event = 'Event',
  Membership = 'Membership'
}

export enum BroadcastType {
  Marketing = 'marketing',
  Transactional = 'transactional'
}

export type BroadcastWhereInput = {
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
  status?: Maybe<BroadcastStatus>;
};

/** Bulk orders item type */
export type BulkOrdersItem = {
  __typename?: 'BulkOrdersItem';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  processedAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  /** bulk orders item status. */
  status?: Maybe<BulkOrdersItemStatus>;
};

/** Bulk order items status */
export enum BulkOrdersItemStatus {
  Success = 'Success',
  Failed = 'Failed'
}

/** Buyer information. */
export type BuyerInformation = {
  __typename?: 'BuyerInformation';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** Postal code provided by the customer. Returns `null` if `UpdateOrderInput.deliveryMethod` is set to other than `eTicket`. */
  postalCode?: Maybe<Scalars['String']>;
  /** Tax number provided by the customer. */
  taxNumber?: Maybe<Scalars['String']>;
  /** Company name provided by the customer. */
  companyName?: Maybe<Scalars['String']>;
};

/** Buyer information. */
export type BuyerInformationInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  /** Postal code provided by the customer. Pass `null` if `UpdateOrderInput.deliveryMethod` is set to other than `eTicket`. */
  postalCode?: Maybe<Scalars['String']>;
  /** Tax Number provided by the customer. */
  taxNumber?: Maybe<Scalars['String']>;
  /** Company name provided by the customer. */
  companyName?: Maybe<Scalars['String']>;
};

export type CapacityOverview = {
  __typename?: 'CapacityOverview';
  /** The zone id */
  id: Scalars['String'];
  zoneName: Scalars['String'];
  capacity: Scalars['Float'];
  totalNotForSaleCount: Scalars['Float'];
  totalMembershipTicketCount: Scalars['Float'];
  totalCompTicketCount: Scalars['Float'];
  totalPaidTicketCount: Scalars['Float'];
  totalHolds: Scalars['Float'];
  sellableCapacity: Scalars['Float'];
  totalHoldByMembershipCount: Scalars['Float'];
  totalAllocated: Scalars['Float'];
};

export type ClaimTicketOutput = {
  __typename?: 'ClaimTicketOutput';
  eventId: Scalars['String'];
  parentTicketId: Scalars['String'];
  result: ClaimTicketResult;
};

export enum ClaimTicketResult {
  Success = 'SUCCESS',
  Failure = 'FAILURE'
}

export type Competition = {
  __typename?: 'Competition';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  competitionType: CompetitionType;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  bannerImage?: Maybe<ExtendedFile>;
  isPublished: Scalars['Boolean'];
  prizes?: Maybe<Array<CompetitionPrize>>;
  promoter?: Maybe<Array<CompetitionReward>>;
  isCompetitionRunning: Scalars['Boolean'];
  competitionState: CompetitionState;
  referralRewardValue?: Maybe<Scalars['Int']>;
};

export type CompetitionPrize = {
  __typename?: 'CompetitionPrize';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  prizeOrder: Scalars['Float'];
  quantity: Scalars['Float'];
  image?: Maybe<ExtendedFile>;
};

export type CompetitionPrizeInput = {
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  prizeOrder?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['Upload']>;
};

export type CompetitionPromoterInput = {
  platform: Scalars['String'];
  actionType: Scalars['String'];
  value: Scalars['Int'];
  enabled: Scalars['Boolean'];
};

export type CompetitionReward = {
  __typename?: 'CompetitionReward';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  platform: Scalars['String'];
  actionType: Scalars['String'];
  value: Scalars['Float'];
  isEnabled: Scalars['Boolean'];
};

export enum CompetitionState {
  Upcoming = 'UPCOMING',
  Running = 'RUNNING',
  Ended = 'ENDED'
}

/** Competition type. */
export enum CompetitionType {
  Registration = 'REGISTRATION',
  Onsale = 'ONSALE'
}

export type Coordinate = {
  __typename?: 'Coordinate';
  /** Latitude */
  lat: Scalars['Float'];
  /** Longitude */
  lng: Scalars['Float'];
};

export type CoordinateInput = {
  /** Latitude */
  lat: Scalars['Float'];
  /** Longitude */
  lng: Scalars['Float'];
};

export type CreateAutomationInput = {
  name: Scalars['String'];
  automationType: AutomationType;
  templateId?: Maybe<Scalars['Float']>;
  subject?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  targetSource: ReportingFilterSource;
  targetSourceId?: Maybe<Scalars['String']>;
  targetReleaseId?: Maybe<Scalars['String']>;
  timeOfDay?: Maybe<Scalars['DateTime']>;
  templateName?: Maybe<Scalars['String']>;
};

export type CreateCompetitionInput = {
  competitionType: CompetitionType;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  referralRewardValue?: Maybe<Scalars['Int']>;
  bannerImage?: Maybe<Scalars['Upload']>;
  prizes?: Maybe<Array<CompetitionPrizeInput>>;
  promoter?: Maybe<Array<CompetitionPromoterInput>>;
};

/** Represents additional info required to host a digital event. */
export type CreateDigitalInfoInput = {
  /** The url that digital pass codes are appended to in order to access the digital event/membership. */
  url: Scalars['String'];
  /** The Postmark email template that is used to send digital pass codes. */
  emailTemplateId?: Maybe<Scalars['String']>;
  additionalEmailInfo?: Maybe<AdditionalEmailInfoInput>;
};

export type CreateEventAddonInput = {
  /** The event id that is associated with the addon. */
  eventId: Scalars['String'];
  /** The name of the addon. */
  name: Scalars['String'];
  /** Indicates whether naming the addon is possible or not. */
  enableNaming: Scalars['Boolean'];
  /** Maximum quantity to be sold for the addon. */
  quantity: Scalars['Float'];
  /** The price associated with the addon. */
  price: Scalars['Float'];
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive: Scalars['Boolean'];
  namingFields: Array<FormFieldInput>;
  /** Image banner specific for a ticket type on the print at home ticket */
  addonImage?: Maybe<Scalars['Upload']>;
  insideFee?: Maybe<Scalars['Float']>;
};

export type CreateEventDate = {
  id?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

/** Creates a new event. */
export type CreateEventInput = {
  /** The kind of event. */
  eventKind?: Maybe<EventKind>;
  /** Represents additional info required to host a digital event. */
  digitalInfo?: Maybe<CreateDigitalInfoInput>;
  /** Event season. */
  season?: Maybe<Scalars['String']>;
  venue?: Maybe<Scalars['String']>;
  /** Event title. */
  title: Scalars['String'];
  logo?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  backgroundImageFullPage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  printBanner1?: Maybe<Scalars['Upload']>;
  printBanner2?: Maybe<Scalars['Upload']>;
  hardCopyTicketBanner?: Maybe<Scalars['Upload']>;
  /** Event description. */
  description?: Maybe<Scalars['String']>;
  /** Event dates. */
  dates: Array<CreateEventDate>;
  /** Date at which tickets are viewable/printable from. */
  ticketsViewableFromDate?: Maybe<Scalars['String']>;
  /** Event active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Event featured status. */
  isFeatured?: Maybe<Scalars['Boolean']>;
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Whether event is R-18. */
  isR18?: Maybe<Scalars['Boolean']>;
  /** Whether event is checking for vaccine passports on entry */
  checkForVaccinePass?: Maybe<Scalars['Boolean']>;
  /** Whether naming ticket is available. */
  canNameTicket?: Maybe<Scalars['Boolean']>;
  /** Whether renaming ticket is available. */
  canRenameTicket?: Maybe<Scalars['Boolean']>;
  /** Whether changing seats is available. */
  canChangeSeats?: Maybe<Scalars['Boolean']>;
  /** Whether transfering ticket is available. */
  canTransferTicket?: Maybe<Scalars['Boolean']>;
  /** Whether the waitlist is visible on the event information page */
  enableWaitlist?: Maybe<Scalars['Boolean']>;
  /** The start date of the presale registration. */
  waitlistStartDate?: Maybe<Scalars['DateTime']>;
  /** The end date of the presale registration. */
  waitlistEndDate?: Maybe<Scalars['DateTime']>;
  /** Whether release codes are visible on the event information page */
  enableReleaseCodes?: Maybe<Scalars['Boolean']>;
  /** The renaming fee for the event ticket. */
  renamingFee?: Maybe<Scalars['Float']>;
  /** The fee for changing seats for the event ticket. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The fee the seller pays for transferring a ticket. */
  sellerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** The fee the buyer pays for transferring a ticket. */
  buyerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptionsInput>;
  /** The payment gateways enabled for the event. */
  gateways?: Maybe<Array<Scalars['String']>>;
  termsAndConditions?: Maybe<Scalars['String']>;
  importantNotice?: Maybe<Scalars['String']>;
  accessibility?: Maybe<Scalars['String']>;
  invoiceInformation?: Maybe<Scalars['String']>;
  presaleInformation?: Maybe<Scalars['String']>;
  emailNotification?: Maybe<Scalars['String']>;
  redirectURL?: Maybe<Scalars['String']>;
  zonesAllocatedGates?: Maybe<Array<ZoneAllocatedGateInput>>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** Inside fees for the event */
  insideFeeDetails?: Maybe<Array<InsideFeeDetailsInput>>;
  canUsePoints?: Maybe<Scalars['Boolean']>;
  gaVenue?: Maybe<CreateGaEventVenueInput>;
  ticketCover?: Maybe<TicketCoverInput>;
  listedReleaseOptions?: Maybe<ListedReleaseOptionsInput>;
};

export type CreateEventMultiBuyPromotionInput = {
  name: Scalars['String'];
  buyQuantity: Scalars['Float'];
  getQuantity: Scalars['Float'];
  price: Scalars['Float'];
  /** The event id that is associated with the promotion. */
  eventId: Scalars['String'];
  buyTicketTypeId: Scalars['String'];
  getTicketTypeId: Scalars['String'];
};

export type CreateEventPromoCodeInput = {
  /** The unique code that represents the promotion. */
  code: Scalars['String'];
  /** The discount type associated with the promotion. */
  discountType: DiscountType;
  /** The discount amount of the promotion. */
  discountAmount: Scalars['Float'];
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
  eventId: Scalars['String'];
  type: EventPromoCodeType;
  ticketTypes?: Maybe<Array<Scalars['String']>>;
};

export type CreateGaEventVenueInput = {
  name?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  location?: Maybe<CoordinateInput>;
};

export type CreateHistoryInput = {
  /** The reference name of the history item. */
  refName: HistoryReferenceType;
  /** The reference id of the history item. */
  refId: Scalars['String'];
  /** The description of the history item. */
  description: Scalars['String'];
};

export type CreateIntegrationInput = {
  type: IntegrationType;
  name: Scalars['String'];
  secretKey?: Maybe<Scalars['String']>;
  publicKey?: Maybe<Scalars['String']>;
  wcPxPostSecretKey?: Maybe<Scalars['String']>;
  wcPxPostPublicKey?: Maybe<Scalars['String']>;
  webhookUrl?: Maybe<Scalars['String']>;
  transactionFeeType?: Maybe<FeeType>;
  transactionFee?: Maybe<Scalars['Float']>;
  transactionFeeType2?: Maybe<FeeType>;
  transactionFee2?: Maybe<Scalars['Float']>;
  paymentMethodType?: Maybe<Scalars['String']>;
  facebookTempToken?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
};

export type CreateMembershipAddonInput = {
  /** The membership id that is associated with the addon. */
  membershipId: Scalars['String'];
  /** The name of the addon. */
  name: Scalars['String'];
  /** Indicates whether naming the addon is possible or not. */
  enableNaming: Scalars['Boolean'];
  /** Maximum quantity to be sold for the addon. */
  quantity: Scalars['Float'];
  /** The price associated with the addon. */
  price: Scalars['Float'];
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive: Scalars['Boolean'];
  namingFields: Array<FormFieldInput>;
  /** Image banner specific for a ticket type on the print at home ticket */
  addonImage?: Maybe<Scalars['Upload']>;
};

export type CreateMembershipInput = {
  /** Name of the membership. */
  name: Scalars['String'];
  /** The kind of membership. */
  membershipKind: MembershipKind;
  /** Represents additional info required to host a digital membership. */
  digitalInfo?: Maybe<CreateDigitalInfoInput>;
  /** The previous memberships related to the membership. */
  previousMemberships?: Maybe<Array<Scalars['String']>>;
  /** The start date of the membership. */
  startDate: Scalars['DateTime'];
  /** The end date of the membership. */
  endDate: Scalars['DateTime'];
  /** The booking fee type of the membership. */
  bookingFeeType: FeeType;
  /** The booking fee for the membership. */
  bookingFee: Scalars['Float'];
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptionsInput>;
  /** The description of the membership. */
  description: Scalars['String'];
  thumbnail?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  banner?: Maybe<Scalars['Upload']>;
  printBanner1?: Maybe<Scalars['Upload']>;
  printBanner2?: Maybe<Scalars['Upload']>;
  /** The payment gateways enabled for the membership. */
  gateways?: Maybe<Array<Scalars['String']>>;
  /** Whether naming a membership is available. */
  canNameMembership?: Maybe<Scalars['Boolean']>;
  /** Whether renaming a membership is available. */
  canRenameMembership?: Maybe<Scalars['Boolean']>;
  /** Flag to determine if the membership is hidden from the public */
  hiddenFromPublic?: Maybe<Scalars['Boolean']>;
  /** Whether naming a membership is available. */
  canChangeSeats?: Maybe<Scalars['Boolean']>;
  /** The renaming fee for the membership. */
  renamingFee?: Maybe<Scalars['Float']>;
  /** The fee for changing seats for the membership. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The active status of the membership. */
  isActive?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  importantNotice?: Maybe<Scalars['String']>;
  accessibility?: Maybe<Scalars['String']>;
  invoiceInformation?: Maybe<Scalars['String']>;
  showSchedule?: Maybe<Scalars['Boolean']>;
  emailNotification?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  canUsePoints?: Maybe<Scalars['Boolean']>;
  enableAutoRenew?: Maybe<Scalars['Boolean']>;
  /** Whether individual event tickets can be transferred. */
  canTransferTickets?: Maybe<Scalars['Boolean']>;
};

export type CreateMembershipMultiBuyPromotionInput = {
  name: Scalars['String'];
  buyQuantity: Scalars['Float'];
  getQuantity: Scalars['Float'];
  price: Scalars['Float'];
  /** The membership id that is associated with the promotion. */
  membershipId: Scalars['String'];
  buyMembershipTypeId: Scalars['String'];
  getMembershipTypeId: Scalars['String'];
};

export type CreateMembershipPromoCodeInput = {
  /** The unique code that represents the promotion. */
  code: Scalars['String'];
  /** The discount type associated with the promotion. */
  discountType: DiscountType;
  /** The discount amount of the promotion. */
  discountAmount: Scalars['Float'];
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
  membershipId: Scalars['String'];
  type: MembershipPromoCodeType;
  membershipTypes?: Maybe<Array<Scalars['String']>>;
};

export type CreateMembershipTypeInput = {
  /** The associated membership of the membership type. */
  membershipId: Scalars['String'];
  /** The kind of the membership type. */
  kind: MembershipTypeKind;
  /** Name of the membership type. */
  name: Scalars['String'];
  /** The ticket fee type. */
  ticketFeeType: FeeType;
  /** The ticket fee. */
  ticketFee: Scalars['Float'];
  /** Restrictions for the membership type. */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the membership type. */
  restrictions?: Maybe<Scalars['String']>;
  namingFields: Array<FormFieldInput>;
};

export type CreateOrderInput = {
  /** Order type */
  orderType?: Maybe<OrderType>;
  /** Release id associated with the order. */
  releaseId?: Maybe<Scalars['String']>;
  /** Release password id associated with the order. */
  releasePasswordId?: Maybe<Scalars['String']>;
  /** Membership id associated with the order. */
  membershipId?: Maybe<Scalars['String']>;
  /** User id can be provided for back-office orders */
  userId?: Maybe<Scalars['String']>;
  /** List of the order's line items. */
  lineItems: Array<LineItemInput>;
  /** Seats.IO hold token. */
  holdToken?: Maybe<Scalars['String']>;
  /** Multi buy promotion id. */
  multiBuyId?: Maybe<Scalars['String']>;
  posId?: Maybe<Scalars['String']>;
  referralId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  transferFee?: Maybe<Scalars['Float']>;
  isCreatedFromRecoveredCart?: Maybe<Scalars['Boolean']>;
};

export type CreateOrganizationInput = {
  name: Scalars['String'];
  slug: Scalars['String'];
  address: AddressInput;
  email: Scalars['String'];
  phone: Scalars['String'];
  taxNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  supportInfo?: Maybe<Scalars['String']>;
  landingPage: LandingPage;
  showMemberships?: Maybe<Scalars['Boolean']>;
  showMembershipRenewal?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  privacyPolicy?: Maybe<Scalars['String']>;
  branding?: Maybe<BrandingInput>;
  marketing?: Maybe<MarketingInput>;
  helpLink?: Maybe<Scalars['String']>;
};

export type CreateOrganizationOutput = {
  __typename?: 'CreateOrganizationOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type CreatePaymentInput = {
  /** Payment gateway chosen by the customer (leave empty if paying with credits only). */
  gateway?: Maybe<Scalars['String']>;
  /** Whether the customer opts-in for marketing & promotions. */
  optInForMarketingPromotions: Scalars['Boolean'];
  /** Whether the customer receives a receipt by email. */
  skipOrderConfirmation?: Maybe<Scalars['Boolean']>;
  /** Whether the customer gets a hold order confirmation. */
  sendHoldOrderCustomerEmail?: Maybe<Scalars['Boolean']>;
  /** Whether the customer wants to initiate a reoccurring payment. */
  reoccurringPayment?: Maybe<Scalars['Boolean']>;
  pointRedemptionAmount?: Maybe<Scalars['Float']>;
};

/** Represents the order creation result. */
export type CreatePaymentOutput = {
  __typename?: 'CreatePaymentOutput';
  /** The order. */
  order: Order;
  /** The payment creation result of the order. */
  result?: Maybe<PaymentResult>;
};

export type CreatePinPaymentCharge = {
  refId: Scalars['String'];
  cardToken: Scalars['String'];
};

export type CreatePointInput = {
  name?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  gatewayIds: Array<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
};

export type CreatePointItemInput = {
  pointId: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['Float'];
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  banner?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  isVisible: Scalars['Boolean'];
};

export type CreatePosInput = {
  eventId: Scalars['String'];
  releaseId: Scalars['String'];
  name: Scalars['String'];
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  paymentOptions: PosPaymentOptionsInput;
  deliveryOptions: Array<ShippingOption>;
  cashAmount?: Maybe<Scalars['Float']>;
  /** Whether receipts are turned on. */
  enableReceipts?: Maybe<Scalars['Boolean']>;
};

export type CreatePosUserInput = {
  eventId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  accessCode: Scalars['String'];
};

export type CreatePurchaseRestrictionInput = {
  restrictedType: LineItemType;
  restrictedId: Scalars['String'];
  requiredEntities: Array<PurchaseRestrictionRequiredEntityInput>;
  isExclusive?: Maybe<Scalars['Boolean']>;
  isAlwaysVisible?: Maybe<Scalars['Boolean']>;
  quantity: Scalars['Float'];
};

export type CreateRedirectUrlInput = {
  /** Type of entity this redirect is for. */
  refName: Scalars['String'];
  /** Reference entity ID. */
  refId: Scalars['String'];
  /** Full URL path. */
  redirectURL: Scalars['String'];
};

export type CreateReferralCampaignDto = {
  referralReleaseId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  referralOwnerRewardType: ReferralRewardType;
  referralOwnerRewardQuantityType: ReferralRewardQuantityType;
  referralOwnerRewardQuantity: Scalars['Float'];
  referralUserRewardType: ReferralRewardType;
  referralUserRewardQuantityType: ReferralRewardQuantityType;
  referralUserRewardQuantity: Scalars['Float'];
};

export type CreateReferralRewardsDto = {
  referralCampaignId: Scalars['String'];
  referralOwnerUserReferralId: Scalars['String'];
  referralUserId: Scalars['String'];
  orderId: Scalars['String'];
};

/** Creates a refund. */
export type CreateRefundInput = {
  /** Order id for which the refund will be created. */
  orderId: Scalars['String'];
  /** Desired amount of the refund. */
  amount: Scalars['Float'];
  /** Notes why the refund was created. */
  notes: Scalars['String'];
  /** Tickets to realease (will also release child tickets). */
  ticketIds?: Maybe<Array<Scalars['String']>>;
  /** Whether the refund is a manual one. */
  isManual?: Maybe<Scalars['Boolean']>;
  gateway?: Maybe<RefundGateway>;
  /** Whether to send a refund confirmation email. */
  sendEmail?: Maybe<Scalars['Boolean']>;
};

export type CreateReleaseInput = {
  event: Scalars['String'];
  /** Release name. */
  name: Scalars['String'];
  /** Release type. */
  type: ReleaseType;
  /** The slug for the unlisted release. Pass null if the release type is set to other than `unlisted`. */
  slug?: Maybe<Scalars['String']>;
  /** The password for the unlisted release. Pass null if the release type is set to other than `unlisted`. */
  password?: Maybe<Scalars['String']>;
  /** The start condition of the release. */
  startCondition: ReleaseStartCondition;
  /** The start date of the release. Pass null if the startCondition is set to other than `date`. */
  startConditionDate?: Maybe<Scalars['DateTime']>;
  /** The end condition of the release. */
  endCondition: ReleaseEndCondition;
  /** The quantity limit of the release. Pass null if the endCondition is set to other than `quantity`. */
  endConditionQuantity?: Maybe<Scalars['Float']>;
  /** The end date of the release. Pass null if the endCondition is set to other than `date`. */
  endConditionDate?: Maybe<Scalars['DateTime']>;
  /** The status of the release. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The zones of the release. */
  releaseZones: Array<ReleaseZoneInput>;
  /** The title of the unlisted release. Pass null if the `type` is set to other than `unlisted`. */
  presaleTitle?: Maybe<Scalars['String']>;
  presaleLogo?: Maybe<Scalars['Upload']>;
  presaleHeader?: Maybe<Scalars['Upload']>;
  /** The information of the unlisted release. Pass null if the `type` is set to other than `unlisted`. */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The information that will be shown to customers on the ticketing page. */
  releaseNotes?: Maybe<Scalars['String']>;
  /** Ask how did you heard about us during the purchasing flow */
  askHowDidYouHearAboutUs?: Maybe<Scalars['Boolean']>;
  /** Request purchasers  */
  askForDietaryRequirements?: Maybe<Scalars['Boolean']>;
  /** Are comps visible to public */
  allowPublicComp?: Maybe<Scalars['Boolean']>;
  /** Can this release use Windcaves Account2Account functionality */
  allowAccount2Account?: Maybe<Scalars['Boolean']>;
  /** Can customers create hold orders for this release */
  allowHoldOrders?: Maybe<Scalars['Boolean']>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  releaseEventAddons?: Maybe<Array<Scalars['String']>>;
};

export type CreateReleaseZoneInput = {
  eventId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  capacity: Scalars['Int'];
  admission: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
};

export type CreateScoutCommunicationInput = {
  name: Scalars['String'];
  purpose: ScoutPurpose;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  type: ScoutCommunicationType;
  includeOptedOutOfMarketing?: Maybe<Scalars['Boolean']>;
  segmentId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  trackSource?: Maybe<ReportingFilterSource>;
  trackSourceId?: Maybe<Scalars['String']>;
  trackReleaseId?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  shouldUpdate?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Float']>;
  subject?: Maybe<Scalars['String']>;
};

export type CreateScoutInput = {
  name: Scalars['String'];
  promoteTo: Array<FilterSelectionInput>;
  exclude?: Maybe<Array<FilterSelectionInput>>;
};

export type CreateSeasonInput = {
  /** Season name. */
  name: Scalars['String'];
  /** Season active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Season description. */
  description: Scalars['String'];
  thumbnail?: Maybe<Scalars['Upload']>;
  backgroundImageFullPage?: Maybe<Scalars['Upload']>;
  displayOrder: Scalars['Float'];
};

export type CreateTagInput = {
  name: Scalars['String'];
};

export type CreateTemporaryPosUserInput = {
  eventId: Scalars['String'];
  fullName: Scalars['String'];
};

export type CreateTemporaryPosUserOutput = {
  __typename?: 'CreateTemporaryPosUserOutput';
  user: User;
  password: Scalars['String'];
  /** Access token to create a single temporary POS user */
  oneTimeAccessToken: Scalars['String'];
};

export type CreateTestEmailInput = {
  emails: Array<Scalars['String']>;
  templateId: Scalars['Float'];
  subject: Scalars['String'];
  communicationId: Scalars['String'];
};

export type CreateTicketTypeDate = {
  eventDateId: Scalars['String'];
  alternateEntryTime?: Maybe<Scalars['String']>;
};

export type CreateTicketTypeInput = {
  /** The event id that is associated with the ticket type. */
  event: Scalars['String'];
  /** The kind of the ticket type. */
  kind: TicketTypeKind;
  /** Whether the ticket type is grouped. */
  isGrouped?: Maybe<Scalars['Boolean']>;
  /** The amount of people in a group. Returns null if the ticket type is not grouped. */
  groupAmount?: Maybe<Scalars['Float']>;
  /** Ticket group name. */
  name: Scalars['String'];
  /** Event dates. */
  dates: Array<CreateTicketTypeDate>;
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Per ticket stadium levy ticket fee. */
  stadiumLevyFee?: Maybe<Scalars['Float']>;
  /** Mark a ticket type as high demand */
  inHighDemand: Scalars['Boolean'];
  /** MMark a ticket type as sold out */
  soldOut: Scalars['Boolean'];
  /** Restrictions for the ticket group. */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the ticket group. */
  restrictions?: Maybe<Scalars['String']>;
  /** Print at home information for the ticket group. */
  printAtHomeInformation?: Maybe<Scalars['String']>;
  namingFields: Array<FormFieldInput>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketBanner?: Maybe<Scalars['Upload']>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketImage?: Maybe<Scalars['Upload']>;
  quantity?: Maybe<Scalars['Float']>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** Price for v2 event */
  price?: Maybe<Scalars['Float']>;
  /** releaseZoneId for v2 event */
  releaseZoneId?: Maybe<Scalars['String']>;
  /** isActive for v2 event */
  isActive?: Maybe<Scalars['Boolean']>;
};

export type CreateUserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  twoFactorAuthenticationSecret?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  usableForMarketing?: Maybe<Scalars['Boolean']>;
  /** Billing address provided by the user. */
  billingAddress?: Maybe<PartialAddressInput>;
  /** Shipping address provided by the user. */
  shippingAddress?: Maybe<PartialAddressInput>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress?: Maybe<Scalars['Boolean']>;
  credits?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  instagramUsername?: Maybe<Scalars['String']>;
  referralId?: Maybe<Scalars['String']>;
  accessEventIds?: Maybe<Array<Scalars['String']>>;
  accessMembershipIds?: Maybe<Array<Scalars['String']>>;
  /** Elevate users privileges from user to admin. */
  elevatePrivileges?: Maybe<Scalars['Boolean']>;
};

export type CreateVenueInput = {
  seating: VenueSeating;
  /** Seats.IO chart id. */
  seatsChartKey?: Maybe<Scalars['String']>;
  accessibilityInfo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  capacity: Scalars['Float'];
  capacityUtilization?: Maybe<Scalars['Float']>;
  address: AddressInput;
  location?: Maybe<CoordinateInput>;
  zones?: Maybe<Array<ZoneInput>>;
  gates?: Maybe<Array<GateInput>>;
};

export type CurrentOrganizationOutput = {
  __typename?: 'CurrentOrganizationOutput';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Organization name. */
  name: Scalars['String'];
  /** Organization slug. */
  slug: Scalars['String'];
  /** Contact e-mail address. */
  email: Scalars['String'];
  /** Contact phone. */
  phone: Scalars['String'];
  /** Tax number */
  taxNumber?: Maybe<Scalars['String']>;
  /** Currency */
  currency?: Maybe<Scalars['String']>;
  /** Address details. */
  address?: Maybe<Address>;
  /** Landing page settings. */
  landingPage: LandingPage;
  /** Show memberships in client navigation. */
  showMemberships: Scalars['Boolean'];
  /** Show memberships renewal banner. */
  showMembershipRenewal?: Maybe<Scalars['Boolean']>;
  /** The support information of the organistion */
  supportInfo?: Maybe<Scalars['String']>;
  /** The privacy policy of the organistion */
  privacyPolicy?: Maybe<Scalars['String']>;
  /** The terms and conditions of the organistion */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Marketing settings. */
  marketing?: Maybe<Marketing>;
  /** Shipping labels. */
  shippingLabels?: Maybe<ShippingLabels>;
  /** Beta features. */
  features?: Maybe<Array<Scalars['String']>>;
  timezone: Scalars['String'];
  helpLink?: Maybe<Scalars['String']>;
  ticketCoverPlatformFeePercentage?: Maybe<Scalars['Float']>;
  branding: OrganizationOutputBranding;
  singleEvent?: Maybe<Event>;
  shopify?: Maybe<ShopifyIntegration>;
  point?: Maybe<Point>;
};

export type CustomField = {
  __typename?: 'CustomField';
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type CustomFieldInput = {
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type CustomSaleOutput = {
  __typename?: 'CustomSaleOutput';
  data?: Maybe<Scalars['JSON']>;
};


export type DeleteOneOutput = {
  __typename?: 'DeleteOneOutput';
  deletedId?: Maybe<Scalars['String']>;
};

export type DeleteScoutUserInput = {
  ids: Array<Scalars['String']>;
};

/** Represents additional info required to host a digital event/membership. */
export type DigitalInfo = {
  __typename?: 'DigitalInfo';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The url that digital pass codes are appended to in order to access the digital event/membership. */
  url: Scalars['String'];
  /** The Postmark email template that is used to send digital pass codes. */
  emailTemplateId?: Maybe<Scalars['String']>;
  /** Additional email info to be added in digital event/membership access emails. */
  additionalEmailInfoText?: Maybe<Scalars['String']>;
  /** Additional email info button URL to be added in digital event/membership access emails. */
  additionalEmailButtonUrl?: Maybe<Scalars['String']>;
  /** Additional email info button text to be added in digital event/membership access emails. */
  additionalEmailButtonText?: Maybe<Scalars['String']>;
  /** Additional email info HTML be added in digital event/membership access emails. */
  additionalEmailInfoHTML?: Maybe<Scalars['String']>;
  /** Event. */
  event?: Maybe<Event>;
  /** Membership. */
  membership?: Maybe<Membership>;
};

export type DigitalPassCodeStatusOutput = {
  __typename?: 'DigitalPassCodeStatusOutput';
  totalPassCodes: Scalars['Int'];
  remainingPassCodes: Scalars['Int'];
};

export enum DiscountType {
  Percentage = 'PERCENTAGE',
  Fixed = 'FIXED'
}

/** Duplicate an existing release. */
export type DuplicateAllReleasesInput = {
  /** Array of ticketTypes that are being duplicated */
  ticketTypeIdMapping: Array<Scalars['String']>;
  /** The new slug for the release */
  newSlug?: Maybe<Scalars['String']>;
};

/** Duplicate an existing release. */
export type DuplicateSingleReleaseInput = {
  /** Event where the duplicated release will be */
  eventId: Scalars['String'];
  /** Event where the duplicated release will be */
  releaseId: Scalars['String'];
  /** The new slug for the release */
  newSlug?: Maybe<Scalars['String']>;
  /** The type of the new release */
  releaseType?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'Event';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The kind of event */
  eventKind: EventKind;
  /** Event season. */
  season?: Maybe<Season>;
  /** Event venue. */
  venue: Venue;
  releases: Array<Release>;
  /** Seats.io event key. */
  seatsEventKey?: Maybe<Scalars['String']>;
  /** Event title. */
  title: Scalars['String'];
  /** Event description. */
  description: Scalars['String'];
  /** Event dates. */
  dates: Array<EventDate>;
  /** Event start date. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Event end date. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Date at which tickets are viewable/printable after. */
  ticketsViewableFromDate?: Maybe<Scalars['DateTime']>;
  /** Event active status. */
  isActive: Scalars['Boolean'];
  /** Featured status. */
  isFeatured: Scalars['Boolean'];
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Whether event is R-18. */
  isR18: Scalars['Boolean'];
  /** Whether naming ticket is available. */
  canNameTicket: Scalars['Boolean'];
  /** Whether renaming ticket is available. */
  canRenameTicket: Scalars['Boolean'];
  /** Whether the waitlist is visible on the event information page */
  enableWaitlist: Scalars['Boolean'];
  /** The date the presale registration will be visible on the event information page. */
  waitlistStartDate?: Maybe<Scalars['DateTime']>;
  /** The date the presale registration will no longer be visible on the event information page. */
  waitlistEndDate?: Maybe<Scalars['DateTime']>;
  /** Whether renaming ticket is available. */
  enableReleaseCodes: Scalars['Boolean'];
  /** Whether changing seats is available. */
  canChangeSeats: Scalars['Boolean'];
  /** Whether transfering ticket is available. */
  canTransferTicket: Scalars['Boolean'];
  /** The renaming fee for the event ticket. */
  renamingFee?: Maybe<Scalars['Float']>;
  /** The fee for changing seats for the event ticket. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The fee the seller pays for transferring a ticket. */
  sellerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** The fee the buyer pays for transferring a ticket. */
  buyerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptions>;
  thumbnail?: Maybe<ExtendedFile>;
  logo?: Maybe<ExtendedFile>;
  backgroundImage?: Maybe<ExtendedFile>;
  backgroundImageFullPage?: Maybe<ExtendedFile>;
  descriptionImage?: Maybe<ExtendedFile>;
  printBanner1?: Maybe<ExtendedFile>;
  printBanner2?: Maybe<ExtendedFile>;
  hardCopyTicketBanner?: Maybe<ExtendedFile>;
  /** The terms and conditions of the event */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Important notice section on the tickets */
  importantNotice?: Maybe<Scalars['String']>;
  /** The accessibility info of the event */
  accessibility?: Maybe<Scalars['String']>;
  /** The presale info of the event */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The invoice info of the event */
  invoiceInformation?: Maybe<Scalars['String']>;
  /** Allocated gates to venue zones */
  zonesAllocatedGates?: Maybe<Array<ZoneAllocatedGate>>;
  /** Inside fees for the event */
  insideFeeDetails?: Maybe<Array<InsideFeeDetails>>;
  /** Featured status. */
  checkForVaccinePass: Scalars['Boolean'];
  /** Email address that gets sent a notifcation every time an order is completed */
  emailNotification?: Maybe<Scalars['String']>;
  /** Once a customer has finished purchasing they can be redirected back to another URL to continuing their purchsing journey */
  redirectURL?: Maybe<Scalars['String']>;
  /** The referral campaign associated with this event */
  referralCampaignId?: Maybe<Scalars['String']>;
  canUsePoints: Scalars['Boolean'];
  /** The ID of the Google Wallet Event Class for this event */
  googleWalletEventClassId?: Maybe<Scalars['String']>;
  lastTicketsViewableEmailsSentAt?: Maybe<Scalars['DateTime']>;
  ticketCover?: Maybe<EventTicketCover>;
  hasPublicRelease: Scalars['Boolean'];
  venueAddress: Venue;
  ticketTypes: Array<TicketType>;
  gateways: Array<Integration>;
  addons: Array<EventAddon>;
  soldTicketsCount?: Maybe<Scalars['Float']>;
  soldTicketsCountToday?: Maybe<Scalars['Float']>;
  soldTicketsCountYesterday?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  multiBuyPromotions: Array<EventMultiBuyPromotion>;
  tags: Array<Tag>;
  digitalPassCodesStatus?: Maybe<DigitalPassCodeStatusOutput>;
  digitalInfo?: Maybe<DigitalInfo>;
  ticketSoldTime?: Maybe<TicketSoldTime>;
  hasPromoCodes: Scalars['Boolean'];
  isWaitlistAvailable: Scalars['Boolean'];
  listedRelease?: Maybe<Release>;
};

export type EventAddon = {
  __typename?: 'EventAddon';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The name of the addon. */
  name: Scalars['String'];
  /** Indicates whether naming the addon is possible or not. */
  enableNaming: Scalars['Boolean'];
  /** Maximum quantity to be sold for the addon. */
  quantity: Scalars['Float'];
  /** The price associated with the addon. */
  price: Scalars['Float'];
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive: Scalars['Boolean'];
  namingFields: Array<FormField>;
  /** Image to be shown on the customer portal of the addon . Returns null if the not set. */
  addonImage?: Maybe<ExtendedFile>;
  /** Booking fee. */
  insideFee?: Maybe<Scalars['Float']>;
  purchaseRestrictions: Array<PurchaseRestriction>;
  purchaseRestrictionsHelpText: Array<Scalars['String']>;
};

export type EventConnection = {
  __typename?: 'EventConnection';
  pageInfo: PageInfo;
  edges: Array<EventEdge>;
  totalCount: Scalars['Int'];
};

/** Represents a date in an event. */
export type EventDate = {
  __typename?: 'EventDate';
  id: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String'];
  node: Event;
};

export type EventForecastOutput = {
  __typename?: 'EventForecastOutput';
  id: Scalars['String'];
  eventId: Scalars['String'];
  /** The zones and forecasted seat count attributes */
  zones?: Maybe<Array<EventForecastZoneOutput>>;
  /** The array of possible forecasting scenarios */
  scenarios?: Maybe<Array<ForecastScenario>>;
};

/** Object to hold the zoneId and the seat allocation forecasts */
export type EventForecastZone = {
  __typename?: 'EventForecastZone';
  /** The zone id of for the seats forecast. */
  zoneId?: Maybe<Scalars['String']>;
  /** How many seats are forecast to be comps */
  comps: Scalars['Int'];
  /** How many seats are forecast to be contingency */
  contingency: Scalars['Int'];
};

/** Object to hold the zoneId and the seat allocation forecasts */
export type EventForecastZoneOutput = {
  __typename?: 'EventForecastZoneOutput';
  /** The zone id of for the seats forecast. */
  zoneId?: Maybe<Scalars['String']>;
  /** How many seats are forecast to be comps */
  comps: Scalars['Int'];
  /** How many seats are forecast to be contingency */
  contingency: Scalars['Int'];
  /** Sales statistics if available */
  sales?: Maybe<FinancialSales>;
};

/** Ticket kind for ticket type. */
export enum EventKind {
  Standard = 'STANDARD',
  Digital = 'DIGITAL'
}

export type EventMultiBuyPromotion = {
  __typename?: 'EventMultiBuyPromotion';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  buyQuantity: Scalars['Float'];
  getQuantity: Scalars['Float'];
  price: Scalars['Float'];
  buyTicketType: TicketType;
  getTicketType: TicketType;
};

export type EventOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
  startDate?: Maybe<OrderByDirection>;
  endDate?: Maybe<OrderByDirection>;
  isFeatured?: Maybe<OrderByDirection>;
};

export type EventOrdersOnlineOutput = {
  __typename?: 'EventOrdersOnlineOutput';
  totalCount: Scalars['Float'];
  baseTickets: Scalars['Float'];
  ticketFees: Scalars['Float'];
  bookingFees: Scalars['Float'];
  transactionFees: Scalars['Float'];
  deliveryFees: Scalars['Float'];
  refundedAmount: Scalars['Float'];
  addons: Scalars['Float'];
  creditsUsed: Scalars['Float'];
  orderIdsOnline: Array<OrderIdsOnlineOutput>;
};

export type EventPromoCode = {
  __typename?: 'EventPromoCode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The unique code that represents the promotion. */
  code: Scalars['String'];
  /** The discount type associated with the promotion. */
  discountType: DiscountType;
  /** The discount amount of the promotion. */
  discountAmount: Scalars['Float'];
  /** The type of the promotion which determines on which items the promotion will be applied. */
  type: EventPromoCodeType;
  /** Ticket type ids for promo code. */
  ticketTypes?: Maybe<Array<Scalars['String']>>;
  /** The total amount of usage of the promotion. */
  used?: Maybe<Scalars['Int']>;
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
};

export enum EventPromoCodeType {
  EventAndAddons = 'EVENT_AND_ADDONS',
  Event = 'EVENT',
  Addons = 'ADDONS'
}

export type EventSocialPage = {
  __typename?: 'EventSocialPage';
  name: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type EventSocialPageInput = {
  name: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type EventTicketCover = {
  __typename?: 'EventTicketCover';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Event that the ticket cover is configured for */
  event: Event;
  enabledAt?: Maybe<Scalars['DateTime']>;
  disabledAt?: Maybe<Scalars['DateTime']>;
  /** Promoter fee as percentage of ticket price */
  promoterFeePercentage: Scalars['Float'];
  /** Platform fee as percentage of ticket price */
  platformFeePercentage: Scalars['Float'];
  /** Total fee as percentage of ticket price */
  totalFeePercentage: Scalars['Float'];
  /** Is ticket cover enabled */
  isEnabled: Scalars['Boolean'];
};

export type EventWhereInput = {
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
  /** Event active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Event featured status. */
  isFeatured?: Maybe<Scalars['Boolean']>;
  /** Event start date. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Event end date. */
  endDate?: Maybe<Scalars['DateTime']>;
  pos?: Maybe<Scalars['Boolean']>;
  seasonId?: Maybe<Scalars['String']>;
  /**
   * If this is set to true,
   *     then we will left join release and check whether this event contains a outlet release.
   */
  isOutlet?: Maybe<Scalars['Boolean']>;
  seating?: Maybe<VenueSeating>;
  /** Add it if the user only have limited access to events. */
  restrictedUserId?: Maybe<Scalars['String']>;
};

export type ExtendedFile = {
  __typename?: 'ExtendedFile';
  storage: StorageType;
  directory: Scalars['String'];
  fileName: Scalars['String'];
  originalFileName?: Maybe<Scalars['String']>;
  metaData?: Maybe<MetaData>;
};

export type FacebookPageListsInput = {
  token?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type FailedImportItem = {
  __typename?: 'FailedImportItem';
  index: Scalars['Float'];
  message?: Maybe<Scalars['String']>;
};

/** The valid values for fee types. */
export enum FeeType {
  FlatRate = 'FlatRate',
  Percentage = 'Percentage'
}

export type FilterSelection = {
  __typename?: 'FilterSelection';
  userTagIds?: Maybe<Array<Scalars['String']>>;
  seasonIds?: Maybe<Array<Scalars['String']>>;
  eventTypes?: Maybe<Array<ScoutEventType>>;
  regions?: Maybe<Array<Scalars['String']>>;
  membershipTypes?: Maybe<Array<Scalars['String']>>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  eventTitlesForWaitlist?: Maybe<Array<Scalars['String']>>;
  totalEventsPurchasedTo?: Maybe<Scalars['Float']>;
  ticketTypeKinds?: Maybe<Array<TicketTypeKind>>;
  zones?: Maybe<Array<Scalars['String']>>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
  gender?: Maybe<Array<Gender>>;
  minAge?: Maybe<Scalars['Float']>;
  maxAge?: Maybe<Scalars['Float']>;
};

export type FilterSelectionInput = {
  userTagIds?: Maybe<Array<Scalars['String']>>;
  seasonIds?: Maybe<Array<Scalars['String']>>;
  eventTypes?: Maybe<Array<ScoutEventType>>;
  regions?: Maybe<Array<Scalars['String']>>;
  membershipTypes?: Maybe<Array<Scalars['String']>>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  eventTitlesForWaitlist?: Maybe<Array<Scalars['String']>>;
  totalEventsPurchasedTo?: Maybe<Scalars['Float']>;
  ticketTypeKinds?: Maybe<Array<TicketTypeKind>>;
  zones?: Maybe<Array<Scalars['String']>>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
  gender?: Maybe<Array<Gender>>;
  minAge?: Maybe<Scalars['Float']>;
  maxAge?: Maybe<Scalars['Float']>;
};

export type FinancialGatewayGraphOutput = {
  __typename?: 'FinancialGatewayGraphOutput';
  transactions: Scalars['Float'];
  integrations: Array<FinancialGraphIntegration>;
};

export type FinancialGraphIntegration = {
  __typename?: 'FinancialGraphIntegration';
  name: Scalars['String'];
  transactions: Scalars['Float'];
};

export type FinancialOverviewOutput = {
  __typename?: 'FinancialOverviewOutput';
  grossSales: Scalars['Float'];
  netSales: Scalars['Float'];
  discounts: Scalars['Float'];
  avgOrderAmount: Scalars['Float'];
  avgOrderItemsCount: Scalars['Float'];
  transactionFees: Scalars['Float'];
  shippingCosts: Scalars['Float'];
  transferFees: Scalars['Float'];
  ticketCoverMargin: Scalars['Float'];
  ticketCoverCost: Scalars['Float'];
};

export type FinancialSales = {
  __typename?: 'FinancialSales';
  zoneId: Scalars['String'];
  zoneName: Scalars['String'];
  capacity: Scalars['Float'];
  available: Scalars['Float'];
  sellableCapacity: Scalars['Float'];
  totalNotForSaleCount: Scalars['Float'];
  totalHoldByMembershipCount: Scalars['Float'];
  totalMembershipTicketCount: Scalars['Float'];
  soldPercentage: Scalars['Float'];
  types: Array<FinancialSalesType>;
};

export type FinancialSalesType = {
  __typename?: 'FinancialSalesType';
  name: Scalars['String'];
  issued: Scalars['Float'];
  holds: Scalars['Float'];
  transfersPending: Scalars['Float'];
  transfers: Scalars['Float'];
  comps: Scalars['Float'];
  sold: Scalars['Float'];
  baseRevenue: Scalars['Float'];
  totalWithBookingFees: Scalars['Float'];
};

export type FindAutomationsInput = {
  isActive: Scalars['Boolean'];
  automationType?: Maybe<Scalars['String']>;
};

export type FindOrderIdForTicketOutput = {
  __typename?: 'findOrderIdForTicketOutput';
  /** Order Id */
  orderId: Scalars['String'];
};

export type FindScoutsInput = {
  isActive?: Maybe<Scalars['Boolean']>;
};

export type ForecastScenario = {
  __typename?: 'ForecastScenario';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The zones and forecasted seat count attributes */
  zones?: Maybe<Array<ForecastScenarioZone>>;
};

/** Object to hold the zoneId and the seat allocation forecasts */
export type ForecastScenarioZone = {
  __typename?: 'ForecastScenarioZone';
  /** The zone id of for the seats forecast. */
  zoneId?: Maybe<Scalars['String']>;
  /** Array of ticket type ids and the forecast cost and spilt of ticket sales */
  ticketTypes: Array<ScenarioZoneTicketType>;
};

export type ForecastZoneInput = {
  /** The zone related to this input */
  zoneId: Scalars['String'];
  /** How many seats are forecast to be comped. */
  comps: Scalars['Float'];
  /** How many seats are forecast to be comped. */
  contingency: Scalars['Float'];
};

export type FormField = {
  __typename?: 'FormField';
  field: Scalars['String'];
  isRequired?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
};

export type FormFieldInput = {
  field: Scalars['String'];
  isRequired?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
};

export type Gate = {
  __typename?: 'Gate';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
};

/** The gate belonging to a venue */
export type GateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** The valid values for gender. */
export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other'
}

export type GenderBreakDownOutput = {
  __typename?: 'GenderBreakDownOutput';
  male?: Maybe<Scalars['Float']>;
  female?: Maybe<Scalars['Float']>;
  other?: Maybe<Scalars['Float']>;
};

export type GetHistoryByCustomerIdInput = {
  /** An array of the reference name of the history item. */
  refName?: Maybe<Array<Scalars['String']>>;
  /** Id of order. Used when looking at a customers order */
  orderId?: Maybe<Scalars['String']>;
  /** Id of customers. Not the id of admins. */
  userId?: Maybe<Scalars['String']>;
};

export type GrantCompetitionRewardInput = {
  competitionId: Scalars['String'];
  userId: Scalars['String'];
  platform: Scalars['String'];
  actionType: Scalars['String'];
  orderId?: Maybe<Scalars['String']>;
};

export type GraphDateItem = {
  __typename?: 'GraphDateItem';
  date: Scalars['DateTime'];
  items: Array<GraphItem>;
};

export enum GraphFilterType {
  Overall = 'OVERALL',
  Tickets = 'TICKETS',
  AddOns = 'ADD_ONS',
  Memberships = 'MEMBERSHIPS',
  Package = 'PACKAGE'
}

export type GraphItem = {
  __typename?: 'GraphItem';
  name: Scalars['String'];
  value: Scalars['Float'];
};

export type GraphOutput = {
  __typename?: 'GraphOutput';
  dates: Array<GraphDateItem>;
};

export type GraphRangeItem = {
  __typename?: 'GraphRangeItem';
  start: Scalars['String'];
  end: Scalars['String'];
  value: Scalars['Float'];
};

export type GraphTextItem = {
  __typename?: 'GraphTextItem';
  identifier: Scalars['String'];
  items: Array<GraphItem>;
};

/** Grey scale options. */
export enum GreyScale {
  Warm = 'Warm',
  Neutral = 'Neutral',
  Cool = 'Cool'
}

export type HandleInstagramCodeInput = {
  code: Scalars['String'];
  url: Scalars['String'];
};

export type HeardAboutUsBreakDownOutput = {
  __typename?: 'HeardAboutUsBreakDownOutput';
  heardAboutUs?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
};

/** Heard about us type */
export enum HeardAboutUsType {
  WordOfMouth = 'WordOfMouth',
  Radio = 'Radio',
  Billboard = 'Billboard',
  SocialMedia = 'SocialMedia',
  Email = 'Email',
  Other = 'Other',
  InternetSearch = 'InternetSearch'
}

export type HighestValueCustomersOutput = {
  __typename?: 'HighestValueCustomersOutput';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** Represents information about an history item. */
export type History = {
  __typename?: 'History';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  refName: Scalars['String'];
  /** The user who make this history, should get this value from @CurrentUser */
  user?: Maybe<User>;
  /** History item description. */
  description: Scalars['String'];
  scoutCommunication?: Maybe<Scout>;
  order?: Maybe<Order>;
  ticket?: Maybe<Ticket>;
};

export type HistoryConnection = {
  __typename?: 'HistoryConnection';
  pageInfo: PageInfo;
  edges: Array<HistoryEdge>;
  totalCount: Scalars['Int'];
};

export type HistoryEdge = {
  __typename?: 'HistoryEdge';
  cursor: Scalars['String'];
  node: History;
};

export type HistoryOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
};

/** The valid reference types for history items. */
export enum HistoryReferenceType {
  Order = 'Order',
  User = 'User',
  ScoutUser = 'ScoutUser',
  Scan = 'Scan',
  Competition = 'Competition'
}

export type HoldBestAvailableSeatsInput = {
  seatsEventId: Scalars['String'];
  holdToken: Scalars['String'];
  number: Scalars['Float'];
  categories: Array<Scalars['Float']>;
};

export type HoldBestAvailableSeatsOutput = {
  __typename?: 'HoldBestAvailableSeatsOutput';
  objects: Array<Scalars['String']>;
  nextToEachOther: Scalars['Boolean'];
};

export type ImportInput = {
  file: Scalars['Upload'];
};

export type ImportOutput = {
  __typename?: 'ImportOutput';
  /** Returns information about failed lines. */
  failed: Array<FailedImportItem>;
};

export type InitScout = {
  __typename?: 'InitScout';
  seasons: Array<Season>;
  membershipTypes: Array<MembershipType>;
  events: Array<Event>;
  userTags: Array<Tag>;
  zones: Array<Zone>;
};

/** Inside fee and range. */
export type InsideFeeDetails = {
  __typename?: 'InsideFeeDetails';
  priceRangeFrom: Scalars['Float'];
  priceRangeTo: Scalars['Float'];
  insideFee: Scalars['Float'];
};

/** Inside fee and range. */
export type InsideFeeDetailsInput = {
  priceRangeFrom: Scalars['Float'];
  priceRangeTo: Scalars['Float'];
  insideFee: Scalars['Float'];
};

export type InsightsOverviewOutput = {
  __typename?: 'InsightsOverviewOutput';
  customers?: Maybe<Scalars['Float']>;
  addressableAudience?: Maybe<Scalars['Float']>;
  customerValue?: Maybe<Scalars['Float']>;
  numberOfOrders?: Maybe<Scalars['Float']>;
  returningCustomers?: Maybe<Scalars['Float']>;
  referralLinksCreated?: Maybe<Scalars['Float']>;
  newReferredCustomers?: Maybe<Scalars['Float']>;
};

export type Integration = {
  __typename?: 'Integration';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Integration type */
  type: IntegrationType;
  /** Integration name */
  name: Scalars['String'];
  /** External public key (can be used in customer frontend) */
  publicKey?: Maybe<Scalars['String']>;
  /** Webhook URL to point integration to */
  webhookUrl?: Maybe<Scalars['String']>;
  /** Transaction fee type. */
  transactionFeeType?: Maybe<FeeType>;
  /** Transaction fee. */
  transactionFee?: Maybe<Scalars['Float']>;
  /** Transaction fee type(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFeeType2?: Maybe<FeeType>;
  /** Transaction fee(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFee2?: Maybe<Scalars['Float']>;
  /** If payment gateways have different option types this field is used to specify which one to force */
  paymentMethodType?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
  /** Internal API key (should not be shared) */
  secretKey?: Maybe<Scalars['String']>;
  /** External secret key (should not be shared) */
  apiKey?: Maybe<Scalars['String']>;
  /** External secret key for Windcave PxPost. */
  wcPxPostSecretKey?: Maybe<Scalars['String']>;
  /** External public key for Windcave PxPost. */
  wcPxPostPublicKey?: Maybe<Scalars['String']>;
};

/** Integration group. */
export enum IntegrationGroup {
  Payment = 'PAYMENT',
  Ecommerce = 'ECOMMERCE',
  Crm = 'CRM',
  Marketing = 'MARKETING',
  Social = 'SOCIAL',
  Accounting = 'ACCOUNTING'
}

/** Integration type. */
export enum IntegrationType {
  PaymentStripe = 'PAYMENT_STRIPE',
  PaymentWindcave = 'PAYMENT_WINDCAVE',
  PaymentLaybuy = 'PAYMENT_LAYBUY',
  PaymentMpaisa = 'PAYMENT_MPAISA',
  PaymentPin = 'PAYMENT_PIN',
  EcommerceShopify = 'ECOMMERCE_SHOPIFY',
  ReportingShopify = 'REPORTING_SHOPIFY',
  CrmKore = 'CRM_KORE',
  CrmCustom = 'CRM_CUSTOM',
  CrmUssegment = 'CRM_USSEGMENT',
  CrmAdobe = 'CRM_ADOBE',
  MarketingDatorama = 'MARKETING_DATORAMA',
  MarketingMailchimp = 'MARKETING_MAILCHIMP',
  SocialInstagram = 'SOCIAL_INSTAGRAM',
  AccountingXero = 'ACCOUNTING_XERO'
}

export type IntegrationWhereInput = {
  group?: Maybe<IntegrationGroup>;
};

export type JoinWaitlistInput = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  usableForMarketing: Scalars['Boolean'];
  eventId: Scalars['String'];
  referralCode?: Maybe<Scalars['String']>;
};


/** Landing page options. */
export enum LandingPage {
  MultiEvent = 'MultiEvent',
  SingleEvent = 'SingleEvent',
  Tours = 'Tours'
}

/** Order line items */
export type LineItem = {
  __typename?: 'LineItem';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Item type. */
  type: LineItemType;
  /** Ticket type. Only available for ticket type line items. */
  ticketType?: Maybe<TicketType>;
  /** The release associated with the line item. Returns null if the line item is not bound to a release. */
  release?: Maybe<Release>;
  /** Membership type. Only available for membership type line items. */
  membershipType?: Maybe<MembershipType>;
  /** Event addon. Only available for addon line items. */
  eventAddon?: Maybe<EventAddon>;
  /** Membership addon. Only available for addon line items. */
  membershipAddon?: Maybe<MembershipAddon>;
  /** Seat label. Only available for ticket type line items. */
  seatLabel?: Maybe<Scalars['String']>;
  /** Seat zone. Only available for ticket type line items. */
  seatZone?: Maybe<Scalars['String']>;
  seatZoneEntity?: Maybe<Zone>;
  /** Seat section. Only available for ticket type line items. */
  seatSection?: Maybe<Scalars['String']>;
  seatSectionEntity?: Maybe<Section>;
  /** Seat type. Only available for seated events. */
  seatType?: Maybe<SeatType>;
  /** Seat tags. Only available for ticket type line items. */
  seatTags?: Maybe<Array<Scalars['String']>>;
  /** Item name. */
  name: Scalars['String'];
  /** Price of the line item with discounts applied. */
  price: Scalars['Float'];
  /** Price of the line item with discounts applied. */
  stadiumLevyFee?: Maybe<Scalars['Float']>;
  /** Original price of the line item without any discounts applied. */
  originalPrice: Scalars['Float'];
  /** Item quantity. */
  quantity: Scalars['Float'];
  /** Ticket fee type. */
  ticketFeeType?: Maybe<FeeType>;
  /** Item ticket fee. */
  ticketFee?: Maybe<Scalars['Float']>;
  /** Tax rate applied to the item. */
  taxRate: Scalars['Float'];
  isComp: Scalars['Boolean'];
  pointItem?: Maybe<PointItem>;
  /** Calculated ticket fee amount (for 1 ticket) */
  ticketFeeAmount?: Maybe<Scalars['Float']>;
  /** Total amount: quantity * (price + ticketFee) */
  total: Scalars['Float'];
  taxAmount: Scalars['Float'];
  /** Subtotal: total - taxAmount */
  subtotal: Scalars['Float'];
};

/** Action to perform on line item */
export enum LineItemAction {
  Delete = 'DELETE',
  Update = 'UPDATE',
  Complete = 'COMPLETE'
}

export type LineItemActionInput = {
  /** ID of the line item in the order. */
  id: Scalars['String'];
  /** Action to perform on the line item. */
  action: LineItemAction;
  /** New ticket or membership type ID (only relevant for `UPDATE`). */
  ticketOrMembershipTypeId?: Maybe<Scalars['String']>;
};

export type LineItemConnection = {
  __typename?: 'LineItemConnection';
  pageInfo: PageInfo;
  edges: Array<LineItemEdge>;
  totalCount: Scalars['Int'];
};

export type LineItemEdge = {
  __typename?: 'LineItemEdge';
  cursor: Scalars['String'];
  node: LineItem;
};

export type LineItemInput = {
  /** Item type. */
  type: LineItemType;
  /** Line item quantity. */
  quantity: Scalars['Float'];
  /** Previous ticket. Only applicable for seat changes and membership renewals */
  previousTicketId?: Maybe<Scalars['String']>;
  /** Seat label. Only applicable seated venues in combination with for `ticket` and `membership` line items. */
  seatLabel?: Maybe<Scalars['String']>;
  /** Seat zone. Only applicable to non-seated venues in combination for `ticket` and `membership` line items. */
  seatZone?: Maybe<Scalars['String']>;
  seatType?: Maybe<Scalars['String']>;
  /** Seat tags. Only available for ticket type line items. */
  seatTags?: Maybe<Array<Scalars['String']>>;
  /** Seat section. Only available for ticket type line items. */
  seatSection?: Maybe<Scalars['String']>;
  /** Ticket type. Only applicable for `ticket` line items. */
  ticketTypeId?: Maybe<Scalars['String']>;
  /** Membership type. Only applicable for `membership` line items. */
  membershipTypeId?: Maybe<Scalars['String']>;
  /** Addon id. Only applicable for `addon` line items. */
  addonId?: Maybe<Scalars['String']>;
  /** Ticket transfer id. Only applicable for `ticket` line items in a ticket transfer order. */
  ticketTransferId?: Maybe<Scalars['String']>;
  pointItemId?: Maybe<Scalars['String']>;
  /** Price of the line item with discounts applied. Only used for ticket transfers. */
  price?: Maybe<Scalars['Float']>;
};

export type LineItemsToCompleteInput = {
  /** Quantity of tickets to keep on each line item. */
  items: Array<LineItemToCompleteInput>;
  /** Selected payment method if order status is paid (allowed: cash, eftpos, invoice, other). */
  method: PaymentProvider;
  /** Will not send order confirmation email if set */
  skipOrderConfirmation: Scalars['Boolean'];
};

export type LineItemToCompleteInput = {
  /** ID of the line item in the order. */
  id: Scalars['String'];
  /** Quantity of tickets to keep on each line item. */
  quantity: Scalars['Int'];
};

export enum LineItemType {
  Ticket = 'Ticket',
  Membership = 'Membership',
  Addon = 'Addon',
  Point = 'Point',
  MembershipSingleEventTicket = 'MembershipSingleEventTicket'
}

export type LinkedAccountRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  newAccountPassword: Scalars['String'];
  token: Scalars['String'];
};

export type LinkedAccountUser = {
  __typename?: 'LinkedAccountUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  hasVerifiedEmail: Scalars['Boolean'];
  organizationSlugs: Array<Scalars['String']>;
};

export type ListedReleaseOptionsInput = {
  askHowDidYouHearAboutUs?: Maybe<Scalars['Boolean']>;
  askForDietaryRequirements?: Maybe<Scalars['Boolean']>;
  startCondition?: Maybe<ReleaseStartCondition>;
  startConditionDate?: Maybe<Scalars['DateTime']>;
  endCondition?: Maybe<ReleaseEndCondition>;
  endConditionDate?: Maybe<Scalars['DateTime']>;
  endConditionQuantity?: Maybe<Scalars['Float']>;
};

export type LocationOutput = {
  __typename?: 'LocationOutput';
  city: Scalars['String'];
  count: Scalars['String'];
  amount?: Maybe<Scalars['Float']>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
};

/** Organization marketing settings. */
export type Marketing = {
  __typename?: 'Marketing';
  /** Google Tag Manager ID */
  gtmId?: Maybe<Scalars['String']>;
  /** Facebook Pixel ID */
  pixelId?: Maybe<Scalars['String']>;
};

export type MarketingFiltersInput = {
  ids: Array<Scalars['String']>;
  criteria?: Maybe<BroadcastFilterCriteria>;
  filterType: BroadcastFilterType;
};

/** Organization marketing settings. */
export type MarketingInput = {
  /** Google Tag Manager ID */
  gtmId?: Maybe<Scalars['String']>;
  /** Facebook Pixel ID */
  pixelId?: Maybe<Scalars['String']>;
};

export type Membership = {
  __typename?: 'Membership';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Name of the membership. */
  name: Scalars['String'];
  membershipKind: MembershipKind;
  /** The start date of the membership. */
  startDate: Scalars['DateTime'];
  /** The end date of the membership. */
  endDate: Scalars['DateTime'];
  /** The booking fee type of the membership. */
  bookingFeeType: FeeType;
  /** The booking fee for the membership. */
  bookingFee: Scalars['Float'];
  /** Shipping options of the membership. */
  shippingOptions?: Maybe<ShippingOptions>;
  /** The description of the membership. */
  description: Scalars['String'];
  /** The thumbnail associated with the membership. */
  thumbnail?: Maybe<ExtendedFile>;
  backgroundImage?: Maybe<ExtendedFile>;
  descriptionImage?: Maybe<ExtendedFile>;
  /** The banner associated with the membership. */
  banner?: Maybe<ExtendedFile>;
  printBanner1?: Maybe<ExtendedFile>;
  printBanner2?: Maybe<ExtendedFile>;
  /** The payment gateways enabled for the event. */
  gateways?: Maybe<Array<Integration>>;
  /** Whether naming a membership is available. */
  canNameMembership: Scalars['Boolean'];
  /** Whether renaming a membership is available. */
  canRenameMembership: Scalars['Boolean'];
  /** Whether naming a membership is available. */
  canChangeSeats: Scalars['Boolean'];
  /** The renaming fee for the membership. */
  renamingFee?: Maybe<Scalars['Float']>;
  /** The fee for changing seats for the membership. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The active status of the membership. */
  isActive: Scalars['Boolean'];
  events?: Maybe<Array<Event>>;
  membershipZones: Array<MembershipZone>;
  /** The terms and conditions of the membership */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Important notice section on the tickets */
  importantNotice?: Maybe<Scalars['String']>;
  /** The accessibility info of the membership */
  accessibility?: Maybe<Scalars['String']>;
  /** The accessibility info of the membership */
  invoiceInformation?: Maybe<Scalars['String']>;
  /** Whether the schedule is shown on the customer portal */
  showSchedule?: Maybe<Scalars['Boolean']>;
  /** The referral campaign associated with this membership */
  referralCampaignId?: Maybe<Scalars['String']>;
  /** Email address that gets sent a notifcation every time an order is completed */
  emailNotification?: Maybe<Scalars['String']>;
  /** Flag to determine if the membership is hidden from the public */
  hiddenFromPublic: Scalars['Boolean'];
  /** Flag to issue the value of the membership as credit on sale */
  issueCreditOnSale: Scalars['Boolean'];
  canUsePoints: Scalars['Boolean'];
  enableAutoRenew: Scalars['Boolean'];
  canTransferTickets: Scalars['Boolean'];
  types: Array<MembershipType>;
  renewalMembership?: Maybe<Membership>;
  previousMemberships: Array<Membership>;
  season?: Maybe<Season>;
  /** The venue associated with the membership. */
  venue?: Maybe<Venue>;
  addons: Array<MembershipAddon>;
  membershipHoldersCount?: Maybe<Scalars['Float']>;
  multiBuyPromotions: Array<MembershipMultiBuyPromotion>;
  digitalPassCodesStatus?: Maybe<DigitalPassCodeStatusOutput>;
  digitalInfo?: Maybe<DigitalInfo>;
  ticketSoldTime?: Maybe<TicketSoldTime>;
  tags: Array<Tag>;
  hasPromoCodes: Scalars['Boolean'];
};

export type MembershipAddon = {
  __typename?: 'MembershipAddon';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The name of the addon. */
  name: Scalars['String'];
  /** Indicates whether naming the addon is possible or not. */
  enableNaming: Scalars['Boolean'];
  /** Maximum quantity to be sold for the addon. */
  quantity: Scalars['Float'];
  /** The price associated with the addon. */
  price: Scalars['Float'];
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive: Scalars['Boolean'];
  namingFields: Array<FormField>;
  /** Image to be shown on the customer portal of the addon . Returns null if the not set. */
  addonImage?: Maybe<ExtendedFile>;
};

export type MembershipConnection = {
  __typename?: 'MembershipConnection';
  pageInfo: PageInfo;
  edges: Array<MembershipEdge>;
  totalCount: Scalars['Int'];
};

export type MembershipEdge = {
  __typename?: 'MembershipEdge';
  cursor: Scalars['String'];
  node: Membership;
};

export enum MembershipKind {
  Standard = 'Standard',
  Digital = 'Digital'
}

export type MembershipMultiBuyPromotion = {
  __typename?: 'MembershipMultiBuyPromotion';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  buyQuantity: Scalars['Float'];
  getQuantity: Scalars['Float'];
  price: Scalars['Float'];
  buyMembershipType?: Maybe<MembershipType>;
  getMembershipType?: Maybe<MembershipType>;
};

export type MembershipOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
  startDate?: Maybe<OrderByDirection>;
  endDate?: Maybe<OrderByDirection>;
};

export type MembershipPromoCode = {
  __typename?: 'MembershipPromoCode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The unique code that represents the promotion. */
  code: Scalars['String'];
  /** The discount type associated with the promotion. */
  discountType: DiscountType;
  /** The discount amount of the promotion. */
  discountAmount: Scalars['Float'];
  /** The type of the promotion which determines on which items the promotion will be applied. */
  type: MembershipPromoCodeType;
  membershipTypes?: Maybe<Array<Scalars['String']>>;
  /** The total amount of usage of the promotion. */
  used?: Maybe<Scalars['Int']>;
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
};

export enum MembershipPromoCodeType {
  MembershipAndAddons = 'MEMBERSHIP_AND_ADDONS',
  Membership = 'MEMBERSHIP',
  Addons = 'ADDONS'
}

/** Represents a membership type in a seating zone. */
export type MembershipSeatingZoneType = {
  __typename?: 'MembershipSeatingZoneType';
  /** The price of the zone ticket. Returns null if `pricingLevel` of the parent is set to other than `zone`. */
  price?: Maybe<Scalars['Float']>;
  /** The sections of the zone ticket. Returns null if `pricingLevel` of the parent is set to other than `section`. */
  sections?: Maybe<Array<ZonePricingTypeSection>>;
  /** The active status of the zone ticket. Defaults to `false`. */
  isActive: Scalars['Boolean'];
  /** The membership type id of the membership zone. */
  membershipTypeId: Scalars['String'];
};

export type MembershipType = {
  __typename?: 'MembershipType';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The kind of the membership type. */
  kind: MembershipTypeKind;
  /** Name of the membership type. */
  name: Scalars['String'];
  /** The ticket fee type. */
  ticketFeeType: FeeType;
  /** The ticket fee. */
  ticketFee: Scalars['Float'];
  /** Restrictions for the membership type. */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the membership type. */
  restrictions?: Maybe<Scalars['String']>;
  namingFields: Array<FormField>;
  membership: Membership;
};

export type MembershipTypeEventTransferPrice = {
  __typename?: 'MembershipTypeEventTransferPrice';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  membership: Membership;
  membershipType: MembershipType;
  membershipZone: MembershipZone;
  event: Event;
  maxSalePrice: Scalars['Float'];
};

/** Membership kind for membership type. */
export enum MembershipTypeKind {
  Standard = 'STANDARD',
  ComplimentaryNamed = 'COMPLIMENTARY_NAMED',
  ComplimentaryUnnamed = 'COMPLIMENTARY_UNNAMED',
  Addon = 'ADDON'
}

export type MembershipTypeTransferPriceInput = {
  eventId: Scalars['String'];
  maxSalePrice: Scalars['Float'];
};

export type MembershipWhereInput = {
  /** Membership active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
};

export type MembershipZone = {
  __typename?: 'MembershipZone';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  zone: Zone;
  /** The pricing level of the zone. Will be set to `zone` for non-seated events. */
  pricingLevel: ZonePricingLevel;
  /** The active status of the zone. Defaults to `false`. */
  isActive: Scalars['Boolean'];
  /** The list of ticket types of the release zone. */
  membershipTypes: Array<MembershipSeatingZoneType>;
};

/** The zone belonging to a release zone */
export type MembershipZoneZoneInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Represents the overview of mentions. */
export type MentionOverview = {
  __typename?: 'MentionOverview';
  commentMentionCount: Scalars['Float'];
  mediaMentionCount: Scalars['Float'];
  storyMentionCount: Scalars['Float'];
};

export type MentionOverviewInput = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};

export type MetaData = {
  __typename?: 'MetaData';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
};

export type MultiBuyPromotionUnion = EventMultiBuyPromotion | MembershipMultiBuyPromotion;

export type Mutation = {
  __typename?: 'Mutation';
  register: Scalars['Boolean'];
  linkedAccountLogin: LinkedAccountUser;
  linkedAccountRegister: LinkedAccountUser;
  initiateLinkedAccountRegistration: Scalars['Boolean'];
  login: User;
  socialAuth: User;
  logout: Scalars['Boolean'];
  requestMagicLink: Scalars['Boolean'];
  getMagicLink: Scalars['String'];
  requestDeleteAccount: Scalars['Boolean'];
  sendMemberRenewalEmail: Scalars['Boolean'];
  verifyMagicLink: VerifyMagicLinkOutput;
  verifyToken: VerifyMagicLinkOutput;
  requestResetPassword: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  setPasswordForNewUser: Scalars['Boolean'];
  updatePassword: Scalars['Boolean'];
  assignTwoFactorAuthenticationSecret: TwoFactorAuthenticationSetupResult;
  removeTwoFactorAuthenticationSecret: Scalars['Boolean'];
  enableTwoFactorAuthentication: Scalars['Boolean'];
  authenticateWithTwoFactor: User;
  sendTwoFactorCodeViaSMSMessage: Scalars['Boolean'];
  /** Creates a user. */
  createUser: User;
  createPosUser: User;
  createTemporaryPosUser: CreateTemporaryPosUserOutput;
  updatePosUser: User;
  /** Updates a user. */
  updateUser: User;
  /** Deletes a user. */
  deleteUser: DeleteOneOutput;
  /** Delete yourself. */
  deleteSelf: DeleteOneOutput;
  /** Updates the current user. */
  updateProfile: User;
  unsubscribeFromMarketing: User;
  resubscribe: User;
  addUnsubscribeReason: User;
  /** Sends an invite to an existing user. */
  sendUserInvite: User;
  /** Sends invitations to existing users based on CSV file. */
  importAndInviteUsers: ImportOutput;
  updateCreditsForUser: User;
  createPos: Pos;
  updateForecast: EventForecastOutput;
  addForecastScenario: EventForecastOutput;
  deleteForecastScenario: EventForecastOutput;
  createEvent: Event;
  updateEvent: Event;
  duplicateEvent: Scalars['String'];
  createTicketType: TicketType;
  updateTicketType: TicketType;
  deleteTicketType: DeleteOneOutput;
  createRelease: Release;
  updateRelease: Release;
  deleteRelease: DeleteOneOutput;
  holdBestAvailableSeats: HoldBestAvailableSeatsOutput;
  validateReleasePasswordOrRelease: Release;
  validateReleasePassword: ReleasePassword;
  importReleasePasswords: Scalars['Boolean'];
  duplicateAllReleases: Release;
  duplicateSingleRelease: Release;
  createEventPromoCode: EventPromoCode;
  updateEventPromoCode: EventPromoCode;
  deleteEventPromoCode: DeleteOneOutput;
  createEventMultiBuyPromotion: EventMultiBuyPromotion;
  updateEventMultiBuyPromotion: EventMultiBuyPromotion;
  deleteEventMultiBuyPromotion: DeleteOneOutput;
  createEventAddon: EventAddon;
  updateEventAddon: EventAddon;
  deleteEventAddon: DeleteOneOutput;
  createReleaseZone: Array<Release>;
  updateReleaseZone: ReleaseZone;
  deleteReleaseZone: Scalars['Boolean'];
  reorderTicketTypes: ReleaseZone;
  createSeason: Season;
  updateSeason: Season;
  createIntegration: Integration;
  updateIntegration: Integration;
  rollIntegrationApiKey: Integration;
  setXeroAccountCode: Scalars['Boolean'];
  enableXeroIntegration: Scalars['Boolean'];
  completeShopifySetup: Scalars['Boolean'];
  upsertAdobeIntegration: AdobeExperiencePlatformIntegration;
  createOrganization: CreateOrganizationOutput;
  updateOrganization: Organization;
  updateOrganizationById: Organization;
  uploadImage: Scalars['JSON'];
  createOrder: Order;
  updateOrder: Order;
  updateHoldOrder: Order;
  splitHoldOrder: Order;
  releaseSeats: Order;
  createPayment: CreatePaymentOutput;
  applyPromoCodeToOrder: Order;
  updateTicketCoverForOrder: Order;
  removePromoCodeFromOrder: Order;
  holdCustomerOrder: Order;
  updateOrderStatus: Order;
  completePreprintTicketOrder: Order;
  addPosTransaction: Order;
  removePosTransaction: Order;
  finishPosTransaction: Order;
  sendOrderConfirmation: SendOrderConfirmationOutput;
  sendInternalOrderReceipt: SendOrderConfirmationOutput;
  cancelOrder: Order;
  expireOrder: Order;
  splitGroupOrder: Order;
  createBulkOrders: Scalars['Boolean'];
  createRefund: Refund;
  createPurchaseRestriction: PurchaseRestriction;
  updatePurchaseRestriction: PurchaseRestriction;
  deletePurchaseRestriction: DeleteOneOutput;
  createHistory: History;
  createVenue: Venue;
  updateVenue: Venue;
  /** Update zones based on seatsChartKey. */
  updateVenueZones: Venue;
  deleteVenue: DeleteOneOutput;
  updateVenueCapacity: Scalars['Boolean'];
  reorderZones: Array<Zone>;
  createMembership: Membership;
  updateMembership: Membership;
  importPurchasedMemberships: ImportOutput;
  duplicateMembership: Scalars['String'];
  upsertMembershipTypeEventTransferPrices: Array<MembershipTypeEventTransferPrice>;
  createMembershipType: MembershipType;
  updateMembershipType: MembershipType;
  deleteMembershipType: DeleteOneOutput;
  createMembershipAddon: MembershipAddon;
  updateMembershipAddon: MembershipAddon;
  deleteMembershipAddon: DeleteOneOutput;
  createMembershipPromoCode: MembershipPromoCode;
  updateMembershipPromoCode: MembershipPromoCode;
  deleteMembershipPromoCode: DeleteOneOutput;
  createMembershipMultiBuyPromotion: MembershipMultiBuyPromotion;
  updateMembershipMultiBuyPromotion: MembershipMultiBuyPromotion;
  deleteMembershipMultiBuyPromotion: DeleteOneOutput;
  createScout: Scout;
  updateScout: Scout;
  updateScoutUsers: Scalars['Boolean'];
  deleteScoutUsers: Scalars['Boolean'];
  createScoutCommunication: ScoutCommunication;
  updateScoutCommunication: ScoutCommunication;
  createTestEmail: Scalars['Boolean'];
  updateScoutCommunicationUser: ScoutCommunicationUser;
  addReminderToScoutCommunicationUser: Scalars['Boolean'];
  clearReminderFromScoutCommunicationUser: Scalars['Boolean'];
  assignScoutCommunicationUsersToAgent: Scalars['Boolean'];
  createTag: Tag;
  updateTag: Tag;
  tagEntities: Array<Scalars['String']>;
  deleteTag: Scalars['Boolean'];
  updateTicketHolder: Ticket;
  increaseDownloadCount: Scalars['Boolean'];
  releaseClaimsForNextMembership: Array<Ticket>;
  claimTicketsForMembership: Array<ClaimTicketOutput>;
  syncTicketWithSeatsIo: Scalars['Boolean'];
  requestTicketTransfer: Scalars['Boolean'];
  cancelPendingTicketTransfer: Scalars['Boolean'];
  scanTicket: ScanTicketOutput;
  redeemTicket: ScanTicketOutput;
  scanVaccinePass: Scalars['Boolean'];
  scanTicketBulk: Array<ScanTicketOutput>;
  importDigitalPassCodesForEvent: Scalars['Boolean'];
  importDigitalPassCodesForMembership: Scalars['Boolean'];
  createPinPaymentCharge: PinPaymentChargeResponse;
  verifyPinPayment3DS: PinPaymentChargeResponse;
  handleInstagramCode: Scalars['String'];
  createPoint: Point;
  updatePoint: Point;
  createPointItem: PointItem;
  updatePointItem: PointItem;
  createAutomation: Automation;
  updateAutomation: Automation;
  setPromoterSettings: PromoterSettings;
  createReferralCampaign: ReferralCampaign;
  updateReferralCampaign: ReferralCampaign;
  createReferralRewards: Array<ReferralReward>;
  createRedirectUrl: RedirectUrl;
  createCompetition: Competition;
  updateCompetition: Competition;
  unpublishCompetition: Competition;
  deleteCompetition: Scalars['Boolean'];
  updateAndPublishCompetition: Competition;
  grantCompetitionReward?: Maybe<CompetitionReward>;
  broadcastReportingLinkOpened: Scalars['Boolean'];
  broadcastReportingOrderCreated: Scalars['Boolean'];
  broadcastReportingSetAsSpamFromUser: Scalars['Boolean'];
  deleteBroadcast: DeleteOneOutput;
  sendBroadcast: Scalars['Boolean'];
  joinWaitlist: Waitlist;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationLinkedAccountLoginArgs = {
  input: LoginInput;
};


export type MutationLinkedAccountRegisterArgs = {
  input: LinkedAccountRegisterInput;
};


export type MutationInitiateLinkedAccountRegistrationArgs = {
  input: LoginInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationSocialAuthArgs = {
  input: SocialAuthInput;
};


export type MutationRequestMagicLinkArgs = {
  input: RequestMagicLinkInput;
};


export type MutationGetMagicLinkArgs = {
  input: RequestMagicLinkInput;
};


export type MutationRequestDeleteAccountArgs = {
  input: RequestMagicLinkInput;
};


export type MutationSendMemberRenewalEmailArgs = {
  id: Scalars['String'];
};


export type MutationVerifyMagicLinkArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyTokenArgs = {
  input: VerifyEmailInput;
};


export type MutationRequestResetPasswordArgs = {
  input: RequestResetPasswordInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSetPasswordForNewUserArgs = {
  input: SetPasswordForNewUserInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationEnableTwoFactorAuthenticationArgs = {
  input: TwoFactorAuthenticationCodeInput;
};


export type MutationAuthenticateWithTwoFactorArgs = {
  input: TwoFactorAuthenticationCodeInput;
};


export type MutationCreateUserArgs = {
  sendInvite: Scalars['Boolean'];
  input: CreateUserInput;
};


export type MutationCreatePosUserArgs = {
  input: CreatePosUserInput;
};


export type MutationCreateTemporaryPosUserArgs = {
  input: CreateTemporaryPosUserInput;
};


export type MutationUpdatePosUserArgs = {
  input: UpdatePosUserInput;
  id: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
  id: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String'];
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUnsubscribeFromMarketingArgs = {
  userId: Scalars['String'];
};


export type MutationResubscribeArgs = {
  userId: Scalars['String'];
};


export type MutationAddUnsubscribeReasonArgs = {
  input: AddUnsubscribeReasonInput;
};


export type MutationSendUserInviteArgs = {
  id: Scalars['String'];
};


export type MutationImportAndInviteUsersArgs = {
  input: ImportInput;
};


export type MutationUpdateCreditsForUserArgs = {
  input: UpdateCreditsInput;
  userId: Scalars['String'];
};


export type MutationCreatePosArgs = {
  input: CreatePosInput;
};


export type MutationUpdateForecastArgs = {
  input: UpdateForecastInput;
  id: Scalars['String'];
};


export type MutationAddForecastScenarioArgs = {
  id: Scalars['String'];
};


export type MutationDeleteForecastScenarioArgs = {
  forecastId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationUpdateEventArgs = {
  sendTicketViewableEmails?: Maybe<Scalars['Boolean']>;
  input: UpdateEventInput;
  id: Scalars['String'];
};


export type MutationDuplicateEventArgs = {
  id: Scalars['String'];
};


export type MutationCreateTicketTypeArgs = {
  input: CreateTicketTypeInput;
};


export type MutationUpdateTicketTypeArgs = {
  id: Scalars['String'];
  input: UpdateTicketTypeInput;
};


export type MutationDeleteTicketTypeArgs = {
  id: Scalars['String'];
};


export type MutationCreateReleaseArgs = {
  input: CreateReleaseInput;
};


export type MutationUpdateReleaseArgs = {
  input: UpdateReleaseInput;
  id: Scalars['String'];
};


export type MutationDeleteReleaseArgs = {
  id: Scalars['String'];
};


export type MutationHoldBestAvailableSeatsArgs = {
  input: HoldBestAvailableSeatsInput;
};


export type MutationValidateReleasePasswordOrReleaseArgs = {
  password: Scalars['String'];
  eventId: Scalars['String'];
};


export type MutationValidateReleasePasswordArgs = {
  password: Scalars['String'];
  id: Scalars['String'];
};


export type MutationImportReleasePasswordsArgs = {
  input: ImportInput;
  id: Scalars['String'];
};


export type MutationDuplicateAllReleasesArgs = {
  input: DuplicateAllReleasesInput;
};


export type MutationDuplicateSingleReleaseArgs = {
  input: DuplicateSingleReleaseInput;
};


export type MutationCreateEventPromoCodeArgs = {
  input: CreateEventPromoCodeInput;
};


export type MutationUpdateEventPromoCodeArgs = {
  input: UpdateEventPromoCodeInput;
  id: Scalars['String'];
};


export type MutationDeleteEventPromoCodeArgs = {
  id: Scalars['String'];
};


export type MutationCreateEventMultiBuyPromotionArgs = {
  input: CreateEventMultiBuyPromotionInput;
};


export type MutationUpdateEventMultiBuyPromotionArgs = {
  id: Scalars['String'];
  input: UpdateEventMultiBuyPromotionInput;
};


export type MutationDeleteEventMultiBuyPromotionArgs = {
  id: Scalars['String'];
};


export type MutationCreateEventAddonArgs = {
  input: CreateEventAddonInput;
};


export type MutationUpdateEventAddonArgs = {
  id: Scalars['String'];
  input: UpdateEventAddonInput;
};


export type MutationDeleteEventAddonArgs = {
  id: Scalars['String'];
};


export type MutationCreateReleaseZoneArgs = {
  input: CreateReleaseZoneInput;
};


export type MutationUpdateReleaseZoneArgs = {
  input: UpdateReleaseZoneInput;
  id: Scalars['String'];
};


export type MutationDeleteReleaseZoneArgs = {
  id: Scalars['String'];
};


export type MutationReorderTicketTypesArgs = {
  input: ReorderTicketTypeInput;
};


export type MutationCreateSeasonArgs = {
  input: CreateSeasonInput;
};


export type MutationUpdateSeasonArgs = {
  input: UpdateSeasonInput;
  id: Scalars['String'];
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationUpdateIntegrationArgs = {
  input: UpdateIntegrationInput;
  id: Scalars['String'];
};


export type MutationRollIntegrationApiKeyArgs = {
  id: Scalars['String'];
};


export type MutationSetXeroAccountCodeArgs = {
  accountCode: Scalars['String'];
};


export type MutationEnableXeroIntegrationArgs = {
  input: XeroCallbackInput;
};


export type MutationCompleteShopifySetupArgs = {
  input: ShopifySetupInput;
};


export type MutationUpsertAdobeIntegrationArgs = {
  input: AdobeExperiencePlatformIntegrationInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationByIdArgs = {
  input: UpdateOrganizationInput;
  id: Scalars['String'];
};


export type MutationUploadImageArgs = {
  file: ImportInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
  id: Scalars['String'];
};


export type MutationUpdateHoldOrderArgs = {
  input: UpdateHoldOrderInput;
  id: Scalars['String'];
};


export type MutationSplitHoldOrderArgs = {
  input: SplitOrderInput;
  id: Scalars['String'];
};


export type MutationReleaseSeatsArgs = {
  input: ReleaseSeatsInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
  id: Scalars['String'];
};


export type MutationApplyPromoCodeToOrderArgs = {
  input: ApplyPromoCode;
  id: Scalars['String'];
};


export type MutationUpdateTicketCoverForOrderArgs = {
  input: UpdateOrderTicketCoverInput;
  id: Scalars['String'];
};


export type MutationRemovePromoCodeFromOrderArgs = {
  id: Scalars['String'];
};


export type MutationHoldCustomerOrderArgs = {
  id: Scalars['String'];
};


export type MutationUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
  id: Scalars['String'];
};


export type MutationCompletePreprintTicketOrderArgs = {
  input: LineItemsToCompleteInput;
  id: Scalars['String'];
};


export type MutationAddPosTransactionArgs = {
  input: AddPosTransactionInput;
  id: Scalars['String'];
};


export type MutationRemovePosTransactionArgs = {
  posTransactionId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationFinishPosTransactionArgs = {
  id: Scalars['String'];
};


export type MutationSendOrderConfirmationArgs = {
  input: SendOrderConfirmationInput;
  id: Scalars['String'];
};


export type MutationSendInternalOrderReceiptArgs = {
  id: Scalars['String'];
};


export type MutationCancelOrderArgs = {
  id: Scalars['String'];
};


export type MutationExpireOrderArgs = {
  id: Scalars['String'];
};


export type MutationSplitGroupOrderArgs = {
  input: SplitOrderInput;
  id: Scalars['String'];
};


export type MutationCreateBulkOrdersArgs = {
  input: ImportInput;
  createdById: Scalars['String'];
};


export type MutationCreateRefundArgs = {
  input: CreateRefundInput;
};


export type MutationCreatePurchaseRestrictionArgs = {
  input: CreatePurchaseRestrictionInput;
};


export type MutationUpdatePurchaseRestrictionArgs = {
  id: Scalars['String'];
  input: CreatePurchaseRestrictionInput;
};


export type MutationDeletePurchaseRestrictionArgs = {
  id: Scalars['String'];
};


export type MutationCreateHistoryArgs = {
  input: CreateHistoryInput;
};


export type MutationCreateVenueArgs = {
  input: CreateVenueInput;
};


export type MutationUpdateVenueArgs = {
  input: UpdateVenueInput;
  id: Scalars['String'];
};


export type MutationUpdateVenueZonesArgs = {
  id: Scalars['String'];
};


export type MutationDeleteVenueArgs = {
  id: Scalars['String'];
};


export type MutationUpdateVenueCapacityArgs = {
  capacity: Scalars['Int'];
  id: Scalars['String'];
};


export type MutationReorderZonesArgs = {
  input: ReorderZoneInput;
};


export type MutationCreateMembershipArgs = {
  input: CreateMembershipInput;
};


export type MutationUpdateMembershipArgs = {
  input: UpdateMembershipInput;
  id: Scalars['String'];
};


export type MutationImportPurchasedMembershipsArgs = {
  input: ImportInput;
};


export type MutationDuplicateMembershipArgs = {
  id: Scalars['String'];
};


export type MutationUpsertMembershipTypeEventTransferPricesArgs = {
  input: Array<UpdateMembershipTypeEventTransferPriceInput>;
  id: Scalars['String'];
};


export type MutationCreateMembershipTypeArgs = {
  input: CreateMembershipTypeInput;
};


export type MutationUpdateMembershipTypeArgs = {
  input: UpdateMembershipTypeInput;
  id: Scalars['String'];
};


export type MutationDeleteMembershipTypeArgs = {
  id: Scalars['String'];
};


export type MutationCreateMembershipAddonArgs = {
  input: CreateMembershipAddonInput;
};


export type MutationUpdateMembershipAddonArgs = {
  id: Scalars['String'];
  input: UpdateMembershipAddonInput;
};


export type MutationDeleteMembershipAddonArgs = {
  id: Scalars['String'];
};


export type MutationCreateMembershipPromoCodeArgs = {
  input: CreateMembershipPromoCodeInput;
};


export type MutationUpdateMembershipPromoCodeArgs = {
  input: UpdateMembershipPromoCodeInput;
  id: Scalars['String'];
};


export type MutationDeleteMembershipPromoCodeArgs = {
  id: Scalars['String'];
};


export type MutationCreateMembershipMultiBuyPromotionArgs = {
  input: CreateMembershipMultiBuyPromotionInput;
};


export type MutationUpdateMembershipMultiBuyPromotionArgs = {
  id: Scalars['String'];
  input: UpdateMembershipMultiBuyPromotionInput;
};


export type MutationDeleteMembershipMultiBuyPromotionArgs = {
  id: Scalars['String'];
};


export type MutationCreateScoutArgs = {
  input: CreateScoutInput;
};


export type MutationUpdateScoutArgs = {
  input: UpdateScoutInput;
  id: Scalars['String'];
};


export type MutationUpdateScoutUsersArgs = {
  id: Scalars['String'];
};


export type MutationDeleteScoutUsersArgs = {
  input: DeleteScoutUserInput;
};


export type MutationCreateScoutCommunicationArgs = {
  input: CreateScoutCommunicationInput;
};


export type MutationUpdateScoutCommunicationArgs = {
  input: UpdateScoutCommunicationInput;
  id: Scalars['String'];
};


export type MutationCreateTestEmailArgs = {
  input: CreateTestEmailInput;
};


export type MutationUpdateScoutCommunicationUserArgs = {
  input: UpdateScoutCommunicationUserInput;
  id: Scalars['String'];
};


export type MutationAddReminderToScoutCommunicationUserArgs = {
  input: AddReminderToScoutCommunicationUserInput;
  id: Scalars['String'];
};


export type MutationClearReminderFromScoutCommunicationUserArgs = {
  id: Scalars['String'];
};


export type MutationAssignScoutCommunicationUsersToAgentArgs = {
  input: AssignScoutCommunicationUsersToAgentInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
  id: Scalars['String'];
};


export type MutationTagEntitiesArgs = {
  input: TagEntitiesInput;
};


export type MutationDeleteTagArgs = {
  entityId: Scalars['String'];
  tagId: Scalars['String'];
};


export type MutationUpdateTicketHolderArgs = {
  id: Scalars['String'];
  input: UpdateTicketHolderInput;
};


export type MutationIncreaseDownloadCountArgs = {
  id: Scalars['String'];
};


export type MutationReleaseClaimsForNextMembershipArgs = {
  ids: Scalars['String'];
};


export type MutationClaimTicketsForMembershipArgs = {
  membershipId: Scalars['String'];
};


export type MutationSyncTicketWithSeatsIoArgs = {
  ticketId: Scalars['String'];
};


export type MutationRequestTicketTransferArgs = {
  input: RequestTicketTransferInput;
};


export type MutationCancelPendingTicketTransferArgs = {
  ticketId: Scalars['String'];
};


export type MutationScanTicketArgs = {
  eventId: Scalars['String'];
  input: ScanTicketInput;
};


export type MutationRedeemTicketArgs = {
  input: RedeemTicketInput;
};


export type MutationScanVaccinePassArgs = {
  payload: Scalars['String'];
  ticketId: Scalars['String'];
};


export type MutationScanTicketBulkArgs = {
  input: ScanTicketBulkInput;
};


export type MutationImportDigitalPassCodesForEventArgs = {
  input: ImportInput;
  eventId: Scalars['String'];
};


export type MutationImportDigitalPassCodesForMembershipArgs = {
  input: ImportInput;
  membershipId: Scalars['String'];
};


export type MutationCreatePinPaymentChargeArgs = {
  input: CreatePinPaymentCharge;
};


export type MutationVerifyPinPayment3DsArgs = {
  input: VerifyPinPayment3Ds;
};


export type MutationHandleInstagramCodeArgs = {
  input: HandleInstagramCodeInput;
};


export type MutationCreatePointArgs = {
  input: CreatePointInput;
};


export type MutationUpdatePointArgs = {
  input: UpdatePointInput;
};


export type MutationCreatePointItemArgs = {
  input: CreatePointItemInput;
};


export type MutationUpdatePointItemArgs = {
  input: UpdatePointItemInput;
  id: Scalars['String'];
};


export type MutationCreateAutomationArgs = {
  input: CreateAutomationInput;
};


export type MutationUpdateAutomationArgs = {
  input: UpdateAutomationInput;
  id: Scalars['String'];
};


export type MutationSetPromoterSettingsArgs = {
  input: PromoterSettingsInput;
};


export type MutationCreateReferralCampaignArgs = {
  campaign: CreateReferralCampaignDto;
};


export type MutationUpdateReferralCampaignArgs = {
  campaign: UpdateReferralCampaignDto;
};


export type MutationCreateReferralRewardsArgs = {
  rewards: CreateReferralRewardsDto;
};


export type MutationCreateRedirectUrlArgs = {
  input: CreateRedirectUrlInput;
};


export type MutationCreateCompetitionArgs = {
  input: CreateCompetitionInput;
  eventId: Scalars['String'];
};


export type MutationUpdateCompetitionArgs = {
  input: CreateCompetitionInput;
  competitionId: Scalars['String'];
};


export type MutationUnpublishCompetitionArgs = {
  competitionId: Scalars['String'];
};


export type MutationDeleteCompetitionArgs = {
  competitionId: Scalars['String'];
};


export type MutationUpdateAndPublishCompetitionArgs = {
  input: PublishCompetitionInput;
  eventId: Scalars['String'];
};


export type MutationGrantCompetitionRewardArgs = {
  input: GrantCompetitionRewardInput;
};


export type MutationBroadcastReportingLinkOpenedArgs = {
  input: BroadcastReportingOpenInput;
};


export type MutationBroadcastReportingOrderCreatedArgs = {
  input: BroadcastReportingOrderInput;
};


export type MutationBroadcastReportingSetAsSpamFromUserArgs = {
  input: BroadcastReportingSpamInput;
};


export type MutationDeleteBroadcastArgs = {
  id: Scalars['String'];
};


export type MutationSendBroadcastArgs = {
  input: SendBroadcastInput;
};


export type MutationJoinWaitlistArgs = {
  input: JoinWaitlistInput;
};

export type MyEventsOrderByInput = {
  startDate?: Maybe<OrderByDirection>;
};

export type MyEventsWhereInput = {
  /** Event start date. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Event end date. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Filter on tickets that are (not) related to a membership ticket. */
  hasParentTicket?: Maybe<Scalars['Boolean']>;
};

export type MyLoggedInOrganizationsOutput = {
  __typename?: 'MyLoggedInOrganizationsOutput';
  id: Scalars['String'];
  slug: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  isLinked: Scalars['Boolean'];
};

/** Order type */
export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Order type. */
  orderType: OrderType;
  /** The order number. */
  orderNumber: Scalars['String'];
  /** The order number. */
  currency: Scalars['String'];
  /** Indicates if the order has been handled on success (e.g. ticket creation). */
  isHandled: Scalars['Boolean'];
  /** Indicates if the order is a full comp order (all tickets are comps). */
  isComp: Scalars['Boolean'];
  /** Buyer details. */
  buyerInformation?: Maybe<BuyerInformation>;
  /** Billing address provided by the customer. */
  billingAddress?: Maybe<Address>;
  /** Shipping address provided by the customer. */
  shippingAddress?: Maybe<Address>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress: Scalars['Boolean'];
  optInForMarketingPromotions?: Maybe<Scalars['Boolean']>;
  membershipSubscriptionId?: Maybe<Scalars['String']>;
  /** The release associated with the order. Returns null if the order is not bound to a release. */
  release?: Maybe<Release>;
  /** The release password associated with the order. Returns null if the order is not bound to a release password. */
  releasePassword?: Maybe<ReleasePassword>;
  /** Indicated whether the order has been paid with a subscription. */
  paidWithSubscription: Scalars['Boolean'];
  /** Current status of the order. */
  status: OrderStatus;
  /** Channel associated with the order. */
  channel: OrderChannel;
  /** Last used payment gateway. */
  paymentGateway?: Maybe<PaymentProvider>;
  /** The status of the latest transaction status. */
  transactionStatus?: Maybe<OrderTransactionStatus>;
  orderTicketCover?: Maybe<OrderTicketCover>;
  /** Timestamp when order confirmation has been sent. */
  orderConfirmationSentAt?: Maybe<Scalars['DateTime']>;
  /** The ip address of the client that is associated with this order. */
  clientIp: Scalars['String'];
  /** Amount of credits used in the order */
  usedCredits?: Maybe<Scalars['Float']>;
  usedPoints: Scalars['Float'];
  /** Amount of credits detucted from the total for changing the seats */
  changingSeatsCredits?: Maybe<Scalars['Float']>;
  /** Fee for changing seats. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee (amount or percentage based on type). */
  bookingFee: Scalars['Float'];
  /** Calculated booking fee. */
  bookingFeeAmount: Scalars['Float'];
  /** Fee charged for ticket transfer. */
  transferFee?: Maybe<Scalars['Float']>;
  /** The delivery method chosen by the customer. */
  deliveryMethod?: Maybe<ShippingOption>;
  /** Delivery fee (based on delivery method). */
  deliveryFee?: Maybe<Scalars['Float']>;
  /** Transaction fee type. */
  transactionFeeType?: Maybe<FeeType>;
  /** Transaction fee. */
  transactionFee?: Maybe<Scalars['Float']>;
  /** Transaction fee type. */
  transactionFeeType2?: Maybe<FeeType>;
  /** Transaction fee. */
  transactionFee2?: Maybe<Scalars['Float']>;
  /** Calculated transaction fee. */
  transactionFeeAmount?: Maybe<Scalars['Float']>;
  /** Order total (including fees and taxes). */
  total: Scalars['Float'];
  /** Time after which the order will be automatically expired */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** Total amount of refunds. */
  refundedAmount: Scalars['Float'];
  /** If the order is created from order abandoned email. */
  isCreatedFromRecoveredCart: Scalars['Boolean'];
  /** Tax rate: taxRate * total */
  totalTax: Scalars['Float'];
  /** Subtotal: total - taxAmount */
  subtotal: Scalars['Float'];
  amountDue: Scalars['Float'];
  /** Whether the hardcopy tickets have been printed for an order */
  hardCopyTicketsPrinted: Scalars['Boolean'];
  /** How the customer heard about the items they are purchasing */
  heardAboutUs?: Maybe<HeardAboutUsType>;
  /** Heard about us details when heardAboutUs is other */
  heardAboutUsDetails?: Maybe<Scalars['String']>;
  /** How the customer heard about the items they are purchasing */
  dietaryRequirements?: Maybe<Scalars['String']>;
  /** Used to link an order to the referrer user that refered the order creator */
  referralId?: Maybe<Scalars['String']>;
  /**
   * Used to link an order to the referral code that was used to create the order.
   * Currently only used for competitions but will eventually be used for all referrals.
   */
  referralCode?: Maybe<ReferralCode>;
  /** Xero invoice ID if Xero integration is configured and an invoice was created for this order */
  xeroInvoiceId?: Maybe<Scalars['String']>;
  /** Amount of referral discount applied to the order. Used when there is a flat amount applied to the order */
  referralDiscountAmount?: Maybe<Scalars['Float']>;
  compReason?: Maybe<Scalars['String']>;
  /** The event associated with the order. Returns null if the order is not bound to an event. */
  event?: Maybe<Event>;
  /** The payment provider which processed the last transaction. */
  gateway?: Maybe<PaymentIntegrationOutput>;
  transactions: OrderTransactionConnection;
  posTransactions: PosTransactionConnection;
  /** List of the order's line items. */
  lineItems: LineItemConnection;
  /** The created tickets for the order. Only returns the membership tickets (including add-on tickets) for memberships. */
  tickets: Array<Ticket>;
  /** Order owner. Not all orders have users. */
  user?: Maybe<User>;
  /** Order is created by */
  createdBy?: Maybe<User>;
  /** The membership associated with the order. Returns null if the order is not bound to a membership. */
  membership?: Maybe<Membership>;
  promoCode?: Maybe<PromoCodeUnion>;
  multiBuyPromotion?: Maybe<MultiBuyPromotionUnion>;
  history: HistoryConnection;
  refunds: Array<Refund>;
  pos?: Maybe<Pos>;
  point?: Maybe<Point>;
};


/** Order type */
export type OrderTransactionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<TransactionOrderByInput>;
};


/** Order type */
export type OrderPosTransactionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<PosTransactionOrderByInput>;
};


/** Order type */
export type OrderLineItemsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Order type */
export type OrderHistoryArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<HistoryOrderByInput>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Order status */
export enum OrderChannel {
  Online = 'Online',
  BackOffice = 'BackOffice',
  Pos = 'POS'
}

export type OrderConnection = {
  __typename?: 'OrderConnection';
  pageInfo: PageInfo;
  edges: Array<OrderEdge>;
  totalCount: Scalars['Int'];
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['String'];
  node: Order;
};

export type OrderIdsOnlineOutput = {
  __typename?: 'OrderIdsOnlineOutput';
  orderId: Scalars['String'];
};

export type OrderOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
};

export type OrderRefundDetailsOutput = {
  __typename?: 'OrderRefundDetailsOutput';
  orderId: Scalars['String'];
  baseTickets: Scalars['Float'];
  ticketFees: Scalars['Float'];
  bookingFees: Scalars['Float'];
  transactionFees: Scalars['Float'];
  deliveryFees: Scalars['Float'];
  refundedAmount: Scalars['Float'];
  addons: Scalars['Float'];
  creditsUsed: Scalars['Float'];
};

/** Order status */
export enum OrderStatus {
  Pending = 'Pending',
  Hold = 'Hold',
  Paid = 'Paid',
  Completed = 'Completed',
  Canceled = 'Canceled',
  Expired = 'Expired'
}

export type OrderTicketCover = {
  __typename?: 'OrderTicketCover';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  purchasedAt?: Maybe<Scalars['DateTime']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  promoterFeeAmount: Scalars['Float'];
  platformFeeAmount: Scalars['Float'];
  totalFeeAmount?: Maybe<Scalars['Float']>;
  ticketTicketCovers?: Maybe<Array<TicketTicketCover>>;
  /** Order that the ticket cover is purchased for */
  order: Order;
  retryCount: Scalars['Float'];
};

/** A transaction represents an exchange of money as part of an order. */
export type OrderTransaction = {
  __typename?: 'OrderTransaction';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The kind of the transaction. */
  kind: OrderTransactionKind;
  /** The status of the transaction. */
  status: OrderTransactionStatus;
  /** The amount of the transaction. */
  amount: Scalars['Float'];
  /** The amount of the transaction that is held for Flicket at the point of sale as a platform commission. */
  platformAdjustment: Scalars['Float'];
};

export type OrderTransactionConnection = {
  __typename?: 'OrderTransactionConnection';
  pageInfo: PageInfo;
  edges: Array<OrderTransactionEdge>;
  totalCount: Scalars['Int'];
};

export type OrderTransactionEdge = {
  __typename?: 'OrderTransactionEdge';
  cursor: Scalars['String'];
  node: OrderTransaction;
};

/** The different kinds of order transactions. */
export enum OrderTransactionKind {
  Sale = 'Sale',
  Refund = 'Refund'
}

/** Payment statuses */
export enum OrderTransactionStatus {
  Waiting = 'Waiting',
  Pending = 'Pending',
  Error = 'Error',
  Failure = 'Failure',
  Success = 'Success',
  Unknown = 'Unknown',
  Cancelled = 'Cancelled'
}

/** Order type */
export enum OrderType {
  Default = 'DEFAULT',
  RenewMemberships = 'RENEW_MEMBERSHIPS',
  ChangeSeats = 'CHANGE_SEATS',
  RenameTickets = 'RENAME_TICKETS',
  TicketTransfer = 'TICKET_TRANSFER',
  MembershipTicketTransfer = 'MEMBERSHIP_TICKET_TRANSFER',
  PointPurchase = 'POINT_PURCHASE'
}

export type OrderWhereInput = {
  source?: Maybe<PointReportingFilterSource>;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  gateway?: Maybe<PaymentProvider>;
  createdById?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  dates?: Maybe<Array<Scalars['DateTime']>>;
  status?: Maybe<Array<OrderStatus>>;
  releaseId?: Maybe<Scalars['String']>;
  release?: Maybe<Scalars['String']>;
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Organization name. */
  name: Scalars['String'];
  /** Organization slug. */
  slug: Scalars['String'];
  /** Contact e-mail address. */
  email: Scalars['String'];
  /** Contact phone. */
  phone: Scalars['String'];
  /** Tax number */
  taxNumber?: Maybe<Scalars['String']>;
  /** Currency */
  currency?: Maybe<Scalars['String']>;
  /** Address details. */
  address?: Maybe<Address>;
  /** Landing page settings. */
  landingPage: LandingPage;
  /** Show memberships in client navigation. */
  showMemberships: Scalars['Boolean'];
  /** Show memberships renewal banner. */
  showMembershipRenewal?: Maybe<Scalars['Boolean']>;
  /** The support information of the organistion */
  supportInfo?: Maybe<Scalars['String']>;
  /** The privacy policy of the organistion */
  privacyPolicy?: Maybe<Scalars['String']>;
  /** The terms and conditions of the organistion */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Marketing settings. */
  marketing?: Maybe<Marketing>;
  /** Branding settings. */
  branding: BrandingOutputBase;
  /** Shipping labels. */
  shippingLabels?: Maybe<ShippingLabels>;
  /** Beta features. */
  features?: Maybe<Array<Scalars['String']>>;
  timezone: Scalars['String'];
  helpLink?: Maybe<Scalars['String']>;
  ticketCoverPlatformFeePercentage?: Maybe<Scalars['Float']>;
  point: Point;
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  pageInfo: PageInfo;
  edges: Array<OrganizationEdge>;
  totalCount: Scalars['Int'];
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String'];
  node: Organization;
};

export type OrganizationOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
};

export type OrganizationOutputBranding = {
  __typename?: 'OrganizationOutputBranding';
  /** Organization logo. */
  logo?: Maybe<ExtendedFile>;
  /** Organization mobile logo. */
  mobileLogo?: Maybe<ExtendedFile>;
  /** Organization favicon. */
  favicon?: Maybe<ExtendedFile>;
  /** Organization background image. */
  background?: Maybe<ExtendedFile>;
  /** Organization full background image. */
  fullBackground?: Maybe<ExtendedFile>;
  /** Primary color. */
  primaryColor: Scalars['String'];
  /** Secondary color. */
  secondaryColor: Scalars['String'];
  /** Grey scale option. */
  greyScale?: Maybe<GreyScale>;
  P300: Scalars['String'];
  P200: Scalars['String'];
  P100: Scalars['String'];
  S300: Scalars['String'];
  S200: Scalars['String'];
  S100: Scalars['String'];
  N800: Scalars['String'];
  N700: Scalars['String'];
  N600: Scalars['String'];
  N500: Scalars['String'];
  N400: Scalars['String'];
  N300: Scalars['String'];
  N200: Scalars['String'];
  N100: Scalars['String'];
};

export type OrganizationWhereInput = {
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

/** Facebook page. */
export type PageListsOutput = {
  __typename?: 'PageListsOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  access_token: Scalars['String'];
};

/** Address details. */
export type PartialAddress = {
  __typename?: 'PartialAddress';
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

/** Address details. */
export type PartialAddressInput = {
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type PaymentError = {
  __typename?: 'PaymentError';
  code?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Represents the order creation result. */
export type PaymentIntegrationOutput = {
  __typename?: 'PaymentIntegrationOutput';
  id?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Integration type */
  type?: Maybe<IntegrationType>;
  /** Integration name */
  name?: Maybe<Scalars['String']>;
  /** External public key (can be used in customer frontend) */
  publicKey?: Maybe<Scalars['String']>;
  /** Webhook URL to point integration to */
  webhookUrl?: Maybe<Scalars['String']>;
  /** Transaction fee type. */
  transactionFeeType?: Maybe<FeeType>;
  /** Transaction fee. */
  transactionFee?: Maybe<Scalars['Float']>;
  /** Transaction fee type(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFeeType2?: Maybe<FeeType>;
  /** Transaction fee(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFee2?: Maybe<Scalars['Float']>;
  /** If payment gateways have different option types this field is used to specify which one to force */
  paymentMethodType?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
};

/** Payment providers and methods */
export enum PaymentProvider {
  Stripe = 'Stripe',
  Laybuy = 'Laybuy',
  Windcave = 'Windcave',
  MpAiSa = 'MPAiSA',
  Pin = 'Pin',
  Credits = 'Credits',
  Points = 'Points',
  Pos = 'Pos',
  Cash = 'Cash',
  Eftpos = 'Eftpos',
  CreditCard = 'CreditCard',
  Invoice = 'Invoice',
  Other = 'Other'
}

export type PaymentResult = PaymentSuccess | PaymentError;

export type PaymentSuccess = {
  __typename?: 'PaymentSuccess';
  /** The payment gateway. */
  gateway: PaymentProvider;
  /** The payment url provided by the payment gateway. */
  redirectTo?: Maybe<Scalars['String']>;
};

/** Permission for a specific action */
export enum Permission {
  AccountCreate = 'ACCOUNT_CREATE',
  AccountRead = 'ACCOUNT_READ',
  AccountUpdate = 'ACCOUNT_UPDATE',
  AccountDelete = 'ACCOUNT_DELETE',
  CustomerCreate = 'CUSTOMER_CREATE',
  CustomerRead = 'CUSTOMER_READ',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  CustomerDelete = 'CUSTOMER_DELETE',
  CustomerCredits = 'CUSTOMER_CREDITS',
  CustomerImport = 'CUSTOMER_IMPORT',
  CustomerExport = 'CUSTOMER_EXPORT',
  EventCreate = 'EVENT_CREATE',
  EventRead = 'EVENT_READ',
  EventUpdate = 'EVENT_UPDATE',
  EventDelete = 'EVENT_DELETE',
  MembershipCreate = 'MEMBERSHIP_CREATE',
  MembershipRead = 'MEMBERSHIP_READ',
  MembershipUpdate = 'MEMBERSHIP_UPDATE',
  MembershipDelete = 'MEMBERSHIP_DELETE',
  OrderCreate = 'ORDER_CREATE',
  OrderRead = 'ORDER_READ',
  OrderUpdate = 'ORDER_UPDATE',
  OrderDelete = 'ORDER_DELETE',
  OrderCancel = 'ORDER_CANCEL',
  OrderComp = 'ORDER_COMP',
  OrderRefund = 'ORDER_REFUND',
  OrderExport = 'ORDER_EXPORT',
  OrganizationCreate = 'ORGANIZATION_CREATE',
  OrganizationDelete = 'ORGANIZATION_DELETE',
  OrganizationSettings = 'ORGANIZATION_SETTINGS',
  OrganizationBranding = 'ORGANIZATION_BRANDING',
  OrganizationIntegrations = 'ORGANIZATION_INTEGRATIONS',
  OrganizationVenues = 'ORGANIZATION_VENUES',
  OrganizationLegal = 'ORGANIZATION_LEGAL',
  ReportingSales = 'REPORTING_SALES',
  ReportingFinancial = 'REPORTING_FINANCIAL',
  ReportingScans = 'REPORTING_SCANS',
  ReportingPos = 'REPORTING_POS',
  SeasonCreate = 'SEASON_CREATE',
  SeasonRead = 'SEASON_READ',
  SeasonUpdate = 'SEASON_UPDATE',
  SeasonDelete = 'SEASON_DELETE',
  TicketRead = 'TICKET_READ',
  TicketPrint = 'TICKET_PRINT',
  TicketRelease = 'TICKET_RELEASE',
  TicketImport = 'TICKET_IMPORT',
  TicketExport = 'TICKET_EXPORT',
  PosRead = 'POS_READ',
  PosCreate = 'POS_CREATE',
  PosOperatorCreate = 'POS_OPERATOR_CREATE',
  ScoutRead = 'SCOUT_READ',
  ScoutDelete = 'SCOUT_DELETE',
  SocialRead = 'SOCIAL_READ',
  SocialCreate = 'SOCIAL_CREATE',
  WaitlistRead = 'WAITLIST_READ',
  WaitlistExport = 'WAITLIST_EXPORT',
  AutomationCreate = 'AUTOMATION_CREATE',
  AutomationRead = 'AUTOMATION_READ',
  AutomationUpdate = 'AUTOMATION_UPDATE',
  PointsRead = 'POINTS_READ',
  PointsUpdate = 'POINTS_UPDATE',
  PointsCreate = 'POINTS_CREATE',
  BroadcastCreate = 'BROADCAST_CREATE',
  BroadcastRead = 'BROADCAST_READ',
  CompetitionEntriesRead = 'COMPETITION_ENTRIES_READ'
}

export type PinPaymentChargeResponse = {
  __typename?: 'PinPaymentChargeResponse';
  redirectUrl: Scalars['String'];
};

export type PinPaymentContext = {
  __typename?: 'PinPaymentContext';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  publicKey?: Maybe<Scalars['String']>;
  isSandbox: Scalars['Boolean'];
};

export type Point = {
  __typename?: 'Point';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  name: Scalars['String'];
  termsAndConditions?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  pointItems: Array<PointItem>;
  gateways: Array<Integration>;
};

export type PointItem = {
  __typename?: 'PointItem';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  point: Point;
  name: Scalars['String'];
  price: Scalars['Float'];
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<ExtendedFile>;
  banner?: Maybe<ExtendedFile>;
  backgroundImage?: Maybe<ExtendedFile>;
  descriptionImage?: Maybe<ExtendedFile>;
  isVisible: Scalars['Boolean'];
};

export enum PointReportingFilterSource {
  Overall = 'OVERALL',
  Membership = 'MEMBERSHIP',
  Event = 'EVENT',
  Package = 'PACKAGE'
}

/** Represents a POS terminal. */
export type Pos = {
  __typename?: 'Pos';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Friendly name of the POS terminal. */
  name: Scalars['String'];
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Available payment option incl. fees. */
  paymentOptions: PosPaymentOptions;
  /** Available delivery options for the POS terminal. */
  deliveryOptions: Array<ShippingOption>;
  /** The beginning float of change for the POS terminal. */
  cashAmount?: Maybe<Scalars['Float']>;
  /** Whether receipts are turned on. */
  enableReceipts: Scalars['Boolean'];
  event?: Maybe<Event>;
  release?: Maybe<Release>;
  users: Array<PosUser>;
};

export type PosPaymentFee = {
  __typename?: 'PosPaymentFee';
  /** Fee type. */
  feeType: FeeType;
  /** Fee amount */
  feeAmount: Scalars['Float'];
};

export type PosPaymentFeeInput = {
  /** Fee type. */
  feeType: FeeType;
  /** Fee amount */
  feeAmount: Scalars['Float'];
};

/** Represents POS options incl. fees. */
export type PosPaymentOptions = {
  __typename?: 'PosPaymentOptions';
  /** Cash fee (normally $0). */
  cash?: Maybe<PosPaymentFee>;
  /** Eftpos fee. */
  eftpos?: Maybe<PosPaymentFee>;
  /** Credit card fee. */
  cc?: Maybe<PosPaymentFee>;
  /** MPAiSA fee. */
  MPAiSA?: Maybe<PosPaymentFee>;
};

export type PosPaymentOptionsInput = {
  /** Cash fee (normally $0). */
  cash?: Maybe<PosPaymentFeeInput>;
  /** Eftpos fee. */
  eftpos?: Maybe<PosPaymentFeeInput>;
  /** Credit card fee. */
  cc?: Maybe<PosPaymentFeeInput>;
  /** MPAiSA fee. */
  MPAiSA?: Maybe<PosPaymentFeeInput>;
};

export type PosSalesOverviewOutput = {
  __typename?: 'PosSalesOverviewOutput';
  soldAtTheDoor: Scalars['Float'];
  orders: Scalars['Float'];
  soldOnline: Scalars['Float'];
  scannedPercentage: Scalars['Float'];
  average: Scalars['Float'];
  perHour: Scalars['Float'];
};

export type PosSession = {
  __typename?: 'PosSession';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pos: Pos;
  operator: User;
  startedAt: Scalars['DateTime'];
  endedAt?: Maybe<Scalars['DateTime']>;
  startCash?: Maybe<Scalars['Float']>;
  endCash?: Maybe<Scalars['Float']>;
};

export type PostmarkEmailStatsOverviewOutput = {
  __typename?: 'PostmarkEmailStatsOverviewOutput';
  sent: Scalars['Float'];
  bounced: Scalars['Float'];
  smtpApiErrors: Scalars['Float'];
  bounceRate: Scalars['Float'];
  spamComplaints: Scalars['Float'];
  spamComplaintsRate: Scalars['Float'];
  opens: Scalars['Float'];
  uniqueOpens: Scalars['Float'];
  tracked: Scalars['Float'];
  withLinkTracking: Scalars['Float'];
  withOpenTracking: Scalars['Float'];
  totalTrackedLinksSent: Scalars['Float'];
  uniqueLinksClicked: Scalars['Float'];
  totalClicks: Scalars['Float'];
  withClientRecorded: Scalars['Float'];
  withPlatformRecorded: Scalars['Float'];
};

/** Represents a POS transaction. */
export type PosTransaction = {
  __typename?: 'PosTransaction';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Used payment gateway. */
  paymentGateway: PaymentProvider;
  /** Transaction amount. */
  amount: Scalars['Float'];
  /** Fee amount. */
  fee: Scalars['Float'];
  /** Return amount (only relevant for cash). */
  returned: Scalars['Float'];
};

export type PosTransactionConnection = {
  __typename?: 'PosTransactionConnection';
  pageInfo: PageInfo;
  edges: Array<PosTransactionEdge>;
  totalCount: Scalars['Int'];
};

export type PosTransactionEdge = {
  __typename?: 'PosTransactionEdge';
  cursor: Scalars['String'];
  node: PosTransaction;
};

export type PosTransactionOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
};

export type PosUser = {
  __typename?: 'PosUser';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type PromoCodeUnion = EventPromoCode | MembershipPromoCode;

export type PromoterConfig = {
  __typename?: 'PromoterConfig';
  share?: Maybe<Array<Scalars['String']>>;
  like?: Maybe<Array<Scalars['String']>>;
  rsvp?: Maybe<Array<Scalars['String']>>;
  follow?: Maybe<Array<Scalars['String']>>;
  invite?: Maybe<Array<Scalars['String']>>;
};

export type PromoterConfigInput = {
  share?: Maybe<Array<Scalars['String']>>;
  like?: Maybe<Array<Scalars['String']>>;
  rsvp?: Maybe<Array<Scalars['String']>>;
  follow?: Maybe<Array<Scalars['String']>>;
  invite?: Maybe<Array<Scalars['String']>>;
};

export type PromoterSettings = {
  __typename?: 'PromoterSettings';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  event: Event;
  config?: Maybe<PromoterConfig>;
  socialPages?: Maybe<Array<EventSocialPage>>;
  /** The referral campaign associated with this event */
  referralCampaign?: Maybe<ReferralCampaign>;
};


export type PromoterSettingsReferralCampaignArgs = {
  eventId: Scalars['String'];
};

export type PromoterSettingsInput = {
  eventId: Scalars['String'];
  config?: Maybe<PromoterConfigInput>;
  socialPages?: Maybe<Array<EventSocialPageInput>>;
  rewardSettings?: Maybe<RewardSettingsDto>;
};

export type PublishCompetitionInput = {
  competitionType: CompetitionType;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  referralRewardValue?: Maybe<Scalars['Int']>;
  bannerImage?: Maybe<Scalars['Upload']>;
  prizes?: Maybe<Array<CompetitionPrizeInput>>;
  promoter?: Maybe<Array<CompetitionPromoterInput>>;
  competitionId?: Maybe<Scalars['String']>;
};

export type PurchaseRestriction = {
  __typename?: 'PurchaseRestriction';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  restrictedType: LineItemType;
  restrictedId: Scalars['ID'];
  quantity: Scalars['Int'];
  requiredEntities: Array<PurchaseRestrictionRequiredEntity>;
  isExclusive: Scalars['Boolean'];
  isAlwaysVisible: Scalars['Boolean'];
};

export type PurchaseRestrictionInput = {
  restrictedType: LineItemType;
  restrictedId: Scalars['ID'];
  quantity: Scalars['Int'];
  requiredEntities: Array<PurchaseRestrictionRequiredEntityInput>;
  isExclusive?: Maybe<Scalars['Boolean']>;
  isAlwaysVisible?: Maybe<Scalars['Boolean']>;
};

export type PurchaseRestrictionRequiredEntity = {
  __typename?: 'PurchaseRestrictionRequiredEntity';
  requiredType: LineItemType;
  requiredId: Scalars['ID'];
};

export type PurchaseRestrictionRequiredEntityInput = {
  requiredType: LineItemType;
  requiredId: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  isLoggedIn: Scalars['Boolean'];
  me: User;
  myLoggedInOrganizations?: Maybe<Array<MyLoggedInOrganizationsOutput>>;
  /** Fetches users (paginated). */
  users: UserConnection;
  /** Fetches a user. */
  user: User;
  /** Fetches a users referral ID. */
  findUserReferralId: User;
  posUsers: Array<User>;
  linkedAccountUser: LinkedAccountUser;
  poses: Array<Pos>;
  pos: Pos;
  posSessions: Array<PosSession>;
  events: EventConnection;
  event: Event;
  myEvents: Array<Event>;
  eventForecast: EventForecastOutput;
  hasSeatedEvent: Scalars['Boolean'];
  ticketTypes: Array<TicketType>;
  releases: Array<Release>;
  release: Release;
  getReleaseBySlug?: Maybe<Release>;
  eventPromoCodes: Array<EventPromoCode>;
  eventMultiBuyPromotions: Array<EventMultiBuyPromotion>;
  eventAddons: Array<EventAddon>;
  seasons: Array<Season>;
  season: Season;
  integrations: Array<Integration>;
  integration: Integration;
  getConsentUrl: Scalars['String'];
  getXeroAccounts: XeroAllAccountsOutput;
  getCurrentAccountCode?: Maybe<Scalars['String']>;
  disableXeroIntegration: Scalars['Boolean'];
  disableShopifyIntegration: Scalars['Boolean'];
  customerOrders: Array<ShopifyCustomerOrder>;
  deleteAdobeIntegration: Scalars['Boolean'];
  adobeIntegration?: Maybe<AdobeExperiencePlatformIntegration>;
  currentOrganization: CurrentOrganizationOutput;
  /** [super-admin] | Fetches organizations (paginated) */
  organizations: OrganizationConnection;
  /** [super-admin] | Fetches an organization by id */
  organization: Organization;
  /** [app] | Fetches organization-names and Ids (paginated) */
  organizationNames: OrganizationConnection;
  /** Fetches orders (paginated). */
  orders: OrderConnection;
  /** Fetches an order. */
  order?: Maybe<Order>;
  /** Fetches online orders ids for an event */
  orderIdsOnline?: Maybe<Array<OrderIdsOnlineOutput>>;
  /** Fetches online orders for an event */
  eventOrdersOnline?: Maybe<EventOrdersOnlineOutput>;
  /** Returns an orders details required to do refunds */
  orderRefundDetails?: Maybe<OrderRefundDetailsOutput>;
  /** Fetches orders of a user (paginated). */
  myOrders: OrderConnection;
  /** Gets updated orders */
  ordersUpdatedSince: CustomSaleOutput;
  /** Gets updated orders */
  ordersUpdatedSinceForEvent: CustomSaleOutput;
  /** Gets ticket cover amount for order */
  calculateTicketCoverAmounts: TicketCoverAmount;
  getEventPurchaseRestrictions: Array<PurchaseRestriction>;
  getMembershipPurchaseRestrictions: Array<PurchaseRestriction>;
  getHistoryByCustomerId: Array<History>;
  venues: Array<Venue>;
  venue: Venue;
  venueSeatsThumbnail?: Maybe<Scalars['String']>;
  getZonesByEventId: Array<Zone>;
  memberships: MembershipConnection;
  membership?: Maybe<Membership>;
  previousMembershipCount?: Maybe<Scalars['Float']>;
  membershipTypeEventTransferPrices?: Maybe<Array<MembershipTypeEventTransferPrice>>;
  membershipTypes: Array<MembershipType>;
  membershipAddons: Array<MembershipAddon>;
  membershipPromoCodes: Array<MembershipPromoCode>;
  membershipMultiBuyPromotions: Array<MembershipMultiBuyPromotion>;
  scout: Scout;
  scouts: Array<Scout>;
  /** Fetches users (paginated). */
  scoutUsers: ScoutUserConnection;
  initScout: InitScout;
  scoutCommunications: Array<ScoutCommunication>;
  scoutCommunication: ScoutCommunication;
  scoutCommunicationUsers: ScoutCommunicationUserConnection;
  scoutCommunicationUser: ScoutCommunicationUser;
  scoutUserReminders: Array<ScoutCommunicationUser>;
  tags: Array<Tag>;
  myMembershipTickets: Array<Ticket>;
  usersEventTickets: Array<Ticket>;
  myMembershipAddons: Array<Ticket>;
  myEventTickets: Array<Ticket>;
  ticket?: Maybe<Ticket>;
  findOrderIdForTicket: FindOrderIdForTicketOutput;
  ticketsSoldForUser: Array<TicketTypePurchaseTotal>;
  getTicketsByIds: Array<Ticket>;
  /** DEPRECATED: should use searchTicketsByEventApp to fetch for scanner app */
  searchTickets: TicketConnection;
  searchTicketsByEventApp: SearchEventTicketsAppOutput;
  /** Returns stringyfied mapping of details per seat label. */
  ticketDetailsForBackOfficeOrders: Scalars['String'];
  transferredMembershipTicketsForOrder?: Maybe<Array<Ticket>>;
  myScannedTickets: Array<Ticket>;
  myScannedTicketsCount: Scalars['Float'];
  pinPaymentContext: PinPaymentContext;
  socialMentions: SocialConnection;
  mentionOverview: MentionOverview;
  facebookPageLists: Array<PageListsOutput>;
  mailchimpDomains: Scalars['JSON'];
  mailchimpLists: Scalars['JSON'];
  mailchimpTemplates: Scalars['JSON'];
  point?: Maybe<Point>;
  pointItem: PointItem;
  pointItems: Array<PointItem>;
  activities: ActivityConnection;
  automations: Array<Automation>;
  automation: Automation;
  getPromoterSettings?: Maybe<PromoterSettings>;
  getReferralCampaigns: Array<ReferralCampaign>;
  getReferralCampaignsByEventId?: Maybe<Array<ReferralCampaign>>;
  getReferralCampaignByEventId?: Maybe<ReferralCampaign>;
  getReferralCampaignByReferralCode?: Maybe<ReferralCampaign>;
  getReferralCampaignByOrderId?: Maybe<ReferralCampaign>;
  getReferralCampaignStats: ReferralCampaignOverviewOutput;
  getReferralRewardByOrderId?: Maybe<ReferralReward>;
  referralUrlByOrderId?: Maybe<Scalars['String']>;
  referralUrlByWaitlistUserId?: Maybe<Scalars['String']>;
  getRedirectUrlByCode: RedirectUrl;
  competitions: Array<Competition>;
  competition: Competition;
  activeCompetitions?: Maybe<Array<Competition>>;
  activeCompetitionByType?: Maybe<Competition>;
  salesOverview: SalesOverviewOutput;
  scoutCampaignOverview: ScoutCampaignOverviewOutput;
  scoutCampaignTopTags: Array<TopTagsOutput>;
  scoutCampaignHighestValueCustomers: Array<HighestValueCustomersOutput>;
  scoutCampaignGenderBreakdown: Array<GenderBreakDownOutput>;
  scoutCampaignCustomerLocations: Array<LocationOutput>;
  summaryOverview: SummaryOverviewOutput;
  salesGraph: GraphOutput;
  customerLocations: Array<LocationOutput>;
  salesChannelGraph: SalesChannelGraphOutput;
  financialOverview: FinancialOverviewOutput;
  financialGraph: GraphOutput;
  financialGateways: FinancialGatewayGraphOutput;
  financialSalesBreakdown: Array<FinancialSales>;
  scanVisitors?: Maybe<Array<GraphTextItem>>;
  scanVisitorsOverTime?: Maybe<Array<GraphRangeItem>>;
  scanTicketTypes?: Maybe<Array<GraphTextItem>>;
  posSalesOverview: PosSalesOverviewOutput;
  posFinancialOverview: Array<GraphItem>;
  posFloatOfChange: Array<GraphItem>;
  insightsOverview: InsightsOverviewOutput;
  highestValueCustomers: Array<HighestValueCustomersOutput>;
  topTags: Array<TopTagsOutput>;
  topReferrers: Array<TopReferrersOutput>;
  topRepeatPurchasers: Array<TopRepeatPurchasers>;
  insightsGenderBreakDown: Array<GenderBreakDownOutput>;
  insightsHeardAboutUsBreakDown: Array<HeardAboutUsBreakDownOutput>;
  insightsAgeBreakDown: AgeBreakDownOutput;
  waitlistOverview: WaitlistOverviewOutput;
  capacityOverview: Array<CapacityOverview>;
  capacitySeatingMap: Scalars['String'];
  capacitySeatingMapTooltips: Scalars['String'];
  broadcastReportStats: BroadcastReportingOutput;
  purchasingDaysBreakdown: Array<BarchartOutput>;
  referralPromotionReportStats: ReferralPromotionReportingOutput;
  timeOfDayBreakdown: Array<BarchartOutput>;
  broadcasts: BroadcastConnection;
  broadcast: Broadcast;
  audienceCount: Scalars['Float'];
  marketingUserCount: Scalars['Float'];
  broadcastBounces: Array<User>;
};


export type QueryUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<UserOrderByInput>;
};


export type QueryUserArgs = {
  id: Scalars['String'];
};


export type QueryFindUserReferralIdArgs = {
  id: Scalars['String'];
};


export type QueryPosUsersArgs = {
  eventId: Scalars['String'];
};


export type QueryLinkedAccountUserArgs = {
  id: Scalars['String'];
};


export type QueryPosesArgs = {
  eventId: Scalars['String'];
};


export type QueryPosArgs = {
  id: Scalars['String'];
};


export type QueryPosSessionsArgs = {
  posId: Scalars['String'];
};


export type QueryEventsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
};


export type QueryEventArgs = {
  id: Scalars['String'];
};


export type QueryMyEventsArgs = {
  where?: Maybe<MyEventsWhereInput>;
  orderBy?: Maybe<MyEventsOrderByInput>;
};


export type QueryEventForecastArgs = {
  eventId: Scalars['String'];
};


export type QueryTicketTypesArgs = {
  eventId: Scalars['String'];
};


export type QueryReleasesArgs = {
  event: Scalars['String'];
};


export type QueryReleaseArgs = {
  id: Scalars['String'];
};


export type QueryGetReleaseBySlugArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};


export type QueryEventPromoCodesArgs = {
  eventId: Scalars['String'];
};


export type QueryEventMultiBuyPromotionsArgs = {
  eventId: Scalars['String'];
};


export type QueryEventAddonsArgs = {
  eventId: Scalars['String'];
};


export type QuerySeasonArgs = {
  id: Scalars['String'];
};


export type QueryIntegrationsArgs = {
  input?: Maybe<IntegrationWhereInput>;
};


export type QueryIntegrationArgs = {
  id: Scalars['String'];
};


export type QueryCustomerOrdersArgs = {
  customerId: Scalars['String'];
};


export type QueryOrganizationsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationWhereInput>;
  orderBy?: Maybe<OrganizationOrderByInput>;
};


export type QueryOrganizationArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationNamesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationWhereInput>;
  orderBy?: Maybe<OrganizationOrderByInput>;
};


export type QueryOrdersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<OrderOrderByInput>;
};


export type QueryOrderArgs = {
  id: Scalars['String'];
};


export type QueryOrderIdsOnlineArgs = {
  id: Scalars['String'];
};


export type QueryEventOrdersOnlineArgs = {
  id: Scalars['String'];
};


export type QueryOrderRefundDetailsArgs = {
  eventId: Scalars['String'];
  orderId: Scalars['String'];
};


export type QueryMyOrdersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<OrderOrderByInput>;
};


export type QueryOrdersUpdatedSinceArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['String']>;
};


export type QueryOrdersUpdatedSinceForEventArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['String']>;
};


export type QueryCalculateTicketCoverAmountsArgs = {
  id: Scalars['String'];
};


export type QueryGetEventPurchaseRestrictionsArgs = {
  eventId: Scalars['String'];
};


export type QueryGetMembershipPurchaseRestrictionsArgs = {
  membershipId: Scalars['String'];
};


export type QueryGetHistoryByCustomerIdArgs = {
  input: GetHistoryByCustomerIdInput;
};


export type QueryVenueArgs = {
  id: Scalars['String'];
};


export type QueryVenueSeatsThumbnailArgs = {
  id: Scalars['String'];
};


export type QueryGetZonesByEventIdArgs = {
  eventId: Scalars['String'];
};


export type QueryMembershipsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<MembershipWhereInput>;
  orderBy?: Maybe<MembershipOrderByInput>;
};


export type QueryMembershipArgs = {
  id: Scalars['String'];
};


export type QueryPreviousMembershipCountArgs = {
  id: Scalars['String'];
};


export type QueryMembershipTypeEventTransferPricesArgs = {
  id: Scalars['String'];
};


export type QueryMembershipTypesArgs = {
  membership: Scalars['String'];
};


export type QueryMembershipAddonsArgs = {
  membershipId: Scalars['String'];
};


export type QueryMembershipPromoCodesArgs = {
  membershipId: Scalars['String'];
};


export type QueryMembershipMultiBuyPromotionsArgs = {
  membershipId: Scalars['String'];
};


export type QueryScoutArgs = {
  id: Scalars['String'];
};


export type QueryScoutsArgs = {
  input?: Maybe<FindScoutsInput>;
};


export type QueryScoutUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
  stage?: Maybe<Array<ScoutStage>>;
  agentUserId?: Maybe<Scalars['String']>;
  hasPhoneNumber?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryScoutCommunicationsArgs = {
  input: ScoutCommunicationsInput;
};


export type QueryScoutCommunicationArgs = {
  id: Scalars['String'];
};


export type QueryScoutCommunicationUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
  hasPhoneNumber?: Maybe<Scalars['Boolean']>;
  stage?: Maybe<Array<ScoutStage>>;
  agentUserId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};


export type QueryScoutCommunicationUserArgs = {
  id: Scalars['String'];
};


export type QueryMyMembershipAddonsArgs = {
  membershipId: Scalars['String'];
};


export type QueryMyEventTicketsArgs = {
  eventId: Scalars['String'];
};


export type QueryTicketArgs = {
  id: Scalars['String'];
};


export type QueryFindOrderIdForTicketArgs = {
  ticketId: Scalars['String'];
};


export type QueryTicketsSoldForUserArgs = {
  eventId: Scalars['String'];
};


export type QueryGetTicketsByIdsArgs = {
  ids: Scalars['String'];
};


export type QuerySearchTicketsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<TicketWhereInput>;
  orderBy?: Maybe<TicketWhereInput>;
  eventId: Scalars['String'];
};


export type QuerySearchTicketsByEventAppArgs = {
  q?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
};


export type QueryTicketDetailsForBackOfficeOrdersArgs = {
  membershipId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
};


export type QueryTransferredMembershipTicketsForOrderArgs = {
  orderId: Scalars['String'];
};


export type QueryMyScannedTicketsArgs = {
  eventId: Scalars['String'];
};


export type QueryMyScannedTicketsCountArgs = {
  eventId: Scalars['String'];
};


export type QueryPinPaymentContextArgs = {
  id: Scalars['String'];
};


export type QuerySocialMentionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<SocialWhereInput>;
};


export type QueryMentionOverviewArgs = {
  input: MentionOverviewInput;
};


export type QueryFacebookPageListsArgs = {
  input: FacebookPageListsInput;
};


export type QueryPointItemArgs = {
  id: Scalars['String'];
};


export type QueryActivitiesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<ActivityWhereInput>;
};


export type QueryAutomationsArgs = {
  input: FindAutomationsInput;
};


export type QueryAutomationArgs = {
  id: Scalars['String'];
};


export type QueryGetPromoterSettingsArgs = {
  eventId: Scalars['String'];
};


export type QueryGetReferralCampaignsByEventIdArgs = {
  id: Scalars['String'];
};


export type QueryGetReferralCampaignByEventIdArgs = {
  id: Scalars['String'];
};


export type QueryGetReferralCampaignByReferralCodeArgs = {
  referralCode: Scalars['String'];
};


export type QueryGetReferralCampaignByOrderIdArgs = {
  id: Scalars['String'];
};


export type QueryGetReferralCampaignStatsArgs = {
  eventId: Scalars['String'];
  id: Scalars['String'];
};


export type QueryGetReferralRewardByOrderIdArgs = {
  id: Scalars['String'];
};


export type QueryReferralUrlByOrderIdArgs = {
  orderId: Scalars['String'];
};


export type QueryReferralUrlByWaitlistUserIdArgs = {
  waitlistUserId: Scalars['String'];
  eventId: Scalars['String'];
};


export type QueryGetRedirectUrlByCodeArgs = {
  input: RedirectCodeInput;
};


export type QueryCompetitionsArgs = {
  eventId: Scalars['String'];
};


export type QueryCompetitionArgs = {
  id: Scalars['String'];
};


export type QueryActiveCompetitionsArgs = {
  eventId: Scalars['String'];
};


export type QueryActiveCompetitionByTypeArgs = {
  input: ActiveCompetitionByTypeInput;
};


export type QuerySalesOverviewArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  source: PointReportingFilterSource;
};


export type QueryScoutCampaignOverviewArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryScoutCampaignTopTagsArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryScoutCampaignHighestValueCustomersArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryScoutCampaignGenderBreakdownArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryScoutCampaignCustomerLocationsArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QuerySummaryOverviewArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QuerySalesGraphArgs = {
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  type?: Maybe<GraphFilterType>;
};


export type QueryCustomerLocationsArgs = {
  tagId?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  source: PointReportingFilterSource;
};


export type QuerySalesChannelGraphArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  source: PointReportingFilterSource;
};


export type QueryFinancialOverviewArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  source: PointReportingFilterSource;
};


export type QueryFinancialGraphArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryFinancialGatewaysArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  source: PointReportingFilterSource;
};


export type QueryFinancialSalesBreakdownArgs = {
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  source: ReportingFinancialSalesBreakdownSource;
  sourceId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};


export type QueryScanVisitorsArgs = {
  eventId: Scalars['String'];
};


export type QueryScanVisitorsOverTimeArgs = {
  eventId: Scalars['String'];
};


export type QueryScanTicketTypesArgs = {
  eventId: Scalars['String'];
};


export type QueryPosSalesOverviewArgs = {
  eventId: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
};


export type QueryPosFinancialOverviewArgs = {
  eventId: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
};


export type QueryPosFloatOfChangeArgs = {
  eventId: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
};


export type QueryInsightsOverviewArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryHighestValueCustomersArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryTopTagsArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryTopReferrersArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryTopRepeatPurchasersArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryInsightsGenderBreakDownArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryInsightsHeardAboutUsBreakDownArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryInsightsAgeBreakDownArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryWaitlistOverviewArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryCapacityOverviewArgs = {
  eventId: Scalars['String'];
};


export type QueryCapacitySeatingMapArgs = {
  eventId: Scalars['String'];
};


export type QueryCapacitySeatingMapTooltipsArgs = {
  eventId: Scalars['String'];
};


export type QueryBroadcastReportStatsArgs = {
  input: BroadcastReportingStatsInput;
};


export type QueryPurchasingDaysBreakdownArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryReferralPromotionReportStatsArgs = {
  input: ReferralPromotionReportingInput;
};


export type QueryTimeOfDayBreakdownArgs = {
  tagId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
};


export type QueryBroadcastsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<BroadcastWhereInput>;
};


export type QueryBroadcastArgs = {
  id: Scalars['String'];
};


export type QueryAudienceCountArgs = {
  input: AudienceCountInput;
};


export type QueryMarketingUserCountArgs = {
  input: BroadcastFilterCountInput;
};


export type QueryBroadcastBouncesArgs = {
  count: Scalars['Float'];
  start: Scalars['Float'];
  id: Scalars['String'];
};

export type RedeemTicketInput = {
  /** Ticket number */
  ticketNumber: Scalars['String'];
  /** Event ID */
  eventId: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type RedirectCodeInput = {
  /** Full URL path. */
  redirectCode: Scalars['String'];
};

/** Mapping of a shortened URL to its full path */
export type RedirectUrl = {
  __typename?: 'RedirectUrl';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Type of entity this redirect is for. */
  refName: Scalars['String'];
  /** Reference entity ID. */
  refId: Scalars['String'];
  /** Shortned URL slug. */
  shortenedSlug: Scalars['String'];
  /** Full URL path. */
  redirectURL: Scalars['String'];
  /** Number of times the shortened URL has redirected to the full path. */
  timesUsed: Scalars['Float'];
};

/** Referral Campaign */
export type ReferralCampaign = {
  __typename?: 'ReferralCampaign';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The unique identifier for the referral campaign */
  referralRelease?: Maybe<Release>;
  /** The eventId that the referral campaign is associated with */
  event?: Maybe<Event>;
  /** The memebrshipId that the referral campaign is associated with */
  membership?: Maybe<Membership>;
  /** Whether the referral campaign is active */
  isActive: Scalars['Boolean'];
  /** The type of reward for the owner of the referral */
  referralOwnerRewardType: ReferralRewardType;
  /** The reward quantity type. */
  referralOwnerRewardQuantityType: ReferralRewardQuantityType;
  /** The quantity of the reward for the owner of the referral */
  referralOwnerRewardQuantity: Scalars['Float'];
  /** The type of reward for the user of the referral */
  referralUserRewardType: ReferralRewardType;
  /** The reward quantity type. */
  referralUserRewardQuantityType: ReferralRewardQuantityType;
  /** The quantity of the reward for the user of the referral */
  referralUserRewardQuantity: Scalars['Float'];
};

export type ReferralCampaignOverviewOutput = {
  __typename?: 'ReferralCampaignOverviewOutput';
  numberOfOrders: Scalars['Float'];
  userRewards: Scalars['Float'];
  ownerRewards: Scalars['Float'];
  referralLinksCreated: Scalars['Float'];
  referralLinksClicked: Scalars['Float'];
  tickets: Scalars['Float'];
  revenueGenerated: Scalars['Float'];
  customersAccquired: Scalars['Float'];
};

/** A referral code for a user and event */
export type ReferralCode = {
  __typename?: 'ReferralCode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type ReferralPromotionReportingInput = {
  eventId: Scalars['String'];
};

export type ReferralPromotionReportingOutput = {
  __typename?: 'ReferralPromotionReportingOutput';
  revenue: Scalars['Float'];
  roi: Scalars['Float'];
  orders: Scalars['Float'];
  newReferredCustomers: Scalars['Float'];
  referrerPointsAwarded: Scalars['Float'];
  discountValue: Scalars['Float'];
};

/** Referral Reward */
export type ReferralReward = {
  __typename?: 'ReferralReward';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  order: Order;
  /** The referral campaign the rewards are from */
  referralCampaign: ReferralCampaign;
  /** Organization associated with the referral campaign */
  organization: Organization;
  /** The role of the user played when receiving these rewards */
  rewardForRole: ReferralRole;
  /** The type of reward for the referral */
  rewardType: ReferralRewardType;
  /** The reward quantity type. */
  rewardQuantityType: ReferralRewardQuantityType;
  /** The quantity of the reward for the owner of the referral */
  rewardQuantity: Scalars['Float'];
};

/** The valid values for quantities of referral rewards. */
export enum ReferralRewardQuantityType {
  FlatRate = 'flatRate',
  Percentage = 'percentage'
}

/** The valid values for referral rewards. Some are only applicable to certain roles in a referral transaction. */
export enum ReferralRewardType {
  Points = 'Points',
  Credits = 'Credits',
  Discount = 'Discount'
}

/** The role the user played when in a referral exchange. */
export enum ReferralRole {
  Owner = 'Owner',
  User = 'User'
}

/** Represents a refund of items in an order. */
export type Refund = {
  __typename?: 'Refund';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  kind: RefundKind;
  /** The amount of the refund. */
  amount: Scalars['Float'];
  /** Notes why the refund has been initiated. */
  notes: Scalars['String'];
  /** Whether the refund is a manual one. */
  isManual: Scalars['Boolean'];
  gateway?: Maybe<RefundGateway>;
};

/** Refund gateways. */
export enum RefundGateway {
  Cash = 'Cash',
  Eftpos = 'Eftpos',
  CreditCard = 'CreditCard',
  Invoice = 'Invoice',
  Other = 'Other'
}

/** Refund kinds. */
export enum RefundKind {
  Default = 'Default',
  TicketTransfer = 'TicketTransfer'
}

export type RegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  enableTwoFactorAuthentication: Scalars['Boolean'];
};

/** Represents a release in an event. */
export type Release = {
  __typename?: 'Release';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Release name. */
  name: Scalars['String'];
  /** Release type. */
  type: ReleaseType;
  /** The slug for the unlisted release. Returns null if the release type is set to other than `unlisted`. */
  slug?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  /** The start condition of the release. */
  startCondition: ReleaseStartCondition;
  /** The start date of the release. Returns null if the startCondition is set to other than "date". */
  startConditionDate?: Maybe<Scalars['DateTime']>;
  /** The end condition of the release. */
  endCondition: ReleaseEndCondition;
  /** The quantity limit of the release. Returns null if the endCondition is set to other than "quantity". */
  endConditionQuantity?: Maybe<Scalars['Float']>;
  /** The end date of the release. Returs null if the endCondition is set to other than "date". */
  endConditionDate?: Maybe<Scalars['DateTime']>;
  /** The status of the release. */
  isActive: Scalars['Boolean'];
  /** The title of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleTitle?: Maybe<Scalars['String']>;
  /** The logo of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleLogo?: Maybe<ExtendedFile>;
  /** The header image of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleHeader?: Maybe<ExtendedFile>;
  /** The information of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The information that will be displayed on the ticketing page for a specific release. */
  releaseNotes?: Maybe<Scalars['String']>;
  /** Toggle whether to ask customers how they heard about their purcahse */
  askHowDidYouHearAboutUs?: Maybe<Scalars['Boolean']>;
  /** Toggle whether to ask for dietary requirements with their order */
  askForDietaryRequirements?: Maybe<Scalars['Boolean']>;
  allowPublicComp: Scalars['Boolean'];
  /** Toggle whether customers can create hold orders for this release */
  allowHoldOrders: Scalars['Boolean'];
  allowAccount2Account?: Maybe<Scalars['Boolean']>;
  minPurchaseQuantity: Scalars['Int'];
  maxPurchaseQuantity: Scalars['Int'];
  event: Event;
  canBeHardDeleted: Scalars['Boolean'];
  requiresAuth: Scalars['Boolean'];
  releaseZones: Array<ReleaseZone>;
  releaseEventAddons: Array<ReleaseEventAddon>;
};

export enum ReleaseEndCondition {
  Manual = 'MANUAL',
  Date = 'DATE',
  Quantity = 'QUANTITY'
}

export type ReleaseEventAddon = {
  __typename?: 'ReleaseEventAddon';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  eventAddon: EventAddon;
};

/** Represents a unique password code in a release. */
export type ReleasePassword = {
  __typename?: 'ReleasePassword';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The usage limit of the release password. Returns null if password has no usage limit. */
  quantityPaid: Scalars['Int'];
  /** The usage limit of the release password for complimentary tickets. */
  quantityComp: Scalars['Int'];
  totalUsedPaid: Scalars['Int'];
  totalUsedComp: Scalars['Int'];
};

/** Creates a refund. */
export type ReleaseSeatsInput = {
  /** Order id for which the seats will be released. */
  orderId: Scalars['String'];
  /** Notes why the seats are released. */
  notes: Scalars['String'];
  /** Tickets to realease (will also release child tickets). */
  ticketIds: Array<Scalars['String']>;
};

export enum ReleaseStartCondition {
  Manual = 'MANUAL',
  Date = 'DATE'
}

export enum ReleaseType {
  Listed = 'LISTED',
  Unlisted = 'UNLISTED',
  Presale = 'PRESALE',
  Pos = 'POS',
  Referral = 'REFERRAL',
  Outlet = 'OUTLET'
}

export type ReleaseZone = {
  __typename?: 'ReleaseZone';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  zone: Zone;
  /** The pricing level of the zone. Will be set to `zone` for non-seated events. */
  pricingLevel: ZonePricingLevel;
  /** The active status of the zone. Defaults to `false`. */
  isActive: Scalars['Boolean'];
  /** The list of ticket types of the release zone. */
  ticketTypes: Array<ReleaseZoneTicketType>;
};

export type ReleaseZoneInput = {
  id?: Maybe<Scalars['String']>;
  zone: ReleaseZoneZoneInput;
  /** The pricing level of the release zone. Will be set to `zone` for non-seated events. */
  pricingLevel: ZonePricingLevel;
  /** The active status of the zone seating. Defaults to `false`. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The list of ticket types of the release zone. */
  ticketTypes: Array<ReleaseZoneTicketTypeInput>;
};

/** Represents a ticket type in a release zone. */
export type ReleaseZoneTicketType = {
  __typename?: 'ReleaseZoneTicketType';
  /** The price of the zone ticket. Returns null if `pricingLevel` of the parent is set to other than `zone`. */
  price?: Maybe<Scalars['Float']>;
  /** The sections of the zone ticket. Returns null if `pricingLevel` of the parent is set to other than `section`. */
  sections?: Maybe<Array<ZonePricingTypeSection>>;
  /** The active status of the zone ticket. Defaults to `false`. */
  isActive: Scalars['Boolean'];
  /** The ticket type id of the zone ticket. */
  ticketTypeId?: Maybe<Scalars['String']>;
  minPurchaseQuantity: Scalars['Int'];
  maxPurchaseQuantity: Scalars['Int'];
  isSoldOut: Scalars['Boolean'];
  purchaseRestrictions: Array<PurchaseRestriction>;
  purchaseRestrictionsHelpText?: Maybe<Array<Scalars['String']>>;
  ticketAvailabilityStatus: TicketAvailabilityStatus;
};

export type ReleaseZoneTicketTypeInput = {
  /** The ticket type id of the zone ticket. */
  ticketTypeId: Scalars['String'];
  /** The price of the zone ticket. Pass null if `ReleaseZoneInput.pricingLevel` is set to other than `zone`. */
  price?: Maybe<Scalars['Float']>;
  /** The sections of the zone ticket. Pass null if `ReleaseZoneInput.pricingLevel` is set to other than `section`. */
  sections?: Maybe<Array<ReleaseZoneTicketTypeSectionInput>>;
  /** The active status of the zone ticket type. Defaults to `false`. */
  isActive?: Maybe<Scalars['Boolean']>;
};

export type ReleaseZoneTicketTypeSectionInput = {
  /** The section id. Should be equal to one of the sections defined in the event venue. */
  sectionId: Scalars['String'];
  /** The section name. Should be equal to one of the sections defined in the event venue. */
  name: Scalars['String'];
  /** The price of the section ticket. */
  price?: Maybe<Scalars['Float']>;
};

/** The zone belonging to a release zone */
export type ReleaseZoneZoneInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ReorderTicketTypeInput = {
  releaseZoneId: Scalars['String'];
  ticketTypeIds: Array<Scalars['String']>;
};

export type ReorderZoneInput = {
  venueId: Scalars['String'];
  zoneIds: Array<Scalars['String']>;
};

export enum ReportingFilterSource {
  Overall = 'OVERALL',
  Membership = 'MEMBERSHIP',
  Event = 'EVENT'
}

export enum ReportingFinancialSalesBreakdownSource {
  Membership = 'MEMBERSHIP',
  Event = 'EVENT'
}

export type RequestMagicLinkInput = {
  email: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
  entry?: Maybe<Scalars['String']>;
};

export type RequestResetPasswordInput = {
  email: Scalars['String'];
};

export type RequestTicketTransferInput = {
  email: Scalars['String'];
  ticketId: Scalars['String'];
  /**
   * The price set by the seller for the ticket transfer. Must be between the seller transfer fee
   *     and the original line item price. If not supplied, the original line item price is used.
   */
  ticketSalePrice?: Maybe<Scalars['Float']>;
};

export type ResetPasswordInput = {
  token: Scalars['String'];
  password: Scalars['String'];
};

export type RewardSettingsDto = {
  referralOwnerRewardQuantityType: ReferralRewardQuantityType;
  referralOwnerRewardQuantity?: Maybe<Scalars['Float']>;
  referralUserRewardQuantityType: ReferralRewardQuantityType;
  referralUserRewardQuantity?: Maybe<Scalars['Float']>;
};

export enum Role {
  Superadmin = 'Superadmin',
  Admin = 'Admin',
  Sales = 'Sales',
  PosAdmin = 'PosAdmin',
  PosOperator = 'PosOperator',
  VenueAdmin = 'VenueAdmin',
  Scanner = 'Scanner',
  User = 'User',
  EventReporting = 'EventReporting',
  BackOfficeStaff = 'BackOfficeStaff',
  SalesOutlet = 'SalesOutlet',
  EventManager = 'EventManager'
}

export type SalesChannelGraphOutput = {
  __typename?: 'SalesChannelGraphOutput';
  transactions: Scalars['Float'];
  online: Scalars['Float'];
  backOffice: Scalars['Float'];
  pos: Scalars['Float'];
};

export type SalesOverviewOutput = {
  __typename?: 'SalesOverviewOutput';
  ticketsSold: Scalars['Float'];
  membershipsSold: Scalars['Float'];
  addonsSold: Scalars['Float'];
  orders: Scalars['Float'];
  cartAbandonment: Scalars['Float'];
  returningCustomers: Scalars['Float'];
  ticketsPaid: Scalars['Float'];
  ticketsComp: Scalars['Float'];
  ticketsTransferred: Scalars['Float'];
  packagesSold: Scalars['Float'];
  pointsDistributed: Scalars['Float'];
  membershipsRenewed: Scalars['Float'];
  ticketCoverOrdersSold: Scalars['Float'];
  ticketCoverTicketsSold: Scalars['Float'];
};

export type Scan = {
  __typename?: 'Scan';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  scannedAt: Scalars['DateTime'];
  scanner: User;
  event: Event;
  direction: TicketScanDirection;
  type: TicketScanType;
  gate: Gate;
  hasScannedParentTicket: Scalars['Boolean'];
};

/** Scan status. */
export enum ScanStatus {
  Ok = 'OK',
  Warning = 'WARNING',
  Error = 'ERROR'
}

export type ScanTicketBulk = {
  /** Ticket number */
  ticketNumber: Scalars['String'];
  /** Scanner gate */
  gateId: Scalars['String'];
  /** Scanner direction */
  scanDirection: TicketScanDirection;
  /** Ticket scan type */
  scanType?: Maybe<TicketScanType>;
  eventId: Scalars['String'];
  scannedAt: Scalars['DateTime'];
};

export type ScanTicketBulkInput = {
  /** Scan data. */
  scans: Array<ScanTicketBulk>;
};

export type ScanTicketInput = {
  /** Ticket number */
  ticketNumber: Scalars['String'];
  /** Scanner gate */
  gateId: Scalars['String'];
  /** Scanner direction */
  scanDirection: TicketScanDirection;
  /** Ticket scan type */
  scanType?: Maybe<TicketScanType>;
};

export type ScanTicketOutput = {
  __typename?: 'ScanTicketOutput';
  status: ScanStatus;
  message?: Maybe<Scalars['String']>;
  ticket?: Maybe<Ticket>;
};

export type ScenarioInput = {
  scenarioId: Scalars['String'];
  /** The zones and Scenario inputs. */
  zones: Array<ScenarioZoneInput>;
};

export type ScenarioZoneInput = {
  /** The zone related to this input */
  zoneId: Scalars['String'];
  /** The ticket types for the zone and Scenario inputs. */
  ticketTypes: Array<ScenarioZoneTicketTypeInput>;
};

/** An object with ticket type id and forecast cost and split of sales */
export type ScenarioZoneTicketType = {
  __typename?: 'ScenarioZoneTicketType';
  /** Ticket type id */
  ticketTypeId: Scalars['String'];
  /** The forecast price of a ticket */
  price: Scalars['Float'];
  /** The forecast split of sales for this ticket type as a percentage */
  splitPercentage: Scalars['Float'];
};

export type ScenarioZoneTicketTypeInput = {
  /** The ticket type of this input. */
  ticketTypeId: Scalars['String'];
  /** The price of a seat in this zone for the ticket type. */
  price: Scalars['Float'];
  /** What percentage of the seats will be this ticket type */
  splitPercentage: Scalars['Float'];
};

export type Scout = {
  __typename?: 'Scout';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  purpose?: Maybe<ScoutPurpose>;
  includeOptedOutOfMarketing?: Maybe<Scalars['Boolean']>;
  promoteTo: Array<FilterSelection>;
  exclude: Array<FilterSelection>;
  /** Used to show what we are tracking */
  trackSource?: Maybe<Scalars['String']>;
  /** Id of source */
  trackSourceId?: Maybe<Scalars['String']>;
  /** Release Id of the source that we are tracking */
  trackReleaseId?: Maybe<Scalars['String']>;
  /** Scout active status. */
  isActive: Scalars['Boolean'];
  total: Scalars['Float'];
};

export type ScoutCampaignOverviewOutput = {
  __typename?: 'ScoutCampaignOverviewOutput';
  ticketsSold: Scalars['Float'];
  membershipsSold: Scalars['Float'];
  addonsSold: Scalars['Float'];
  orders: Scalars['Float'];
  cartAbandonment: Scalars['Float'];
  returningCustomers: Scalars['Float'];
  ticketsPaid: Scalars['Float'];
  ticketsComp: Scalars['Float'];
  totalRevenue: Scalars['Float'];
  todayRevenue: Scalars['Float'];
  campaignSize: Scalars['Float'];
  contactRate: Scalars['Float'];
  conversionRate: Scalars['Float'];
  emailClickRate: Scalars['Float'];
  emailOpenRate: Scalars['Float'];
};

export type ScoutCommunication = {
  __typename?: 'ScoutCommunication';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** If a campaign is created from a segment, then it should have a scout Id. */
  scout?: Maybe<Scout>;
  /** If a campaign is created from another campaign, then it should have a campaign Id. */
  campaign?: Maybe<ScoutCommunication>;
  /** email, sms or call */
  type: ScoutCommunicationType;
  data: Scalars['JSON'];
  name: Scalars['String'];
  purpose: ScoutPurpose;
  includeOptedOutOfMarketing?: Maybe<Scalars['Boolean']>;
  /** Used to show what we are tracking */
  trackSource?: Maybe<ReportingFilterSource>;
  /** Id of source */
  trackSourceId?: Maybe<Scalars['String']>;
  /** Release Id of the source that we are tracking */
  trackReleaseId?: Maybe<Scalars['String']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  shouldUpdate?: Maybe<Scalars['Boolean']>;
  /** Required when type is email communication */
  mailchimpCampaignId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Float']>;
  link?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  conversions: Scalars['Float'];
};

export type ScoutCommunicationsInput = {
  isActive?: Maybe<Scalars['Boolean']>;
};

/** The communication types for a scout campaign. */
export enum ScoutCommunicationType {
  Email = 'Email',
  Sms = 'SMS',
  Call = 'Call'
}

export type ScoutCommunicationUser = {
  __typename?: 'ScoutCommunicationUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  scoutCommunication: ScoutCommunication;
  stage: ScoutStage;
  remindAt?: Maybe<Scalars['DateTime']>;
  user: User;
  agentUser?: Maybe<User>;
  response?: Maybe<Scalars['JSON']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  scoutUser?: Maybe<ScoutUser>;
  history: HistoryConnection;
};


export type ScoutCommunicationUserHistoryArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<HistoryOrderByInput>;
};

export type ScoutCommunicationUserConnection = {
  __typename?: 'ScoutCommunicationUserConnection';
  pageInfo: PageInfo;
  edges: Array<ScoutCommunicationUserEdge>;
  totalCount: Scalars['Int'];
};

export type ScoutCommunicationUserEdge = {
  __typename?: 'ScoutCommunicationUserEdge';
  cursor: Scalars['String'];
  node: ScoutCommunicationUser;
};

export enum ScoutEventType {
  Event = 'Event',
  Membership = 'Membership'
}

/** The valid purposes for a scout. */
export enum ScoutPurpose {
  SellMembership = 'SellMembership',
  SellTickets = 'SellTickets',
  SellMerchandise = 'SellMerchandise',
  Communication = 'Communication'
}

/** The valid stages for a scout user. */
export enum ScoutStage {
  NoContact = 'NoContact',
  NoAnswer = 'NoAnswer',
  InProgress = 'InProgress',
  Completed = 'Completed'
}

export type ScoutUser = {
  __typename?: 'ScoutUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  scout: Scout;
  user: User;
  stage: ScoutStage;
  agentUser?: Maybe<User>;
  remindAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
};

export type ScoutUserConnection = {
  __typename?: 'ScoutUserConnection';
  pageInfo: PageInfo;
  edges: Array<ScoutUserEdge>;
  totalCount: Scalars['Int'];
};

export type ScoutUserEdge = {
  __typename?: 'ScoutUserEdge';
  cursor: Scalars['String'];
  node: ScoutUser;
};

export type SearchEventTicketsAppOutput = {
  __typename?: 'SearchEventTicketsAppOutput';
  totalCount: Scalars['Float'];
  tickets: Array<AppTicket>;
};

export type Season = {
  __typename?: 'Season';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Season name */
  name: Scalars['String'];
  /** Events in the season */
  events: Array<Event>;
  /** Season active status */
  isActive: Scalars['Boolean'];
  /** Description of the season */
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<ExtendedFile>;
  backgroundImageFullPage?: Maybe<ExtendedFile>;
  displayOrder: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};

/** The valid values for seat type (based on seats.io). */
export enum SeatType {
  Seat = 'SEAT',
  GeneralAdmission = 'GENERAL_ADMISSION'
}

export type Section = {
  __typename?: 'Section';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  /** The key field from Seats.io */
  seatsIoKey: Scalars['Float'];
};

export type SendBroadcastInput = {
  richTextString: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  audience?: Maybe<BroadcastAudience>;
  fromName: Scalars['String'];
  subject: Scalars['String'];
  /** If the input contains send time, then this is a scheduled email */
  sendTime?: Maybe<Scalars['DateTime']>;
  broadcastId?: Maybe<Scalars['String']>;
  ticketTypeId?: Maybe<Array<Scalars['String']>>;
  zoneId?: Maybe<Array<Scalars['String']>>;
  releaseId?: Maybe<Array<Scalars['String']>>;
  addonId?: Maybe<Array<Scalars['String']>>;
  /** If the input contains test email, then send test email */
  testEmail?: Maybe<Scalars['String']>;
  status: BroadcastStatus;
  type: BroadcastType;
  marketingType?: Maybe<BroadcastMarketingType>;
  marketingFilters?: Maybe<Array<MarketingFiltersInput>>;
  transactionalType?: Maybe<BroadcastTransactionalType>;
};

export type SendOrderConfirmationInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
};

export type SendOrderConfirmationOutput = {
  __typename?: 'SendOrderConfirmationOutput';
  email: Scalars['String'];
};

export type SetPasswordForNewUserInput = {
  password: Scalars['String'];
};

/** Represents shipping labels. */
export type ShippingLabels = {
  __typename?: 'ShippingLabels';
  /** Shipping label for e-tickets. */
  eTicket?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by mail. */
  printedTicketByMail?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by courier. */
  printedTicketByCourier?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by courier - rural. */
  printedTicketByCourierRural?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets at venue. */
  printedTicketAtVenue?: Maybe<Scalars['String']>;
};

/** Specifies the input fields for shipping labels. */
export type ShippingLabelsInput = {
  /** Shipping label for e-tickets. */
  eTicket?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by mail. */
  printedTicketByMail?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by courier. */
  printedTicketByCourier?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by courier - rural. */
  printedTicketByCourierRural?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets at venue. */
  printedTicketAtVenue?: Maybe<Scalars['String']>;
};

export enum ShippingOption {
  Eticket = 'ETICKET',
  PrintedTicketByMail = 'PRINTED_TICKET_BY_MAIL',
  PrintedTicketByCourier = 'PRINTED_TICKET_BY_COURIER',
  PrintedTicketByCourierRural = 'PRINTED_TICKET_BY_COURIER_RURAL',
  PrintedTicketAtVenue = 'PRINTED_TICKET_AT_VENUE'
}

/** Represents shipping options. */
export type ShippingOptions = {
  __typename?: 'ShippingOptions';
  /** Shipping fee for e-tickets. */
  eTicket?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by mail. */
  printedTicketByMail?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by courier. */
  printedTicketByCourier?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by courier - rural. */
  printedTicketByCourierRural?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets at venue. */
  printedTicketAtVenue?: Maybe<Scalars['Float']>;
};

/** Specifies the input fields for shipping options. Set to `null` for unavailability per item. */
export type ShippingOptionsInput = {
  /** Shipping fee for e-tickets. */
  eTicket?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by mail. */
  printedTicketByMail?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by courier. */
  printedTicketByCourier?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by courier - rural. */
  printedTicketByCourierRural?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets at venue. */
  printedTicketAtVenue?: Maybe<Scalars['Float']>;
};

/** Represents a Shopify customer */
export type ShopifyCustomerOrder = {
  __typename?: 'ShopifyCustomerOrder';
  id: Scalars['String'];
  total: Scalars['String'];
  currencyCode: Scalars['String'];
  lineItems: Array<ShopifyLineItem>;
};

export type ShopifyIntegration = {
  __typename?: 'ShopifyIntegration';
  storefrontAccessToken: Scalars['String'];
  shopDomain: Scalars['String'];
};

export type ShopifyLineItem = {
  __typename?: 'ShopifyLineItem';
  id: Scalars['String'];
  title: Scalars['String'];
  quantity: Scalars['Float'];
};

export type ShopifySetupInput = {
  token: Scalars['String'];
};

export type ShopifyUser = {
  __typename?: 'ShopifyUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Shopify user ID */
  shopifyUserId: Scalars['String'];
  /** Total amount spent on Shopify store with currency code */
  totalSpent?: Maybe<Scalars['String']>;
};

export type SocialAuthInput = {
  socialAuthType: SocialAuthType;
  accessToken: Scalars['String'];
};

/** Social authentication type */
export enum SocialAuthType {
  Facebook = 'Facebook',
  Google = 'Google'
}

export type SocialConnection = {
  __typename?: 'SocialConnection';
  pageInfo: PageInfo;
  edges: Array<SocialMentionEdge>;
  totalCount: Scalars['Int'];
};

export type SocialMention = {
  __typename?: 'SocialMention';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: Scalars['String'];
  /** igsid of customer, exist for story mentions */
  senderId?: Maybe<Scalars['String']>;
  /** igid of organisation */
  recipientId: Scalars['String'];
  /** id of comment */
  commentId?: Maybe<Scalars['String']>;
  /** id of media */
  mediaId?: Maybe<Scalars['String']>;
  /** content of comment mention and media mention */
  content?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  /** url of mentions */
  url: Scalars['String'];
};

export type SocialMentionEdge = {
  __typename?: 'SocialMentionEdge';
  cursor: Scalars['String'];
  node: SocialMention;
};

export type SocialWhereInput = {
  mentionType?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};

export type SplitOrderInput = {
  /** List of the order's line items ids that need to be transfered. */
  lineItemIds: Array<Scalars['String']>;
  /** User id can be provided for new order */
  userId?: Maybe<Scalars['String']>;
  /** Delivery method for the new order */
  deliveryMethod: ShippingOption;
  /** Multi buy promotion id for current order. */
  curMultiBuyId?: Maybe<Scalars['String']>;
  /** Multi buy promotion id for new order. */
  newMultiBuyId?: Maybe<Scalars['String']>;
  newTicketTypes?: Maybe<Array<SplitOrderTicketTypes>>;
};

export type SplitOrderTicketTypes = {
  lineItemId: Scalars['String'];
  ticketTypeId: Scalars['String'];
};

/** File storage type. */
export enum StorageType {
  Local = 'Local',
  Google = 'Google'
}

export type SummaryOverviewOutput = {
  __typename?: 'SummaryOverviewOutput';
  ticketsSold: Scalars['Float'];
  membershipsSold: Scalars['Float'];
  addonsSold: Scalars['Float'];
  orders: Scalars['Float'];
  cartAbandonment: Scalars['Float'];
  returningCustomers: Scalars['Float'];
  ticketsPaid: Scalars['Float'];
  ticketsComp: Scalars['Float'];
  totalRevenue: Scalars['Float'];
  todayRevenue: Scalars['Float'];
  yesterdayRevenue: Scalars['Float'];
  ticketsSoldToday: Scalars['Float'];
  ticketsSoldYesterday: Scalars['Float'];
  membershipsRenewed: Scalars['Float'];
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
};

export type TagEntitiesInput = {
  /** tag ids */
  tags: Array<Scalars['String']>;
  entityIds?: Maybe<Array<Scalars['String']>>;
  scoutCommunicationId?: Maybe<Scalars['String']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Ticket owner. Not all tickets have users. */
  user?: Maybe<User>;
  /** Ticket number */
  ticketNumber: Scalars['String'];
  /** Ticket creation origin */
  origin: TicketOrigin;
  /** Ticket status */
  status: TicketStatus;
  /** Ticket event. Only available for single tickets. */
  event?: Maybe<Event>;
  /** Ticket release. Only available for single tickets. */
  release?: Maybe<Release>;
  /** Ticket seat label. Only available for seated events. */
  seatLabel?: Maybe<Scalars['String']>;
  /** Ticket seat zone. Only available for seated events. */
  seatZone?: Maybe<Scalars['String']>;
  seatZoneEntity?: Maybe<Zone>;
  /** Ticket seat section. Only available for seated events. */
  seatSection?: Maybe<Scalars['String']>;
  seatSectionEntity?: Maybe<Section>;
  /** Ticket seat type. Only available for seated events. */
  seatType?: Maybe<SeatType>;
  /** Ticket seat tags. Only available for seated events. */
  seatTags?: Maybe<Array<Scalars['String']>>;
  /** Indicates if the claim for the seat has been released for the next membership. */
  hasReleasedNextMembershipClaim: Scalars['Boolean'];
  ticketTransfer?: Maybe<TicketTransfer>;
  /** Indicates if all required ticket holder naming fields have been filled in. */
  isNamed: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  postalCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  memberSince?: Maybe<Scalars['DateTime']>;
  licensePlate?: Maybe<Scalars['String']>;
  membershipNumber?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  dietaryRequirements?: Maybe<Scalars['String']>;
  lengthOfStay?: Maybe<Scalars['String']>;
  optInToMarketing?: Maybe<Scalars['Boolean']>;
  vaccinePass?: Maybe<VaccinePass>;
  emergencyName?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<Scalars['String']>;
  emergencyContactRelationship?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<CustomField>>;
  dunedinResidentialAddress?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
  /** Timestamp when ticket was most recently preprinted. */
  preprint?: Maybe<Scalars['DateTime']>;
  scans?: Maybe<Array<Scan>>;
  firstScanIn?: Maybe<Scan>;
  lastScanOut?: Maybe<Scan>;
  ticketCover?: Maybe<TicketTicketCover>;
  downloadCount: Scalars['Float'];
  /** Only populated if at least the relations `['event', 'event.venue', 'event.venue.gates'] are loaded */
  gates?: Maybe<Array<Gate>>;
  isViewable: Scalars['Boolean'];
  /** The membership type associated with the ticket. */
  membershipType?: Maybe<MembershipType>;
  /** The ticket type associated with the ticket. */
  ticketType?: Maybe<TicketType>;
  lineItem?: Maybe<LineItem>;
  maxTransferPrice?: Maybe<Scalars['Float']>;
  order?: Maybe<Order>;
  isHold: Scalars['Boolean'];
  displayName: Scalars['String'];
  parentTicketNumber?: Maybe<Scalars['String']>;
  /**
   * Returns the transfer fee paid for the ticket. If the ticket was sold, it will
   * include the seller fee. If the ticket was bought through a transfer, it will
   * include the buyer fee.
   */
  transferFee?: Maybe<TicketTransferFee>;
  digitalPassCode?: Maybe<Scalars['String']>;
  digitalEventUrl?: Maybe<Scalars['String']>;
  shouldBeNamed: Scalars['Boolean'];
  qrCode: Scalars['String'];
  hasRenewedMembership: Scalars['Boolean'];
  /** Parent ticket. Only available for single tickets that are child tickets of a membership. */
  parentTicket?: Maybe<Ticket>;
  childTickets?: Maybe<Array<Ticket>>;
  membership?: Maybe<Membership>;
  addon?: Maybe<AddonUnion>;
  transferStatus?: Maybe<TicketTransferStatus>;
  isTransferrable?: Maybe<Scalars['Boolean']>;
  walletTickets?: Maybe<WalletTicketOutput>;
  purchaseRestrictionText?: Maybe<Array<Scalars['String']>>;
};

export enum TicketAvailabilityStatus {
  Available = 'AVAILABLE',
  AllocationExhausted = 'ALLOCATION_EXHAUSTED',
  Soldout = 'SOLDOUT'
}

export type TicketConnection = {
  __typename?: 'TicketConnection';
  pageInfo: PageInfo;
  edges: Array<TicketEdge>;
  totalCount: Scalars['Int'];
};

export type TicketCoverAmount = {
  __typename?: 'TicketCoverAmount';
  totalFeeAmount: Scalars['Float'];
};

export type TicketCoverInput = {
  /** Promoter fee as percentage of ticket price */
  promoterFeePercentage: Scalars['Float'];
  /** Whether ticket cover is enabled */
  isEnabled: Scalars['Boolean'];
};

export type TicketEdge = {
  __typename?: 'TicketEdge';
  cursor: Scalars['String'];
  node: Ticket;
};

/** Ticket creation origin. */
export enum TicketOrigin {
  Order = 'ORDER',
  Import = 'IMPORT'
}

/** Scanner direction. */
export enum TicketScanDirection {
  ScanIn = 'SCAN_IN',
  ScanOut = 'SCAN_OUT'
}

/** Ticket scan type. */
export enum TicketScanType {
  Eticket = 'ETICKET',
  Hardcopy = 'HARDCOPY',
  Digital = 'DIGITAL'
}

export type TicketSoldTime = {
  __typename?: 'TicketSoldTime';
  /** The time first ticket was sold */
  startTime?: Maybe<Scalars['DateTime']>;
  /** The time last ticket was sold */
  endTime?: Maybe<Scalars['DateTime']>;
  /**
   * The source id.
   *     It is used by a useEffect hook on the front end.
   *     Only used to checked whether the new request has been made.
   *     Since for events or memberships with no tickets, the starttime and endtime will always be null.
   *     And if we only compare these two fields we don't know whether the source has been changed or not.
   */
  sourceId: Scalars['String'];
};

/** Ticket status. */
export enum TicketStatus {
  Active = 'ACTIVE',
  SeatChanged = 'SEAT_CHANGED',
  OrderCanceled = 'ORDER_CANCELED',
  OrderChanged = 'ORDER_CHANGED',
  Released = 'RELEASED',
  Refunded = 'REFUNDED',
  Transferred = 'TRANSFERRED',
  TransferPending = 'TRANSFER_PENDING'
}

export type TicketTicketCover = {
  __typename?: 'TicketTicketCover';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  perTicketAmount: Scalars['Float'];
  orderTicketCover: OrderTicketCover;
};

export type TicketTransfer = {
  __typename?: 'TicketTransfer';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  transferStatus: TicketTransferStatus;
  newOwnerEmail: Scalars['String'];
  buyerTransferFee: Scalars['Float'];
  sellerTransferFee: Scalars['Float'];
  originalLineItemPrice: Scalars['Float'];
  newLineItemPrice: Scalars['Float'];
};

export type TicketTransferFee = {
  __typename?: 'TicketTransferFee';
  type: TransferFeeType;
  fee: Scalars['Float'];
};

/** The status of the ticket transfer. */
export enum TicketTransferStatus {
  Pending = 'PENDING',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED'
}

/** Ticket type. */
export type TicketType = {
  __typename?: 'TicketType';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The kind of the ticket type. */
  kind: TicketTypeKind;
  quantity?: Maybe<Scalars['Int']>;
  minPurchaseQuantity?: Maybe<Scalars['Int']>;
  maxPurchaseQuantity?: Maybe<Scalars['Int']>;
  /** Whether the ticket type is grouped. */
  isGrouped: Scalars['Boolean'];
  /** The amount of people in a group. Returns null if the ticket type is not grouped. */
  groupAmount?: Maybe<Scalars['Int']>;
  /** Ticket group name. */
  name: Scalars['String'];
  /** Ticket type allowed dates. */
  dates: Array<TicketTypeDate>;
  /** Ticket fee type. */
  bookingFeeType: FeeType;
  /** Ticket fee. */
  bookingFee: Scalars['Float'];
  /** Per ticket stadium levy ticket fee. */
  stadiumLevyFee?: Maybe<Scalars['Float']>;
  /** Mark a ticket type as high demand */
  inHighDemand: Scalars['Boolean'];
  /** Mark a ticket type as sold out */
  soldOut: Scalars['Boolean'];
  /** Restrictions for the ticket group. */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the ticket group. */
  restrictions?: Maybe<Scalars['String']>;
  /** Print at home information for the ticket group. */
  printAtHomeInformation?: Maybe<Scalars['String']>;
  /** Image for the bottom of the print at home ticket . Returns null if the not set. */
  ticketBanner?: Maybe<ExtendedFile>;
  /** Image to be shown on the customer portal of the ticket . Returns null if the not set. */
  ticketImage?: Maybe<ExtendedFile>;
  namingFields: Array<FormField>;
  price?: Maybe<Scalars['Float']>;
  tags: Array<Tag>;
};

/** Allowed date for the ticket type. */
export type TicketTypeDate = {
  __typename?: 'TicketTypeDate';
  eventDateId: Scalars['ID'];
  /** Alternate entry time for the date. */
  alternateEntryTime?: Maybe<Scalars['String']>;
};

/** Ticket kind for ticket type. */
export enum TicketTypeKind {
  Standard = 'STANDARD',
  ComplimentaryNamed = 'COMPLIMENTARY_NAMED',
  ComplimentaryUnnamed = 'COMPLIMENTARY_UNNAMED',
  Addon = 'ADDON'
}

export type TicketTypePurchaseTotal = {
  __typename?: 'TicketTypePurchaseTotal';
  ticketType: TicketType;
  total: Scalars['Int'];
};

export type TicketWhereInput = {
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
};

export type TokenSet = {
  __typename?: 'TokenSet';
  idToken?: Maybe<Scalars['String']>;
  accessToken?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['Float']>;
  tokenType?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
};

export type TopReferrersOutput = {
  __typename?: 'TopReferrersOutput';
  name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['String']>;
};

export type TopRepeatPurchasers = {
  __typename?: 'TopRepeatPurchasers';
  name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['String']>;
};

export type TopTagsOutput = {
  __typename?: 'TopTagsOutput';
  tag?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
};

export type TransactionOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
};

/** Transfer fee type. */
export enum TransferFeeType {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type TwoFactorAuthenticationCodeInput = {
  twoFactorAuthenticationCode: Scalars['String'];
};

export type TwoFactorAuthenticationSetupResult = {
  __typename?: 'TwoFactorAuthenticationSetupResult';
  dataURL: Scalars['String'];
  secret: Scalars['String'];
};

/** UnsubscribeReason reason. */
export enum UnsubscribeReason {
  NoLongerInterested = 'NoLongerInterested',
  NeverSubscribed = 'NeverSubscribed',
  TooFrequent = 'TooFrequent',
  Other = 'OTHER'
}

export type UpdateAutomationInput = {
  name?: Maybe<Scalars['String']>;
  automationType?: Maybe<AutomationType>;
  templateId?: Maybe<Scalars['Float']>;
  subject?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  targetSource?: Maybe<ReportingFilterSource>;
  targetSourceId?: Maybe<Scalars['String']>;
  targetReleaseId?: Maybe<Scalars['String']>;
  timeOfDay?: Maybe<Scalars['DateTime']>;
  templateName?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
};

export type UpdateCreditsInput = {
  credits: Scalars['Float'];
};

/** Updates the info for a digital event/membership. */
export type UpdateDigitalInfoInput = {
  /** The url that digital pass codes are appended to in order to access the digital event/membership. */
  url?: Maybe<Scalars['String']>;
  /** The Postmark email template that is used to send digital pass codes. */
  emailTemplateId?: Maybe<Scalars['String']>;
  additionalEmailInfo?: Maybe<AdditionalEmailInfoInput>;
};

export type UpdateEventAddonInput = {
  /** The name of the addon. */
  name?: Maybe<Scalars['String']>;
  /** Indicates whether naming the addon is possible or not. */
  enableNaming?: Maybe<Scalars['Boolean']>;
  /** Maximum quantity to be sold for the addon. */
  quantity?: Maybe<Scalars['Float']>;
  /** The price associated with the addon. */
  price?: Maybe<Scalars['Float']>;
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive?: Maybe<Scalars['Boolean']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
  /** Image banner specific for a ticket type on the print at home ticket */
  addonImage?: Maybe<Scalars['Upload']>;
  insideFee?: Maybe<Scalars['Float']>;
};

/** Updates an event. */
export type UpdateEventInput = {
  /** The kind of event. */
  eventKind?: Maybe<EventKind>;
  /** Represents additional info required to host a digital event. */
  digitalInfo?: Maybe<UpdateDigitalInfoInput>;
  /** Event season. */
  season?: Maybe<Scalars['String']>;
  venue?: Maybe<Scalars['String']>;
  /** Event title. */
  title?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  backgroundImageFullPage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  printBanner1?: Maybe<Scalars['Upload']>;
  printBanner2?: Maybe<Scalars['Upload']>;
  hardCopyTicketBanner?: Maybe<Scalars['Upload']>;
  /** Event description. */
  description?: Maybe<Scalars['String']>;
  /** Event dates. */
  dates?: Maybe<Array<CreateEventDate>>;
  /** Date at which tickets are viewable/printable from. */
  ticketsViewableFromDate?: Maybe<Scalars['String']>;
  /** Event active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Event featured status. */
  isFeatured?: Maybe<Scalars['Boolean']>;
  /** Booking fee type. */
  bookingFeeType?: Maybe<FeeType>;
  /** Booking fee. */
  bookingFee?: Maybe<Scalars['Float']>;
  /** Whether event is R-18. */
  isR18?: Maybe<Scalars['Boolean']>;
  /** Whether event is checking for vaccine passports on entry */
  checkForVaccinePass?: Maybe<Scalars['Boolean']>;
  /** Whether naming ticket is available. */
  canNameTicket?: Maybe<Scalars['Boolean']>;
  /** Whether renaming ticket is available. */
  canRenameTicket?: Maybe<Scalars['Boolean']>;
  /** Whether changing seats is available. */
  canChangeSeats?: Maybe<Scalars['Boolean']>;
  /** Whether transfering ticket is available. */
  canTransferTicket?: Maybe<Scalars['Boolean']>;
  /** Whether the waitlist is visible on the event information page */
  enableWaitlist?: Maybe<Scalars['Boolean']>;
  /** The start date of the presale registration. */
  waitlistStartDate?: Maybe<Scalars['DateTime']>;
  /** The end date of the presale registration. */
  waitlistEndDate?: Maybe<Scalars['DateTime']>;
  /** Whether release codes are visible on the event information page */
  enableReleaseCodes?: Maybe<Scalars['Boolean']>;
  /** The renaming fee for the event ticket. */
  renamingFee?: Maybe<Scalars['Float']>;
  /** The fee for changing seats for the event ticket. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The fee the seller pays for transferring a ticket. */
  sellerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** The fee the buyer pays for transferring a ticket. */
  buyerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptionsInput>;
  /** The payment gateways enabled for the event. */
  gateways?: Maybe<Array<Scalars['String']>>;
  termsAndConditions?: Maybe<Scalars['String']>;
  importantNotice?: Maybe<Scalars['String']>;
  accessibility?: Maybe<Scalars['String']>;
  invoiceInformation?: Maybe<Scalars['String']>;
  presaleInformation?: Maybe<Scalars['String']>;
  emailNotification?: Maybe<Scalars['String']>;
  redirectURL?: Maybe<Scalars['String']>;
  zonesAllocatedGates?: Maybe<Array<ZoneAllocatedGateInput>>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** Inside fees for the event */
  insideFeeDetails?: Maybe<Array<InsideFeeDetailsInput>>;
  canUsePoints?: Maybe<Scalars['Boolean']>;
  gaVenue?: Maybe<CreateGaEventVenueInput>;
  ticketCover?: Maybe<TicketCoverInput>;
  listedReleaseOptions?: Maybe<ListedReleaseOptionsInput>;
};

export type UpdateEventMultiBuyPromotionInput = {
  name?: Maybe<Scalars['String']>;
  buyQuantity?: Maybe<Scalars['Float']>;
  getQuantity?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  buyTicketTypeId?: Maybe<Scalars['String']>;
  getTicketTypeId?: Maybe<Scalars['String']>;
};

export type UpdateEventPromoCodeInput = {
  /** The unique code that represents the promotion. */
  code?: Maybe<Scalars['String']>;
  /** The discount type associated with the promotion. */
  discountType?: Maybe<DiscountType>;
  /** The discount amount of the promotion. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<EventPromoCodeType>;
  ticketTypes?: Maybe<Array<Scalars['String']>>;
};

/** Updates an EventForecst */
export type UpdateForecastInput = {
  eventId: Scalars['String'];
  /** The zones and forecast inputs. */
  zones: Array<ForecastZoneInput>;
  /** The zones and forecast inputs. */
  scenarios: Array<ScenarioInput>;
};

export type UpdateHoldOrderInput = {
  /** List of actions to perform on line items. */
  lineItemActions: Array<LineItemActionInput>;
  /** Multi buy promotion id. */
  multiBuyId?: Maybe<Scalars['String']>;
};

export type UpdateIntegrationInput = {
  name?: Maybe<Scalars['String']>;
  secretKey?: Maybe<Scalars['String']>;
  publicKey?: Maybe<Scalars['String']>;
  wcPxPostSecretKey?: Maybe<Scalars['String']>;
  wcPxPostPublicKey?: Maybe<Scalars['String']>;
  webhookUrl?: Maybe<Scalars['String']>;
  transactionFeeType?: Maybe<FeeType>;
  transactionFee?: Maybe<Scalars['Float']>;
  transactionFeeType2?: Maybe<FeeType>;
  transactionFee2?: Maybe<Scalars['Float']>;
  paymentMethodType?: Maybe<Scalars['String']>;
  facebookTempToken?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
  type: IntegrationType;
};

export type UpdateMembershipAddonInput = {
  /** The name of the addon. */
  name?: Maybe<Scalars['String']>;
  /** Indicates whether naming the addon is possible or not. */
  enableNaming?: Maybe<Scalars['Boolean']>;
  /** Maximum quantity to be sold for the addon. */
  quantity?: Maybe<Scalars['Float']>;
  /** The price associated with the addon. */
  price?: Maybe<Scalars['Float']>;
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive?: Maybe<Scalars['Boolean']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
  /** Image banner specific for a ticket type on the print at home ticket */
  addonImage?: Maybe<Scalars['Upload']>;
};

export type UpdateMembershipInput = {
  /** Name of the membership. */
  name?: Maybe<Scalars['String']>;
  /** The kind of membership. */
  membershipKind?: Maybe<MembershipKind>;
  /** Represents additional info required to host a digital event. */
  digitalInfo?: Maybe<UpdateDigitalInfoInput>;
  /** The previous memberships related to the membership. */
  previousMemberships?: Maybe<Array<Scalars['String']>>;
  /** The start date of the membership. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date of the membership. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The booking fee type of the membership. */
  bookingFeeType?: Maybe<FeeType>;
  /** The booking fee for the membership. */
  bookingFee?: Maybe<Scalars['Float']>;
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptionsInput>;
  /** The description of the membership. */
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  banner?: Maybe<Scalars['Upload']>;
  printBanner1?: Maybe<Scalars['Upload']>;
  printBanner2?: Maybe<Scalars['Upload']>;
  /** The payment gateways enabled for the membership. */
  gateways?: Maybe<Array<Scalars['String']>>;
  /** Whether naming a membership is available. */
  canNameMembership?: Maybe<Scalars['Boolean']>;
  /** Whether renaming a membership is available. */
  canRenameMembership?: Maybe<Scalars['Boolean']>;
  /** Flag to determine if the membership is hidden from the public */
  hiddenFromPublic?: Maybe<Scalars['Boolean']>;
  /** Whether naming a membership is available. */
  canChangeSeats?: Maybe<Scalars['Boolean']>;
  /** The renaming fee for the membership. */
  renamingFee?: Maybe<Scalars['Float']>;
  /** The fee for changing seats for the membership. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The active status of the membership. */
  isActive?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  importantNotice?: Maybe<Scalars['String']>;
  accessibility?: Maybe<Scalars['String']>;
  invoiceInformation?: Maybe<Scalars['String']>;
  showSchedule?: Maybe<Scalars['Boolean']>;
  emailNotification?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  canUsePoints?: Maybe<Scalars['Boolean']>;
  enableAutoRenew?: Maybe<Scalars['Boolean']>;
  /** Whether individual event tickets can be transferred. */
  canTransferTickets?: Maybe<Scalars['Boolean']>;
  /** The season associated with the membership. */
  season?: Maybe<Scalars['String']>;
  /** The events associated with the membership. */
  events?: Maybe<Array<Scalars['String']>>;
  /** The zones of the seating. */
  membershipZones?: Maybe<Array<UpdateMembershipZoneInput>>;
};

export type UpdateMembershipMultiBuyPromotionInput = {
  name?: Maybe<Scalars['String']>;
  buyQuantity?: Maybe<Scalars['Float']>;
  getQuantity?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  buyMembershipTypeId?: Maybe<Scalars['String']>;
  getMembershipTypeId?: Maybe<Scalars['String']>;
};

export type UpdateMembershipPromoCodeInput = {
  /** The unique code that represents the promotion. */
  code?: Maybe<Scalars['String']>;
  /** The discount type associated with the promotion. */
  discountType?: Maybe<DiscountType>;
  /** The discount amount of the promotion. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<MembershipPromoCodeType>;
  membershipTypes?: Maybe<Array<Scalars['String']>>;
};

export type UpdateMembershipTypeEventTransferPriceInput = {
  membershipTypeId: Scalars['String'];
  membershipZoneId: Scalars['String'];
  prices: Array<MembershipTypeTransferPriceInput>;
};

export type UpdateMembershipTypeInput = {
  /** The kind of the membership type. */
  kind?: Maybe<MembershipTypeKind>;
  /** Name of the membership type. */
  name?: Maybe<Scalars['String']>;
  /** The ticket fee type. */
  ticketFeeType?: Maybe<FeeType>;
  /** The ticket fee. */
  ticketFee?: Maybe<Scalars['Float']>;
  /** Restrictions for the membership type. */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the membership type. */
  restrictions?: Maybe<Scalars['String']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
};

export type UpdateMembershipZoneInput = {
  /** The  memebershipZone id. */
  id?: Maybe<Scalars['String']>;
  /** The  zone. */
  zone: MembershipZoneZoneInput;
  /** The pricing level of the seating zone. Will be set to `zone` for non-seated events. */
  pricingLevel: ZonePricingLevel;
  /** The active status of the membership seating. Defaults to `false`. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The list of membership types of the seating zone. */
  membershipTypes: Array<UpdateMembershipZoneMembershipTypeInput>;
};

export type UpdateMembershipZoneMembershipTypeInput = {
  /** The membership type id of the seating. */
  membershipTypeId: Scalars['String'];
  /** The price of the zone per membership. Pass null if `pricingLevel` of the parent is set to other than `zone`. */
  price?: Maybe<Scalars['Float']>;
  /** The sections of the membership seating. Pass null if `pricingLevel` of the parent is set to other than `section`. */
  sections?: Maybe<Array<UpdateMembershipZoneMembershipTypeSectionInput>>;
  /** The active status of the membership type. Defaults to `false`. */
  isActive?: Maybe<Scalars['Boolean']>;
};

export type UpdateMembershipZoneMembershipTypeSectionInput = {
  /** The section id. Should be equal to one of the sections defined in the venue. */
  sectionId: Scalars['String'];
  /** The section name. Should be equal to one of the sections defined in the venue. */
  name: Scalars['String'];
  /** The price of the section ticket. */
  price: Scalars['Float'];
};

export type UpdateOrderInput = {
  /** The step the order currently is in. */
  step: Scalars['Float'];
  /** The delivery method chosen by the customer. */
  deliveryMethod?: Maybe<ShippingOption>;
  /** Buyer details. */
  buyerInformation?: Maybe<BuyerInformationInput>;
  /** Billing address provided by the customer. */
  billingAddress?: Maybe<AddressInput>;
  /** Shipping address provided by the customer. */
  shippingAddress?: Maybe<AddressInput>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress?: Maybe<Scalars['Boolean']>;
  /** If the purchaser has added dietary requirements */
  dietaryRequirements?: Maybe<Scalars['String']>;
  /** How the user heard about the event */
  heardAboutUs?: Maybe<HeardAboutUsType>;
  /** Heard about us details when heardAboutUs is other */
  heardAboutUsDetails?: Maybe<Scalars['String']>;
  /** If the order is starting a membership subscription */
  automaticRenewMambership?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the order is updated on admin portal.
   *     If the user is an admin, we won't update the details even if this is true.
   */
  updateDetails?: Maybe<Scalars['Boolean']>;
};

export type UpdateOrderStatusInput = {
  /** Order status to transition to. */
  status?: Maybe<OrderStatus>;
  /** Selected payment method if order status is paid (allowed: cash, eftpos, invoice, other). */
  method?: Maybe<PaymentProvider>;
  /** Will not send order confirmation email if set */
  skipOrderConfirmation?: Maybe<Scalars['Boolean']>;
  /** Will send the customer an invoice email for hold orders if set */
  sendHoldOrderCustomerEmail?: Maybe<Scalars['Boolean']>;
  isComp?: Maybe<Scalars['Boolean']>;
  compReason?: Maybe<Scalars['String']>;
};

export type UpdateOrderTicketCoverInput = {
  includeTicketCover: Scalars['Boolean'];
};

export type UpdateOrganizationInput = {
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  supportInfo?: Maybe<Scalars['String']>;
  landingPage?: Maybe<LandingPage>;
  showMemberships?: Maybe<Scalars['Boolean']>;
  showMembershipRenewal?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  privacyPolicy?: Maybe<Scalars['String']>;
  branding?: Maybe<BrandingInput>;
  marketing?: Maybe<MarketingInput>;
  helpLink?: Maybe<Scalars['String']>;
  /** Shipping options. */
  shippingLabels?: Maybe<ShippingLabelsInput>;
};

export type UpdatePasswordInput = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type UpdatePointInput = {
  name?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  gatewayIds: Array<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
};

export type UpdatePointItemInput = {
  name: Scalars['String'];
  price: Scalars['Float'];
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  banner?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  isVisible: Scalars['Boolean'];
};

export type UpdatePosUserInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  accessCode?: Maybe<Scalars['String']>;
};

export type UpdateProfileInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  twoFactorAuthenticationSecret?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  usableForMarketing?: Maybe<Scalars['Boolean']>;
  /** Billing address provided by the user. */
  billingAddress?: Maybe<PartialAddressInput>;
  /** Shipping address provided by the user. */
  shippingAddress?: Maybe<PartialAddressInput>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress?: Maybe<Scalars['Boolean']>;
  credits?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  instagramUsername?: Maybe<Scalars['String']>;
  referralId?: Maybe<Scalars['String']>;
  accessEventIds?: Maybe<Array<Scalars['String']>>;
  accessMembershipIds?: Maybe<Array<Scalars['String']>>;
  /** Elevate users privileges from user to admin. */
  elevatePrivileges?: Maybe<Scalars['Boolean']>;
};

/** Updates a Referral Campaign */
export type UpdateReferralCampaignDto = {
  referralReleaseId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  referralOwnerRewardType?: Maybe<ReferralRewardType>;
  referralOwnerRewardQuantityType?: Maybe<ReferralRewardQuantityType>;
  referralOwnerRewardQuantity?: Maybe<Scalars['Float']>;
  referralUserRewardType?: Maybe<ReferralRewardType>;
  referralUserRewardQuantityType?: Maybe<ReferralRewardQuantityType>;
  referralUserRewardQuantity?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
};

export type UpdateReleaseInput = {
  /** Release name. */
  name?: Maybe<Scalars['String']>;
  /** Release type. */
  type?: Maybe<ReleaseType>;
  /** The slug for the unlisted release. Pass null if the release type is set to other than `unlisted`. */
  slug?: Maybe<Scalars['String']>;
  /** The password for the unlisted release. Pass null if the release type is set to other than `unlisted`. */
  password?: Maybe<Scalars['String']>;
  /** The start condition of the release. */
  startCondition?: Maybe<ReleaseStartCondition>;
  /** The start date of the release. Pass null if the startCondition is set to other than `date`. */
  startConditionDate?: Maybe<Scalars['DateTime']>;
  /** The end condition of the release. */
  endCondition?: Maybe<ReleaseEndCondition>;
  /** The quantity limit of the release. Pass null if the endCondition is set to other than `quantity`. */
  endConditionQuantity?: Maybe<Scalars['Float']>;
  /** The end date of the release. Pass null if the endCondition is set to other than `date`. */
  endConditionDate?: Maybe<Scalars['DateTime']>;
  /** The status of the release. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The zones of the release. */
  releaseZones?: Maybe<Array<ReleaseZoneInput>>;
  /** The title of the unlisted release. Pass null if the `type` is set to other than `unlisted`. */
  presaleTitle?: Maybe<Scalars['String']>;
  presaleLogo?: Maybe<Scalars['Upload']>;
  presaleHeader?: Maybe<Scalars['Upload']>;
  /** The information of the unlisted release. Pass null if the `type` is set to other than `unlisted`. */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The information that will be shown to customers on the ticketing page. */
  releaseNotes?: Maybe<Scalars['String']>;
  /** Ask how did you heard about us during the purchasing flow */
  askHowDidYouHearAboutUs?: Maybe<Scalars['Boolean']>;
  /** Request purchasers  */
  askForDietaryRequirements?: Maybe<Scalars['Boolean']>;
  /** Are comps visible to public */
  allowPublicComp?: Maybe<Scalars['Boolean']>;
  /** Can this release use Windcaves Account2Account functionality */
  allowAccount2Account?: Maybe<Scalars['Boolean']>;
  /** Can customers create hold orders for this release */
  allowHoldOrders?: Maybe<Scalars['Boolean']>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  releaseEventAddons?: Maybe<Array<Scalars['String']>>;
};

export type UpdateReleaseZoneInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  capacity: Scalars['Int'];
  admission: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
};

export type UpdateScoutCommunicationInput = {
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<ScoutPurpose>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ScoutCommunicationType>;
  includeOptedOutOfMarketing?: Maybe<Scalars['Boolean']>;
  segmentId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  trackSource?: Maybe<ReportingFilterSource>;
  trackSourceId?: Maybe<Scalars['String']>;
  trackReleaseId?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  shouldUpdate?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Float']>;
  subject?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type UpdateScoutCommunicationUserInput = {
  stage: ScoutStage;
  usableForMarketing?: Maybe<Scalars['Boolean']>;
};

export type UpdateScoutInput = {
  name?: Maybe<Scalars['String']>;
  promoteTo?: Maybe<Array<FilterSelectionInput>>;
  exclude?: Maybe<Array<FilterSelectionInput>>;
  isActive: Scalars['Boolean'];
};

export type UpdateSeasonInput = {
  /** Season name. */
  name?: Maybe<Scalars['String']>;
  /** Season active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Season description. */
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  backgroundImageFullPage?: Maybe<Scalars['Upload']>;
  displayOrder?: Maybe<Scalars['Float']>;
};

export type UpdateTagInput = {
  name?: Maybe<Scalars['String']>;
};

export type UpdateTicketHolderInput = {
  vaccinePass?: Maybe<Scalars['Upload']>;
  optInToMarketing?: Maybe<Scalars['Boolean']>;
  customFields?: Maybe<Array<CustomFieldInput>>;
  /** First name of the ticket holder. */
  firstName?: Maybe<Scalars['String']>;
  /** Last name of the ticket holder. */
  lastName?: Maybe<Scalars['String']>;
  /** Email of the ticket holder. */
  email?: Maybe<Scalars['String']>;
  /** Phone number of the ticket holder. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Birth date of the ticket holder. */
  birthDate?: Maybe<Scalars['DateTime']>;
  /** Gender of the ticket holder. */
  gender?: Maybe<Gender>;
  /** Postal code of the ticket holder. */
  postalCode?: Maybe<Scalars['String']>;
  /** Company name of the ticket holder (optional). */
  companyName?: Maybe<Scalars['String']>;
  /** Since when the ticket holder is a member. */
  memberSince?: Maybe<Scalars['DateTime']>;
  /** License plate of the ticket holder. */
  licensePlate?: Maybe<Scalars['String']>;
  /** Membership number of the ticket holder. */
  membershipNumber?: Maybe<Scalars['String']>;
  /** Comments of the ticket holder. */
  comments?: Maybe<Scalars['String']>;
  /** Dietary requirements of the ticket holder. */
  dietaryRequirements?: Maybe<Scalars['String']>;
  /** How long someone is staying at an event */
  lengthOfStay?: Maybe<Scalars['String']>;
  /** Name of the emergency contact */
  emergencyName?: Maybe<Scalars['String']>;
  /** Phone number of the emergency contact */
  emergencyContact?: Maybe<Scalars['String']>;
  /** Phone number of the emergency contact */
  emergencyContactRelationship?: Maybe<Scalars['String']>;
  /** Residential address in Dunedin */
  dunedinResidentialAddress?: Maybe<Scalars['String']>;
  /** Student id of the ticket holder */
  studentId?: Maybe<Scalars['String']>;
};

export type UpdateTicketTypeInput = {
  /** The kind of the ticket type. */
  kind?: Maybe<TicketTypeKind>;
  /** Whether the ticket type is grouped. */
  isGrouped?: Maybe<Scalars['Boolean']>;
  /** The amount of people in a group. Returns null if the ticket type is not grouped. */
  groupAmount?: Maybe<Scalars['Float']>;
  /** Ticket group name. */
  name?: Maybe<Scalars['String']>;
  /** Event dates. */
  dates?: Maybe<Array<CreateTicketTypeDate>>;
  /** Booking fee type. */
  bookingFeeType?: Maybe<FeeType>;
  /** Booking fee. */
  bookingFee?: Maybe<Scalars['Float']>;
  /** Per ticket stadium levy ticket fee. */
  stadiumLevyFee?: Maybe<Scalars['Float']>;
  /** Mark a ticket type as high demand */
  inHighDemand?: Maybe<Scalars['Boolean']>;
  /** MMark a ticket type as sold out */
  soldOut?: Maybe<Scalars['Boolean']>;
  /** Restrictions for the ticket group. */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the ticket group. */
  restrictions?: Maybe<Scalars['String']>;
  /** Print at home information for the ticket group. */
  printAtHomeInformation?: Maybe<Scalars['String']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketBanner?: Maybe<Scalars['Upload']>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketImage?: Maybe<Scalars['Upload']>;
  quantity?: Maybe<Scalars['Float']>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** Price for v2 event */
  price?: Maybe<Scalars['Float']>;
  /** releaseZoneId for v2 event */
  releaseZoneId?: Maybe<Scalars['String']>;
  /** isActive for v2 event */
  isActive?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  twoFactorAuthenticationSecret?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  usableForMarketing?: Maybe<Scalars['Boolean']>;
  /** Billing address provided by the user. */
  billingAddress?: Maybe<PartialAddressInput>;
  /** Shipping address provided by the user. */
  shippingAddress?: Maybe<PartialAddressInput>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress?: Maybe<Scalars['Boolean']>;
  credits?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  instagramUsername?: Maybe<Scalars['String']>;
  referralId?: Maybe<Scalars['String']>;
  accessEventIds?: Maybe<Array<Scalars['String']>>;
  accessMembershipIds?: Maybe<Array<Scalars['String']>>;
  /** Elevate users privileges from user to admin. */
  elevatePrivileges?: Maybe<Scalars['Boolean']>;
};

export type UpdateVenueInput = {
  accessibilityInfo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Float']>;
  capacityUtilization?: Maybe<Scalars['Float']>;
  address?: Maybe<AddressInput>;
  location?: Maybe<CoordinateInput>;
  zones?: Maybe<Array<ZoneInput>>;
  gates?: Maybe<Array<GateInput>>;
};


export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  roles: Array<Role>;
  /** Permision set based on roles */
  permissions: Array<Permission>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  hasPassword: Scalars['Boolean'];
  isTwoFactorAuthenticationEnabled: Scalars['Boolean'];
  isLoggedInWithLinkedAccount: Scalars['Boolean'];
  hasVerifiedEmail: Scalars['Boolean'];
  birthDate?: Maybe<Scalars['DateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  usableForMarketing?: Maybe<Scalars['Boolean']>;
  /** Billing address associated with the user. */
  billingAddress?: Maybe<PartialAddress>;
  /** Shipping address associated with the user. */
  shippingAddress?: Maybe<PartialAddress>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress: Scalars['Boolean'];
  /** User credits balance */
  credits?: Maybe<Scalars['Float']>;
  /** User points balance */
  points: Scalars['Float'];
  usSegment?: Maybe<UsSegment>;
  /** unique uuid of a customer used to link to referral campaigns */
  referralId: Scalars['String'];
  /** User instagram username */
  instagramUsername?: Maybe<Scalars['String']>;
  /** The company name of the user. */
  companyName?: Maybe<Scalars['String']>;
  /** The tax number of the user. */
  taxNumber?: Maybe<Scalars['String']>;
  /** The region of the user, derived from the postal code of billing address. */
  region?: Maybe<Scalars['String']>;
  unsubscribeReason?: Maybe<UnsubscribeReason>;
  otherUnsubscribeReason?: Maybe<Scalars['String']>;
  lastTimeLoggedInAt?: Maybe<Scalars['DateTime']>;
  tags: Array<Tag>;
  scoutCommunications: Array<ScoutCommunication>;
  orders: OrderConnection;
  membershipTickets: Array<Ticket>;
  eventTickets: Array<Ticket>;
  hasMemberships: Scalars['Boolean'];
  hasTickets: Scalars['Boolean'];
  LTV: Scalars['Float'];
  history: HistoryConnection;
  /** The IDs of the events the user can access when their account is scoped for only certain events */
  accessEventIds?: Maybe<Array<Scalars['String']>>;
  /** The IDs of the memberships the user can access when their account is scoped for only certain events */
  accessMembershipIds?: Maybe<Array<Scalars['String']>>;
  /** The Shopify user entry for the user if they have used the organization's Shopify store */
  shopifyUser?: Maybe<ShopifyUser>;
};


export type UserOrdersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<OrderOrderByInput>;
};


export type UserHistoryArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<HistoryOrderByInput>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  pageInfo: PageInfo;
  edges: Array<UserEdge>;
  totalCount: Scalars['Int'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String'];
  node: User;
};

export type UserOrderByInput = {
  firstName?: Maybe<OrderByDirection>;
  lastName?: Maybe<OrderByDirection>;
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
};

export type UserWhereInput = {
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
};

export type UsSegment = {
  __typename?: 'UsSegment';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: User;
  organization: Organization;
  accuracy: Scalars['Float'];
  /** A single letter representation of the segment a user is in */
  segment: Scalars['String'];
  /** Address that was provided for the Us Segment */
  address: PartialAddress;
};

export type VaccinePass = {
  __typename?: 'VaccinePass';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Pass owner */
  user?: Maybe<User>;
  /** Ticket that the pass is asscoiated with */
  ticket?: Maybe<Ticket>;
  /** Raw payload of the vaccine pass */
  payload?: Maybe<Scalars['String']>;
  /** Decoded payload of the vaccine pass */
  payloadDecoded: Scalars['JSON'];
};

export type Venue = {
  __typename?: 'Venue';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Venue name */
  name: Scalars['String'];
  /** Seats.IO chart key */
  seatsChartKey?: Maybe<Scalars['String']>;
  zones: Array<Zone>;
  /** Seats.IO zones */
  zonesOldField?: Maybe<Array<ZoneObject>>;
  /** Seats.IO zones */
  zoneObjects?: Maybe<Array<ZoneObject>>;
  /** Venue address */
  address: Address;
  /** Venue seating settings. */
  seating: VenueSeating;
  /** Venue capacity. */
  capacity: Scalars['Float'];
  /** Venue capacity utilization as a percentage. */
  capacityUtilization: Scalars['Float'];
  /** Accessibility information. */
  accessibilityInfo?: Maybe<Scalars['String']>;
  /** Venue coordinates (lat, lng). */
  location?: Maybe<Coordinate>;
  gates: Array<Gate>;
  trackHardCopyTickets: Scalars['Boolean'];
  /** Does this stadium require a per ticket levy to be charged */
  hasStadiumLevy: Scalars['Boolean'];
  /** Filter options that are avalible for a seated venue */
  filterOptions?: Maybe<Array<Scalars['String']>>;
  createdFromEvent: Scalars['Boolean'];
};

/** Venue seating settings. */
export enum VenueSeating {
  Seated = 'Seated',
  NonSeated = 'NonSeated',
  Digital = 'Digital'
}

export type VerifyEmailInput = {
  token: Scalars['String'];
};

export type VerifyMagicLinkOutput = {
  __typename?: 'VerifyMagicLinkOutput';
  redirectUrl: Scalars['String'];
};

export type VerifyPinPayment3Ds = {
  refId: Scalars['String'];
  sessionToken: Scalars['String'];
};

/** Represents a date in an event. */
export type Waitlist = {
  __typename?: 'Waitlist';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  user: User;
  event: Event;
};

export type WaitlistOverviewOutput = {
  __typename?: 'WaitlistOverviewOutput';
  totalCustomers?: Maybe<Scalars['Float']>;
  totalNewCustomers?: Maybe<Scalars['Float']>;
  totalReturningCustomers?: Maybe<Scalars['Float']>;
  customersOptedIntoMarketing?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  numberOfOrders?: Maybe<Scalars['Float']>;
  numberOfSuccesfulUsers?: Maybe<Scalars['Float']>;
  numberOfTickets?: Maybe<Scalars['Float']>;
  yetToConvert?: Maybe<Scalars['Float']>;
};

/** Represents a customer on a waitlist for an event. This customer may or may not exist as an actual user. */
export type WaitlistUser = {
  __typename?: 'WaitlistUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  event: Event;
  /** The referral code used when registering for presale access. Will be tied to the referring user/waitlist user */
  referralCode?: Maybe<ReferralCode>;
  /** The user that is on the waitlist. This may be null if the user does not already exist in our system. */
  user?: Maybe<User>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  usableForMarketing: Scalars['Boolean'];
  fullName: Scalars['String'];
};

/** Contains encoded ticket data in the format required for various wallet providers. */
export type WalletTicket = {
  __typename?: 'WalletTicket';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** (Google): A JWT-encoded representation of a ticket to be used with Google Pay. */
  googlePayJwtTicket?: Maybe<Scalars['String']>;
  /** (Apple): Binary contents of a .pkpass file to be used with Apple Wallet. */
  applePassPayload?: Maybe<Scalars['String']>;
  /** (Apple): authentication token to be used with Apple Wallet. */
  authenticationToken?: Maybe<Scalars['String']>;
  /** (Google): The object ID to identify this ticket in the Google Wallet API. */
  googleObjectId?: Maybe<Scalars['String']>;
  /** The ticket that is encoded in the entity */
  ticket?: Maybe<Ticket>;
  /** The organization associated with the ticket. */
  organization?: Maybe<Organization>;
};

export type WalletTicketOutput = {
  __typename?: 'WalletTicketOutput';
  /** Google Wallet URL that contains the payload to add ticket to Google Wallet */
  googleWalletPayload?: Maybe<Scalars['String']>;
  /** The base64 encoded payload to add ticket to Apple Wallet */
  appleWalletPayload?: Maybe<Scalars['String']>;
};

/** Represents a Xero account. */
export type XeroAccountOutput = {
  __typename?: 'XeroAccountOutput';
  accountId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Represents all available Xero accounts. */
export type XeroAllAccountsOutput = {
  __typename?: 'XeroAllAccountsOutput';
  currentAccountCode?: Maybe<Scalars['String']>;
  availableAccounts?: Maybe<Array<XeroAccountOutput>>;
};

export type XeroCallbackInput = {
  code: Scalars['String'];
};

export type Zone = {
  __typename?: 'Zone';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  /** Zone capacity. When used seats.io is source of truth */
  capacity: Scalars['Float'];
  sectionModels?: Maybe<Array<Scalars['String']>>;
  sections?: Maybe<Array<Section>>;
  stand?: Maybe<Scalars['String']>;
  seated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Int'];
  admission: Scalars['Boolean'];
};

/** Allowed date for the zone. */
export type ZoneAllocatedDate = {
  __typename?: 'ZoneAllocatedDate';
  eventDateId: Scalars['ID'];
  /** Alternate entry time for the zone. */
  alternateEntryTime: Scalars['String'];
};

export type ZoneAllocatedDateInput = {
  eventDateId: Scalars['ID'];
  /** Alternate entry time for the zone. */
  alternateEntryTime: Scalars['String'];
};

export type ZoneAllocatedGate = {
  __typename?: 'ZoneAllocatedGate';
  zoneId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  gates?: Maybe<Array<Scalars['String']>>;
  sections?: Maybe<Array<ZoneAllocatedGateSection>>;
  availabilityCount?: Maybe<ZoneAllocationAvailability>;
  /** Alternate entry time for the zone. */
  dates?: Maybe<Array<ZoneAllocatedDate>>;
};

export type ZoneAllocatedGateInput = {
  zoneId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  gates?: Maybe<Array<Scalars['String']>>;
  sections?: Maybe<Array<ZoneAllocatedGateSectionInput>>;
  availabilityCount?: Maybe<ZoneAllocationAvailabilityInput>;
  /** Alternate entry time for the zone. */
  dates?: Maybe<Array<ZoneAllocatedDateInput>>;
};

export type ZoneAllocatedGateSection = {
  __typename?: 'ZoneAllocatedGateSection';
  /** Section name. */
  name: Scalars['String'];
  /** Section id. */
  sectionId?: Maybe<Scalars['String']>;
  gates?: Maybe<Array<Scalars['String']>>;
};

export type ZoneAllocatedGateSectionInput = {
  /** Section name. */
  name: Scalars['String'];
  /** Section id. */
  sectionId?: Maybe<Scalars['String']>;
  gates?: Maybe<Array<Scalars['String']>>;
};

export type ZoneAllocationAvailability = {
  __typename?: 'ZoneAllocationAvailability';
  notForSale?: Maybe<Scalars['Float']>;
  holdByMembership?: Maybe<Scalars['Float']>;
  booked?: Maybe<Scalars['Float']>;
  available?: Maybe<Scalars['Float']>;
};

export type ZoneAllocationAvailabilityInput = {
  notForSale?: Maybe<Scalars['Float']>;
  holdByMembership?: Maybe<Scalars['Float']>;
  booked?: Maybe<Scalars['Float']>;
  available?: Maybe<Scalars['Float']>;
};

/** The zone belonging to a venue (can only be set for non-seated venues) */
export type ZoneInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  capacity: Scalars['Float'];
  stand?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Float'];
  admission?: Maybe<Scalars['Boolean']>;
};

/** Seats.IO Zone. */
export type ZoneObject = {
  __typename?: 'ZoneObject';
  name: Scalars['String'];
  capacity: Scalars['Float'];
  sections: Array<Scalars['String']>;
  stand?: Maybe<Scalars['String']>;
};

export enum ZonePricingLevel {
  Zone = 'ZONE',
  Section = 'SECTION'
}

/** Represents a section level pricing. */
export type ZonePricingTypeSection = {
  __typename?: 'ZonePricingTypeSection';
  /** Section name. */
  name: Scalars['String'];
  /** Section id. */
  sectionId: Scalars['String'];
  /** The price of the section ticket type or the section membership type. */
  price?: Maybe<Scalars['Float']>;
};

export type AudienceCountQueryVariables = Exact<{
  input: AudienceCountInput;
}>;


export type AudienceCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'audienceCount'>
);

export type BroadcastQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BroadcastQuery = (
  { __typename?: 'Query' }
  & { broadcast: (
    { __typename?: 'Broadcast' }
    & Pick<Broadcast, 'id' | 'subject' | 'fromName' | 'audienceType' | 'message' | 'type' | 'marketingType' | 'status' | 'scheduledAt' | 'count' | 'transactionalType'>
    & { marketingFilters?: Maybe<Array<(
      { __typename?: 'BroadcastMarketingFilters' }
      & Pick<BroadcastMarketingFilters, 'ids' | 'criteria' | 'filterType'>
    )>>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'title'>
    )>, membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'id' | 'name'>
    )>, audienceData: (
      { __typename?: 'AudienceData' }
      & Pick<AudienceData, 'ticketTypeId' | 'zoneId' | 'releaseId' | 'addonId'>
    ), stats?: Maybe<(
      { __typename?: 'PostmarkEmailStatsOverviewOutput' }
      & Pick<PostmarkEmailStatsOverviewOutput, 'sent' | 'bounced' | 'bounceRate' | 'opens' | 'uniqueOpens'>
    )> }
  ) }
);

export type BroadcastBouncesQueryVariables = Exact<{
  id: Scalars['String'];
  start: Scalars['Float'];
  count: Scalars['Float'];
}>;


export type BroadcastBouncesQuery = (
  { __typename?: 'Query' }
  & { broadcastBounces: Array<(
    { __typename?: 'User' }
    & Pick<User, 'email' | 'fullName'>
  )> }
);

export type BroadcastReportStatsQueryVariables = Exact<{
  input: BroadcastReportingStatsInput;
}>;


export type BroadcastReportStatsQuery = (
  { __typename?: 'Query' }
  & { broadcastReportStats: (
    { __typename?: 'BroadcastReportingOutput' }
    & Pick<BroadcastReportingOutput, 'clicksOpened' | 'revenue' | 'conversions' | 'spamReported'>
  ) }
);

export type BroadcastsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<BroadcastWhereInput>;
}>;


export type BroadcastsQuery = (
  { __typename?: 'Query' }
  & { broadcasts: (
    { __typename?: 'BroadcastConnection' }
    & Pick<BroadcastConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'BroadcastEdge' }
      & { node: (
        { __typename?: 'Broadcast' }
        & Pick<Broadcast, 'id' | 'subject' | 'status' | 'audienceType' | 'scheduledAt' | 'errors' | 'type' | 'marketingType' | 'count'>
        & { marketingFilters?: Maybe<Array<(
          { __typename?: 'BroadcastMarketingFilters' }
          & Pick<BroadcastMarketingFilters, 'ids' | 'criteria' | 'filterType'>
        )>>, event?: Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'id' | 'title'>
        )>, membership?: Maybe<(
          { __typename?: 'Membership' }
          & Pick<Membership, 'id' | 'name'>
        )>, stats?: Maybe<(
          { __typename?: 'PostmarkEmailStatsOverviewOutput' }
          & Pick<PostmarkEmailStatsOverviewOutput, 'bounced'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type DeleteBroadcastMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBroadcastMutation = (
  { __typename?: 'Mutation' }
  & { deleteBroadcast: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type MarketingUserCountQueryVariables = Exact<{
  input: BroadcastFilterCountInput;
}>;


export type MarketingUserCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'marketingUserCount'>
);

export type SendBroadcastMutationVariables = Exact<{
  input: SendBroadcastInput;
}>;


export type SendBroadcastMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendBroadcast'>
);

export type CompetitionFragmentFragment = (
  { __typename?: 'Competition' }
  & Pick<Competition, 'id' | 'startDate' | 'endDate' | 'competitionType' | 'description' | 'termsAndConditions' | 'title' | 'isPublished' | 'referralRewardValue' | 'isCompetitionRunning' | 'competitionState'>
  & { prizes?: Maybe<Array<(
    { __typename?: 'CompetitionPrize' }
    & CompetitionPrizeFragmentFragment
  )>>, promoter?: Maybe<Array<(
    { __typename?: 'CompetitionReward' }
    & CompetitionRewardFragmentFragment
  )>> }
);

export type CompetitionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompetitionQuery = (
  { __typename?: 'Query' }
  & { competition: (
    { __typename?: 'Competition' }
    & CompetitionFragmentFragment
  ) }
);

export type CompetitionPrizeFragmentFragment = (
  { __typename?: 'CompetitionPrize' }
  & Pick<CompetitionPrize, 'id' | 'title' | 'description' | 'prizeOrder' | 'quantity'>
  & { image?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )> }
);

export type CompetitionRewardFragmentFragment = (
  { __typename?: 'CompetitionReward' }
  & Pick<CompetitionReward, 'platform' | 'actionType' | 'value' | 'isEnabled'>
);

export type CompetitionsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type CompetitionsQuery = (
  { __typename?: 'Query' }
  & { competitions: Array<(
    { __typename?: 'Competition' }
    & CompetitionFragmentFragment
  )> }
);

export type CreateCompetitionMutationVariables = Exact<{
  eventId: Scalars['String'];
  input: CreateCompetitionInput;
}>;


export type CreateCompetitionMutation = (
  { __typename?: 'Mutation' }
  & { createCompetition: (
    { __typename?: 'Competition' }
    & CompetitionFragmentFragment
  ) }
);

export type DeleteCompetitionMutationVariables = Exact<{
  competitionId: Scalars['String'];
}>;


export type DeleteCompetitionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteCompetition'>
);

export type UnpublishCompetitionMutationVariables = Exact<{
  competitionId: Scalars['String'];
}>;


export type UnpublishCompetitionMutation = (
  { __typename?: 'Mutation' }
  & { unpublishCompetition: (
    { __typename?: 'Competition' }
    & CompetitionFragmentFragment
  ) }
);

export type UpdateAndPublishCompetitionMutationVariables = Exact<{
  eventId: Scalars['String'];
  input: PublishCompetitionInput;
}>;


export type UpdateAndPublishCompetitionMutation = (
  { __typename?: 'Mutation' }
  & { updateAndPublishCompetition: (
    { __typename?: 'Competition' }
    & CompetitionFragmentFragment
  ) }
);

export type UpdateCompetitionMutationVariables = Exact<{
  competitionId: Scalars['String'];
  input: CreateCompetitionInput;
}>;


export type UpdateCompetitionMutation = (
  { __typename?: 'Mutation' }
  & { updateCompetition: (
    { __typename?: 'Competition' }
    & CompetitionFragmentFragment
  ) }
);

export type EventDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EventDetailsQuery = (
  { __typename?: 'Query' }
  & { event: (
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'eventKind' | 'startDate' | 'isActive' | 'emailNotification' | 'invoiceInformation'>
    & { dates: Array<(
      { __typename?: 'EventDate' }
      & Pick<EventDate, 'id' | 'startDate' | 'endDate'>
    )>, venue: (
      { __typename?: 'Venue' }
      & Pick<Venue, 'name' | 'id' | 'seating' | 'createdFromEvent'>
      & { zones: Array<(
        { __typename?: 'Zone' }
        & Pick<Zone, 'id' | 'name' | 'capacity'>
        & { sections?: Maybe<Array<(
          { __typename?: 'Section' }
          & Pick<Section, 'id' | 'name'>
        )>> }
      )>, gates: Array<(
        { __typename?: 'Gate' }
        & Pick<Gate, 'id' | 'name'>
      )> }
    ), ticketTypes: Array<(
      { __typename?: 'TicketType' }
      & TicketTypeFragmentFragment
    )>, season?: Maybe<(
      { __typename?: 'Season' }
      & Pick<Season, 'id' | 'name'>
    )>, gateways: Array<(
      { __typename?: 'Integration' }
      & Pick<Integration, 'id' | 'name' | 'paymentMethodType'>
    )> }
  ) }
);

export type EventsListQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type EventsListQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'startDate' | 'endDate' | 'eventKind' | 'title' | 'soldTicketsCount' | 'isActive'>
        & { venue: (
          { __typename?: 'Venue' }
          & Pick<Venue, 'name' | 'createdFromEvent'>
        ) }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type CreateReleaseZoneMutationVariables = Exact<{
  input: CreateReleaseZoneInput;
}>;


export type CreateReleaseZoneMutation = (
  { __typename?: 'Mutation' }
  & { createReleaseZone: Array<(
    { __typename?: 'Release' }
    & Pick<Release, 'id'>
    & { releaseZones: Array<(
      { __typename?: 'ReleaseZone' }
      & { zone: (
        { __typename?: 'Zone' }
        & Pick<Zone, 'id'>
      ) }
    )> }
  )> }
);

export type UpdateReleaseZoneMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateReleaseZoneInput;
}>;


export type UpdateReleaseZoneMutation = (
  { __typename?: 'Mutation' }
  & { updateReleaseZone: (
    { __typename?: 'ReleaseZone' }
    & Pick<ReleaseZone, 'id'>
  ) }
);

export type EventWithListedReleaseQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type EventWithListedReleaseQuery = (
  { __typename?: 'Query' }
  & { event: (
    { __typename?: 'Event' }
    & { ticketTypes: Array<(
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'price'>
    )>, listedRelease?: Maybe<(
      { __typename?: 'Release' }
      & { releaseZones: Array<(
        { __typename?: 'ReleaseZone' }
        & Pick<ReleaseZone, 'id' | 'isActive'>
        & { ticketTypes: Array<(
          { __typename?: 'ReleaseZoneTicketType' }
          & Pick<ReleaseZoneTicketType, 'price' | 'isActive' | 'ticketTypeId' | 'ticketAvailabilityStatus'>
        )>, zone: (
          { __typename?: 'Zone' }
          & Pick<Zone, 'capacity' | 'description' | 'admission' | 'displayOrder'>
        ) }
      )>, releaseEventAddons: Array<(
        { __typename?: 'ReleaseEventAddon' }
        & { eventAddon: (
          { __typename?: 'EventAddon' }
          & Pick<EventAddon, 'createdAt' | 'id' | 'name' | 'enableNaming' | 'quantity' | 'price' | 'description' | 'restrictions' | 'isActive' | 'insideFee'>
          & { namingFields: Array<(
            { __typename?: 'FormField' }
            & Pick<FormField, 'field' | 'isRequired' | 'isCustom' | 'label'>
          )>, addonImage?: Maybe<(
            { __typename?: 'ExtendedFile' }
            & FileFragmentFragment
          )> }
        ) }
      )> }
      & ReleaseFragmentFragment
    )>, venue: (
      { __typename?: 'Venue' }
      & Pick<Venue, 'capacity'>
      & { zones: Array<(
        { __typename?: 'Zone' }
        & Pick<Zone, 'id' | 'name' | 'displayOrder'>
      )> }
    ) }
    & EventFragmentFragment
  ) }
);

export type DashboardEventsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type DashboardEventsQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'startDate' | 'endDate' | 'eventKind' | 'title' | 'soldTicketsCount' | 'soldTicketsCountToday' | 'soldTicketsCountYesterday' | 'totalRevenue' | 'isActive'>
        & { dates: Array<(
          { __typename?: 'EventDate' }
          & Pick<EventDate, 'id' | 'startDate' | 'endDate'>
        )>, logo?: Maybe<(
          { __typename?: 'ExtendedFile' }
          & FileFragmentFragment
        )>, venue: (
          { __typename?: 'Venue' }
          & Pick<Venue, 'name'>
          & { address: (
            { __typename?: 'Address' }
            & Pick<Address, 'city'>
          ) }
        ) }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type MembershipDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MembershipDetailsQuery = (
  { __typename?: 'Query' }
  & { membership?: Maybe<(
    { __typename?: 'Membership' }
    & Pick<Membership, 'id' | 'name' | 'membershipKind' | 'isActive' | 'startDate' | 'endDate' | 'canNameMembership' | 'canRenameMembership' | 'canChangeSeats' | 'canUsePoints' | 'enableAutoRenew' | 'renamingFee' | 'changingSeatsFee' | 'bookingFee' | 'bookingFeeType' | 'description' | 'emailNotification' | 'termsAndConditions' | 'accessibility' | 'importantNotice' | 'invoiceInformation' | 'showSchedule'>
    & { gateways?: Maybe<Array<(
      { __typename?: 'Integration' }
      & Pick<Integration, 'id' | 'name' | 'paymentMethodType'>
    )>>, digitalInfo?: Maybe<(
      { __typename?: 'DigitalInfo' }
      & Pick<DigitalInfo, 'url' | 'additionalEmailInfoHTML' | 'additionalEmailButtonText' | 'additionalEmailButtonUrl' | 'additionalEmailInfoText'>
    )>, digitalPassCodesStatus?: Maybe<(
      { __typename?: 'DigitalPassCodeStatusOutput' }
      & DigitalPassCodesStatusFragmentFragment
    )>, shippingOptions?: Maybe<(
      { __typename?: 'ShippingOptions' }
      & ShippingOptionsFragmentFragment
    )>, thumbnail?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, banner?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, backgroundImage?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, descriptionImage?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, printBanner1?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, printBanner2?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, events?: Maybe<Array<(
      { __typename?: 'Event' }
      & Pick<Event, 'id'>
    )>>, season?: Maybe<(
      { __typename?: 'Season' }
      & Pick<Season, 'id' | 'startDate' | 'endDate'>
    )>, previousMemberships: Array<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'id' | 'startDate' | 'endDate'>
    )>, types: Array<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name' | 'kind' | 'ticketFeeType'>
    )>, venue?: Maybe<(
      { __typename?: 'Venue' }
      & Pick<Venue, 'id' | 'name' | 'seatsChartKey' | 'seating' | 'createdAt' | 'updatedAt'>
      & { address: (
        { __typename?: 'Address' }
        & AddressFragmentFragment
      ), zones: Array<(
        { __typename?: 'Zone' }
        & Pick<Zone, 'id' | 'name' | 'description' | 'displayOrder' | 'capacity' | 'stand' | 'admission'>
        & { sections?: Maybe<Array<(
          { __typename?: 'Section' }
          & Pick<Section, 'id' | 'name'>
        )>> }
      )> }
    )>, membershipZones: Array<(
      { __typename?: 'MembershipZone' }
      & Pick<MembershipZone, 'id' | 'pricingLevel' | 'isActive'>
      & { zone: (
        { __typename?: 'Zone' }
        & Pick<Zone, 'id' | 'name'>
      ), membershipTypes: Array<(
        { __typename?: 'MembershipSeatingZoneType' }
        & Pick<MembershipSeatingZoneType, 'price' | 'isActive' | 'membershipTypeId'>
        & { sections?: Maybe<Array<(
          { __typename?: 'ZonePricingTypeSection' }
          & Pick<ZonePricingTypeSection, 'sectionId' | 'name' | 'price'>
        )>> }
      )> }
    )>, multiBuyPromotions: Array<(
      { __typename?: 'MembershipMultiBuyPromotion' }
      & Pick<MembershipMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity'>
      & { getMembershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
      )> }
    )>, tags: Array<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'name'>
    )> }
  )> }
);

export type MembershipsListQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  where?: Maybe<MembershipWhereInput>;
  orderBy?: Maybe<MembershipOrderByInput>;
}>;


export type MembershipsListQuery = (
  { __typename?: 'Query' }
  & { memberships: (
    { __typename?: 'MembershipConnection' }
    & { edges: Array<(
      { __typename?: 'MembershipEdge' }
      & { node: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'id' | 'name' | 'startDate' | 'endDate' | 'isActive' | 'membershipHoldersCount'>
        & { venue?: Maybe<(
          { __typename?: 'Venue' }
          & Pick<Venue, 'id' | 'name'>
        )> }
      ) }
    )> }
  ) }
);

export type EventsListWithSeasonsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type EventsListWithSeasonsQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'startDate' | 'endDate' | 'eventKind' | 'title' | 'isActive'>
        & { season?: Maybe<(
          { __typename?: 'Season' }
          & Pick<Season, 'id' | 'name'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type PointItemFragment = (
  { __typename?: 'PointItem' }
  & Pick<PointItem, 'id' | 'name' | 'price' | 'amount' | 'isVisible' | 'description'>
  & { banner?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & Pick<ExtendedFile, 'fileName'>
  )>, thumbnail?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & Pick<ExtendedFile, 'fileName'>
  )>, backgroundImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & Pick<ExtendedFile, 'fileName'>
  )>, descriptionImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & Pick<ExtendedFile, 'fileName'>
  )> }
);

export type CreatePointItemMutationVariables = Exact<{
  input: CreatePointItemInput;
}>;


export type CreatePointItemMutation = (
  { __typename?: 'Mutation' }
  & { createPointItem: (
    { __typename?: 'PointItem' }
    & Pick<PointItem, 'id'>
  ) }
);

export type UpdatePointMutationVariables = Exact<{
  input: UpdatePointInput;
}>;


export type UpdatePointMutation = (
  { __typename?: 'Mutation' }
  & { updatePoint: (
    { __typename?: 'Point' }
    & Pick<Point, 'id'>
  ) }
);

export type UpdatePointItemMutationVariables = Exact<{
  input: UpdatePointItemInput;
  id: Scalars['String'];
}>;


export type UpdatePointItemMutation = (
  { __typename?: 'Mutation' }
  & { updatePointItem: (
    { __typename?: 'PointItem' }
    & Pick<PointItem, 'id'>
  ) }
);

export type UpdatePointsMutationVariables = Exact<{
  input: UpdatePointInput;
}>;


export type UpdatePointsMutation = (
  { __typename?: 'Mutation' }
  & { updatePoint: (
    { __typename?: 'Point' }
    & Pick<Point, 'id'>
  ) }
);

export type PointWithItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type PointWithItemsQuery = (
  { __typename?: 'Query' }
  & { point?: Maybe<(
    { __typename?: 'Point' }
    & Pick<Point, 'id' | 'name' | 'isEnabled' | 'termsAndConditions'>
    & { gateways: Array<(
      { __typename?: 'Integration' }
      & Pick<Integration, 'id'>
    )>, pointItems: Array<(
      { __typename?: 'PointItem' }
      & PointItemFragment
    )> }
  )> }
);

export type ReferralPromotionReportStatsQueryVariables = Exact<{
  input: ReferralPromotionReportingInput;
}>;


export type ReferralPromotionReportStatsQuery = (
  { __typename?: 'Query' }
  & { referralPromotionReportStats: (
    { __typename?: 'ReferralPromotionReportingOutput' }
    & Pick<ReferralPromotionReportingOutput, 'referrerPointsAwarded' | 'revenue' | 'discountValue' | 'roi' | 'newReferredCustomers' | 'orders'>
  ) }
);

export type EventsListUseParamsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type EventsListUseParamsQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'startDate' | 'endDate' | 'eventKind' | 'title' | 'isActive'>
        & { ticketSoldTime?: Maybe<(
          { __typename?: 'TicketSoldTime' }
          & Pick<TicketSoldTime, 'startTime' | 'endTime' | 'sourceId'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type MembershipsListUseParamsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  where?: Maybe<MembershipWhereInput>;
}>;


export type MembershipsListUseParamsQuery = (
  { __typename?: 'Query' }
  & { memberships: (
    { __typename?: 'MembershipConnection' }
    & { edges: Array<(
      { __typename?: 'MembershipEdge' }
      & { node: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'id' | 'name' | 'startDate' | 'endDate' | 'isActive'>
        & { ticketSoldTime?: Maybe<(
          { __typename?: 'TicketSoldTime' }
          & Pick<TicketSoldTime, 'startTime' | 'endTime' | 'sourceId'>
        )> }
      ) }
    )> }
  ) }
);

export type ReleasesListUseParamasQueryVariables = Exact<{
  event: Scalars['String'];
}>;


export type ReleasesListUseParamasQuery = (
  { __typename?: 'Query' }
  & { releases: Array<(
    { __typename?: 'Release' }
    & Pick<Release, 'id' | 'name' | 'type'>
  )> }
);

export type UpsertAdobeIntegrationMutationVariables = Exact<{
  input: AdobeExperiencePlatformIntegrationInput;
}>;


export type UpsertAdobeIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { upsertAdobeIntegration: (
    { __typename?: 'AdobeExperiencePlatformIntegration' }
    & Pick<AdobeExperiencePlatformIntegration, 'id'>
  ) }
);

export type DeleteAdobeIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type DeleteAdobeIntegrationQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'deleteAdobeIntegration'>
);

export type AdobeIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type AdobeIntegrationQuery = (
  { __typename?: 'Query' }
  & { adobeIntegration?: Maybe<(
    { __typename?: 'AdobeExperiencePlatformIntegration' }
    & Pick<AdobeExperiencePlatformIntegration, 'tenant' | 'sandboxName' | 'clientId' | 'clientSecret' | 'imsOrgId' | 'technicalAccountId' | 'privateKeyBase64' | 'customerEndpoint' | 'customerSchemaRefId' | 'customerDatasetId' | 'ticketEndpoint' | 'ticketSchemaRefId' | 'ticketDatasetId' | 'scanEndpoint' | 'scanSchemaRefId' | 'scanDatasetId'>
  )> }
);

export type AddressFragmentFragment = (
  { __typename?: 'Address' }
  & Pick<Address, 'line1' | 'line2' | 'postalCode' | 'city' | 'country' | 'state' | 'suburb' | 'formattedAddress'>
);

export type AutomationFragmentFragment = (
  { __typename?: 'Automation' }
  & Pick<Automation, 'id' | 'name' | 'templateId' | 'subject' | 'listId' | 'automationType' | 'isActive' | 'targetSource' | 'targetSourceId' | 'targetReleaseId' | 'timeOfDay' | 'templateName'>
);

export type CurrentOrganizationFragmentFragment = (
  { __typename?: 'CurrentOrganizationOutput' }
  & Pick<CurrentOrganizationOutput, 'createdAt' | 'updatedAt' | 'id' | 'name' | 'slug' | 'email' | 'phone' | 'landingPage' | 'taxNumber' | 'supportInfo' | 'termsAndConditions' | 'privacyPolicy' | 'currency' | 'showMemberships' | 'showMembershipRenewal' | 'features' | 'timezone' | 'helpLink' | 'ticketCoverPlatformFeePercentage'>
  & { point?: Maybe<(
    { __typename?: 'Point' }
    & Pick<Point, 'id' | 'name' | 'isEnabled'>
  )>, address?: Maybe<(
    { __typename?: 'Address' }
    & AddressFragmentFragment
  )>, marketing?: Maybe<(
    { __typename?: 'Marketing' }
    & Pick<Marketing, 'gtmId' | 'pixelId'>
  )>, branding: (
    { __typename?: 'OrganizationOutputBranding' }
    & Pick<OrganizationOutputBranding, 'greyScale' | 'primaryColor' | 'secondaryColor'>
    & { logo?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, mobileLogo?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, favicon?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, background?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, fullBackground?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )> }
  ), shippingLabels?: Maybe<(
    { __typename?: 'ShippingLabels' }
    & Pick<ShippingLabels, 'eTicket' | 'printedTicketByMail' | 'printedTicketByCourier' | 'printedTicketByCourierRural' | 'printedTicketAtVenue'>
  )> }
);

export type DigitalPassCodesStatusFragmentFragment = (
  { __typename?: 'DigitalPassCodeStatusOutput' }
  & Pick<DigitalPassCodeStatusOutput, 'totalPassCodes' | 'remainingPassCodes'>
);

export type EventFragmentFragment = (
  { __typename?: 'Event' }
  & Pick<Event, 'id' | 'title' | 'eventKind' | 'description' | 'startDate' | 'isActive' | 'isFeatured' | 'isR18' | 'bookingFeeType' | 'bookingFee' | 'canUsePoints' | 'canNameTicket' | 'canRenameTicket' | 'canChangeSeats' | 'canTransferTicket' | 'enableReleaseCodes' | 'enableWaitlist' | 'waitlistStartDate' | 'waitlistEndDate' | 'renamingFee' | 'soldTicketsCount' | 'changingSeatsFee' | 'buyerTransferringTicketFee' | 'sellerTransferringTicketFee' | 'updatedAt' | 'createdAt' | 'accessibility' | 'termsAndConditions' | 'importantNotice' | 'presaleInformation' | 'invoiceInformation' | 'checkForVaccinePass' | 'emailNotification' | 'redirectURL' | 'ticketsViewableFromDate' | 'lastTicketsViewableEmailsSentAt'>
  & { dates: Array<(
    { __typename?: 'EventDate' }
    & Pick<EventDate, 'id' | 'startDate' | 'endDate'>
  )>, logo?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, backgroundImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, backgroundImageFullPage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, descriptionImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, thumbnail?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, printBanner1?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, printBanner2?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, hardCopyTicketBanner?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, digitalInfo?: Maybe<(
    { __typename?: 'DigitalInfo' }
    & Pick<DigitalInfo, 'url' | 'additionalEmailInfoHTML' | 'additionalEmailButtonText' | 'additionalEmailButtonUrl' | 'additionalEmailInfoText'>
  )>, digitalPassCodesStatus?: Maybe<(
    { __typename?: 'DigitalPassCodeStatusOutput' }
    & DigitalPassCodesStatusFragmentFragment
  )>, shippingOptions?: Maybe<(
    { __typename?: 'ShippingOptions' }
    & ShippingOptionsFragmentFragment
  )>, venue: (
    { __typename?: 'Venue' }
    & Pick<Venue, 'name' | 'id' | 'seating' | 'hasStadiumLevy' | 'createdFromEvent'>
    & { address: (
      { __typename?: 'Address' }
      & AddressFragmentFragment
    ), location?: Maybe<(
      { __typename?: 'Coordinate' }
      & Pick<Coordinate, 'lat' | 'lng'>
    )>, zones: Array<(
      { __typename?: 'Zone' }
      & Pick<Zone, 'id' | 'name' | 'capacity'>
      & { sections?: Maybe<Array<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'name'>
      )>> }
    )>, gates: Array<(
      { __typename?: 'Gate' }
      & Pick<Gate, 'id' | 'name'>
    )> }
  ), ticketTypes: Array<(
    { __typename?: 'TicketType' }
    & TicketTypeFragmentFragment
  )>, gateways: Array<(
    { __typename?: 'Integration' }
    & Pick<Integration, 'id' | 'name' | 'paymentMethodType'>
  )>, season?: Maybe<(
    { __typename?: 'Season' }
    & Pick<Season, 'id' | 'name'>
  )>, zonesAllocatedGates?: Maybe<Array<(
    { __typename?: 'ZoneAllocatedGate' }
    & Pick<ZoneAllocatedGate, 'zoneId' | 'name' | 'gates'>
    & { availabilityCount?: Maybe<(
      { __typename?: 'ZoneAllocationAvailability' }
      & Pick<ZoneAllocationAvailability, 'notForSale' | 'holdByMembership' | 'booked' | 'available'>
    )>, sections?: Maybe<Array<(
      { __typename?: 'ZoneAllocatedGateSection' }
      & Pick<ZoneAllocatedGateSection, 'sectionId' | 'name' | 'gates'>
    )>>, dates?: Maybe<Array<(
      { __typename?: 'ZoneAllocatedDate' }
      & Pick<ZoneAllocatedDate, 'eventDateId' | 'alternateEntryTime'>
    )>> }
  )>>, multiBuyPromotions: Array<(
    { __typename?: 'EventMultiBuyPromotion' }
    & Pick<EventMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity'>
    & { getTicketType: (
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name' | 'kind'>
    ), buyTicketType: (
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name' | 'kind'>
    ) }
  )>, tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )>, insideFeeDetails?: Maybe<Array<(
    { __typename?: 'InsideFeeDetails' }
    & Pick<InsideFeeDetails, 'insideFee' | 'priceRangeTo' | 'priceRangeFrom'>
  )>>, ticketCover?: Maybe<(
    { __typename?: 'EventTicketCover' }
    & Pick<EventTicketCover, 'isEnabled' | 'promoterFeePercentage' | 'platformFeePercentage' | 'totalFeePercentage' | 'enabledAt' | 'disabledAt'>
  )> }
);

export type FileFragmentFragment = (
  { __typename?: 'ExtendedFile' }
  & Pick<ExtendedFile, 'storage' | 'directory' | 'fileName' | 'originalFileName'>
);

export type FullIntegrationFragmentFragment = (
  { __typename?: 'Integration' }
  & Pick<Integration, 'id' | 'type' | 'name' | 'apiKey' | 'secretKey' | 'publicKey' | 'wcPxPostSecretKey' | 'wcPxPostPublicKey' | 'transactionFeeType' | 'transactionFee' | 'webhookUrl' | 'paymentMethodType' | 'facebookPageId' | 'facebookUserId' | 'transactionFee2' | 'transactionFeeType2'>
);

export type HistoryFragment = (
  { __typename?: 'History' }
  & Pick<History, 'id' | 'description' | 'refName' | 'createdAt'>
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'firstName' | 'lastName' | 'roles'>
  )>, scoutCommunication?: Maybe<(
    { __typename?: 'Scout' }
    & Pick<Scout, 'id' | 'name'>
  )>, order?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'orderNumber'>
  )>, ticket?: Maybe<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id' | 'ticketNumber'>
  )> }
);

export type HistoryConnectionFragment = (
  { __typename?: 'HistoryConnection' }
  & { edges: Array<(
    { __typename?: 'HistoryEdge' }
    & { node: (
      { __typename?: 'History' }
      & HistoryFragment
    ) }
  )> }
);

export type IntegrationFragmentFragment = (
  { __typename?: 'Integration' }
  & Pick<Integration, 'id' | 'type' | 'name' | 'transactionFeeType' | 'transactionFee' | 'publicKey' | 'webhookUrl'>
);

export type LineItemBaseFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'id' | 'createdAt' | 'updatedAt'>
);

export type LineItemFinanceFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'price' | 'originalPrice' | 'quantity' | 'ticketFee' | 'ticketFeeAmount' | 'taxRate' | 'total' | 'taxAmount' | 'subtotal'>
  & { pointItem?: Maybe<(
    { __typename?: 'PointItem' }
    & Pick<PointItem, 'id' | 'name' | 'amount'>
  )>, ticketType?: Maybe<(
    { __typename?: 'TicketType' }
    & Pick<TicketType, 'id' | 'name'>
  )>, membershipType?: Maybe<(
    { __typename?: 'MembershipType' }
    & Pick<MembershipType, 'id'>
    & { membership: (
      { __typename?: 'Membership' }
      & Pick<Membership, 'name'>
    ) }
  )>, eventAddon?: Maybe<(
    { __typename?: 'EventAddon' }
    & Pick<EventAddon, 'id'>
  )>, membershipAddon?: Maybe<(
    { __typename?: 'MembershipAddon' }
    & Pick<MembershipAddon, 'id'>
  )> }
);

export type LineItemFragment = (
  { __typename?: 'LineItem' }
  & LineItemBaseFragment
  & LineItemInfoFragment
  & LineItemSeatFragment
  & LineItemFinanceFragment
);

export type LineItemInfoFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'name' | 'type'>
);

export type LineItemSeatFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'seatLabel' | 'seatZone' | 'seatSection' | 'seatTags'>
);

export type MembershipFragmentFragment = (
  { __typename?: 'Membership' }
  & Pick<Membership, 'id' | 'name' | 'membershipKind' | 'isActive' | 'startDate' | 'endDate' | 'canNameMembership' | 'canRenameMembership' | 'canChangeSeats' | 'canUsePoints' | 'canTransferTickets' | 'enableAutoRenew' | 'renamingFee' | 'changingSeatsFee' | 'bookingFee' | 'bookingFeeType' | 'description' | 'emailNotification' | 'termsAndConditions' | 'accessibility' | 'importantNotice' | 'invoiceInformation' | 'showSchedule'>
  & { gateways?: Maybe<Array<(
    { __typename?: 'Integration' }
    & Pick<Integration, 'id' | 'name' | 'paymentMethodType'>
  )>>, digitalInfo?: Maybe<(
    { __typename?: 'DigitalInfo' }
    & Pick<DigitalInfo, 'url' | 'additionalEmailInfoHTML' | 'additionalEmailButtonText' | 'additionalEmailButtonUrl' | 'additionalEmailInfoText'>
  )>, digitalPassCodesStatus?: Maybe<(
    { __typename?: 'DigitalPassCodeStatusOutput' }
    & DigitalPassCodesStatusFragmentFragment
  )>, shippingOptions?: Maybe<(
    { __typename?: 'ShippingOptions' }
    & ShippingOptionsFragmentFragment
  )>, thumbnail?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, banner?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, backgroundImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, descriptionImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, printBanner1?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, printBanner2?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, events?: Maybe<Array<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'canTransferTicket'>
  )>>, season?: Maybe<(
    { __typename?: 'Season' }
    & Pick<Season, 'id' | 'startDate' | 'endDate'>
  )>, previousMemberships: Array<(
    { __typename?: 'Membership' }
    & Pick<Membership, 'id' | 'startDate' | 'endDate'>
  )>, types: Array<(
    { __typename?: 'MembershipType' }
    & Pick<MembershipType, 'id' | 'name' | 'kind' | 'ticketFeeType' | 'ticketFee'>
  )>, venue?: Maybe<(
    { __typename?: 'Venue' }
    & VenueFragmentFragment
  )>, membershipZones: Array<(
    { __typename?: 'MembershipZone' }
    & Pick<MembershipZone, 'id' | 'pricingLevel' | 'isActive'>
    & { zone: (
      { __typename?: 'Zone' }
      & Pick<Zone, 'id' | 'name'>
    ), membershipTypes: Array<(
      { __typename?: 'MembershipSeatingZoneType' }
      & Pick<MembershipSeatingZoneType, 'price' | 'isActive' | 'membershipTypeId'>
      & { sections?: Maybe<Array<(
        { __typename?: 'ZonePricingTypeSection' }
        & Pick<ZonePricingTypeSection, 'sectionId' | 'name' | 'price'>
      )>> }
    )> }
  )>, multiBuyPromotions: Array<(
    { __typename?: 'MembershipMultiBuyPromotion' }
    & Pick<MembershipMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity'>
    & { getMembershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
    )> }
  )>, tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
);

export type MembershipListFragmentFragment = (
  { __typename?: 'Membership' }
  & Pick<Membership, 'id' | 'name' | 'isActive' | 'startDate' | 'endDate'>
  & { season?: Maybe<(
    { __typename?: 'Season' }
    & Pick<Season, 'name'>
  )> }
);

export type MembershipTypeFragmentFragment = (
  { __typename?: 'MembershipType' }
  & Pick<MembershipType, 'id' | 'name' | 'kind' | 'ticketFeeType' | 'ticketFee' | 'description' | 'restrictions' | 'createdAt' | 'updatedAt'>
  & { namingFields: Array<(
    { __typename?: 'FormField' }
    & NamingFieldsFragment
  )> }
);

export type MembershipTypeEventTransferPricesFragmentFragment = (
  { __typename?: 'MembershipTypeEventTransferPrice' }
  & Pick<MembershipTypeEventTransferPrice, 'maxSalePrice'>
  & { membershipType: (
    { __typename?: 'MembershipType' }
    & Pick<MembershipType, 'id' | 'name'>
  ), membershipZone: (
    { __typename?: 'MembershipZone' }
    & Pick<MembershipZone, 'id' | 'pricingLevel'>
    & { zone: (
      { __typename?: 'Zone' }
      & Pick<Zone, 'id' | 'name'>
    ) }
  ), event: (
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title'>
  ) }
);

export type NamingFieldsFragment = (
  { __typename?: 'FormField' }
  & Pick<FormField, 'field' | 'isRequired' | 'label' | 'isCustom'>
);

export type OrderFragmentFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'orderNumber' | 'referralId' | 'xeroInvoiceId' | 'orderType' | 'deliveryMethod' | 'usedCredits' | 'usedPoints' | 'isComp' | 'shippingAddressMatchesBillingAddress' | 'status' | 'channel' | 'clientIp' | 'paymentGateway' | 'transactionStatus' | 'deliveryFee' | 'bookingFee' | 'bookingFeeAmount' | 'transactionFee' | 'transactionFeeAmount' | 'transactionFeeType' | 'transactionFeeType2' | 'transactionFee2' | 'transferFee' | 'subtotal' | 'totalTax' | 'total' | 'refundedAmount' | 'createdAt' | 'updatedAt'>
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName' | 'birthDate' | 'email' | 'phoneNumber'>
  )>, buyerInformation?: Maybe<(
    { __typename?: 'BuyerInformation' }
    & Pick<BuyerInformation, 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'postalCode' | 'taxNumber' | 'companyName' | 'city'>
  )>, createdBy?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'fullName'>
  )>, billingAddress?: Maybe<(
    { __typename?: 'Address' }
    & AddressFragmentFragment
  )>, shippingAddress?: Maybe<(
    { __typename?: 'Address' }
    & AddressFragmentFragment
  )>, event?: Maybe<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'startDate' | 'endDate' | 'sellerTransferringTicketFee'>
    & { venue: (
      { __typename?: 'Venue' }
      & Pick<Venue, 'name' | 'seating'>
    ), shippingOptions?: Maybe<(
      { __typename?: 'ShippingOptions' }
      & Pick<ShippingOptions, 'eTicket' | 'printedTicketByMail' | 'printedTicketByCourier' | 'printedTicketByCourierRural' | 'printedTicketAtVenue'>
    )>, multiBuyPromotions: Array<(
      { __typename?: 'EventMultiBuyPromotion' }
      & Pick<EventMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity'>
      & { getTicketType: (
        { __typename?: 'TicketType' }
        & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
        & { dates: Array<(
          { __typename?: 'TicketTypeDate' }
          & Pick<TicketTypeDate, 'eventDateId' | 'alternateEntryTime'>
        )> }
      ), buyTicketType: (
        { __typename?: 'TicketType' }
        & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
        & { dates: Array<(
          { __typename?: 'TicketTypeDate' }
          & Pick<TicketTypeDate, 'eventDateId' | 'alternateEntryTime'>
        )> }
      ) }
    )>, ticketTypes: Array<(
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'alternateEntryTime'>
      )> }
    )> }
  )>, membership?: Maybe<(
    { __typename?: 'Membership' }
    & Pick<Membership, 'id' | 'name'>
    & { venue?: Maybe<(
      { __typename?: 'Venue' }
      & Pick<Venue, 'seating'>
    )>, types: Array<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
    )>, shippingOptions?: Maybe<(
      { __typename?: 'ShippingOptions' }
      & Pick<ShippingOptions, 'eTicket' | 'printedTicketByMail' | 'printedTicketByCourier' | 'printedTicketByCourierRural' | 'printedTicketAtVenue'>
    )>, multiBuyPromotions: Array<(
      { __typename?: 'MembershipMultiBuyPromotion' }
      & Pick<MembershipMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity'>
      & { getMembershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
      )>, buyMembershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
      )> }
    )>, events?: Maybe<Array<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'seatsEventKey' | 'title' | 'startDate' | 'description'>
      & { venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'id' | 'name'>
      ), printBanner1?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragmentFragment
      )> }
    )>>, membershipZones: Array<(
      { __typename?: 'MembershipZone' }
      & Pick<MembershipZone, 'id' | 'pricingLevel' | 'isActive'>
      & { zone: (
        { __typename?: 'Zone' }
        & Pick<Zone, 'id' | 'name'>
      ), membershipTypes: Array<(
        { __typename?: 'MembershipSeatingZoneType' }
        & Pick<MembershipSeatingZoneType, 'membershipTypeId' | 'price' | 'isActive'>
        & { sections?: Maybe<Array<(
          { __typename?: 'ZonePricingTypeSection' }
          & Pick<ZonePricingTypeSection, 'name' | 'price'>
        )>> }
      )> }
    )> }
  )>, gateway?: Maybe<(
    { __typename?: 'PaymentIntegrationOutput' }
    & Pick<PaymentIntegrationOutput, 'name'>
  )>, transactions: (
    { __typename?: 'OrderTransactionConnection' }
    & { edges: Array<(
      { __typename?: 'OrderTransactionEdge' }
      & { node: (
        { __typename?: 'OrderTransaction' }
        & Pick<OrderTransaction, 'id' | 'createdAt' | 'updatedAt' | 'kind' | 'status' | 'amount'>
      ) }
    )> }
  ), refunds: Array<(
    { __typename?: 'Refund' }
    & Pick<Refund, 'id' | 'createdAt' | 'updatedAt' | 'amount'>
  )>, tickets: Array<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id' | 'status' | 'ticketNumber' | 'preprint' | 'shouldBeNamed' | 'seatSection' | 'seatZone' | 'seatLabel' | 'seatTags' | 'isNamed' | 'firstName' | 'lastName'>
    & { transferFee?: Maybe<(
      { __typename?: 'TicketTransferFee' }
      & Pick<TicketTransferFee, 'type' | 'fee'>
    )>, lineItem?: Maybe<(
      { __typename?: 'LineItem' }
      & Pick<LineItem, 'id' | 'price' | 'name' | 'type'>
    )>, ticketType?: Maybe<(
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'name'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'alternateEntryTime'>
      )> }
    )>, firstScanIn?: Maybe<(
      { __typename?: 'Scan' }
      & Pick<Scan, 'id'>
    )> }
  )>, lineItems: (
    { __typename?: 'LineItemConnection' }
    & { edges: Array<(
      { __typename?: 'LineItemEdge' }
      & { node: (
        { __typename?: 'LineItem' }
        & Pick<LineItem, 'id' | 'createdAt' | 'updatedAt' | 'type' | 'seatLabel' | 'seatZone' | 'seatSection' | 'seatTags' | 'price' | 'originalPrice' | 'taxRate' | 'taxAmount' | 'quantity' | 'name' | 'ticketFeeAmount' | 'stadiumLevyFee'>
        & { pointItem?: Maybe<(
          { __typename?: 'PointItem' }
          & Pick<PointItem, 'id' | 'name' | 'amount'>
        )>, ticketType?: Maybe<(
          { __typename?: 'TicketType' }
          & Pick<TicketType, 'name' | 'id'>
        )>, membershipType?: Maybe<(
          { __typename?: 'MembershipType' }
          & Pick<MembershipType, 'id'>
          & { membership: (
            { __typename?: 'Membership' }
            & Pick<Membership, 'name'>
          ) }
        )> }
      ) }
    )> }
  ), promoCode?: Maybe<(
    { __typename: 'EventPromoCode' }
    & Pick<EventPromoCode, 'id' | 'code' | 'discountType' | 'discountAmount'>
    & { eventType: EventPromoCode['type'] }
  ) | (
    { __typename: 'MembershipPromoCode' }
    & Pick<MembershipPromoCode, 'id' | 'code' | 'discountType' | 'discountAmount'>
    & { membershipType: MembershipPromoCode['type'] }
  )>, history: (
    { __typename?: 'HistoryConnection' }
    & HistoryConnectionFragment
  ), orderTicketCover?: Maybe<(
    { __typename?: 'OrderTicketCover' }
    & Pick<OrderTicketCover, 'totalFeeAmount' | 'retryCount' | 'issuedAt'>
  )> }
);

export type OrganizationFragmentFragment = (
  { __typename?: 'Organization' }
  & Pick<Organization, 'createdAt' | 'updatedAt' | 'id' | 'name' | 'slug' | 'email' | 'phone' | 'taxNumber' | 'supportInfo' | 'termsAndConditions' | 'privacyPolicy' | 'features' | 'currency' | 'helpLink'>
  & { shippingLabels?: Maybe<(
    { __typename?: 'ShippingLabels' }
    & Pick<ShippingLabels, 'eTicket' | 'printedTicketAtVenue' | 'printedTicketByCourierRural' | 'printedTicketByCourier' | 'printedTicketByMail'>
  )>, address?: Maybe<(
    { __typename?: 'Address' }
    & AddressFragmentFragment
  )>, marketing?: Maybe<(
    { __typename?: 'Marketing' }
    & Pick<Marketing, 'gtmId' | 'pixelId'>
  )>, branding: (
    { __typename?: 'BrandingOutputBase' }
    & Pick<BrandingOutputBase, 'greyScale' | 'primaryColor' | 'secondaryColor'>
    & { logo?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, mobileLogo?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, background?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, fullBackground?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )> }
  ) }
);

export type PartialAddressFragmentFragment = (
  { __typename?: 'PartialAddress' }
  & Pick<PartialAddress, 'line1' | 'line2' | 'postalCode' | 'city' | 'country' | 'suburb'>
);

export type ReleaseFragmentFragment = (
  { __typename?: 'Release' }
  & Pick<Release, 'id' | 'name' | 'type' | 'slug' | 'startCondition' | 'startConditionDate' | 'endCondition' | 'endConditionQuantity' | 'endConditionDate' | 'isActive' | 'askForDietaryRequirements' | 'askHowDidYouHearAboutUs' | 'allowPublicComp' | 'allowAccount2Account' | 'allowHoldOrders' | 'presaleTitle' | 'presaleInformation' | 'releaseNotes' | 'password' | 'createdAt' | 'updatedAt' | 'canBeHardDeleted'>
  & { presaleLogo?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & Pick<ExtendedFile, 'fileName' | 'originalFileName'>
  )>, presaleHeader?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & Pick<ExtendedFile, 'fileName' | 'originalFileName'>
  )>, releaseZones: Array<(
    { __typename?: 'ReleaseZone' }
    & Pick<ReleaseZone, 'id' | 'pricingLevel' | 'isActive'>
    & { zone: (
      { __typename?: 'Zone' }
      & Pick<Zone, 'id' | 'name'>
    ), ticketTypes: Array<(
      { __typename?: 'ReleaseZoneTicketType' }
      & Pick<ReleaseZoneTicketType, 'price' | 'isActive' | 'ticketTypeId'>
      & { sections?: Maybe<Array<(
        { __typename?: 'ZonePricingTypeSection' }
        & Pick<ZonePricingTypeSection, 'sectionId' | 'name' | 'price'>
      )>> }
    )> }
  )>, releaseEventAddons: Array<(
    { __typename?: 'ReleaseEventAddon' }
    & { eventAddon: (
      { __typename?: 'EventAddon' }
      & Pick<EventAddon, 'id' | 'name'>
    ) }
  )> }
);

export type ScoutFilterSelectionFragment = (
  { __typename?: 'FilterSelection' }
  & Pick<FilterSelection, 'userTagIds' | 'seasonIds' | 'eventTypes' | 'membershipTypes' | 'eventIds' | 'eventTitlesForWaitlist' | 'totalEventsPurchasedTo' | 'ticketTypeKinds' | 'zones' | 'releaseIds' | 'regions' | 'minAge' | 'maxAge' | 'gender'>
);

export type SeasonFragmentFragment = (
  { __typename?: 'Season' }
  & Pick<Season, 'id' | 'name' | 'isActive' | 'startDate' | 'description' | 'endDate' | 'updatedAt' | 'createdAt' | 'displayOrder'>
  & { events: Array<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'startDate' | 'eventKind'>
  )>, thumbnail?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, backgroundImageFullPage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )> }
);

export type ShippingOptionsFragmentFragment = (
  { __typename?: 'ShippingOptions' }
  & Pick<ShippingOptions, 'eTicket' | 'printedTicketByMail' | 'printedTicketByCourier' | 'printedTicketByCourierRural' | 'printedTicketAtVenue'>
);

export type TagFragmentFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'updatedAt' | 'createdAt'>
);

export type TicketBaseFragment = (
  { __typename?: 'Ticket' }
  & Pick<Ticket, 'id' | 'createdAt' | 'updatedAt'>
);

export type TicketFragment = (
  { __typename?: 'Ticket' }
  & TicketBaseFragment
  & TicketInfoFragment
  & TicketUserFragment
);

export type TicketInfoFragment = (
  { __typename?: 'Ticket' }
  & Pick<Ticket, 'ticketNumber' | 'digitalPassCode' | 'digitalEventUrl' | 'seatLabel' | 'seatZone' | 'seatSection' | 'seatTags' | 'isNamed' | 'shouldBeNamed' | 'qrCode'>
  & { transferFee?: Maybe<(
    { __typename?: 'TicketTransferFee' }
    & Pick<TicketTransferFee, 'type' | 'fee'>
  )>, gates?: Maybe<Array<(
    { __typename?: 'Gate' }
    & Pick<Gate, 'id' | 'name'>
  )>> }
);

export type TicketUserFragment = (
  { __typename?: 'Ticket' }
  & Pick<Ticket, 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'birthDate' | 'gender' | 'postalCode' | 'companyName' | 'licensePlate' | 'memberSince' | 'membershipNumber' | 'comments' | 'dietaryRequirements' | 'lengthOfStay' | 'emergencyName' | 'emergencyContact' | 'emergencyContactRelationship' | 'dunedinResidentialAddress' | 'studentId'>
  & { vaccinePass?: Maybe<(
    { __typename?: 'VaccinePass' }
    & Pick<VaccinePass, 'id'>
  )>, customFields?: Maybe<Array<(
    { __typename?: 'CustomField' }
    & Pick<CustomField, 'fieldName' | 'fieldValue'>
  )>> }
);

export type TicketTypeFragmentFragment = (
  { __typename?: 'TicketType' }
  & Pick<TicketType, 'id' | 'name' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee' | 'stadiumLevyFee' | 'description' | 'restrictions' | 'createdAt' | 'updatedAt' | 'printAtHomeInformation' | 'quantity' | 'inHighDemand' | 'soldOut' | 'minPurchaseQuantity' | 'maxPurchaseQuantity'>
  & { dates: Array<(
    { __typename?: 'TicketTypeDate' }
    & Pick<TicketTypeDate, 'eventDateId' | 'alternateEntryTime'>
  )>, namingFields: Array<(
    { __typename?: 'FormField' }
    & NamingFieldsFragment
  )>, ticketBanner?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, ticketImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragmentFragment
  )>, tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
);

export type UserFragmentFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'createdAt' | 'updatedAt' | 'firstName' | 'lastName' | 'fullName' | 'email' | 'roles' | 'permissions' | 'credits' | 'points' | 'phoneNumber' | 'birthDate' | 'companyName' | 'taxNumber' | 'instagramUsername' | 'isTwoFactorAuthenticationEnabled' | 'shippingAddressMatchesBillingAddress' | 'usableForMarketing' | 'hasTickets' | 'hasMemberships' | 'LTV'>
  & { shippingAddress?: Maybe<(
    { __typename?: 'PartialAddress' }
    & PartialAddressFragmentFragment
  )>, billingAddress?: Maybe<(
    { __typename?: 'PartialAddress' }
    & PartialAddressFragmentFragment
  )>, shopifyUser?: Maybe<(
    { __typename?: 'ShopifyUser' }
    & Pick<ShopifyUser, 'shopifyUserId' | 'totalSpent'>
  )>, scoutCommunications: Array<(
    { __typename?: 'ScoutCommunication' }
    & Pick<ScoutCommunication, 'id' | 'name' | 'purpose' | 'createdAt' | 'updatedAt'>
  )> }
);

export type VenueFragmentFragment = (
  { __typename?: 'Venue' }
  & Pick<Venue, 'id' | 'name' | 'seatsChartKey' | 'seating' | 'capacity' | 'capacityUtilization' | 'accessibilityInfo' | 'createdAt' | 'updatedAt'>
  & { address: (
    { __typename?: 'Address' }
    & AddressFragmentFragment
  ), location?: Maybe<(
    { __typename?: 'Coordinate' }
    & Pick<Coordinate, 'lat' | 'lng'>
  )>, zones: Array<(
    { __typename?: 'Zone' }
    & Pick<Zone, 'id' | 'name' | 'description' | 'displayOrder' | 'capacity' | 'stand' | 'admission'>
    & { sections?: Maybe<Array<(
      { __typename?: 'Section' }
      & Pick<Section, 'id' | 'name'>
    )>> }
  )>, gates: Array<(
    { __typename?: 'Gate' }
    & Pick<Gate, 'id' | 'name' | 'createdAt'>
  )> }
);

export type AddForecastScenarioMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type AddForecastScenarioMutation = (
  { __typename?: 'Mutation' }
  & { addForecastScenario: (
    { __typename?: 'EventForecastOutput' }
    & Pick<EventForecastOutput, 'id' | 'eventId'>
    & { zones?: Maybe<Array<(
      { __typename?: 'EventForecastZoneOutput' }
      & Pick<EventForecastZoneOutput, 'zoneId' | 'comps' | 'contingency'>
    )>>, scenarios?: Maybe<Array<(
      { __typename?: 'ForecastScenario' }
      & Pick<ForecastScenario, 'id'>
      & { zones?: Maybe<Array<(
        { __typename?: 'ForecastScenarioZone' }
        & Pick<ForecastScenarioZone, 'zoneId'>
        & { ticketTypes: Array<(
          { __typename?: 'ScenarioZoneTicketType' }
          & Pick<ScenarioZoneTicketType, 'ticketTypeId' | 'price' | 'splitPercentage'>
        )> }
      )>> }
    )>> }
  ) }
);

export type AssignScoutCommunicationUsersToAgentMutationVariables = Exact<{
  input: AssignScoutCommunicationUsersToAgentInput;
}>;


export type AssignScoutCommunicationUsersToAgentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignScoutCommunicationUsersToAgent'>
);

export type AssignTwoFactorAuthenticationSecretMutationVariables = Exact<{ [key: string]: never; }>;


export type AssignTwoFactorAuthenticationSecretMutation = (
  { __typename?: 'Mutation' }
  & { assignTwoFactorAuthenticationSecret: (
    { __typename?: 'TwoFactorAuthenticationSetupResult' }
    & Pick<TwoFactorAuthenticationSetupResult, 'dataURL' | 'secret'>
  ) }
);

export type AuthenticateWithTwoFactorMutationVariables = Exact<{
  input: TwoFactorAuthenticationCodeInput;
}>;


export type AuthenticateWithTwoFactorMutation = (
  { __typename?: 'Mutation' }
  & { authenticateWithTwoFactor: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type CancelOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CancelOrderMutation = (
  { __typename?: 'Mutation' }
  & { cancelOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type CompletePreprintTicketOrderMutationVariables = Exact<{
  id: Scalars['String'];
  input: LineItemsToCompleteInput;
}>;


export type CompletePreprintTicketOrderMutation = (
  { __typename?: 'Mutation' }
  & { completePreprintTicketOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type CreateAutomationMutationVariables = Exact<{
  input: CreateAutomationInput;
}>;


export type CreateAutomationMutation = (
  { __typename?: 'Mutation' }
  & { createAutomation: (
    { __typename?: 'Automation' }
    & Pick<Automation, 'id'>
  ) }
);

export type CreateBulkOrdersMutationVariables = Exact<{
  input: ImportInput;
  createdById: Scalars['String'];
}>;


export type CreateBulkOrdersMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createBulkOrders'>
);

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;


export type CreateEventMutation = (
  { __typename?: 'Mutation' }
  & { createEvent: (
    { __typename?: 'Event' }
    & Pick<Event, 'id'>
  ) }
);

export type CreateEventAddonMutationVariables = Exact<{
  input: CreateEventAddonInput;
}>;


export type CreateEventAddonMutation = (
  { __typename?: 'Mutation' }
  & { createEventAddon: (
    { __typename?: 'EventAddon' }
    & Pick<EventAddon, 'id' | 'createdAt'>
  ) }
);

export type CreateEventMultiBuyPromotionMutationVariables = Exact<{
  input: CreateEventMultiBuyPromotionInput;
}>;


export type CreateEventMultiBuyPromotionMutation = (
  { __typename?: 'Mutation' }
  & { createEventMultiBuyPromotion: (
    { __typename?: 'EventMultiBuyPromotion' }
    & Pick<EventMultiBuyPromotion, 'id' | 'createdAt'>
  ) }
);

export type CreateEventPromoCodeMutationVariables = Exact<{
  input: CreateEventPromoCodeInput;
}>;


export type CreateEventPromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { createEventPromoCode: (
    { __typename?: 'EventPromoCode' }
    & Pick<EventPromoCode, 'id' | 'createdAt'>
  ) }
);

export type CreateHistoryMutationVariables = Exact<{
  input: CreateHistoryInput;
}>;


export type CreateHistoryMutation = (
  { __typename?: 'Mutation' }
  & { createHistory: (
    { __typename?: 'History' }
    & Pick<History, 'description' | 'createdAt' | 'updatedAt' | 'id'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'firstName' | 'lastName' | 'roles'>
    )> }
  ) }
);

export type CreateIntegrationMutationVariables = Exact<{
  input: CreateIntegrationInput;
}>;


export type CreateIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { createIntegration: (
    { __typename?: 'Integration' }
    & FullIntegrationFragmentFragment
  ) }
);

export type CreateMembershipMutationVariables = Exact<{
  input: CreateMembershipInput;
}>;


export type CreateMembershipMutation = (
  { __typename?: 'Mutation' }
  & { createMembership: (
    { __typename?: 'Membership' }
    & MembershipFragmentFragment
  ) }
);

export type CreateMembershipAddonMutationVariables = Exact<{
  input: CreateMembershipAddonInput;
}>;


export type CreateMembershipAddonMutation = (
  { __typename?: 'Mutation' }
  & { createMembershipAddon: (
    { __typename?: 'MembershipAddon' }
    & Pick<MembershipAddon, 'id' | 'createdAt'>
  ) }
);

export type CreateMembershipMultiBuyPromotionMutationVariables = Exact<{
  input: CreateMembershipMultiBuyPromotionInput;
}>;


export type CreateMembershipMultiBuyPromotionMutation = (
  { __typename?: 'Mutation' }
  & { createMembershipMultiBuyPromotion: (
    { __typename?: 'MembershipMultiBuyPromotion' }
    & Pick<MembershipMultiBuyPromotion, 'id' | 'createdAt'>
  ) }
);

export type CreateMembershipPromoCodeMutationVariables = Exact<{
  input: CreateMembershipPromoCodeInput;
}>;


export type CreateMembershipPromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { createMembershipPromoCode: (
    { __typename?: 'MembershipPromoCode' }
    & Pick<MembershipPromoCode, 'id' | 'createdAt'>
  ) }
);

export type CreateMembershipTypeMutationVariables = Exact<{
  input: CreateMembershipTypeInput;
}>;


export type CreateMembershipTypeMutation = (
  { __typename?: 'Mutation' }
  & { createMembershipType: (
    { __typename?: 'MembershipType' }
    & MembershipTypeFragmentFragment
  ) }
);

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = (
  { __typename?: 'Mutation' }
  & { createOrder: (
    { __typename?: 'Order' }
    & OrderFragmentFragment
  ) }
);

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = (
  { __typename?: 'Mutation' }
  & { createOrganization: (
    { __typename?: 'CreateOrganizationOutput' }
    & Pick<CreateOrganizationOutput, 'id'>
  ) }
);

export type CreatePosMutationVariables = Exact<{
  input: CreatePosInput;
}>;


export type CreatePosMutation = (
  { __typename?: 'Mutation' }
  & { createPos: (
    { __typename?: 'Pos' }
    & Pick<Pos, 'id'>
  ) }
);

export type CreatePosUserMutationVariables = Exact<{
  input: CreatePosUserInput;
}>;


export type CreatePosUserMutation = (
  { __typename?: 'Mutation' }
  & { createPosUser: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type CreatePurchaseRestrictionMutationVariables = Exact<{
  input: CreatePurchaseRestrictionInput;
}>;


export type CreatePurchaseRestrictionMutation = (
  { __typename?: 'Mutation' }
  & { createPurchaseRestriction: (
    { __typename?: 'PurchaseRestriction' }
    & Pick<PurchaseRestriction, 'id' | 'createdAt'>
  ) }
);

export type CreateReferralCampaignMutationVariables = Exact<{
  input: CreateReferralCampaignDto;
}>;


export type CreateReferralCampaignMutation = (
  { __typename?: 'Mutation' }
  & { createReferralCampaign: (
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantity' | 'referralOwnerRewardQuantityType' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
    & { referralRelease?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'id'>
    )> }
  ) }
);

export type CreateRefundMutationVariables = Exact<{
  input: CreateRefundInput;
}>;


export type CreateRefundMutation = (
  { __typename?: 'Mutation' }
  & { createRefund: (
    { __typename?: 'Refund' }
    & Pick<Refund, 'id'>
  ) }
);

export type CreateReleaseMutationVariables = Exact<{
  input: CreateReleaseInput;
}>;


export type CreateReleaseMutation = (
  { __typename?: 'Mutation' }
  & { createRelease: (
    { __typename?: 'Release' }
    & ReleaseFragmentFragment
  ) }
);

export type CreateScoutMutationVariables = Exact<{
  input: CreateScoutInput;
}>;


export type CreateScoutMutation = (
  { __typename?: 'Mutation' }
  & { createScout: (
    { __typename?: 'Scout' }
    & Pick<Scout, 'id' | 'name'>
  ) }
);

export type CreateScoutCommunicationMutationVariables = Exact<{
  input: CreateScoutCommunicationInput;
}>;


export type CreateScoutCommunicationMutation = (
  { __typename?: 'Mutation' }
  & { createScoutCommunication: (
    { __typename?: 'ScoutCommunication' }
    & Pick<ScoutCommunication, 'id'>
  ) }
);

export type CreateSeasonMutationVariables = Exact<{
  input: CreateSeasonInput;
}>;


export type CreateSeasonMutation = (
  { __typename?: 'Mutation' }
  & { createSeason: (
    { __typename?: 'Season' }
    & SeasonFragmentFragment
  ) }
);

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = (
  { __typename?: 'Mutation' }
  & { createTag: (
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  ) }
);

export type CreateTemporaryPosUserMutationVariables = Exact<{
  input: CreateTemporaryPosUserInput;
}>;


export type CreateTemporaryPosUserMutation = (
  { __typename?: 'Mutation' }
  & { createTemporaryPosUser: (
    { __typename?: 'CreateTemporaryPosUserOutput' }
    & Pick<CreateTemporaryPosUserOutput, 'password' | 'oneTimeAccessToken'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email'>
    ) }
  ) }
);

export type CreateTicketTypeMutationVariables = Exact<{
  input: CreateTicketTypeInput;
}>;


export type CreateTicketTypeMutation = (
  { __typename?: 'Mutation' }
  & { createTicketType: (
    { __typename?: 'TicketType' }
    & TicketTypeFragmentFragment
  ) }
);

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
  sendInvite: Scalars['Boolean'];
}>;


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createUser: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { history: (
      { __typename?: 'HistoryConnection' }
      & { edges: Array<(
        { __typename?: 'HistoryEdge' }
        & { node: (
          { __typename?: 'History' }
          & Pick<History, 'id'>
        ) }
      )> }
    ) }
  ) }
);

export type CreateVenueMutationVariables = Exact<{
  input: CreateVenueInput;
}>;


export type CreateVenueMutation = (
  { __typename?: 'Mutation' }
  & { createVenue: (
    { __typename?: 'Venue' }
    & VenueFragmentFragment
  ) }
);

export type DeleteEventAddonMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEventAddonMutation = (
  { __typename?: 'Mutation' }
  & { deleteEventAddon: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteEventMultiBuyPromotionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEventMultiBuyPromotionMutation = (
  { __typename?: 'Mutation' }
  & { deleteEventMultiBuyPromotion: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteEventPromoCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEventPromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { deleteEventPromoCode: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteForecastScenarioMutationVariables = Exact<{
  id: Scalars['String'];
  forecastId: Scalars['String'];
}>;


export type DeleteForecastScenarioMutation = (
  { __typename?: 'Mutation' }
  & { deleteForecastScenario: (
    { __typename?: 'EventForecastOutput' }
    & Pick<EventForecastOutput, 'id' | 'eventId'>
    & { zones?: Maybe<Array<(
      { __typename?: 'EventForecastZoneOutput' }
      & Pick<EventForecastZoneOutput, 'zoneId' | 'comps' | 'contingency'>
    )>>, scenarios?: Maybe<Array<(
      { __typename?: 'ForecastScenario' }
      & Pick<ForecastScenario, 'id'>
      & { zones?: Maybe<Array<(
        { __typename?: 'ForecastScenarioZone' }
        & Pick<ForecastScenarioZone, 'zoneId'>
        & { ticketTypes: Array<(
          { __typename?: 'ScenarioZoneTicketType' }
          & Pick<ScenarioZoneTicketType, 'ticketTypeId' | 'price' | 'splitPercentage'>
        )> }
      )>> }
    )>> }
  ) }
);

export type DeleteMembershipAddonMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMembershipAddonMutation = (
  { __typename?: 'Mutation' }
  & { deleteMembershipAddon: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteMembershipMultiBuyPromotionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMembershipMultiBuyPromotionMutation = (
  { __typename?: 'Mutation' }
  & { deleteMembershipMultiBuyPromotion: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteMembershipPromoCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMembershipPromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { deleteMembershipPromoCode: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteMembershipTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMembershipTypeMutation = (
  { __typename?: 'Mutation' }
  & { deleteMembershipType: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeletePurchaseRestrictionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePurchaseRestrictionMutation = (
  { __typename?: 'Mutation' }
  & { deletePurchaseRestriction: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteReleaseMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteReleaseMutation = (
  { __typename?: 'Mutation' }
  & { deleteRelease: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteScoutUsersMutationVariables = Exact<{
  input: DeleteScoutUserInput;
}>;


export type DeleteScoutUsersMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteScoutUsers'>
);

export type DeleteTagMutationVariables = Exact<{
  tagId: Scalars['String'];
  entityId: Scalars['String'];
}>;


export type DeleteTagMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteTag'>
);

export type DeleteTicketTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTicketTypeMutation = (
  { __typename?: 'Mutation' }
  & { deleteTicketType: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserMutation = (
  { __typename?: 'Mutation' }
  & { deleteUser: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DeleteVenueMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteVenueMutation = (
  { __typename?: 'Mutation' }
  & { deleteVenue: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type DuplicateEventMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DuplicateEventMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'duplicateEvent'>
);

export type DuplicateMembershipMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DuplicateMembershipMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'duplicateMembership'>
);

export type DuplicateSingleReleaseMutationVariables = Exact<{
  input: DuplicateSingleReleaseInput;
}>;


export type DuplicateSingleReleaseMutation = (
  { __typename?: 'Mutation' }
  & { duplicateSingleRelease: (
    { __typename?: 'Release' }
    & Pick<Release, 'id'>
  ) }
);

export type EnableTwoFactorAuthenticationMutationVariables = Exact<{
  input: TwoFactorAuthenticationCodeInput;
}>;


export type EnableTwoFactorAuthenticationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'enableTwoFactorAuthentication'>
);

export type ImportDigitalPassCodesForEventMutationVariables = Exact<{
  eventId: Scalars['String'];
  input: ImportInput;
}>;


export type ImportDigitalPassCodesForEventMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'importDigitalPassCodesForEvent'>
);

export type ImportDigitalPassCodesForMembershipMutationVariables = Exact<{
  membershipId: Scalars['String'];
  input: ImportInput;
}>;


export type ImportDigitalPassCodesForMembershipMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'importDigitalPassCodesForMembership'>
);

export type ImportReleasePasswordsMutationVariables = Exact<{
  id: Scalars['String'];
  input: ImportInput;
}>;


export type ImportReleasePasswordsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'importReleasePasswords'>
);

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'createdAt' | 'updatedAt' | 'firstName' | 'lastName' | 'fullName' | 'email' | 'roles' | 'permissions' | 'credits' | 'phoneNumber' | 'birthDate' | 'shippingAddressMatchesBillingAddress' | 'usableForMarketing'>
  ) }
);

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type ReleaseClaimsForNextMembershipMutationVariables = Exact<{
  ids: Scalars['String'];
}>;


export type ReleaseClaimsForNextMembershipMutation = (
  { __typename?: 'Mutation' }
  & { releaseClaimsForNextMembership: Array<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id'>
  )> }
);

export type ReleaseSeatsMutationVariables = Exact<{
  input: ReleaseSeatsInput;
}>;


export type ReleaseSeatsMutation = (
  { __typename?: 'Mutation' }
  & { releaseSeats: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type RemoveTwoFactorAuthenticationSecretMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveTwoFactorAuthenticationSecretMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeTwoFactorAuthenticationSecret'>
);

export type RequestMagicLinkMutationVariables = Exact<{
  input: RequestMagicLinkInput;
}>;


export type RequestMagicLinkMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'requestMagicLink'>
);

export type RequestResetPasswordMutationVariables = Exact<{
  input: RequestResetPasswordInput;
}>;


export type RequestResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'requestResetPassword'>
);

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetPassword'>
);

export type AddReminderToScoutCommunicationUserMutationVariables = Exact<{
  id: Scalars['String'];
  input: AddReminderToScoutCommunicationUserInput;
}>;


export type AddReminderToScoutCommunicationUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addReminderToScoutCommunicationUser'>
);

export type ClearReminderFromScoutCommunicationUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ClearReminderFromScoutCommunicationUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'clearReminderFromScoutCommunicationUser'>
);

export type SendMemberRenewalEmailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SendMemberRenewalEmailMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendMemberRenewalEmail'>
);

export type SendOrderConfirmationMutationVariables = Exact<{
  id: Scalars['String'];
  input: SendOrderConfirmationInput;
}>;


export type SendOrderConfirmationMutation = (
  { __typename?: 'Mutation' }
  & { sendOrderConfirmation: (
    { __typename?: 'SendOrderConfirmationOutput' }
    & Pick<SendOrderConfirmationOutput, 'email'>
  ) }
);

export type CreateTestEmailMutationVariables = Exact<{
  input: CreateTestEmailInput;
}>;


export type CreateTestEmailMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createTestEmail'>
);

export type SendTwoFactorCodeViaSmsMessageMutationVariables = Exact<{ [key: string]: never; }>;


export type SendTwoFactorCodeViaSmsMessageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendTwoFactorCodeViaSMSMessage'>
);

export type SendUserInviteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SendUserInviteMutation = (
  { __typename?: 'Mutation' }
  & { sendUserInvite: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'email'>
  ) }
);

export type SetPasswordForNewUserMutationVariables = Exact<{
  input: SetPasswordForNewUserInput;
}>;


export type SetPasswordForNewUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setPasswordForNewUser'>
);

export type SplitOrderMutationVariables = Exact<{
  id: Scalars['String'];
  input: SplitOrderInput;
}>;


export type SplitOrderMutation = (
  { __typename?: 'Mutation' }
  & { splitHoldOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type SyncTicketWithSeatsIoMutationVariables = Exact<{
  ticketId: Scalars['String'];
}>;


export type SyncTicketWithSeatsIoMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'syncTicketWithSeatsIo'>
);

export type TagEntitiesMutationVariables = Exact<{
  input: TagEntitiesInput;
}>;


export type TagEntitiesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'tagEntities'>
);

export type UpdateAutomationMutationVariables = Exact<{
  input: UpdateAutomationInput;
  id: Scalars['String'];
}>;


export type UpdateAutomationMutation = (
  { __typename?: 'Mutation' }
  & { updateAutomation: (
    { __typename?: 'Automation' }
    & Pick<Automation, 'id'>
  ) }
);

export type UpdateCreditsForUserMutationVariables = Exact<{
  input: UpdateCreditsInput;
  userId: Scalars['String'];
}>;


export type UpdateCreditsForUserMutation = (
  { __typename?: 'Mutation' }
  & { updateCreditsForUser: (
    { __typename?: 'User' }
    & Pick<User, 'credits'>
  ) }
);

export type UpdateEventMutationVariables = Exact<{
  input: UpdateEventInput;
  id: Scalars['String'];
  sendTicketViewableEmails?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateEventMutation = (
  { __typename?: 'Mutation' }
  & { updateEvent: (
    { __typename?: 'Event' }
    & Pick<Event, 'id'>
  ) }
);

export type UpdateEventAddonMutationVariables = Exact<{
  input: UpdateEventAddonInput;
  id: Scalars['String'];
}>;


export type UpdateEventAddonMutation = (
  { __typename?: 'Mutation' }
  & { updateEventAddon: (
    { __typename?: 'EventAddon' }
    & Pick<EventAddon, 'id'>
  ) }
);

export type UpdateEventMultiBuyPromotionMutationVariables = Exact<{
  input: UpdateEventMultiBuyPromotionInput;
  id: Scalars['String'];
}>;


export type UpdateEventMultiBuyPromotionMutation = (
  { __typename?: 'Mutation' }
  & { updateEventMultiBuyPromotion: (
    { __typename?: 'EventMultiBuyPromotion' }
    & Pick<EventMultiBuyPromotion, 'id'>
  ) }
);

export type UpdateEventPromoCodeMutationVariables = Exact<{
  input: UpdateEventPromoCodeInput;
  id: Scalars['String'];
}>;


export type UpdateEventPromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { updateEventPromoCode: (
    { __typename?: 'EventPromoCode' }
    & Pick<EventPromoCode, 'id'>
  ) }
);

export type UpdateForecastMutationVariables = Exact<{
  input: UpdateForecastInput;
  id: Scalars['String'];
}>;


export type UpdateForecastMutation = (
  { __typename?: 'Mutation' }
  & { updateForecast: (
    { __typename?: 'EventForecastOutput' }
    & Pick<EventForecastOutput, 'id' | 'eventId'>
    & { zones?: Maybe<Array<(
      { __typename?: 'EventForecastZoneOutput' }
      & Pick<EventForecastZoneOutput, 'zoneId' | 'comps' | 'contingency'>
    )>>, scenarios?: Maybe<Array<(
      { __typename?: 'ForecastScenario' }
      & Pick<ForecastScenario, 'id'>
      & { zones?: Maybe<Array<(
        { __typename?: 'ForecastScenarioZone' }
        & Pick<ForecastScenarioZone, 'zoneId'>
        & { ticketTypes: Array<(
          { __typename?: 'ScenarioZoneTicketType' }
          & Pick<ScenarioZoneTicketType, 'ticketTypeId' | 'price' | 'splitPercentage'>
        )> }
      )>> }
    )>> }
  ) }
);

export type UpdateHoldOrderMutationVariables = Exact<{
  input: UpdateHoldOrderInput;
  id: Scalars['String'];
}>;


export type UpdateHoldOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateHoldOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type UpdateIntegrationMutationVariables = Exact<{
  input: UpdateIntegrationInput;
  id: Scalars['String'];
}>;


export type UpdateIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { updateIntegration: (
    { __typename?: 'Integration' }
    & FullIntegrationFragmentFragment
  ) }
);

export type UpdateMembershipMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateMembershipInput;
}>;


export type UpdateMembershipMutation = (
  { __typename?: 'Mutation' }
  & { updateMembership: (
    { __typename?: 'Membership' }
    & Pick<Membership, 'id'>
  ) }
);

export type UpdateMembershipAddonMutationVariables = Exact<{
  input: UpdateMembershipAddonInput;
  id: Scalars['String'];
}>;


export type UpdateMembershipAddonMutation = (
  { __typename?: 'Mutation' }
  & { updateMembershipAddon: (
    { __typename?: 'MembershipAddon' }
    & Pick<MembershipAddon, 'id'>
  ) }
);

export type UpdateMembershipMultiBuyPromotionMutationVariables = Exact<{
  input: UpdateMembershipMultiBuyPromotionInput;
  id: Scalars['String'];
}>;


export type UpdateMembershipMultiBuyPromotionMutation = (
  { __typename?: 'Mutation' }
  & { updateMembershipMultiBuyPromotion: (
    { __typename?: 'MembershipMultiBuyPromotion' }
    & Pick<MembershipMultiBuyPromotion, 'id'>
  ) }
);

export type UpdateMembershipPromoCodeMutationVariables = Exact<{
  input: UpdateMembershipPromoCodeInput;
  id: Scalars['String'];
}>;


export type UpdateMembershipPromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { updateMembershipPromoCode: (
    { __typename?: 'MembershipPromoCode' }
    & Pick<MembershipPromoCode, 'id'>
  ) }
);

export type UpdateMembershipTicketTransferPricesMutationVariables = Exact<{
  id: Scalars['String'];
  input: Array<UpdateMembershipTypeEventTransferPriceInput> | UpdateMembershipTypeEventTransferPriceInput;
}>;


export type UpdateMembershipTicketTransferPricesMutation = (
  { __typename?: 'Mutation' }
  & { upsertMembershipTypeEventTransferPrices: Array<(
    { __typename?: 'MembershipTypeEventTransferPrice' }
    & Pick<MembershipTypeEventTransferPrice, 'id'>
  )> }
);

export type UpdateMembershipTypeMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateMembershipTypeInput;
}>;


export type UpdateMembershipTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateMembershipType: (
    { __typename?: 'MembershipType' }
    & MembershipTypeFragmentFragment
  ) }
);

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
  id: Scalars['String'];
}>;


export type UpdateOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type UpdateOrderStatusMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateOrderStatusInput;
}>;


export type UpdateOrderStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateOrderStatus: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = (
  { __typename?: 'Mutation' }
  & { updateOrganization: (
    { __typename?: 'Organization' }
    & OrganizationFragmentFragment
  ) }
);

export type UpdateOrganizationByIdMutationVariables = Exact<{
  input: UpdateOrganizationInput;
  id: Scalars['String'];
}>;


export type UpdateOrganizationByIdMutation = (
  { __typename?: 'Mutation' }
  & { updateOrganizationById: (
    { __typename?: 'Organization' }
    & Pick<Organization, 'id'>
  ) }
);

export type UpdatePosUserMutationVariables = Exact<{
  input: UpdatePosUserInput;
  id: Scalars['String'];
}>;


export type UpdatePosUserMutation = (
  { __typename?: 'Mutation' }
  & { updatePosUser: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type UpdatePromoCodeMutationVariables = Exact<{
  input: UpdateEventPromoCodeInput;
  id: Scalars['String'];
}>;


export type UpdatePromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { updateEventPromoCode: (
    { __typename?: 'EventPromoCode' }
    & Pick<EventPromoCode, 'id'>
  ) }
);

export type UpdatePurchaseRestrictionMutationVariables = Exact<{
  id: Scalars['String'];
  input: CreatePurchaseRestrictionInput;
}>;


export type UpdatePurchaseRestrictionMutation = (
  { __typename?: 'Mutation' }
  & { updatePurchaseRestriction: (
    { __typename?: 'PurchaseRestriction' }
    & Pick<PurchaseRestriction, 'id' | 'restrictedType' | 'restrictedId' | 'quantity' | 'isExclusive' | 'isAlwaysVisible' | 'createdAt' | 'updatedAt'>
    & { requiredEntities: Array<(
      { __typename?: 'PurchaseRestrictionRequiredEntity' }
      & Pick<PurchaseRestrictionRequiredEntity, 'requiredId' | 'requiredType'>
    )> }
  ) }
);

export type UpdateReferralCampaignMutationVariables = Exact<{
  input: UpdateReferralCampaignDto;
}>;


export type UpdateReferralCampaignMutation = (
  { __typename?: 'Mutation' }
  & { updateReferralCampaign: (
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantity' | 'referralOwnerRewardQuantityType' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
    & { referralRelease?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'id'>
    )> }
  ) }
);

export type UpdateReleaseMutationVariables = Exact<{
  input: UpdateReleaseInput;
  id: Scalars['String'];
}>;


export type UpdateReleaseMutation = (
  { __typename?: 'Mutation' }
  & { updateRelease: (
    { __typename?: 'Release' }
    & Pick<Release, 'id'>
  ) }
);

export type UpdateScoutMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateScoutInput;
}>;


export type UpdateScoutMutation = (
  { __typename?: 'Mutation' }
  & { updateScout: (
    { __typename?: 'Scout' }
    & Pick<Scout, 'id'>
  ) }
);

export type UpdateScoutCommunicationMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateScoutCommunicationInput;
}>;


export type UpdateScoutCommunicationMutation = (
  { __typename?: 'Mutation' }
  & { updateScoutCommunication: (
    { __typename?: 'ScoutCommunication' }
    & Pick<ScoutCommunication, 'id'>
  ) }
);

export type UpdateScoutCommunicationUserMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateScoutCommunicationUserInput;
}>;


export type UpdateScoutCommunicationUserMutation = (
  { __typename?: 'Mutation' }
  & { updateScoutCommunicationUser: (
    { __typename?: 'ScoutCommunicationUser' }
    & Pick<ScoutCommunicationUser, 'id'>
  ) }
);

export type UpdateScoutUsersMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UpdateScoutUsersMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateScoutUsers'>
);

export type UpdateSeasonMutationVariables = Exact<{
  input: UpdateSeasonInput;
  id: Scalars['String'];
}>;


export type UpdateSeasonMutation = (
  { __typename?: 'Mutation' }
  & { updateSeason: (
    { __typename?: 'Season' }
    & SeasonFragmentFragment
  ) }
);

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
  id: Scalars['String'];
}>;


export type UpdateTagMutation = (
  { __typename?: 'Mutation' }
  & { updateTag: (
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  ) }
);

export type UpdateTicketHolderMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateTicketHolderInput;
}>;


export type UpdateTicketHolderMutation = (
  { __typename?: 'Mutation' }
  & { updateTicketHolder: (
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id'>
  ) }
);

export type UpdateTicketTypeMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateTicketTypeInput;
}>;


export type UpdateTicketTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateTicketType: (
    { __typename?: 'TicketType' }
    & TicketTypeFragmentFragment
  ) }
);

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
  id: Scalars['String'];
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type UpdateVenueMutationVariables = Exact<{
  input: UpdateVenueInput;
  id: Scalars['String'];
}>;


export type UpdateVenueMutation = (
  { __typename?: 'Mutation' }
  & { updateVenue: (
    { __typename?: 'Venue' }
    & Pick<Venue, 'id'>
  ) }
);

export type UpdateVenueZonesMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UpdateVenueZonesMutation = (
  { __typename?: 'Mutation' }
  & { updateVenueZones: (
    { __typename?: 'Venue' }
    & { zones: Array<(
      { __typename?: 'Zone' }
      & Pick<Zone, 'name' | 'capacity' | 'description' | 'displayOrder'>
      & { sections?: Maybe<Array<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'name'>
      )>> }
    )> }
  ) }
);

export type VerifyMagicLinkMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyMagicLinkMutation = (
  { __typename?: 'Mutation' }
  & { verifyMagicLink: (
    { __typename?: 'VerifyMagicLinkOutput' }
    & Pick<VerifyMagicLinkOutput, 'redirectUrl'>
  ) }
);

export type GetPromoterSettingsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetPromoterSettingsQuery = (
  { __typename?: 'Query' }
  & { getPromoterSettings?: Maybe<(
    { __typename?: 'PromoterSettings' }
    & { event: (
      { __typename?: 'Event' }
      & Pick<Event, 'id'>
    ), config?: Maybe<(
      { __typename?: 'PromoterConfig' }
      & Pick<PromoterConfig, 'share' | 'rsvp' | 'follow' | 'like' | 'invite'>
    )>, socialPages?: Maybe<Array<(
      { __typename?: 'EventSocialPage' }
      & Pick<EventSocialPage, 'name' | 'isEnabled' | 'url'>
    )>>, referralCampaign?: Maybe<(
      { __typename?: 'ReferralCampaign' }
      & Pick<ReferralCampaign, 'id' | 'createdAt' | 'updatedAt' | 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantityType' | 'referralOwnerRewardQuantity' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
      & { referralRelease?: Maybe<(
        { __typename?: 'Release' }
        & Pick<Release, 'id'>
      )> }
    )> }
  )> }
);

export type SetPromoterSettingsMutationVariables = Exact<{
  input: PromoterSettingsInput;
}>;


export type SetPromoterSettingsMutation = (
  { __typename?: 'Mutation' }
  & { setPromoterSettings: (
    { __typename?: 'PromoterSettings' }
    & { config?: Maybe<(
      { __typename?: 'PromoterConfig' }
      & Pick<PromoterConfig, 'share' | 'rsvp' | 'follow' | 'like' | 'invite'>
    )>, socialPages?: Maybe<Array<(
      { __typename?: 'EventSocialPage' }
      & Pick<EventSocialPage, 'name' | 'isEnabled' | 'url'>
    )>> }
  ) }
);

export type ActivitiesQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<ActivityWhereInput>;
}>;


export type ActivitiesQuery = (
  { __typename?: 'Query' }
  & { activities: (
    { __typename?: 'ActivityConnection' }
    & Pick<ActivityConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'ActivityEdge' }
      & { node: (
        { __typename?: 'Activity' }
        & Pick<Activity, 'id' | 'description' | 'createdAt'>
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type InsightsAgeBreakDownQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
  scoutCommunicationId?: Maybe<Scalars['String']>;
}>;


export type InsightsAgeBreakDownQuery = (
  { __typename?: 'Query' }
  & { insightsAgeBreakDown: (
    { __typename?: 'AgeBreakDownOutput' }
    & Pick<AgeBreakDownOutput, 'seg1' | 'seg2' | 'seg3' | 'seg4' | 'seg5' | 'seg6' | 'seg7'>
  ) }
);

export type AutomationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AutomationQuery = (
  { __typename?: 'Query' }
  & { automation: (
    { __typename?: 'Automation' }
    & AutomationFragmentFragment
  ) }
);

export type AutomationsQueryVariables = Exact<{
  input: FindAutomationsInput;
}>;


export type AutomationsQuery = (
  { __typename?: 'Query' }
  & { automations: Array<(
    { __typename?: 'Automation' }
    & AutomationFragmentFragment
  )> }
);

export type CapacityOverviewQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type CapacityOverviewQuery = (
  { __typename?: 'Query' }
  & { capacityOverview: Array<(
    { __typename?: 'CapacityOverview' }
    & Pick<CapacityOverview, 'id' | 'zoneName' | 'totalNotForSaleCount' | 'totalMembershipTicketCount' | 'totalCompTicketCount' | 'totalPaidTicketCount' | 'totalHolds' | 'capacity' | 'sellableCapacity' | 'totalHoldByMembershipCount' | 'totalAllocated'>
  )> }
);

export type CapacitySeatingMapQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type CapacitySeatingMapQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'capacitySeatingMap'>
);

export type CapacitySeatingMapTooltipsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type CapacitySeatingMapTooltipsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'capacitySeatingMapTooltips'>
);

export type CreateOrderEventsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type CreateOrderEventsQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'startDate' | 'title'>
        & { season?: Maybe<(
          { __typename?: 'Season' }
          & Pick<Season, 'id'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type CurrentOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentOrganizationQuery = (
  { __typename?: 'Query' }
  & { currentOrganization: (
    { __typename?: 'CurrentOrganizationOutput' }
    & CurrentOrganizationFragmentFragment
  ) }
);

export type CustomerLocationsQueryVariables = Exact<{
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
}>;


export type CustomerLocationsQuery = (
  { __typename?: 'Query' }
  & { customerLocations: Array<(
    { __typename?: 'LocationOutput' }
    & Pick<LocationOutput, 'city' | 'count' | 'amount'>
  )> }
);

export type EventQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EventQuery = (
  { __typename?: 'Query' }
  & { event: (
    { __typename?: 'Event' }
    & EventFragmentFragment
  ) }
);

export type EventAddonsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type EventAddonsQuery = (
  { __typename?: 'Query' }
  & { eventAddons: Array<(
    { __typename?: 'EventAddon' }
    & Pick<EventAddon, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'enableNaming' | 'quantity' | 'isActive' | 'price' | 'description' | 'restrictions' | 'insideFee'>
    & { namingFields: Array<(
      { __typename?: 'FormField' }
      & NamingFieldsFragment
    )>, addonImage?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )> }
  )> }
);

export type EventForecastQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type EventForecastQuery = (
  { __typename?: 'Query' }
  & { eventForecast: (
    { __typename?: 'EventForecastOutput' }
    & Pick<EventForecastOutput, 'id' | 'eventId'>
    & { zones?: Maybe<Array<(
      { __typename?: 'EventForecastZoneOutput' }
      & Pick<EventForecastZoneOutput, 'zoneId' | 'comps' | 'contingency'>
      & { sales?: Maybe<(
        { __typename?: 'FinancialSales' }
        & Pick<FinancialSales, 'zoneId' | 'zoneName' | 'capacity' | 'available' | 'sellableCapacity' | 'totalNotForSaleCount' | 'totalHoldByMembershipCount' | 'totalMembershipTicketCount' | 'soldPercentage'>
        & { types: Array<(
          { __typename?: 'FinancialSalesType' }
          & Pick<FinancialSalesType, 'name' | 'issued' | 'holds' | 'comps' | 'transfers' | 'transfersPending' | 'sold' | 'baseRevenue' | 'totalWithBookingFees'>
        )> }
      )> }
    )>>, scenarios?: Maybe<Array<(
      { __typename?: 'ForecastScenario' }
      & Pick<ForecastScenario, 'id'>
      & { zones?: Maybe<Array<(
        { __typename?: 'ForecastScenarioZone' }
        & Pick<ForecastScenarioZone, 'zoneId'>
        & { ticketTypes: Array<(
          { __typename?: 'ScenarioZoneTicketType' }
          & Pick<ScenarioZoneTicketType, 'ticketTypeId' | 'price' | 'splitPercentage'>
        )> }
      )>> }
    )>> }
  ) }
);

export type EventMultiBuyPromotionsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type EventMultiBuyPromotionsQuery = (
  { __typename?: 'Query' }
  & { eventMultiBuyPromotions: Array<(
    { __typename?: 'EventMultiBuyPromotion' }
    & Pick<EventMultiBuyPromotion, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'buyQuantity' | 'getQuantity' | 'price'>
    & { buyTicketType: (
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name'>
    ), getTicketType: (
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name'>
    ) }
  )> }
);

export type EventOrdersOnlineQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EventOrdersOnlineQuery = (
  { __typename?: 'Query' }
  & { eventOrdersOnline?: Maybe<(
    { __typename?: 'EventOrdersOnlineOutput' }
    & Pick<EventOrdersOnlineOutput, 'totalCount' | 'baseTickets' | 'ticketFees' | 'bookingFees' | 'transactionFees' | 'deliveryFees' | 'refundedAmount' | 'addons' | 'creditsUsed'>
    & { orderIdsOnline: Array<(
      { __typename?: 'OrderIdsOnlineOutput' }
      & Pick<OrderIdsOnlineOutput, 'orderId'>
    )> }
  )> }
);

export type EventPromoCodesQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type EventPromoCodesQuery = (
  { __typename?: 'Query' }
  & { eventPromoCodes: Array<(
    { __typename?: 'EventPromoCode' }
    & Pick<EventPromoCode, 'id' | 'code' | 'discountType' | 'discountAmount' | 'used' | 'maxUsage' | 'startDate' | 'endDate' | 'minOrderAmount' | 'maxOrderAmount' | 'type' | 'ticketTypes' | 'createdAt' | 'updatedAt'>
  )> }
);

export type EventsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type EventsQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'startDate' | 'endDate' | 'eventKind' | 'title' | 'soldTicketsCount' | 'isActive'>
        & { season?: Maybe<(
          { __typename?: 'Season' }
          & Pick<Season, 'id' | 'name'>
        )>, dates: Array<(
          { __typename?: 'EventDate' }
          & Pick<EventDate, 'id' | 'startDate' | 'endDate'>
        )>, logo?: Maybe<(
          { __typename?: 'ExtendedFile' }
          & FileFragmentFragment
        )>, venue: (
          { __typename?: 'Venue' }
          & Pick<Venue, 'name'>
          & { address: (
            { __typename?: 'Address' }
            & Pick<Address, 'city'>
          ) }
        ), ticketTypes: Array<(
          { __typename?: 'TicketType' }
          & Pick<TicketType, 'id' | 'name'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type EventsSelectQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type EventsSelectQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'startDate' | 'title' | 'isActive'>
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type FacebookPageListsQueryVariables = Exact<{
  input: FacebookPageListsInput;
}>;


export type FacebookPageListsQuery = (
  { __typename?: 'Query' }
  & { facebookPageLists: Array<(
    { __typename?: 'PageListsOutput' }
    & Pick<PageListsOutput, 'id' | 'name' | 'access_token'>
  )> }
);

export type FinancialGatewaysQueryVariables = Exact<{
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
}>;


export type FinancialGatewaysQuery = (
  { __typename?: 'Query' }
  & { financialGateways: (
    { __typename?: 'FinancialGatewayGraphOutput' }
    & Pick<FinancialGatewayGraphOutput, 'transactions'>
    & { integrations: Array<(
      { __typename?: 'FinancialGraphIntegration' }
      & Pick<FinancialGraphIntegration, 'name' | 'transactions'>
    )> }
  ) }
);

export type FinancialGraphQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
}>;


export type FinancialGraphQuery = (
  { __typename?: 'Query' }
  & { financialGraph: (
    { __typename?: 'GraphOutput' }
    & { dates: Array<(
      { __typename?: 'GraphDateItem' }
      & Pick<GraphDateItem, 'date'>
      & { items: Array<(
        { __typename?: 'GraphItem' }
        & Pick<GraphItem, 'name' | 'value'>
      )> }
    )> }
  ) }
);

export type FinancialOverviewQueryVariables = Exact<{
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
}>;


export type FinancialOverviewQuery = (
  { __typename?: 'Query' }
  & { financialOverview: (
    { __typename?: 'FinancialOverviewOutput' }
    & Pick<FinancialOverviewOutput, 'grossSales' | 'netSales' | 'discounts' | 'avgOrderAmount' | 'avgOrderItemsCount' | 'transactionFees' | 'shippingCosts' | 'transferFees' | 'ticketCoverCost' | 'ticketCoverMargin'>
  ) }
);

export type FinancialSalesBreakdownQueryVariables = Exact<{
  source: ReportingFinancialSalesBreakdownSource;
  sourceId: Scalars['String'];
  channel?: Maybe<OrderChannel>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  release?: Maybe<Scalars['String']>;
}>;


export type FinancialSalesBreakdownQuery = (
  { __typename?: 'Query' }
  & { financialSalesBreakdown: Array<(
    { __typename?: 'FinancialSales' }
    & Pick<FinancialSales, 'zoneId' | 'zoneName' | 'capacity' | 'available' | 'sellableCapacity' | 'totalNotForSaleCount' | 'totalHoldByMembershipCount' | 'totalMembershipTicketCount' | 'soldPercentage'>
    & { types: Array<(
      { __typename?: 'FinancialSalesType' }
      & Pick<FinancialSalesType, 'name' | 'issued' | 'holds' | 'transfers' | 'transfersPending' | 'comps' | 'sold' | 'baseRevenue' | 'totalWithBookingFees'>
    )> }
  )> }
);

export type FullIntegrationsQueryVariables = Exact<{
  input?: Maybe<IntegrationWhereInput>;
}>;


export type FullIntegrationsQuery = (
  { __typename?: 'Query' }
  & { integrations: Array<(
    { __typename?: 'Integration' }
    & FullIntegrationFragmentFragment
  )> }
);

export type InsightsGenderBreakDownQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
}>;


export type InsightsGenderBreakDownQuery = (
  { __typename?: 'Query' }
  & { insightsGenderBreakDown: Array<(
    { __typename?: 'GenderBreakDownOutput' }
    & Pick<GenderBreakDownOutput, 'male' | 'female' | 'other'>
  )> }
);

export type GetEventPurchaseRestrictionsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventPurchaseRestrictionsQuery = (
  { __typename?: 'Query' }
  & { getEventPurchaseRestrictions: Array<(
    { __typename?: 'PurchaseRestriction' }
    & Pick<PurchaseRestriction, 'id' | 'restrictedType' | 'restrictedId' | 'quantity' | 'isExclusive' | 'isAlwaysVisible' | 'createdAt' | 'updatedAt'>
    & { requiredEntities: Array<(
      { __typename?: 'PurchaseRestrictionRequiredEntity' }
      & Pick<PurchaseRestrictionRequiredEntity, 'requiredId' | 'requiredType'>
    )> }
  )> }
);

export type GetHistoryByCustomerIdQueryVariables = Exact<{
  input: GetHistoryByCustomerIdInput;
}>;


export type GetHistoryByCustomerIdQuery = (
  { __typename?: 'Query' }
  & { getHistoryByCustomerId: Array<(
    { __typename?: 'History' }
    & HistoryFragment
  )> }
);

export type GetMembershipOrderOptionsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  where?: Maybe<MembershipWhereInput>;
}>;


export type GetMembershipOrderOptionsQuery = (
  { __typename?: 'Query' }
  & { memberships: (
    { __typename?: 'MembershipConnection' }
    & { edges: Array<(
      { __typename?: 'MembershipEdge' }
      & { node: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'id' | 'name'>
        & { season?: Maybe<(
          { __typename?: 'Season' }
          & Pick<Season, 'id' | 'name'>
        )> }
      ) }
    )> }
  ) }
);

export type GetMembershipPurchaseRestrictionsQueryVariables = Exact<{
  membershipId: Scalars['String'];
}>;


export type GetMembershipPurchaseRestrictionsQuery = (
  { __typename?: 'Query' }
  & { getMembershipPurchaseRestrictions: Array<(
    { __typename?: 'PurchaseRestriction' }
    & Pick<PurchaseRestriction, 'id' | 'restrictedType' | 'restrictedId' | 'quantity' | 'isExclusive' | 'isAlwaysVisible' | 'createdAt' | 'updatedAt'>
    & { requiredEntities: Array<(
      { __typename?: 'PurchaseRestrictionRequiredEntity' }
      & Pick<PurchaseRestrictionRequiredEntity, 'requiredId' | 'requiredType'>
    )> }
  )> }
);

export type GetMembershipRenewalQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMembershipRenewalQuery = (
  { __typename?: 'Query' }
  & { membership?: Maybe<(
    { __typename?: 'Membership' }
    & Pick<Membership, 'id'>
    & { multiBuyPromotions: Array<(
      { __typename?: 'MembershipMultiBuyPromotion' }
      & Pick<MembershipMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity'>
      & { getMembershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
      )>, buyMembershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
      )> }
    )>, membershipZones: Array<(
      { __typename?: 'MembershipZone' }
      & Pick<MembershipZone, 'id' | 'pricingLevel' | 'isActive'>
      & { zone: (
        { __typename?: 'Zone' }
        & Pick<Zone, 'id' | 'name'>
      ), membershipTypes: Array<(
        { __typename?: 'MembershipSeatingZoneType' }
        & Pick<MembershipSeatingZoneType, 'price' | 'isActive' | 'membershipTypeId'>
        & { sections?: Maybe<Array<(
          { __typename?: 'ZonePricingTypeSection' }
          & Pick<ZonePricingTypeSection, 'name' | 'price'>
        )>> }
      )> }
    )>, types: Array<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name' | 'kind' | 'ticketFeeType'>
    )> }
  )> }
);

export type GetReferralCampaignByEventIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReferralCampaignByEventIdQuery = (
  { __typename?: 'Query' }
  & { getReferralCampaignByEventId?: Maybe<(
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantityType' | 'referralOwnerRewardQuantity' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
    & { referralRelease?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'id'>
    )> }
  )> }
);

export type GetReferralCampaignByOrderIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReferralCampaignByOrderIdQuery = (
  { __typename?: 'Query' }
  & { getReferralCampaignByOrderId?: Maybe<(
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'id' | 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantityType' | 'referralOwnerRewardQuantity' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
  )> }
);

export type GetReferralCampaignStatsQueryVariables = Exact<{
  id: Scalars['String'];
  eventId: Scalars['String'];
}>;


export type GetReferralCampaignStatsQuery = (
  { __typename?: 'Query' }
  & { getReferralCampaignStats: (
    { __typename?: 'ReferralCampaignOverviewOutput' }
    & Pick<ReferralCampaignOverviewOutput, 'numberOfOrders' | 'userRewards' | 'ownerRewards' | 'referralLinksCreated' | 'referralLinksClicked' | 'tickets' | 'revenueGenerated' | 'customersAccquired'>
  ) }
);

export type GetReferralCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferralCampaignsQuery = (
  { __typename?: 'Query' }
  & { getReferralCampaigns: Array<(
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'id' | 'createdAt' | 'updatedAt' | 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantityType' | 'referralOwnerRewardQuantity' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
    & { referralRelease?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'id'>
    )> }
  )> }
);

export type GetReferralRewardByOrderIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReferralRewardByOrderIdQuery = (
  { __typename?: 'Query' }
  & { getReferralRewardByOrderId?: Maybe<(
    { __typename?: 'ReferralReward' }
    & Pick<ReferralReward, 'id' | 'rewardType' | 'rewardQuantityType' | 'rewardQuantity'>
    & { referralCampaign: (
      { __typename?: 'ReferralCampaign' }
      & Pick<ReferralCampaign, 'id'>
    ) }
  )> }
);

export type GetReferralCampaignsByEventIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReferralCampaignsByEventIdQuery = (
  { __typename?: 'Query' }
  & { getReferralCampaignsByEventId?: Maybe<Array<(
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'id' | 'createdAt' | 'updatedAt' | 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantityType' | 'referralOwnerRewardQuantity' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
    & { referralRelease?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'id'>
    )> }
  )>> }
);

export type GetTicketSoldTimeForEventQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTicketSoldTimeForEventQuery = (
  { __typename?: 'Query' }
  & { event: (
    { __typename?: 'Event' }
    & Pick<Event, 'id'>
    & { ticketSoldTime?: Maybe<(
      { __typename?: 'TicketSoldTime' }
      & Pick<TicketSoldTime, 'startTime' | 'endTime' | 'sourceId'>
    )> }
  ) }
);

export type GetTicketSoldTimeForMembershipQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTicketSoldTimeForMembershipQuery = (
  { __typename?: 'Query' }
  & { membership?: Maybe<(
    { __typename?: 'Membership' }
    & Pick<Membership, 'id'>
    & { ticketSoldTime?: Maybe<(
      { __typename?: 'TicketSoldTime' }
      & Pick<TicketSoldTime, 'startTime' | 'endTime' | 'sourceId'>
    )> }
  )> }
);

export type GetZonesByEventIdQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetZonesByEventIdQuery = (
  { __typename?: 'Query' }
  & { getZonesByEventId: Array<(
    { __typename?: 'Zone' }
    & Pick<Zone, 'id' | 'name'>
  )> }
);

export type HasSeatedEventQueryVariables = Exact<{ [key: string]: never; }>;


export type HasSeatedEventQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'hasSeatedEvent'>
);

export type HighestValueCustomersQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
}>;


export type HighestValueCustomersQuery = (
  { __typename?: 'Query' }
  & { highestValueCustomers: Array<(
    { __typename?: 'HighestValueCustomersOutput' }
    & Pick<HighestValueCustomersOutput, 'name' | 'value' | 'userId'>
  )> }
);

export type InsightsHeardAboutUsBreakDownQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
}>;


export type InsightsHeardAboutUsBreakDownQuery = (
  { __typename?: 'Query' }
  & { insightsHeardAboutUsBreakDown: Array<(
    { __typename?: 'HeardAboutUsBreakDownOutput' }
    & Pick<HeardAboutUsBreakDownOutput, 'heardAboutUs' | 'count'>
  )> }
);

export type InsightsOverviewQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
}>;


export type InsightsOverviewQuery = (
  { __typename?: 'Query' }
  & { insightsOverview: (
    { __typename?: 'InsightsOverviewOutput' }
    & Pick<InsightsOverviewOutput, 'customers' | 'addressableAudience' | 'customerValue' | 'numberOfOrders' | 'returningCustomers' | 'referralLinksCreated' | 'newReferredCustomers'>
  ) }
);

export type IntegrationsQueryVariables = Exact<{
  input?: Maybe<IntegrationWhereInput>;
}>;


export type IntegrationsQuery = (
  { __typename?: 'Query' }
  & { integrations: Array<(
    { __typename?: 'Integration' }
    & IntegrationFragmentFragment
  )> }
);

export type MailchimpDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type MailchimpDomainsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'mailchimpDomains'>
);

export type MailchimpListsQueryVariables = Exact<{ [key: string]: never; }>;


export type MailchimpListsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'mailchimpLists'>
);

export type MailchimpTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type MailchimpTemplatesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'mailchimpTemplates'>
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'createdAt' | 'updatedAt' | 'firstName' | 'lastName' | 'fullName' | 'email' | 'roles' | 'permissions' | 'credits' | 'phoneNumber' | 'birthDate' | 'isTwoFactorAuthenticationEnabled' | 'isLoggedInWithLinkedAccount' | 'shippingAddressMatchesBillingAddress' | 'usableForMarketing' | 'accessEventIds' | 'accessMembershipIds' | 'hasPassword'>
    & { shippingAddress?: Maybe<(
      { __typename?: 'PartialAddress' }
      & PartialAddressFragmentFragment
    )>, billingAddress?: Maybe<(
      { __typename?: 'PartialAddress' }
      & PartialAddressFragmentFragment
    )> }
  ) }
);

export type MembershipQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MembershipQuery = (
  { __typename?: 'Query' }
  & { membership?: Maybe<(
    { __typename?: 'Membership' }
    & MembershipFragmentFragment
  )> }
);

export type MembershipAddonsQueryVariables = Exact<{
  membershipId: Scalars['String'];
}>;


export type MembershipAddonsQuery = (
  { __typename?: 'Query' }
  & { membershipAddons: Array<(
    { __typename?: 'MembershipAddon' }
    & Pick<MembershipAddon, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'enableNaming' | 'quantity' | 'isActive' | 'price' | 'description' | 'restrictions'>
    & { addonImage?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragmentFragment
    )>, namingFields: Array<(
      { __typename?: 'FormField' }
      & NamingFieldsFragment
    )> }
  )> }
);

export type MembershipMultiBuyPromotionsQueryVariables = Exact<{
  membershipId: Scalars['String'];
}>;


export type MembershipMultiBuyPromotionsQuery = (
  { __typename?: 'Query' }
  & { membershipMultiBuyPromotions: Array<(
    { __typename?: 'MembershipMultiBuyPromotion' }
    & Pick<MembershipMultiBuyPromotion, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'buyQuantity' | 'getQuantity' | 'price'>
    & { buyMembershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name'>
    )>, getMembershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name'>
    )> }
  )> }
);

export type MembershipPromoCodesQueryVariables = Exact<{
  membershipId: Scalars['String'];
}>;


export type MembershipPromoCodesQuery = (
  { __typename?: 'Query' }
  & { membershipPromoCodes: Array<(
    { __typename?: 'MembershipPromoCode' }
    & Pick<MembershipPromoCode, 'id' | 'code' | 'discountType' | 'discountAmount' | 'used' | 'maxUsage' | 'startDate' | 'endDate' | 'minOrderAmount' | 'maxOrderAmount' | 'type' | 'membershipTypes' | 'createdAt' | 'updatedAt'>
  )> }
);

export type MembershipTypeEventTransferPricesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MembershipTypeEventTransferPricesQuery = (
  { __typename?: 'Query' }
  & { membershipTypeEventTransferPrices?: Maybe<Array<(
    { __typename?: 'MembershipTypeEventTransferPrice' }
    & MembershipTypeEventTransferPricesFragmentFragment
  )>> }
);

export type MembershipTypesQueryVariables = Exact<{
  membership: Scalars['String'];
}>;


export type MembershipTypesQuery = (
  { __typename?: 'Query' }
  & { membershipTypes: Array<(
    { __typename?: 'MembershipType' }
    & MembershipTypeFragmentFragment
  )> }
);

export type MembershipsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  where?: Maybe<MembershipWhereInput>;
  orderBy?: Maybe<MembershipOrderByInput>;
}>;


export type MembershipsQuery = (
  { __typename?: 'Query' }
  & { memberships: (
    { __typename?: 'MembershipConnection' }
    & { edges: Array<(
      { __typename?: 'MembershipEdge' }
      & { node: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'id' | 'name' | 'startDate' | 'endDate' | 'isActive'>
        & { venue?: Maybe<(
          { __typename?: 'Venue' }
          & Pick<Venue, 'id' | 'name'>
        )> }
      ) }
    )> }
  ) }
);

export type MentionOverviewQueryVariables = Exact<{
  input: MentionOverviewInput;
}>;


export type MentionOverviewQuery = (
  { __typename?: 'Query' }
  & { mentionOverview: (
    { __typename?: 'MentionOverview' }
    & Pick<MentionOverview, 'commentMentionCount' | 'mediaMentionCount' | 'storyMentionCount'>
  ) }
);

export type OrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrderQuery = (
  { __typename?: 'Query' }
  & { order?: Maybe<(
    { __typename?: 'Order' }
    & OrderFragmentFragment
  )> }
);

export type OrderIdsOnlineQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrderIdsOnlineQuery = (
  { __typename?: 'Query' }
  & { orderIdsOnline?: Maybe<Array<(
    { __typename?: 'OrderIdsOnlineOutput' }
    & Pick<OrderIdsOnlineOutput, 'orderId'>
  )>> }
);

export type OrderRefundDetailsQueryVariables = Exact<{
  orderId: Scalars['String'];
  eventId: Scalars['String'];
}>;


export type OrderRefundDetailsQuery = (
  { __typename?: 'Query' }
  & { orderRefundDetails?: Maybe<(
    { __typename?: 'OrderRefundDetailsOutput' }
    & Pick<OrderRefundDetailsOutput, 'orderId' | 'baseTickets' | 'ticketFees' | 'bookingFees' | 'transactionFees' | 'deliveryFees' | 'refundedAmount' | 'addons' | 'creditsUsed'>
  )> }
);

export type OrdersQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<OrderOrderByInput>;
}>;


export type OrdersQuery = (
  { __typename?: 'Query' }
  & { orders: (
    { __typename?: 'OrderConnection' }
    & Pick<OrderConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'OrderEdge' }
      & { node: (
        { __typename?: 'Order' }
        & Pick<Order, 'id' | 'orderNumber' | 'createdAt' | 'total' | 'refundedAmount' | 'transactionStatus' | 'status' | 'isComp' | 'orderType' | 'deliveryMethod'>
        & { event?: Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'title'>
        )>, membership?: Maybe<(
          { __typename?: 'Membership' }
          & Pick<Membership, 'name'>
        )>, buyerInformation?: Maybe<(
          { __typename?: 'BuyerInformation' }
          & Pick<BuyerInformation, 'firstName' | 'lastName'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type OrganizationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrganizationQuery = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<Organization, 'id' | 'slug' | 'name' | 'email' | 'phone'>
    & { address?: Maybe<(
      { __typename?: 'Address' }
      & AddressFragmentFragment
    )> }
  ) }
);

export type OrganizationsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationWhereInput>;
  orderBy?: Maybe<OrganizationOrderByInput>;
}>;


export type OrganizationsQuery = (
  { __typename?: 'Query' }
  & { organizations: (
    { __typename?: 'OrganizationConnection' }
    & Pick<OrganizationConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'OrganizationEdge' }
      & { node: (
        { __typename?: 'Organization' }
        & Pick<Organization, 'id' | 'createdAt' | 'updatedAt' | 'name'>
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type ParamsEventsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type ParamsEventsQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'startDate' | 'title'>
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type ParamsMembershipsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  where?: Maybe<MembershipWhereInput>;
  orderBy?: Maybe<MembershipOrderByInput>;
}>;


export type ParamsMembershipsQuery = (
  { __typename?: 'Query' }
  & { memberships: (
    { __typename?: 'MembershipConnection' }
    & { edges: Array<(
      { __typename?: 'MembershipEdge' }
      & { node: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'id' | 'name' | 'startDate'>
      ) }
    )> }
  ) }
);

export type ParamsReleasesQueryVariables = Exact<{
  event: Scalars['String'];
}>;


export type ParamsReleasesQuery = (
  { __typename?: 'Query' }
  & { releases: Array<(
    { __typename?: 'Release' }
    & Pick<Release, 'id' | 'name' | 'type'>
  )> }
);

export type PaymentOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentOptionsQuery = (
  { __typename?: 'Query' }
  & { integrations: Array<(
    { __typename?: 'Integration' }
    & Pick<Integration, 'id' | 'name'>
  )> }
);

export type PosQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PosQuery = (
  { __typename?: 'Query' }
  & { pos: (
    { __typename?: 'Pos' }
    & Pick<Pos, 'id' | 'name' | 'bookingFeeType' | 'bookingFee' | 'enableReceipts' | 'createdAt' | 'updatedAt' | 'deliveryOptions' | 'cashAmount'>
    & { paymentOptions: (
      { __typename?: 'PosPaymentOptions' }
      & { cash?: Maybe<(
        { __typename?: 'PosPaymentFee' }
        & Pick<PosPaymentFee, 'feeType' | 'feeAmount'>
      )>, eftpos?: Maybe<(
        { __typename?: 'PosPaymentFee' }
        & Pick<PosPaymentFee, 'feeType' | 'feeAmount'>
      )>, cc?: Maybe<(
        { __typename?: 'PosPaymentFee' }
        & Pick<PosPaymentFee, 'feeType' | 'feeAmount'>
      )>, MPAiSA?: Maybe<(
        { __typename?: 'PosPaymentFee' }
        & Pick<PosPaymentFee, 'feeType' | 'feeAmount'>
      )> }
    ), event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'title' | 'id' | 'startDate' | 'endDate'>
      & { venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
      ) }
    )>, release?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'name' | 'id'>
    )>, users: Array<(
      { __typename?: 'PosUser' }
      & Pick<PosUser, 'id' | 'fullName' | 'email'>
    )> }
  ) }
);

export type PosEventsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type PosEventsQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'title' | 'bookingFee' | 'bookingFeeType'>
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type PosFinancialOverviewQueryVariables = Exact<{
  eventId: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
}>;


export type PosFinancialOverviewQuery = (
  { __typename?: 'Query' }
  & { posFinancialOverview: Array<(
    { __typename?: 'GraphItem' }
    & Pick<GraphItem, 'name' | 'value'>
  )> }
);

export type PosFloatOfChangeQueryVariables = Exact<{
  eventId: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
}>;


export type PosFloatOfChangeQuery = (
  { __typename?: 'Query' }
  & { posFloatOfChange: Array<(
    { __typename?: 'GraphItem' }
    & Pick<GraphItem, 'name' | 'value'>
  )> }
);

export type PosOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PosOrderQuery = (
  { __typename?: 'Query' }
  & { order?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'orderNumber' | 'deliveryMethod' | 'usedCredits' | 'isComp' | 'shippingAddressMatchesBillingAddress' | 'status' | 'channel' | 'clientIp' | 'paymentGateway' | 'transactionStatus' | 'deliveryFee' | 'bookingFee' | 'bookingFeeAmount' | 'transactionFee' | 'transactionFeeAmount' | 'transactionFeeType' | 'subtotal' | 'totalTax' | 'total' | 'refundedAmount' | 'createdAt' | 'updatedAt'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName' | 'birthDate' | 'email' | 'phoneNumber'>
    )>, buyerInformation?: Maybe<(
      { __typename?: 'BuyerInformation' }
      & Pick<BuyerInformation, 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'postalCode' | 'taxNumber' | 'companyName'>
    )>, billingAddress?: Maybe<(
      { __typename?: 'Address' }
      & AddressFragmentFragment
    )>, shippingAddress?: Maybe<(
      { __typename?: 'Address' }
      & AddressFragmentFragment
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'title' | 'startDate' | 'endDate'>
      & { venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name' | 'seating'>
      ) }
    )>, membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'id' | 'name'>
      & { venue?: Maybe<(
        { __typename?: 'Venue' }
        & Pick<Venue, 'seating'>
      )> }
    )>, gateway?: Maybe<(
      { __typename?: 'PaymentIntegrationOutput' }
      & Pick<PaymentIntegrationOutput, 'name'>
    )>, refunds: Array<(
      { __typename?: 'Refund' }
      & Pick<Refund, 'id' | 'createdAt' | 'updatedAt' | 'amount'>
    )>, tickets: Array<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id' | 'status' | 'ticketNumber' | 'shouldBeNamed' | 'seatSection' | 'seatZone' | 'seatLabel' | 'seatTags' | 'isNamed' | 'firstName' | 'lastName'>
      & { lineItem?: Maybe<(
        { __typename?: 'LineItem' }
        & Pick<LineItem, 'id' | 'price' | 'name' | 'type'>
      )>, ticketType?: Maybe<(
        { __typename?: 'TicketType' }
        & { dates: Array<(
          { __typename?: 'TicketTypeDate' }
          & Pick<TicketTypeDate, 'alternateEntryTime'>
        )> }
      )> }
    )>, lineItems: (
      { __typename?: 'LineItemConnection' }
      & { edges: Array<(
        { __typename?: 'LineItemEdge' }
        & { node: (
          { __typename?: 'LineItem' }
          & Pick<LineItem, 'id' | 'createdAt' | 'updatedAt' | 'type' | 'seatLabel' | 'seatZone' | 'seatSection' | 'seatTags' | 'price' | 'originalPrice' | 'taxRate' | 'taxAmount' | 'quantity' | 'name' | 'ticketFeeAmount'>
          & { ticketType?: Maybe<(
            { __typename?: 'TicketType' }
            & Pick<TicketType, 'name' | 'id'>
          )>, membershipType?: Maybe<(
            { __typename?: 'MembershipType' }
            & Pick<MembershipType, 'id'>
            & { membership: (
              { __typename?: 'Membership' }
              & Pick<Membership, 'name'>
            ) }
          )> }
        ) }
      )> }
    ), promoCode?: Maybe<(
      { __typename: 'EventPromoCode' }
      & Pick<EventPromoCode, 'id' | 'code' | 'discountType' | 'discountAmount'>
      & { eventType: EventPromoCode['type'] }
    ) | (
      { __typename: 'MembershipPromoCode' }
      & Pick<MembershipPromoCode, 'id' | 'code' | 'discountType' | 'discountAmount'>
      & { membershipType: MembershipPromoCode['type'] }
    )> }
  )> }
);

export type PosSalesOverviewQueryVariables = Exact<{
  eventId: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
}>;


export type PosSalesOverviewQuery = (
  { __typename?: 'Query' }
  & { posSalesOverview: (
    { __typename?: 'PosSalesOverviewOutput' }
    & Pick<PosSalesOverviewOutput, 'soldAtTheDoor' | 'soldOnline' | 'scannedPercentage' | 'average' | 'perHour' | 'orders'>
  ) }
);

export type PosSessionsQueryVariables = Exact<{
  posId: Scalars['String'];
}>;


export type PosSessionsQuery = (
  { __typename?: 'Query' }
  & { posSessions: Array<(
    { __typename?: 'PosSession' }
    & Pick<PosSession, 'id' | 'startedAt' | 'endedAt' | 'startCash' | 'endCash'>
    & { operator: (
      { __typename?: 'User' }
      & Pick<User, 'fullName'>
    ) }
  )> }
);

export type PosUsersQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type PosUsersQuery = (
  { __typename?: 'Query' }
  & { posUsers: Array<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName' | 'companyName' | 'email' | 'createdAt' | 'updatedAt'>
  )> }
);

export type TerminalsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type TerminalsQuery = (
  { __typename?: 'Query' }
  & { poses: Array<(
    { __typename?: 'Pos' }
    & Pick<Pos, 'id' | 'name'>
  )> }
);

export type PreviousMembershipCountQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PreviousMembershipCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'previousMembershipCount'>
);

export type PurchasingDaysBreakdownQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  tagId?: Maybe<Scalars['String']>;
}>;


export type PurchasingDaysBreakdownQuery = (
  { __typename?: 'Query' }
  & { purchasingDaysBreakdown: Array<(
    { __typename?: 'BarchartOutput' }
    & Pick<BarchartOutput, 'range' | 'value'>
  )> }
);

export type ReleaseQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReleaseQuery = (
  { __typename?: 'Query' }
  & { release: (
    { __typename?: 'Release' }
    & ReleaseFragmentFragment
  ) }
);

export type ReleasesQueryVariables = Exact<{
  event: Scalars['String'];
}>;


export type ReleasesQuery = (
  { __typename?: 'Query' }
  & { releases: Array<(
    { __typename?: 'Release' }
    & Pick<Release, 'id' | 'name' | 'type' | 'isActive' | 'startCondition' | 'startConditionDate' | 'endCondition' | 'endConditionDate' | 'endConditionQuantity' | 'slug' | 'canBeHardDeleted' | 'allowHoldOrders'>
  )> }
);

export type SalesChannelGraphQueryVariables = Exact<{
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
}>;


export type SalesChannelGraphQuery = (
  { __typename?: 'Query' }
  & { salesChannelGraph: (
    { __typename?: 'SalesChannelGraphOutput' }
    & Pick<SalesChannelGraphOutput, 'transactions' | 'online' | 'backOffice' | 'pos'>
  ) }
);

export type SalesGraphQueryVariables = Exact<{
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  type?: Maybe<GraphFilterType>;
  release?: Maybe<Scalars['String']>;
}>;


export type SalesGraphQuery = (
  { __typename?: 'Query' }
  & { salesGraph: (
    { __typename?: 'GraphOutput' }
    & { dates: Array<(
      { __typename?: 'GraphDateItem' }
      & Pick<GraphDateItem, 'date'>
      & { items: Array<(
        { __typename?: 'GraphItem' }
        & Pick<GraphItem, 'name' | 'value'>
      )> }
    )> }
  ) }
);

export type SalesOverviewQueryVariables = Exact<{
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
}>;


export type SalesOverviewQuery = (
  { __typename?: 'Query' }
  & { salesOverview: (
    { __typename?: 'SalesOverviewOutput' }
    & Pick<SalesOverviewOutput, 'ticketsSold' | 'membershipsSold' | 'addonsSold' | 'orders' | 'cartAbandonment' | 'returningCustomers' | 'ticketsPaid' | 'ticketsComp' | 'ticketsTransferred' | 'packagesSold' | 'pointsDistributed' | 'membershipsRenewed' | 'ticketCoverOrdersSold' | 'ticketCoverTicketsSold'>
  ) }
);

export type ScanTicketTypesQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type ScanTicketTypesQuery = (
  { __typename?: 'Query' }
  & { scanTicketTypes?: Maybe<Array<(
    { __typename?: 'GraphTextItem' }
    & Pick<GraphTextItem, 'identifier'>
    & { items: Array<(
      { __typename?: 'GraphItem' }
      & Pick<GraphItem, 'name' | 'value'>
    )> }
  )>> }
);

export type ScanVisitorsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type ScanVisitorsQuery = (
  { __typename?: 'Query' }
  & { scanVisitors?: Maybe<Array<(
    { __typename?: 'GraphTextItem' }
    & Pick<GraphTextItem, 'identifier'>
    & { items: Array<(
      { __typename?: 'GraphItem' }
      & Pick<GraphItem, 'name' | 'value'>
    )> }
  )>> }
);

export type ScanVisitorsOverTimeQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type ScanVisitorsOverTimeQuery = (
  { __typename?: 'Query' }
  & { scanVisitorsOverTime?: Maybe<Array<(
    { __typename?: 'GraphRangeItem' }
    & Pick<GraphRangeItem, 'start' | 'end' | 'value'>
  )>> }
);

export type ScoutQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ScoutQuery = (
  { __typename?: 'Query' }
  & { scout: (
    { __typename?: 'Scout' }
    & Pick<Scout, 'id' | 'isActive' | 'name' | 'purpose' | 'createdAt' | 'updatedAt' | 'trackSource' | 'trackSourceId' | 'trackReleaseId' | 'includeOptedOutOfMarketing'>
    & { promoteTo: Array<(
      { __typename?: 'FilterSelection' }
      & ScoutFilterSelectionFragment
    )>, exclude: Array<(
      { __typename?: 'FilterSelection' }
      & ScoutFilterSelectionFragment
    )> }
  ) }
);

export type ScoutAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ScoutAgentsQuery = (
  { __typename?: 'Query' }
  & { users: (
    { __typename?: 'UserConnection' }
    & { edges: Array<(
      { __typename?: 'UserEdge' }
      & { node: (
        { __typename?: 'User' }
        & Pick<User, 'id' | 'fullName'>
      ) }
    )> }
  ) }
);

export type ScoutCampaignCustomerLocationsQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
}>;


export type ScoutCampaignCustomerLocationsQuery = (
  { __typename?: 'Query' }
  & { scoutCampaignCustomerLocations: Array<(
    { __typename?: 'LocationOutput' }
    & Pick<LocationOutput, 'city' | 'count' | 'amount'>
  )> }
);

export type ScoutCampaignGenderBreakdownQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
}>;


export type ScoutCampaignGenderBreakdownQuery = (
  { __typename?: 'Query' }
  & { scoutCampaignGenderBreakdown: Array<(
    { __typename?: 'GenderBreakDownOutput' }
    & Pick<GenderBreakDownOutput, 'male' | 'female' | 'other'>
  )> }
);

export type ScoutCampaignHighestValueCustomersQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
}>;


export type ScoutCampaignHighestValueCustomersQuery = (
  { __typename?: 'Query' }
  & { scoutCampaignHighestValueCustomers: Array<(
    { __typename?: 'HighestValueCustomersOutput' }
    & Pick<HighestValueCustomersOutput, 'name' | 'value' | 'userId'>
  )> }
);

export type ScoutCampaignOverviewQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
}>;


export type ScoutCampaignOverviewQuery = (
  { __typename?: 'Query' }
  & { scoutCampaignOverview: (
    { __typename?: 'ScoutCampaignOverviewOutput' }
    & Pick<ScoutCampaignOverviewOutput, 'ticketsSold' | 'membershipsSold' | 'addonsSold' | 'orders' | 'cartAbandonment' | 'returningCustomers' | 'ticketsPaid' | 'ticketsComp' | 'campaignSize' | 'contactRate' | 'conversionRate' | 'totalRevenue' | 'todayRevenue' | 'emailOpenRate' | 'emailClickRate'>
  ) }
);

export type ScoutCampaignTopTagsQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
}>;


export type ScoutCampaignTopTagsQuery = (
  { __typename?: 'Query' }
  & { scoutCampaignTopTags: Array<(
    { __typename?: 'TopTagsOutput' }
    & Pick<TopTagsOutput, 'tag' | 'count'>
  )> }
);

export type ScoutCommunicationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ScoutCommunicationQuery = (
  { __typename?: 'Query' }
  & { scoutCommunication: (
    { __typename?: 'ScoutCommunication' }
    & Pick<ScoutCommunication, 'id' | 'createdAt' | 'type' | 'data' | 'name' | 'purpose' | 'includeOptedOutOfMarketing' | 'trackSource' | 'trackSourceId' | 'trackReleaseId' | 'scheduledAt' | 'shouldUpdate' | 'isActive' | 'count' | 'message' | 'listId' | 'templateId' | 'subject' | 'link'>
    & { scout?: Maybe<(
      { __typename?: 'Scout' }
      & Pick<Scout, 'id' | 'name'>
    )>, campaign?: Maybe<(
      { __typename?: 'ScoutCommunication' }
      & Pick<ScoutCommunication, 'id' | 'name'>
    )> }
  ) }
);

export type ScoutCommunicationUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ScoutCommunicationUserQuery = (
  { __typename?: 'Query' }
  & { scoutCommunicationUser: (
    { __typename?: 'ScoutCommunicationUser' }
    & Pick<ScoutCommunicationUser, 'id' | 'stage' | 'remindAt' | 'createdAt' | 'updatedAt'>
    & { user: (
      { __typename?: 'User' }
      & { tags: Array<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'id' | 'name'>
      )>, scoutCommunications: Array<(
        { __typename?: 'ScoutCommunication' }
        & Pick<ScoutCommunication, 'id' | 'name' | 'purpose' | 'createdAt' | 'updatedAt'>
      )> }
      & UserFragmentFragment
    ), history: (
      { __typename?: 'HistoryConnection' }
      & HistoryConnectionFragment
    ) }
  ) }
);

export type ScoutCommunicationUsersQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  hasPhoneNumber?: Maybe<Scalars['Boolean']>;
  where?: Maybe<UserWhereInput>;
  stage?: Maybe<Array<ScoutStage> | ScoutStage>;
  agentUserId?: Maybe<Scalars['String']>;
}>;


export type ScoutCommunicationUsersQuery = (
  { __typename?: 'Query' }
  & { scoutCommunicationUsers: (
    { __typename?: 'ScoutCommunicationUserConnection' }
    & Pick<ScoutCommunicationUserConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'ScoutCommunicationUserEdge' }
      & { node: (
        { __typename?: 'ScoutCommunicationUser' }
        & Pick<ScoutCommunicationUser, 'id' | 'createdAt' | 'stage'>
        & { user: (
          { __typename?: 'User' }
          & Pick<User, 'id' | 'fullName' | 'email'>
        ), agentUser?: Maybe<(
          { __typename?: 'User' }
          & Pick<User, 'id' | 'fullName'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type ScoutCommunicationsQueryVariables = Exact<{
  input: ScoutCommunicationsInput;
}>;


export type ScoutCommunicationsQuery = (
  { __typename?: 'Query' }
  & { scoutCommunications: Array<(
    { __typename?: 'ScoutCommunication' }
    & Pick<ScoutCommunication, 'id' | 'type' | 'createdAt' | 'scheduledAt' | 'processedAt' | 'count' | 'name' | 'conversions' | 'data' | 'isActive'>
  )> }
);

export type InitScoutQueryVariables = Exact<{ [key: string]: never; }>;


export type InitScoutQuery = (
  { __typename?: 'Query' }
  & { initScout: (
    { __typename?: 'InitScout' }
    & { seasons: Array<(
      { __typename?: 'Season' }
      & Pick<Season, 'id' | 'name'>
    )>, membershipTypes: Array<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name'>
    )>, events: Array<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'title'>
      & { releases: Array<(
        { __typename?: 'Release' }
        & Pick<Release, 'id' | 'name'>
      )> }
    )>, userTags: Array<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'name'>
    )>, zones: Array<(
      { __typename?: 'Zone' }
      & Pick<Zone, 'id' | 'name'>
    )> }
  ) }
);

export type ScoutUserRemindersQueryVariables = Exact<{ [key: string]: never; }>;


export type ScoutUserRemindersQuery = (
  { __typename?: 'Query' }
  & { scoutUserReminders: Array<(
    { __typename?: 'ScoutCommunicationUser' }
    & Pick<ScoutCommunicationUser, 'id' | 'stage' | 'remindAt'>
    & { scoutCommunication: (
      { __typename?: 'ScoutCommunication' }
      & Pick<ScoutCommunication, 'id' | 'name'>
    ), user: (
      { __typename?: 'User' }
      & Pick<User, 'fullName'>
    ) }
  )> }
);

export type ScoutUsersQueryVariables = Exact<{
  id: Scalars['String'];
  stage?: Maybe<Array<ScoutStage> | ScoutStage>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
  hasPhoneNumber?: Maybe<Scalars['Boolean']>;
  agentUserId?: Maybe<Scalars['String']>;
}>;


export type ScoutUsersQuery = (
  { __typename?: 'Query' }
  & { scoutUsers: (
    { __typename?: 'ScoutUserConnection' }
    & Pick<ScoutUserConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'ScoutUserEdge' }
      & { node: (
        { __typename?: 'ScoutUser' }
        & Pick<ScoutUser, 'id' | 'stage'>
        & { user: (
          { __typename?: 'User' }
          & Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName' | 'companyName' | 'email' | 'createdAt' | 'updatedAt'>
        ), agentUser?: Maybe<(
          { __typename?: 'User' }
          & Pick<User, 'id' | 'fullName' | 'email'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type ScoutsQueryVariables = Exact<{
  input?: Maybe<FindScoutsInput>;
}>;


export type ScoutsQuery = (
  { __typename?: 'Query' }
  & { scouts: Array<(
    { __typename?: 'Scout' }
    & Pick<Scout, 'id' | 'isActive' | 'name' | 'purpose' | 'total' | 'createdAt' | 'updatedAt'>
  )> }
);

export type SeasonQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SeasonQuery = (
  { __typename?: 'Query' }
  & { season: (
    { __typename?: 'Season' }
    & SeasonFragmentFragment
  ) }
);

export type SeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type SeasonsQuery = (
  { __typename?: 'Query' }
  & { seasons: Array<(
    { __typename?: 'Season' }
    & SeasonFragmentFragment
  )> }
);

export type SeatsEventKeyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SeatsEventKeyQuery = (
  { __typename?: 'Query' }
  & { event: (
    { __typename?: 'Event' }
    & Pick<Event, 'seatsEventKey'>
  ) }
);

export type SocialMentionsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<SocialWhereInput>;
}>;


export type SocialMentionsQuery = (
  { __typename?: 'Query' }
  & { socialMentions: (
    { __typename?: 'SocialConnection' }
    & Pick<SocialConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'SocialMentionEdge' }
      & { node: (
        { __typename?: 'SocialMention' }
        & Pick<SocialMention, 'id' | 'createdAt' | 'type' | 'content' | 'url'>
        & { user?: Maybe<(
          { __typename?: 'User' }
          & Pick<User, 'id' | 'firstName' | 'lastName'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type SummaryOverviewQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
}>;


export type SummaryOverviewQuery = (
  { __typename?: 'Query' }
  & { summaryOverview: (
    { __typename?: 'SummaryOverviewOutput' }
    & Pick<SummaryOverviewOutput, 'ticketsSold' | 'membershipsSold' | 'addonsSold' | 'orders' | 'cartAbandonment' | 'returningCustomers' | 'ticketsPaid' | 'ticketsComp' | 'totalRevenue' | 'todayRevenue' | 'yesterdayRevenue' | 'ticketsSoldToday' | 'ticketsSoldYesterday' | 'membershipsRenewed'>
  ) }
);

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = (
  { __typename?: 'Query' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & TagFragmentFragment
  )> }
);

export type TicketQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type TicketQuery = (
  { __typename?: 'Query' }
  & { ticket?: Maybe<(
    { __typename?: 'Ticket' }
    & { addon?: Maybe<(
      { __typename: 'EventAddon' }
      & Pick<EventAddon, 'name' | 'id'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & Pick<FormField, 'field' | 'isRequired'>
      )> }
    ) | (
      { __typename: 'MembershipAddon' }
      & Pick<MembershipAddon, 'id' | 'name'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & Pick<FormField, 'field' | 'isRequired'>
      )> }
    )>, membershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & { membership: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'id' | 'membershipKind' | 'endDate'>
        & { renewalMembership?: Maybe<(
          { __typename?: 'Membership' }
          & Pick<Membership, 'id'>
        )> }
      ), namingFields: Array<(
        { __typename?: 'FormField' }
        & Pick<FormField, 'field' | 'isRequired'>
      )> }
    )>, ticketType?: Maybe<(
      { __typename?: 'TicketType' }
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & Pick<FormField, 'field' | 'isRequired'>
      )> }
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'title' | 'eventKind' | 'startDate' | 'ticketsViewableFromDate'>
      & { venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & { address: (
          { __typename?: 'Address' }
          & Pick<Address, 'city'>
        ), zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
      ), zonesAllocatedGates?: Maybe<Array<(
        { __typename?: 'ZoneAllocatedGate' }
        & Pick<ZoneAllocatedGate, 'name'>
      )>> }
    )>, membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'name' | 'membershipKind' | 'startDate'>
      & { venue?: Maybe<(
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & { address: (
          { __typename?: 'Address' }
          & Pick<Address, 'city'>
        ), zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
      )> }
    )> }
    & TicketFragment
  )> }
);

export type TicketTypesQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type TicketTypesQuery = (
  { __typename?: 'Query' }
  & { ticketTypes: Array<(
    { __typename?: 'TicketType' }
    & Pick<TicketType, 'id' | 'name'>
  )> }
);

export type TimeOfDayBreakdownQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  tagId?: Maybe<Scalars['String']>;
}>;


export type TimeOfDayBreakdownQuery = (
  { __typename?: 'Query' }
  & { timeOfDayBreakdown: Array<(
    { __typename?: 'BarchartOutput' }
    & Pick<BarchartOutput, 'range' | 'value'>
  )> }
);

export type TopReferrersQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
}>;


export type TopReferrersQuery = (
  { __typename?: 'Query' }
  & { topReferrers: Array<(
    { __typename?: 'TopReferrersOutput' }
    & Pick<TopReferrersOutput, 'name' | 'count' | 'userId'>
  )> }
);

export type TopRepeatPurchasersQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
}>;


export type TopRepeatPurchasersQuery = (
  { __typename?: 'Query' }
  & { topRepeatPurchasers: Array<(
    { __typename?: 'TopRepeatPurchasers' }
    & Pick<TopRepeatPurchasers, 'name' | 'count' | 'userId'>
  )> }
);

export type TopTagsQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
}>;


export type TopTagsQuery = (
  { __typename?: 'Query' }
  & { topTags: Array<(
    { __typename?: 'TopTagsOutput' }
    & Pick<TopTagsOutput, 'tag' | 'count'>
  )> }
);

export type TransferredMembershipTicketsForOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type TransferredMembershipTicketsForOrderQuery = (
  { __typename?: 'Query' }
  & { transferredMembershipTicketsForOrder?: Maybe<Array<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id'>
    & { lineItem?: Maybe<(
      { __typename?: 'LineItem' }
      & Pick<LineItem, 'id'>
    )>, transferFee?: Maybe<(
      { __typename?: 'TicketTransferFee' }
      & Pick<TicketTransferFee, 'type' | 'fee'>
    )> }
  )>> }
);

export type UploadImageMutationVariables = Exact<{
  file: ImportInput;
}>;


export type UploadImageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'uploadImage'>
);

export type UserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserQuery = (
  { __typename?: 'Query' }
  & { user: (
    { __typename?: 'User' }
    & Pick<User, 'accessEventIds' | 'accessMembershipIds'>
    & { orders: (
      { __typename?: 'OrderConnection' }
      & { edges: Array<(
        { __typename?: 'OrderEdge' }
        & { node: (
          { __typename?: 'Order' }
          & Pick<Order, 'id' | 'createdAt' | 'orderNumber' | 'status' | 'isComp' | 'total'>
          & { membership?: Maybe<(
            { __typename?: 'Membership' }
            & Pick<Membership, 'name'>
          )>, event?: Maybe<(
            { __typename?: 'Event' }
            & Pick<Event, 'title'>
          )>, user?: Maybe<(
            { __typename?: 'User' }
            & Pick<User, 'fullName'>
          )> }
        ) }
      )> }
    ), tags: Array<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'name'>
    )> }
    & UserFragmentFragment
  ) }
);

export type UserEventTicketsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserEventTicketsQuery = (
  { __typename?: 'Query' }
  & { user: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName'>
    & { eventTickets: Array<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id' | 'seatLabel' | 'seatZone' | 'seatSection' | 'seatTags' | 'isNamed' | 'firstName' | 'lastName' | 'birthDate' | 'email' | 'phoneNumber' | 'postalCode' | 'gender' | 'shouldBeNamed'>
      & { event?: Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'title'>
      )> }
    )> }
  ) }
);

export type UserMembershipTicketsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserMembershipTicketsQuery = (
  { __typename?: 'Query' }
  & { user: (
    { __typename?: 'User' }
    & { membershipTickets: Array<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id' | 'seatLabel' | 'seatZone' | 'seatSection' | 'seatTags' | 'isNamed' | 'firstName' | 'lastName' | 'birthDate' | 'email' | 'phoneNumber' | 'postalCode' | 'gender' | 'hasRenewedMembership' | 'hasReleasedNextMembershipClaim' | 'shouldBeNamed'>
      & { membershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & Pick<MembershipType, 'id' | 'name'>
      )>, membership?: Maybe<(
        { __typename?: 'Membership' }
        & Pick<Membership, 'name' | 'startDate' | 'endDate'>
        & { renewalMembership?: Maybe<(
          { __typename?: 'Membership' }
          & Pick<Membership, 'id' | 'name'>
          & { addons: Array<(
            { __typename?: 'MembershipAddon' }
            & Pick<MembershipAddon, 'id' | 'name' | 'price'>
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type UsersQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<UserOrderByInput>;
}>;


export type UsersQuery = (
  { __typename?: 'Query' }
  & { users: (
    { __typename?: 'UserConnection' }
    & Pick<UserConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'UserEdge' }
      & { node: (
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName' | 'companyName' | 'email' | 'phoneNumber' | 'createdAt' | 'updatedAt' | 'roles'>
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type UserOrdersQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserOrdersQuery = (
  { __typename?: 'Query' }
  & { user: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName'>
    & { orders: (
      { __typename?: 'OrderConnection' }
      & { edges: Array<(
        { __typename?: 'OrderEdge' }
        & { node: (
          { __typename?: 'Order' }
          & Pick<Order, 'id' | 'orderNumber' | 'status' | 'transactionStatus' | 'total' | 'refundedAmount' | 'createdAt' | 'hardCopyTicketsPrinted' | 'isComp'>
          & { buyerInformation?: Maybe<(
            { __typename?: 'BuyerInformation' }
            & Pick<BuyerInformation, 'firstName' | 'lastName'>
          )>, event?: Maybe<(
            { __typename?: 'Event' }
            & Pick<Event, 'title'>
          )>, membership?: Maybe<(
            { __typename?: 'Membership' }
            & Pick<Membership, 'name'>
          )> }
        ) }
      )> }
    ) }
  ) }
);

export type VenueQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type VenueQuery = (
  { __typename?: 'Query' }
  & { venue: (
    { __typename?: 'Venue' }
    & VenueFragmentFragment
  ) }
);

export type VenueSeatsThumbnailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type VenueSeatsThumbnailQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'venueSeatsThumbnail'>
);

export type VenuesQueryVariables = Exact<{ [key: string]: never; }>;


export type VenuesQuery = (
  { __typename?: 'Query' }
  & { venues: Array<(
    { __typename?: 'Venue' }
    & Pick<Venue, 'id' | 'name' | 'seating'>
  )> }
);

export type WaitlistOverviewQueryVariables = Exact<{
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  release?: Maybe<Scalars['String']>;
}>;


export type WaitlistOverviewQuery = (
  { __typename?: 'Query' }
  & { waitlistOverview: (
    { __typename?: 'WaitlistOverviewOutput' }
    & Pick<WaitlistOverviewOutput, 'totalCustomers' | 'totalNewCustomers' | 'totalReturningCustomers' | 'customersOptedIntoMarketing' | 'totalRevenue' | 'numberOfOrders' | 'numberOfSuccesfulUsers' | 'numberOfTickets' | 'yetToConvert'>
  ) }
);

export type ShopifyDisableIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopifyDisableIntegrationQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'disableShopifyIntegration'>
);

export type ShopifyCustomerOrdersQueryVariables = Exact<{
  customerId: Scalars['String'];
}>;


export type ShopifyCustomerOrdersQuery = (
  { __typename?: 'Query' }
  & { customerOrders: Array<(
    { __typename?: 'ShopifyCustomerOrder' }
    & Pick<ShopifyCustomerOrder, 'id' | 'total' | 'currencyCode'>
    & { lineItems: Array<(
      { __typename?: 'ShopifyLineItem' }
      & Pick<ShopifyLineItem, 'id' | 'title' | 'quantity'>
    )> }
  )> }
);

export type CompleteShopifySetupMutationVariables = Exact<{
  input: ShopifySetupInput;
}>;


export type CompleteShopifySetupMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'completeShopifySetup'>
);

export type MyLoggedInOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLoggedInOrganizationsQuery = (
  { __typename?: 'Query' }
  & { myLoggedInOrganizations?: Maybe<Array<(
    { __typename?: 'MyLoggedInOrganizationsOutput' }
    & Pick<MyLoggedInOrganizationsOutput, 'slug' | 'logoUrl' | 'isLinked'>
  )>> }
);

export type XeroConsentUrlQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type XeroConsentUrlQueryQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getConsentUrl'>
);

export type XeroEnableIntegrationMutationMutationVariables = Exact<{
  input: XeroCallbackInput;
}>;


export type XeroEnableIntegrationMutationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'enableXeroIntegration'>
);

export type XeroDisableIntegrationQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type XeroDisableIntegrationQueryQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'disableXeroIntegration'>
);

export type GetXeroCurrentAccountCodeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetXeroCurrentAccountCodeQueryQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getCurrentAccountCode'>
);

export type GetXeroAccountsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetXeroAccountsQueryQuery = (
  { __typename?: 'Query' }
  & { getXeroAccounts: (
    { __typename?: 'XeroAllAccountsOutput' }
    & Pick<XeroAllAccountsOutput, 'currentAccountCode'>
    & { availableAccounts?: Maybe<Array<(
      { __typename?: 'XeroAccountOutput' }
      & Pick<XeroAccountOutput, 'accountId' | 'name' | 'code'>
    )>> }
  ) }
);

export type SetXeroAccountCodeMutationMutationVariables = Exact<{
  accountCode: Scalars['String'];
}>;


export type SetXeroAccountCodeMutationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setXeroAccountCode'>
);

export const FileFragmentFragmentDoc = gql`
    fragment FileFragment on ExtendedFile {
  storage
  directory
  fileName
  originalFileName
}
    `;
export const CompetitionPrizeFragmentFragmentDoc = gql`
    fragment CompetitionPrizeFragment on CompetitionPrize {
  id
  title
  description
  image {
    ...FileFragment
  }
  prizeOrder
  quantity
}
    ${FileFragmentFragmentDoc}`;
export const CompetitionRewardFragmentFragmentDoc = gql`
    fragment CompetitionRewardFragment on CompetitionReward {
  platform
  actionType
  value
  isEnabled
}
    `;
export const CompetitionFragmentFragmentDoc = gql`
    fragment CompetitionFragment on Competition {
  id
  startDate
  endDate
  competitionType
  description
  termsAndConditions
  title
  isPublished
  referralRewardValue
  isCompetitionRunning
  competitionState
  prizes {
    ...CompetitionPrizeFragment
  }
  promoter {
    ...CompetitionRewardFragment
  }
}
    ${CompetitionPrizeFragmentFragmentDoc}
${CompetitionRewardFragmentFragmentDoc}`;
export const PointItemFragmentDoc = gql`
    fragment pointItem on PointItem {
  id
  name
  price
  amount
  isVisible
  description
  banner {
    fileName
  }
  thumbnail {
    fileName
  }
  backgroundImage {
    fileName
  }
  descriptionImage {
    fileName
  }
}
    `;
export const AutomationFragmentFragmentDoc = gql`
    fragment AutomationFragment on Automation {
  id
  name
  templateId
  subject
  listId
  automationType
  isActive
  targetSource
  targetSourceId
  targetReleaseId
  timeOfDay
  templateName
}
    `;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  line1
  line2
  postalCode
  city
  country
  state
  suburb
  formattedAddress
}
    `;
export const CurrentOrganizationFragmentFragmentDoc = gql`
    fragment CurrentOrganizationFragment on CurrentOrganizationOutput {
  createdAt
  updatedAt
  id
  name
  slug
  email
  phone
  landingPage
  taxNumber
  supportInfo
  termsAndConditions
  privacyPolicy
  currency
  point {
    id
    name
    isEnabled
  }
  showMemberships
  showMembershipRenewal
  features
  point {
    id
    name
  }
  address {
    ...AddressFragment
  }
  marketing {
    gtmId
    pixelId
  }
  branding {
    logo {
      ...FileFragment
    }
    mobileLogo {
      ...FileFragment
    }
    favicon {
      ...FileFragment
    }
    background {
      ...FileFragment
    }
    fullBackground {
      ...FileFragment
    }
    greyScale
    primaryColor
    secondaryColor
  }
  shippingLabels {
    eTicket
    printedTicketByMail
    printedTicketByCourier
    printedTicketByCourierRural
    printedTicketAtVenue
  }
  timezone
  helpLink
  ticketCoverPlatformFeePercentage
}
    ${AddressFragmentFragmentDoc}
${FileFragmentFragmentDoc}`;
export const DigitalPassCodesStatusFragmentFragmentDoc = gql`
    fragment DigitalPassCodesStatusFragment on DigitalPassCodeStatusOutput {
  totalPassCodes
  remainingPassCodes
}
    `;
export const ShippingOptionsFragmentFragmentDoc = gql`
    fragment ShippingOptionsFragment on ShippingOptions {
  eTicket
  printedTicketByMail
  printedTicketByCourier
  printedTicketByCourierRural
  printedTicketAtVenue
}
    `;
export const NamingFieldsFragmentDoc = gql`
    fragment NamingFields on FormField {
  field
  isRequired
  label
  isCustom
}
    `;
export const TicketTypeFragmentFragmentDoc = gql`
    fragment TicketTypeFragment on TicketType {
  id
  name
  kind
  isGrouped
  groupAmount
  dates {
    eventDateId
    alternateEntryTime
  }
  bookingFeeType
  bookingFee
  stadiumLevyFee
  description
  restrictions
  createdAt
  updatedAt
  printAtHomeInformation
  quantity
  inHighDemand
  soldOut
  minPurchaseQuantity
  maxPurchaseQuantity
  namingFields {
    ...NamingFields
  }
  ticketBanner {
    ...FileFragment
  }
  ticketImage {
    ...FileFragment
  }
  tags {
    id
    name
  }
}
    ${NamingFieldsFragmentDoc}
${FileFragmentFragmentDoc}`;
export const EventFragmentFragmentDoc = gql`
    fragment EventFragment on Event {
  id
  title
  eventKind
  description
  dates {
    id
    startDate
    endDate
  }
  startDate
  isActive
  isFeatured
  logo {
    ...FileFragment
  }
  backgroundImage {
    ...FileFragment
  }
  backgroundImageFullPage {
    ...FileFragment
  }
  descriptionImage {
    ...FileFragment
  }
  thumbnail {
    ...FileFragment
  }
  printBanner1 {
    ...FileFragment
  }
  printBanner2 {
    ...FileFragment
  }
  hardCopyTicketBanner {
    ...FileFragment
  }
  digitalInfo {
    url
    additionalEmailInfoHTML
    additionalEmailButtonText
    additionalEmailButtonUrl
    additionalEmailInfoText
  }
  isR18
  bookingFeeType
  bookingFee
  canUsePoints
  canNameTicket
  canRenameTicket
  canChangeSeats
  canTransferTicket
  enableReleaseCodes
  enableWaitlist
  waitlistStartDate
  waitlistEndDate
  renamingFee
  soldTicketsCount
  changingSeatsFee
  buyerTransferringTicketFee
  sellerTransferringTicketFee
  digitalPassCodesStatus {
    ...DigitalPassCodesStatusFragment
  }
  shippingOptions {
    ...ShippingOptionsFragment
  }
  venue {
    name
    id
    seating
    hasStadiumLevy
    createdFromEvent
    address {
      ...AddressFragment
    }
    location {
      lat
      lng
    }
    zones {
      id
      name
      capacity
      sections {
        id
        name
      }
    }
    gates {
      id
      name
    }
  }
  ticketTypes {
    ...TicketTypeFragment
  }
  gateways {
    id
    name
    paymentMethodType
  }
  updatedAt
  createdAt
  season {
    id
    name
  }
  accessibility
  termsAndConditions
  importantNotice
  presaleInformation
  invoiceInformation
  zonesAllocatedGates {
    zoneId
    name
    gates
    availabilityCount {
      notForSale
      holdByMembership
      booked
      available
    }
    sections {
      sectionId
      name
      gates
    }
    dates {
      eventDateId
      alternateEntryTime
    }
  }
  multiBuyPromotions {
    id
    name
    getQuantity
    getTicketType {
      id
      name
      kind
    }
    buyQuantity
    buyTicketType {
      id
      name
      kind
    }
  }
  tags {
    id
    name
  }
  checkForVaccinePass
  emailNotification
  redirectURL
  ticketsViewableFromDate
  lastTicketsViewableEmailsSentAt
  insideFeeDetails {
    insideFee
    priceRangeTo
    priceRangeFrom
  }
  ticketCover {
    isEnabled
    promoterFeePercentage
    platformFeePercentage
    totalFeePercentage
    enabledAt
    disabledAt
  }
}
    ${FileFragmentFragmentDoc}
${DigitalPassCodesStatusFragmentFragmentDoc}
${ShippingOptionsFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${TicketTypeFragmentFragmentDoc}`;
export const FullIntegrationFragmentFragmentDoc = gql`
    fragment FullIntegrationFragment on Integration {
  id
  type
  name
  apiKey
  secretKey
  publicKey
  wcPxPostSecretKey
  wcPxPostPublicKey
  transactionFeeType
  transactionFee
  webhookUrl
  paymentMethodType
  facebookPageId
  facebookUserId
  transactionFee2
  transactionFeeType2
}
    `;
export const IntegrationFragmentFragmentDoc = gql`
    fragment IntegrationFragment on Integration {
  id
  type
  name
  transactionFeeType
  transactionFee
  publicKey
  webhookUrl
}
    `;
export const LineItemBaseFragmentDoc = gql`
    fragment LineItemBase on LineItem {
  id
  createdAt
  updatedAt
}
    `;
export const LineItemInfoFragmentDoc = gql`
    fragment LineItemInfo on LineItem {
  name
  type
}
    `;
export const LineItemSeatFragmentDoc = gql`
    fragment LineItemSeat on LineItem {
  seatLabel
  seatZone
  seatSection
  seatTags
}
    `;
export const LineItemFinanceFragmentDoc = gql`
    fragment LineItemFinance on LineItem {
  price
  originalPrice
  quantity
  ticketFee
  ticketFeeAmount
  taxRate
  total
  taxAmount
  subtotal
  pointItem {
    id
    name
    amount
  }
  ticketType {
    id
    name
  }
  membershipType {
    id
    membership {
      name
    }
  }
  eventAddon {
    id
  }
  membershipAddon {
    id
  }
}
    `;
export const LineItemFragmentDoc = gql`
    fragment LineItem on LineItem {
  ...LineItemBase
  ...LineItemInfo
  ...LineItemSeat
  ...LineItemFinance
}
    ${LineItemBaseFragmentDoc}
${LineItemInfoFragmentDoc}
${LineItemSeatFragmentDoc}
${LineItemFinanceFragmentDoc}`;
export const VenueFragmentFragmentDoc = gql`
    fragment VenueFragment on Venue {
  id
  name
  seatsChartKey
  address {
    ...AddressFragment
  }
  seating
  capacity
  capacityUtilization
  accessibilityInfo
  location {
    lat
    lng
  }
  zones {
    id
    name
    description
    displayOrder
    capacity
    sections {
      id
      name
    }
    stand
    admission
  }
  gates {
    id
    name
    createdAt
  }
  createdAt
  updatedAt
}
    ${AddressFragmentFragmentDoc}`;
export const MembershipFragmentFragmentDoc = gql`
    fragment MembershipFragment on Membership {
  id
  name
  membershipKind
  isActive
  startDate
  endDate
  canNameMembership
  canRenameMembership
  canChangeSeats
  canUsePoints
  canTransferTickets
  enableAutoRenew
  renamingFee
  changingSeatsFee
  bookingFee
  bookingFeeType
  description
  emailNotification
  gateways {
    id
    name
    paymentMethodType
  }
  digitalInfo {
    url
    additionalEmailInfoHTML
    additionalEmailButtonText
    additionalEmailButtonUrl
    additionalEmailInfoText
  }
  termsAndConditions
  accessibility
  importantNotice
  invoiceInformation
  showSchedule
  digitalPassCodesStatus {
    ...DigitalPassCodesStatusFragment
  }
  shippingOptions {
    ...ShippingOptionsFragment
  }
  thumbnail {
    ...FileFragment
  }
  banner {
    ...FileFragment
  }
  backgroundImage {
    ...FileFragment
  }
  descriptionImage {
    ...FileFragment
  }
  printBanner1 {
    ...FileFragment
  }
  printBanner2 {
    ...FileFragment
  }
  events {
    id
    title
    canTransferTicket
  }
  season {
    id
    startDate
    endDate
  }
  previousMemberships {
    id
    startDate
    endDate
  }
  types {
    id
    name
    kind
    ticketFeeType
    ticketFee
  }
  venue {
    ...VenueFragment
  }
  membershipZones {
    id
    zone {
      id
      name
    }
    pricingLevel
    isActive
    membershipTypes {
      price
      sections {
        sectionId
        name
        price
      }
      isActive
      membershipTypeId
    }
  }
  multiBuyPromotions {
    id
    name
    getQuantity
    getMembershipType {
      id
      name
      description
      restrictions
      kind
    }
    buyQuantity
    getMembershipType {
      id
      name
      description
      restrictions
      kind
    }
  }
  tags {
    id
    name
  }
}
    ${DigitalPassCodesStatusFragmentFragmentDoc}
${ShippingOptionsFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${VenueFragmentFragmentDoc}`;
export const MembershipListFragmentFragmentDoc = gql`
    fragment MembershipListFragment on Membership {
  id
  name
  isActive
  startDate
  endDate
  season {
    name
  }
}
    `;
export const MembershipTypeFragmentFragmentDoc = gql`
    fragment MembershipTypeFragment on MembershipType {
  id
  name
  kind
  ticketFeeType
  ticketFee
  description
  restrictions
  createdAt
  updatedAt
  namingFields {
    ...NamingFields
  }
}
    ${NamingFieldsFragmentDoc}`;
export const MembershipTypeEventTransferPricesFragmentFragmentDoc = gql`
    fragment MembershipTypeEventTransferPricesFragment on MembershipTypeEventTransferPrice {
  membershipType {
    id
    name
  }
  membershipZone {
    id
    pricingLevel
    zone {
      id
      name
    }
  }
  event {
    id
    title
  }
  maxSalePrice
}
    `;
export const HistoryFragmentDoc = gql`
    fragment History on History {
  id
  description
  refName
  user {
    firstName
    lastName
    roles
  }
  createdAt
  scoutCommunication {
    id
    name
  }
  order {
    id
    orderNumber
  }
  ticket {
    id
    ticketNumber
  }
}
    `;
export const HistoryConnectionFragmentDoc = gql`
    fragment HistoryConnection on HistoryConnection {
  edges {
    node {
      ...History
    }
  }
}
    ${HistoryFragmentDoc}`;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  id
  orderNumber
  referralId
  xeroInvoiceId
  orderType
  user {
    id
    firstName
    lastName
    fullName
    birthDate
    email
    phoneNumber
  }
  deliveryMethod
  usedCredits
  usedPoints
  isComp
  buyerInformation {
    firstName
    lastName
    email
    phoneNumber
    postalCode
    taxNumber
    companyName
    city
  }
  createdBy {
    fullName
  }
  billingAddress {
    ...AddressFragment
  }
  shippingAddress {
    ...AddressFragment
  }
  shippingAddressMatchesBillingAddress
  event {
    id
    title
    startDate
    endDate
    sellerTransferringTicketFee
    venue {
      name
      seating
    }
    shippingOptions {
      eTicket
      printedTicketByMail
      printedTicketByCourier
      printedTicketByCourierRural
      printedTicketAtVenue
    }
    multiBuyPromotions {
      id
      name
      getQuantity
      getTicketType {
        id
        name
        description
        restrictions
        kind
        isGrouped
        groupAmount
        dates {
          eventDateId
          alternateEntryTime
        }
        bookingFeeType
        bookingFee
      }
      buyQuantity
      buyTicketType {
        id
        name
        description
        restrictions
        kind
        isGrouped
        groupAmount
        dates {
          eventDateId
          alternateEntryTime
        }
        bookingFeeType
        bookingFee
      }
    }
    ticketTypes {
      id
      name
      dates {
        alternateEntryTime
      }
      description
      restrictions
      kind
    }
  }
  membership {
    id
    name
    venue {
      seating
    }
    types {
      id
      name
      description
      restrictions
      kind
    }
    shippingOptions {
      eTicket
      printedTicketByMail
      printedTicketByCourier
      printedTicketByCourierRural
      printedTicketAtVenue
    }
    multiBuyPromotions {
      id
      name
      getQuantity
      getMembershipType {
        id
        name
        description
        restrictions
        kind
      }
      buyQuantity
      buyMembershipType {
        id
        name
        description
        restrictions
        kind
      }
    }
    events {
      id
      seatsEventKey
      title
      startDate
      startDate
      venue {
        id
        name
      }
      printBanner1 {
        ...FileFragment
      }
      description
    }
    membershipZones {
      id
      zone {
        id
        name
      }
      pricingLevel
      isActive
      membershipTypes {
        membershipTypeId
        price
        sections {
          name
          price
        }
        isActive
      }
    }
  }
  status
  channel
  clientIp
  paymentGateway
  gateway {
    name
  }
  transactionStatus
  transactions {
    edges {
      node {
        id
        createdAt
        updatedAt
        kind
        status
        amount
      }
    }
  }
  deliveryFee
  bookingFee
  bookingFeeAmount
  transactionFee
  transactionFeeAmount
  transactionFeeType
  transactionFeeType2
  transactionFee2
  transferFee
  subtotal
  totalTax
  total
  refundedAmount
  refunds {
    id
    createdAt
    updatedAt
    amount
  }
  tickets {
    id
    status
    ticketNumber
    preprint
    transferFee {
      type
      fee
    }
    lineItem {
      id
      price
      name
      type
    }
    shouldBeNamed
    seatSection
    seatZone
    seatLabel
    seatTags
    isNamed
    firstName
    lastName
    ticketType {
      name
      dates {
        alternateEntryTime
      }
    }
    firstScanIn {
      id
    }
  }
  lineItems {
    edges {
      node {
        id
        createdAt
        updatedAt
        type
        seatLabel
        seatZone
        seatSection
        seatTags
        price
        originalPrice
        taxRate
        taxAmount
        quantity
        name
        type
        pointItem {
          id
          name
          amount
        }
        ticketFeeAmount
        stadiumLevyFee
        ticketType {
          name
          id
        }
        membershipType {
          id
          membership {
            name
          }
        }
      }
    }
  }
  promoCode {
    ... on EventPromoCode {
      __typename
      id
      code
      discountType
      discountAmount
      eventType: type
    }
    ... on MembershipPromoCode {
      __typename
      id
      code
      discountType
      discountAmount
      membershipType: type
    }
  }
  history {
    ...HistoryConnection
  }
  createdAt
  updatedAt
  orderTicketCover {
    totalFeeAmount
    retryCount
    issuedAt
  }
}
    ${AddressFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${HistoryConnectionFragmentDoc}`;
export const OrganizationFragmentFragmentDoc = gql`
    fragment OrganizationFragment on Organization {
  createdAt
  updatedAt
  id
  name
  slug
  email
  phone
  taxNumber
  supportInfo
  termsAndConditions
  privacyPolicy
  features
  currency
  shippingLabels {
    eTicket
    printedTicketAtVenue
    printedTicketByCourierRural
    printedTicketByCourier
    printedTicketByMail
  }
  address {
    ...AddressFragment
  }
  marketing {
    gtmId
    pixelId
  }
  branding {
    logo {
      ...FileFragment
    }
    mobileLogo {
      ...FileFragment
    }
    background {
      ...FileFragment
    }
    fullBackground {
      ...FileFragment
    }
    greyScale
    primaryColor
    secondaryColor
  }
  helpLink
}
    ${AddressFragmentFragmentDoc}
${FileFragmentFragmentDoc}`;
export const ReleaseFragmentFragmentDoc = gql`
    fragment ReleaseFragment on Release {
  id
  name
  type
  slug
  startCondition
  startConditionDate
  endCondition
  endConditionQuantity
  endConditionDate
  isActive
  askForDietaryRequirements
  askHowDidYouHearAboutUs
  allowPublicComp
  allowAccount2Account
  allowHoldOrders
  presaleTitle
  presaleLogo {
    fileName
    originalFileName
  }
  presaleHeader {
    fileName
    originalFileName
  }
  presaleInformation
  releaseNotes
  releaseZones {
    id
    zone {
      id
      name
    }
    pricingLevel
    isActive
    ticketTypes {
      price
      sections {
        sectionId
        name
        price
      }
      isActive
      ticketTypeId
    }
  }
  password
  createdAt
  updatedAt
  canBeHardDeleted
  releaseEventAddons {
    eventAddon {
      id
      name
    }
  }
}
    `;
export const ScoutFilterSelectionFragmentDoc = gql`
    fragment ScoutFilterSelection on FilterSelection {
  userTagIds
  seasonIds
  eventTypes
  membershipTypes
  eventIds
  eventTitlesForWaitlist
  totalEventsPurchasedTo
  ticketTypeKinds
  zones
  releaseIds
  regions
  minAge
  maxAge
  gender
}
    `;
export const SeasonFragmentFragmentDoc = gql`
    fragment SeasonFragment on Season {
  id
  name
  isActive
  startDate
  description
  endDate
  events {
    id
    title
    startDate
    eventKind
  }
  thumbnail {
    ...FileFragment
  }
  backgroundImageFullPage {
    ...FileFragment
  }
  updatedAt
  createdAt
  displayOrder
}
    ${FileFragmentFragmentDoc}`;
export const TagFragmentFragmentDoc = gql`
    fragment TagFragment on Tag {
  id
  name
  updatedAt
  createdAt
}
    `;
export const TicketBaseFragmentDoc = gql`
    fragment TicketBase on Ticket {
  id
  createdAt
  updatedAt
}
    `;
export const TicketInfoFragmentDoc = gql`
    fragment TicketInfo on Ticket {
  ticketNumber
  digitalPassCode
  digitalEventUrl
  seatLabel
  seatZone
  seatSection
  seatTags
  isNamed
  shouldBeNamed
  qrCode
  transferFee {
    type
    fee
  }
  gates {
    id
    name
  }
}
    `;
export const TicketUserFragmentDoc = gql`
    fragment TicketUser on Ticket {
  firstName
  lastName
  email
  phoneNumber
  birthDate
  gender
  postalCode
  companyName
  licensePlate
  memberSince
  membershipNumber
  comments
  dietaryRequirements
  lengthOfStay
  vaccinePass {
    id
  }
  emergencyName
  emergencyContact
  emergencyContactRelationship
  dunedinResidentialAddress
  studentId
  customFields {
    fieldName
    fieldValue
  }
}
    `;
export const TicketFragmentDoc = gql`
    fragment Ticket on Ticket {
  ...TicketBase
  ...TicketInfo
  ...TicketUser
}
    ${TicketBaseFragmentDoc}
${TicketInfoFragmentDoc}
${TicketUserFragmentDoc}`;
export const PartialAddressFragmentFragmentDoc = gql`
    fragment PartialAddressFragment on PartialAddress {
  line1
  line2
  postalCode
  city
  country
  suburb
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  id
  createdAt
  updatedAt
  firstName
  lastName
  fullName
  email
  roles
  permissions
  credits
  points
  phoneNumber
  birthDate
  companyName
  taxNumber
  instagramUsername
  isTwoFactorAuthenticationEnabled
  shippingAddress {
    ...PartialAddressFragment
  }
  billingAddress {
    ...PartialAddressFragment
  }
  shippingAddressMatchesBillingAddress
  usableForMarketing
  hasTickets
  hasMemberships
  LTV
  shopifyUser {
    shopifyUserId
    totalSpent
  }
  scoutCommunications {
    id
    name
    purpose
    createdAt
    updatedAt
  }
}
    ${PartialAddressFragmentFragmentDoc}`;
export const AudienceCountDocument = gql`
    query audienceCount($input: AudienceCountInput!) {
  audienceCount(input: $input)
}
    `;
export const BroadcastDocument = gql`
    query broadcast($id: String!) {
  broadcast(id: $id) {
    id
    subject
    fromName
    audienceType
    message
    type
    marketingType
    marketingFilters {
      ids
      criteria
      filterType
    }
    event {
      id
      title
    }
    membership {
      id
      name
    }
    status
    audienceData {
      ticketTypeId
      zoneId
      releaseId
      addonId
    }
    scheduledAt
    count
    transactionalType
    stats {
      sent
      bounced
      bounceRate
      opens
      uniqueOpens
    }
  }
}
    `;
export const BroadcastBouncesDocument = gql`
    query broadcastBounces($id: String!, $start: Float!, $count: Float!) {
  broadcastBounces(id: $id, start: $start, count: $count) {
    email
    fullName
  }
}
    `;
export const BroadcastReportStatsDocument = gql`
    query broadcastReportStats($input: BroadcastReportingStatsInput!) {
  broadcastReportStats(input: $input) {
    clicksOpened
    revenue
    conversions
    spamReported
  }
}
    `;
export const BroadcastsDocument = gql`
    query broadcasts($before: String, $after: String, $first: Int, $last: Int, $where: BroadcastWhereInput) {
  broadcasts(before: $before, after: $after, first: $first, last: $last, where: $where) {
    edges {
      node {
        id
        subject
        status
        audienceType
        scheduledAt
        errors
        type
        marketingType
        marketingFilters {
          ids
          criteria
          filterType
        }
        event {
          id
          title
        }
        membership {
          id
          name
        }
        count
        stats {
          bounced
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const DeleteBroadcastDocument = gql`
    mutation deleteBroadcast($id: String!) {
  deleteBroadcast(id: $id) {
    deletedId
  }
}
    `;
export const MarketingUserCountDocument = gql`
    query marketingUserCount($input: BroadcastFilterCountInput!) {
  marketingUserCount(input: $input)
}
    `;
export const SendBroadcastDocument = gql`
    mutation sendBroadcast($input: SendBroadcastInput!) {
  sendBroadcast(input: $input)
}
    `;
export const CompetitionDocument = gql`
    query competition($id: String!) {
  competition(id: $id) {
    ...CompetitionFragment
  }
}
    ${CompetitionFragmentFragmentDoc}`;
export const CompetitionsDocument = gql`
    query competitions($eventId: String!) {
  competitions(eventId: $eventId) {
    ...CompetitionFragment
  }
}
    ${CompetitionFragmentFragmentDoc}`;
export const CreateCompetitionDocument = gql`
    mutation createCompetition($eventId: String!, $input: CreateCompetitionInput!) {
  createCompetition(eventId: $eventId, input: $input) {
    ...CompetitionFragment
  }
}
    ${CompetitionFragmentFragmentDoc}`;
export const DeleteCompetitionDocument = gql`
    mutation deleteCompetition($competitionId: String!) {
  deleteCompetition(competitionId: $competitionId)
}
    `;
export const UnpublishCompetitionDocument = gql`
    mutation unpublishCompetition($competitionId: String!) {
  unpublishCompetition(competitionId: $competitionId) {
    ...CompetitionFragment
  }
}
    ${CompetitionFragmentFragmentDoc}`;
export const UpdateAndPublishCompetitionDocument = gql`
    mutation updateAndPublishCompetition($eventId: String!, $input: PublishCompetitionInput!) {
  updateAndPublishCompetition(eventId: $eventId, input: $input) {
    ...CompetitionFragment
  }
}
    ${CompetitionFragmentFragmentDoc}`;
export const UpdateCompetitionDocument = gql`
    mutation updateCompetition($competitionId: String!, $input: CreateCompetitionInput!) {
  updateCompetition(competitionId: $competitionId, input: $input) {
    ...CompetitionFragment
  }
}
    ${CompetitionFragmentFragmentDoc}`;
export const EventDetailsDocument = gql`
    query eventDetails($id: String!) {
  event(id: $id) {
    id
    title
    eventKind
    dates {
      id
      startDate
      endDate
    }
    startDate
    isActive
    emailNotification
    invoiceInformation
    venue {
      name
      id
      seating
      createdFromEvent
      zones {
        id
        name
        capacity
        sections {
          id
          name
        }
      }
      gates {
        id
        name
      }
    }
    ticketTypes {
      ...TicketTypeFragment
    }
    season {
      id
      name
    }
    gateways {
      id
      name
      paymentMethodType
    }
  }
}
    ${TicketTypeFragmentFragmentDoc}`;
export const EventsListDocument = gql`
    query eventsList($before: String, $after: String, $first: Int, $last: Int, $where: EventWhereInput, $orderBy: EventOrderByInput) {
  events(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        startDate
        endDate
        eventKind
        title
        soldTicketsCount
        isActive
        venue {
          name
          createdFromEvent
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const CreateReleaseZoneDocument = gql`
    mutation createReleaseZone($input: CreateReleaseZoneInput!) {
  createReleaseZone(input: $input) {
    id
    releaseZones {
      zone {
        id
      }
    }
  }
}
    `;
export const UpdateReleaseZoneDocument = gql`
    mutation updateReleaseZone($id: String!, $input: UpdateReleaseZoneInput!) {
  updateReleaseZone(id: $id, input: $input) {
    id
  }
}
    `;
export const EventWithListedReleaseDocument = gql`
    query eventWithListedRelease($eventId: String!) {
  event(id: $eventId) {
    ...EventFragment
    ticketTypes {
      price
    }
    listedRelease {
      ...ReleaseFragment
      releaseZones {
        id
        isActive
        ticketTypes {
          price
          isActive
          ticketTypeId
          ticketAvailabilityStatus
        }
        zone {
          capacity
          description
          admission
          displayOrder
        }
      }
      releaseEventAddons {
        eventAddon {
          createdAt
          id
          name
          enableNaming
          quantity
          price
          description
          restrictions
          isActive
          insideFee
          namingFields {
            field
            isRequired
            isCustom
            label
          }
          addonImage {
            ...FileFragment
          }
        }
      }
    }
    venue {
      capacity
      zones {
        id
        name
        displayOrder
      }
    }
  }
}
    ${EventFragmentFragmentDoc}
${ReleaseFragmentFragmentDoc}
${FileFragmentFragmentDoc}`;
export const DashboardEventsDocument = gql`
    query dashboardEvents($before: String, $after: String, $first: Int, $last: Int, $where: EventWhereInput, $orderBy: EventOrderByInput) {
  events(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        dates {
          id
          startDate
          endDate
        }
        id
        startDate
        endDate
        eventKind
        title
        soldTicketsCount
        soldTicketsCountToday
        soldTicketsCountYesterday
        totalRevenue
        isActive
        logo {
          ...FileFragment
        }
        venue {
          name
          address {
            city
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${FileFragmentFragmentDoc}`;
export const MembershipDetailsDocument = gql`
    query membershipDetails($id: String!) {
  membership(id: $id) {
    id
    name
    membershipKind
    isActive
    startDate
    endDate
    canNameMembership
    canRenameMembership
    canChangeSeats
    canUsePoints
    enableAutoRenew
    renamingFee
    changingSeatsFee
    bookingFee
    bookingFeeType
    description
    emailNotification
    gateways {
      id
      name
      paymentMethodType
    }
    digitalInfo {
      url
      additionalEmailInfoHTML
      additionalEmailButtonText
      additionalEmailButtonUrl
      additionalEmailInfoText
    }
    termsAndConditions
    accessibility
    importantNotice
    invoiceInformation
    showSchedule
    digitalPassCodesStatus {
      ...DigitalPassCodesStatusFragment
    }
    shippingOptions {
      ...ShippingOptionsFragment
    }
    thumbnail {
      ...FileFragment
    }
    banner {
      ...FileFragment
    }
    backgroundImage {
      ...FileFragment
    }
    descriptionImage {
      ...FileFragment
    }
    printBanner1 {
      ...FileFragment
    }
    printBanner2 {
      ...FileFragment
    }
    events {
      id
    }
    season {
      id
      startDate
      endDate
    }
    previousMemberships {
      id
      startDate
      endDate
    }
    types {
      id
      name
      kind
      ticketFeeType
      ticketFeeType
    }
    venue {
      id
      name
      seatsChartKey
      address {
        ...AddressFragment
      }
      seating
      zones {
        id
        name
        description
        displayOrder
        capacity
        sections {
          id
          name
        }
        stand
        admission
      }
      createdAt
      updatedAt
    }
    membershipZones {
      id
      zone {
        id
        name
      }
      pricingLevel
      isActive
      membershipTypes {
        price
        sections {
          sectionId
          name
          price
        }
        isActive
        membershipTypeId
      }
    }
    multiBuyPromotions {
      id
      name
      getQuantity
      getMembershipType {
        id
        name
        description
        restrictions
        kind
      }
      buyQuantity
      getMembershipType {
        id
        name
        description
        restrictions
        kind
      }
    }
    tags {
      id
      name
    }
  }
}
    ${DigitalPassCodesStatusFragmentFragmentDoc}
${ShippingOptionsFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export const MembershipsListDocument = gql`
    query membershipsList($first: Int, $last: Int, $before: String, $after: String, $where: MembershipWhereInput, $orderBy: MembershipOrderByInput) {
  memberships(first: $first, last: $last, before: $before, after: $after, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        name
        startDate
        endDate
        isActive
        membershipHoldersCount
        venue {
          id
          name
        }
      }
    }
  }
}
    `;
export const EventsListWithSeasonsDocument = gql`
    query eventsListWithSeasons($before: String, $after: String, $first: Int, $last: Int, $where: EventWhereInput, $orderBy: EventOrderByInput) {
  events(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        startDate
        endDate
        eventKind
        title
        isActive
        season {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const CreatePointItemDocument = gql`
    mutation createPointItem($input: CreatePointItemInput!) {
  createPointItem(input: $input) {
    id
  }
}
    `;
export const UpdatePointDocument = gql`
    mutation updatePoint($input: UpdatePointInput!) {
  updatePoint(input: $input) {
    id
  }
}
    `;
export const UpdatePointItemDocument = gql`
    mutation updatePointItem($input: UpdatePointItemInput!, $id: String!) {
  updatePointItem(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdatePointsDocument = gql`
    mutation updatePoints($input: UpdatePointInput!) {
  updatePoint(input: $input) {
    id
  }
}
    `;
export const PointWithItemsDocument = gql`
    query pointWithItems {
  point {
    id
    name
    isEnabled
    termsAndConditions
    gateways {
      id
    }
    pointItems {
      ...pointItem
    }
  }
}
    ${PointItemFragmentDoc}`;
export const ReferralPromotionReportStatsDocument = gql`
    query referralPromotionReportStats($input: ReferralPromotionReportingInput!) {
  referralPromotionReportStats(input: $input) {
    referrerPointsAwarded
    revenue
    discountValue
    roi
    newReferredCustomers
    orders
  }
}
    `;
export const EventsListUseParamsDocument = gql`
    query eventsListUseParams($before: String, $after: String, $first: Int, $last: Int, $where: EventWhereInput, $orderBy: EventOrderByInput) {
  events(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        startDate
        endDate
        eventKind
        title
        isActive
        ticketSoldTime {
          startTime
          endTime
          sourceId
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const MembershipsListUseParamsDocument = gql`
    query membershipsListUseParams($first: Int, $last: Int, $before: String, $after: String, $where: MembershipWhereInput) {
  memberships(first: $first, last: $last, before: $before, after: $after, where: $where) {
    edges {
      node {
        id
        name
        startDate
        endDate
        isActive
        ticketSoldTime {
          startTime
          endTime
          sourceId
        }
      }
    }
  }
}
    `;
export const ReleasesListUseParamasDocument = gql`
    query releasesListUseParamas($event: String!) {
  releases(event: $event) {
    id
    name
    type
  }
}
    `;
export const UpsertAdobeIntegrationDocument = gql`
    mutation upsertAdobeIntegration($input: AdobeExperiencePlatformIntegrationInput!) {
  upsertAdobeIntegration(input: $input) {
    id
  }
}
    `;
export const DeleteAdobeIntegrationDocument = gql`
    query deleteAdobeIntegration {
  deleteAdobeIntegration
}
    `;
export const AdobeIntegrationDocument = gql`
    query adobeIntegration {
  adobeIntegration {
    tenant
    sandboxName
    clientId
    clientSecret
    imsOrgId
    technicalAccountId
    privateKeyBase64
    customerEndpoint
    customerSchemaRefId
    customerDatasetId
    ticketEndpoint
    ticketSchemaRefId
    ticketDatasetId
    scanEndpoint
    scanSchemaRefId
    scanDatasetId
  }
}
    `;
export const AddForecastScenarioDocument = gql`
    mutation addForecastScenario($id: String!) {
  addForecastScenario(id: $id) {
    id
    eventId
    zones {
      zoneId
      comps
      contingency
    }
    scenarios {
      id
      zones {
        zoneId
        ticketTypes {
          ticketTypeId
          price
          splitPercentage
        }
      }
    }
  }
}
    `;
export const AssignScoutCommunicationUsersToAgentDocument = gql`
    mutation assignScoutCommunicationUsersToAgent($input: AssignScoutCommunicationUsersToAgentInput!) {
  assignScoutCommunicationUsersToAgent(input: $input)
}
    `;
export const AssignTwoFactorAuthenticationSecretDocument = gql`
    mutation assignTwoFactorAuthenticationSecret {
  assignTwoFactorAuthenticationSecret {
    dataURL
    secret
  }
}
    `;
export const AuthenticateWithTwoFactorDocument = gql`
    mutation authenticateWithTwoFactor($input: TwoFactorAuthenticationCodeInput!) {
  authenticateWithTwoFactor(input: $input) {
    id
  }
}
    `;
export const CancelOrderDocument = gql`
    mutation cancelOrder($id: String!) {
  cancelOrder(id: $id) {
    id
  }
}
    `;
export const CompletePreprintTicketOrderDocument = gql`
    mutation completePreprintTicketOrder($id: String!, $input: LineItemsToCompleteInput!) {
  completePreprintTicketOrder(id: $id, input: $input) {
    id
  }
}
    `;
export const CreateAutomationDocument = gql`
    mutation createAutomation($input: CreateAutomationInput!) {
  createAutomation(input: $input) {
    id
  }
}
    `;
export const CreateBulkOrdersDocument = gql`
    mutation createBulkOrders($input: ImportInput!, $createdById: String!) {
  createBulkOrders(input: $input, createdById: $createdById)
}
    `;
export const CreateEventDocument = gql`
    mutation createEvent($input: CreateEventInput!) {
  createEvent(input: $input) {
    id
  }
}
    `;
export const CreateEventAddonDocument = gql`
    mutation createEventAddon($input: CreateEventAddonInput!) {
  createEventAddon(input: $input) {
    id
    createdAt
  }
}
    `;
export const CreateEventMultiBuyPromotionDocument = gql`
    mutation createEventMultiBuyPromotion($input: CreateEventMultiBuyPromotionInput!) {
  createEventMultiBuyPromotion(input: $input) {
    id
    createdAt
  }
}
    `;
export const CreateEventPromoCodeDocument = gql`
    mutation createEventPromoCode($input: CreateEventPromoCodeInput!) {
  createEventPromoCode(input: $input) {
    id
    createdAt
  }
}
    `;
export const CreateHistoryDocument = gql`
    mutation createHistory($input: CreateHistoryInput!) {
  createHistory(input: $input) {
    description
    createdAt
    updatedAt
    id
    user {
      firstName
      lastName
      roles
    }
  }
}
    `;
export const CreateIntegrationDocument = gql`
    mutation createIntegration($input: CreateIntegrationInput!) {
  createIntegration(input: $input) {
    ...FullIntegrationFragment
  }
}
    ${FullIntegrationFragmentFragmentDoc}`;
export const CreateMembershipDocument = gql`
    mutation createMembership($input: CreateMembershipInput!) {
  createMembership(input: $input) {
    ...MembershipFragment
  }
}
    ${MembershipFragmentFragmentDoc}`;
export const CreateMembershipAddonDocument = gql`
    mutation createMembershipAddon($input: CreateMembershipAddonInput!) {
  createMembershipAddon(input: $input) {
    id
    createdAt
  }
}
    `;
export const CreateMembershipMultiBuyPromotionDocument = gql`
    mutation createMembershipMultiBuyPromotion($input: CreateMembershipMultiBuyPromotionInput!) {
  createMembershipMultiBuyPromotion(input: $input) {
    id
    createdAt
  }
}
    `;
export const CreateMembershipPromoCodeDocument = gql`
    mutation createMembershipPromoCode($input: CreateMembershipPromoCodeInput!) {
  createMembershipPromoCode(input: $input) {
    id
    createdAt
  }
}
    `;
export const CreateMembershipTypeDocument = gql`
    mutation createMembershipType($input: CreateMembershipTypeInput!) {
  createMembershipType(input: $input) {
    ...MembershipTypeFragment
  }
}
    ${MembershipTypeFragmentFragmentDoc}`;
export const CreateOrderDocument = gql`
    mutation createOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    id
  }
}
    `;
export const CreatePosDocument = gql`
    mutation createPos($input: CreatePosInput!) {
  createPos(input: $input) {
    id
  }
}
    `;
export const CreatePosUserDocument = gql`
    mutation createPosUser($input: CreatePosUserInput!) {
  createPosUser(input: $input) {
    id
  }
}
    `;
export const CreatePurchaseRestrictionDocument = gql`
    mutation createPurchaseRestriction($input: CreatePurchaseRestrictionInput!) {
  createPurchaseRestriction(input: $input) {
    id
    createdAt
  }
}
    `;
export const CreateReferralCampaignDocument = gql`
    mutation createReferralCampaign($input: CreateReferralCampaignDto!) {
  createReferralCampaign(campaign: $input) {
    referralRelease {
      id
    }
    isActive
    referralOwnerRewardType
    referralOwnerRewardQuantity
    referralOwnerRewardQuantityType
    referralUserRewardType
    referralUserRewardQuantityType
    referralUserRewardQuantity
  }
}
    `;
export const CreateRefundDocument = gql`
    mutation createRefund($input: CreateRefundInput!) {
  createRefund(input: $input) {
    id
  }
}
    `;
export const CreateReleaseDocument = gql`
    mutation createRelease($input: CreateReleaseInput!) {
  createRelease(input: $input) {
    ...ReleaseFragment
  }
}
    ${ReleaseFragmentFragmentDoc}`;
export const CreateScoutDocument = gql`
    mutation createScout($input: CreateScoutInput!) {
  createScout(input: $input) {
    id
    name
  }
}
    `;
export const CreateScoutCommunicationDocument = gql`
    mutation createScoutCommunication($input: CreateScoutCommunicationInput!) {
  createScoutCommunication(input: $input) {
    id
  }
}
    `;
export const CreateSeasonDocument = gql`
    mutation createSeason($input: CreateSeasonInput!) {
  createSeason(input: $input) {
    ...SeasonFragment
  }
}
    ${SeasonFragmentFragmentDoc}`;
export const CreateTagDocument = gql`
    mutation createTag($input: CreateTagInput!) {
  createTag(input: $input) {
    id
    name
  }
}
    `;
export const CreateTemporaryPosUserDocument = gql`
    mutation createTemporaryPosUser($input: CreateTemporaryPosUserInput!) {
  createTemporaryPosUser(input: $input) {
    user {
      id
      email
    }
    password
    oneTimeAccessToken
  }
}
    `;
export const CreateTicketTypeDocument = gql`
    mutation createTicketType($input: CreateTicketTypeInput!) {
  createTicketType(input: $input) {
    ...TicketTypeFragment
  }
}
    ${TicketTypeFragmentFragmentDoc}`;
export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!, $sendInvite: Boolean!) {
  createUser(input: $input, sendInvite: $sendInvite) {
    id
    history {
      edges {
        node {
          id
        }
      }
    }
  }
}
    `;
export const CreateVenueDocument = gql`
    mutation createVenue($input: CreateVenueInput!) {
  createVenue(input: $input) {
    ...VenueFragment
  }
}
    ${VenueFragmentFragmentDoc}`;
export const DeleteEventAddonDocument = gql`
    mutation deleteEventAddon($id: String!) {
  deleteEventAddon(id: $id) {
    deletedId
  }
}
    `;
export const DeleteEventMultiBuyPromotionDocument = gql`
    mutation deleteEventMultiBuyPromotion($id: String!) {
  deleteEventMultiBuyPromotion(id: $id) {
    deletedId
  }
}
    `;
export const DeleteEventPromoCodeDocument = gql`
    mutation deleteEventPromoCode($id: String!) {
  deleteEventPromoCode(id: $id) {
    deletedId
  }
}
    `;
export const DeleteForecastScenarioDocument = gql`
    mutation deleteForecastScenario($id: String!, $forecastId: String!) {
  deleteForecastScenario(id: $id, forecastId: $forecastId) {
    id
    eventId
    zones {
      zoneId
      comps
      contingency
    }
    scenarios {
      id
      zones {
        zoneId
        ticketTypes {
          ticketTypeId
          price
          splitPercentage
        }
      }
    }
  }
}
    `;
export const DeleteMembershipAddonDocument = gql`
    mutation deleteMembershipAddon($id: String!) {
  deleteMembershipAddon(id: $id) {
    deletedId
  }
}
    `;
export const DeleteMembershipMultiBuyPromotionDocument = gql`
    mutation deleteMembershipMultiBuyPromotion($id: String!) {
  deleteMembershipMultiBuyPromotion(id: $id) {
    deletedId
  }
}
    `;
export const DeleteMembershipPromoCodeDocument = gql`
    mutation deleteMembershipPromoCode($id: String!) {
  deleteMembershipPromoCode(id: $id) {
    deletedId
  }
}
    `;
export const DeleteMembershipTypeDocument = gql`
    mutation deleteMembershipType($id: String!) {
  deleteMembershipType(id: $id) {
    deletedId
  }
}
    `;
export const DeletePurchaseRestrictionDocument = gql`
    mutation deletePurchaseRestriction($id: String!) {
  deletePurchaseRestriction(id: $id) {
    deletedId
  }
}
    `;
export const DeleteReleaseDocument = gql`
    mutation deleteRelease($id: String!) {
  deleteRelease(id: $id) {
    deletedId
  }
}
    `;
export const DeleteScoutUsersDocument = gql`
    mutation deleteScoutUsers($input: DeleteScoutUserInput!) {
  deleteScoutUsers(input: $input)
}
    `;
export const DeleteTagDocument = gql`
    mutation deleteTag($tagId: String!, $entityId: String!) {
  deleteTag(tagId: $tagId, entityId: $entityId)
}
    `;
export const DeleteTicketTypeDocument = gql`
    mutation deleteTicketType($id: String!) {
  deleteTicketType(id: $id) {
    deletedId
  }
}
    `;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: String!) {
  deleteUser(id: $id) {
    deletedId
  }
}
    `;
export const DeleteVenueDocument = gql`
    mutation deleteVenue($id: String!) {
  deleteVenue(id: $id) {
    deletedId
  }
}
    `;
export const DuplicateEventDocument = gql`
    mutation duplicateEvent($id: String!) {
  duplicateEvent(id: $id)
}
    `;
export const DuplicateMembershipDocument = gql`
    mutation duplicateMembership($id: String!) {
  duplicateMembership(id: $id)
}
    `;
export const DuplicateSingleReleaseDocument = gql`
    mutation duplicateSingleRelease($input: DuplicateSingleReleaseInput!) {
  duplicateSingleRelease(input: $input) {
    id
  }
}
    `;
export const EnableTwoFactorAuthenticationDocument = gql`
    mutation enableTwoFactorAuthentication($input: TwoFactorAuthenticationCodeInput!) {
  enableTwoFactorAuthentication(input: $input)
}
    `;
export const ImportDigitalPassCodesForEventDocument = gql`
    mutation importDigitalPassCodesForEvent($eventId: String!, $input: ImportInput!) {
  importDigitalPassCodesForEvent(eventId: $eventId, input: $input)
}
    `;
export const ImportDigitalPassCodesForMembershipDocument = gql`
    mutation importDigitalPassCodesForMembership($membershipId: String!, $input: ImportInput!) {
  importDigitalPassCodesForMembership(membershipId: $membershipId, input: $input)
}
    `;
export const ImportReleasePasswordsDocument = gql`
    mutation importReleasePasswords($id: String!, $input: ImportInput!) {
  importReleasePasswords(id: $id, input: $input)
}
    `;
export const LoginDocument = gql`
    mutation login($input: LoginInput!) {
  login(input: $input) {
    id
    createdAt
    updatedAt
    firstName
    lastName
    fullName
    email
    roles
    permissions
    credits
    phoneNumber
    birthDate
    shippingAddressMatchesBillingAddress
    usableForMarketing
  }
}
    `;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export const ReleaseClaimsForNextMembershipDocument = gql`
    mutation releaseClaimsForNextMembership($ids: String!) {
  releaseClaimsForNextMembership(ids: $ids) {
    id
  }
}
    `;
export const ReleaseSeatsDocument = gql`
    mutation releaseSeats($input: ReleaseSeatsInput!) {
  releaseSeats(input: $input) {
    id
  }
}
    `;
export const RemoveTwoFactorAuthenticationSecretDocument = gql`
    mutation removeTwoFactorAuthenticationSecret {
  removeTwoFactorAuthenticationSecret
}
    `;
export const RequestMagicLinkDocument = gql`
    mutation requestMagicLink($input: RequestMagicLinkInput!) {
  requestMagicLink(input: $input)
}
    `;
export const RequestResetPasswordDocument = gql`
    mutation requestResetPassword($input: RequestResetPasswordInput!) {
  requestResetPassword(input: $input)
}
    `;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export const AddReminderToScoutCommunicationUserDocument = gql`
    mutation addReminderToScoutCommunicationUser($id: String!, $input: AddReminderToScoutCommunicationUserInput!) {
  addReminderToScoutCommunicationUser(id: $id, input: $input)
}
    `;
export const ClearReminderFromScoutCommunicationUserDocument = gql`
    mutation clearReminderFromScoutCommunicationUser($id: String!) {
  clearReminderFromScoutCommunicationUser(id: $id)
}
    `;
export const SendMemberRenewalEmailDocument = gql`
    mutation sendMemberRenewalEmail($id: String!) {
  sendMemberRenewalEmail(id: $id)
}
    `;
export const SendOrderConfirmationDocument = gql`
    mutation sendOrderConfirmation($id: String!, $input: SendOrderConfirmationInput!) {
  sendOrderConfirmation(id: $id, input: $input) {
    email
  }
}
    `;
export const CreateTestEmailDocument = gql`
    mutation createTestEmail($input: CreateTestEmailInput!) {
  createTestEmail(input: $input)
}
    `;
export const SendTwoFactorCodeViaSmsMessageDocument = gql`
    mutation sendTwoFactorCodeViaSMSMessage {
  sendTwoFactorCodeViaSMSMessage
}
    `;
export const SendUserInviteDocument = gql`
    mutation sendUserInvite($id: String!) {
  sendUserInvite(id: $id) {
    id
    email
  }
}
    `;
export const SetPasswordForNewUserDocument = gql`
    mutation setPasswordForNewUser($input: SetPasswordForNewUserInput!) {
  setPasswordForNewUser(input: $input)
}
    `;
export const SplitOrderDocument = gql`
    mutation splitOrder($id: String!, $input: SplitOrderInput!) {
  splitHoldOrder(id: $id, input: $input) {
    id
  }
}
    `;
export const SyncTicketWithSeatsIoDocument = gql`
    mutation syncTicketWithSeatsIo($ticketId: String!) {
  syncTicketWithSeatsIo(ticketId: $ticketId)
}
    `;
export const TagEntitiesDocument = gql`
    mutation tagEntities($input: TagEntitiesInput!) {
  tagEntities(input: $input)
}
    `;
export const UpdateAutomationDocument = gql`
    mutation updateAutomation($input: UpdateAutomationInput!, $id: String!) {
  updateAutomation(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateCreditsForUserDocument = gql`
    mutation updateCreditsForUser($input: UpdateCreditsInput!, $userId: String!) {
  updateCreditsForUser(input: $input, userId: $userId) {
    credits
  }
}
    `;
export const UpdateEventDocument = gql`
    mutation updateEvent($input: UpdateEventInput!, $id: String!, $sendTicketViewableEmails: Boolean) {
  updateEvent(input: $input, id: $id, sendTicketViewableEmails: $sendTicketViewableEmails) {
    id
  }
}
    `;
export const UpdateEventAddonDocument = gql`
    mutation updateEventAddon($input: UpdateEventAddonInput!, $id: String!) {
  updateEventAddon(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateEventMultiBuyPromotionDocument = gql`
    mutation updateEventMultiBuyPromotion($input: UpdateEventMultiBuyPromotionInput!, $id: String!) {
  updateEventMultiBuyPromotion(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateEventPromoCodeDocument = gql`
    mutation updateEventPromoCode($input: UpdateEventPromoCodeInput!, $id: String!) {
  updateEventPromoCode(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateForecastDocument = gql`
    mutation updateForecast($input: UpdateForecastInput!, $id: String!) {
  updateForecast(input: $input, id: $id) {
    id
    eventId
    zones {
      zoneId
      comps
      contingency
    }
    scenarios {
      id
      zones {
        zoneId
        ticketTypes {
          ticketTypeId
          price
          splitPercentage
        }
      }
    }
  }
}
    `;
export const UpdateHoldOrderDocument = gql`
    mutation updateHoldOrder($input: UpdateHoldOrderInput!, $id: String!) {
  updateHoldOrder(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateIntegrationDocument = gql`
    mutation updateIntegration($input: UpdateIntegrationInput!, $id: String!) {
  updateIntegration(input: $input, id: $id) {
    ...FullIntegrationFragment
  }
}
    ${FullIntegrationFragmentFragmentDoc}`;
export const UpdateMembershipDocument = gql`
    mutation updateMembership($id: String!, $input: UpdateMembershipInput!) {
  updateMembership(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateMembershipAddonDocument = gql`
    mutation updateMembershipAddon($input: UpdateMembershipAddonInput!, $id: String!) {
  updateMembershipAddon(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateMembershipMultiBuyPromotionDocument = gql`
    mutation updateMembershipMultiBuyPromotion($input: UpdateMembershipMultiBuyPromotionInput!, $id: String!) {
  updateMembershipMultiBuyPromotion(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateMembershipPromoCodeDocument = gql`
    mutation updateMembershipPromoCode($input: UpdateMembershipPromoCodeInput!, $id: String!) {
  updateMembershipPromoCode(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateMembershipTicketTransferPricesDocument = gql`
    mutation updateMembershipTicketTransferPrices($id: String!, $input: [UpdateMembershipTypeEventTransferPriceInput!]!) {
  upsertMembershipTypeEventTransferPrices(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateMembershipTypeDocument = gql`
    mutation updateMembershipType($id: String!, $input: UpdateMembershipTypeInput!) {
  updateMembershipType(id: $id, input: $input) {
    ...MembershipTypeFragment
  }
}
    ${MembershipTypeFragmentFragmentDoc}`;
export const UpdateOrderDocument = gql`
    mutation updateOrder($input: UpdateOrderInput!, $id: String!) {
  updateOrder(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateOrderStatusDocument = gql`
    mutation updateOrderStatus($id: String!, $input: UpdateOrderStatusInput!) {
  updateOrderStatus(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export const UpdateOrganizationByIdDocument = gql`
    mutation updateOrganizationById($input: UpdateOrganizationInput!, $id: String!) {
  updateOrganizationById(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdatePosUserDocument = gql`
    mutation updatePosUser($input: UpdatePosUserInput!, $id: String!) {
  updatePosUser(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdatePromoCodeDocument = gql`
    mutation updatePromoCode($input: UpdateEventPromoCodeInput!, $id: String!) {
  updateEventPromoCode(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdatePurchaseRestrictionDocument = gql`
    mutation updatePurchaseRestriction($id: String!, $input: CreatePurchaseRestrictionInput!) {
  updatePurchaseRestriction(id: $id, input: $input) {
    id
    restrictedType
    restrictedId
    requiredEntities {
      requiredId
      requiredType
    }
    quantity
    isExclusive
    isAlwaysVisible
    createdAt
    updatedAt
  }
}
    `;
export const UpdateReferralCampaignDocument = gql`
    mutation updateReferralCampaign($input: UpdateReferralCampaignDto!) {
  updateReferralCampaign(campaign: $input) {
    referralRelease {
      id
    }
    isActive
    referralOwnerRewardType
    referralOwnerRewardQuantity
    referralOwnerRewardQuantityType
    referralUserRewardType
    referralUserRewardQuantityType
    referralUserRewardQuantity
  }
}
    `;
export const UpdateReleaseDocument = gql`
    mutation updateRelease($input: UpdateReleaseInput!, $id: String!) {
  updateRelease(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateScoutDocument = gql`
    mutation updateScout($id: String!, $input: UpdateScoutInput!) {
  updateScout(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateScoutCommunicationDocument = gql`
    mutation updateScoutCommunication($id: String!, $input: UpdateScoutCommunicationInput!) {
  updateScoutCommunication(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateScoutCommunicationUserDocument = gql`
    mutation updateScoutCommunicationUser($id: String!, $input: UpdateScoutCommunicationUserInput!) {
  updateScoutCommunicationUser(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateScoutUsersDocument = gql`
    mutation updateScoutUsers($id: String!) {
  updateScoutUsers(id: $id)
}
    `;
export const UpdateSeasonDocument = gql`
    mutation updateSeason($input: UpdateSeasonInput!, $id: String!) {
  updateSeason(input: $input, id: $id) {
    ...SeasonFragment
  }
}
    ${SeasonFragmentFragmentDoc}`;
export const UpdateTagDocument = gql`
    mutation updateTag($input: UpdateTagInput!, $id: String!) {
  updateTag(input: $input, id: $id) {
    id
    name
  }
}
    `;
export const UpdateTicketHolderDocument = gql`
    mutation updateTicketHolder($id: String!, $input: UpdateTicketHolderInput!) {
  updateTicketHolder(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateTicketTypeDocument = gql`
    mutation updateTicketType($id: String!, $input: UpdateTicketTypeInput!) {
  updateTicketType(id: $id, input: $input) {
    ...TicketTypeFragment
  }
}
    ${TicketTypeFragmentFragmentDoc}`;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!, $id: String!) {
  updateUser(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateVenueDocument = gql`
    mutation updateVenue($input: UpdateVenueInput!, $id: String!) {
  updateVenue(input: $input, id: $id) {
    id
  }
}
    `;
export const UpdateVenueZonesDocument = gql`
    mutation updateVenueZones($id: String!) {
  updateVenueZones(id: $id) {
    zones {
      name
      capacity
      description
      displayOrder
      sections {
        id
        name
      }
    }
  }
}
    `;
export const VerifyMagicLinkDocument = gql`
    mutation verifyMagicLink($input: VerifyEmailInput!) {
  verifyMagicLink(input: $input) {
    redirectUrl
  }
}
    `;
export const GetPromoterSettingsDocument = gql`
    query getPromoterSettings($eventId: String!) {
  getPromoterSettings(eventId: $eventId) {
    event {
      id
    }
    config {
      share
      rsvp
      follow
      like
      invite
    }
    socialPages {
      name
      isEnabled
      url
    }
    referralCampaign(eventId: $eventId) {
      id
      createdAt
      updatedAt
      isActive
      referralRelease {
        id
      }
      referralOwnerRewardType
      referralOwnerRewardQuantityType
      referralOwnerRewardQuantity
      referralUserRewardType
      referralUserRewardQuantityType
      referralUserRewardQuantity
    }
  }
}
    `;
export const SetPromoterSettingsDocument = gql`
    mutation setPromoterSettings($input: PromoterSettingsInput!) {
  setPromoterSettings(input: $input) {
    config {
      share
      rsvp
      follow
      like
      invite
    }
    socialPages {
      name
      isEnabled
      url
    }
  }
}
    `;
export const ActivitiesDocument = gql`
    query activities($before: String, $after: String, $first: Int, $last: Int, $where: ActivityWhereInput) {
  activities(before: $before, after: $after, first: $first, last: $last, where: $where) {
    edges {
      node {
        id
        description
        createdAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const InsightsAgeBreakDownDocument = gql`
    query insightsAgeBreakDown($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String, $tagId: String, $scoutCommunicationId: String) {
  insightsAgeBreakDown(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release, tagId: $tagId, scoutCommunicationId: $scoutCommunicationId) {
    seg1
    seg2
    seg3
    seg4
    seg5
    seg6
    seg7
  }
}
    `;
export const AutomationDocument = gql`
    query automation($id: String!) {
  automation(id: $id) {
    ...AutomationFragment
  }
}
    ${AutomationFragmentFragmentDoc}`;
export const AutomationsDocument = gql`
    query automations($input: FindAutomationsInput!) {
  automations(input: $input) {
    ...AutomationFragment
  }
}
    ${AutomationFragmentFragmentDoc}`;
export const CapacityOverviewDocument = gql`
    query capacityOverview($eventId: String!) {
  capacityOverview(eventId: $eventId) {
    id
    zoneName
    totalNotForSaleCount
    totalMembershipTicketCount
    totalCompTicketCount
    totalPaidTicketCount
    totalHolds
    capacity
    sellableCapacity
    totalHoldByMembershipCount
    totalAllocated
  }
}
    `;
export const CapacitySeatingMapDocument = gql`
    query capacitySeatingMap($eventId: String!) {
  capacitySeatingMap(eventId: $eventId)
}
    `;
export const CapacitySeatingMapTooltipsDocument = gql`
    query capacitySeatingMapTooltips($eventId: String!) {
  capacitySeatingMapTooltips(eventId: $eventId)
}
    `;
export const CreateOrderEventsDocument = gql`
    query createOrderEvents($before: String, $after: String, $first: Int, $last: Int, $where: EventWhereInput, $orderBy: EventOrderByInput) {
  events(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        startDate
        title
        season {
          id
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const CurrentOrganizationDocument = gql`
    query currentOrganization {
  currentOrganization {
    ...CurrentOrganizationFragment
  }
}
    ${CurrentOrganizationFragmentFragmentDoc}`;
export const CustomerLocationsDocument = gql`
    query customerLocations($source: PointReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String, $tagId: String) {
  customerLocations(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release, tagId: $tagId) {
    city
    count
    amount
  }
}
    `;
export const EventDocument = gql`
    query event($id: String!) {
  event(id: $id) {
    ...EventFragment
  }
}
    ${EventFragmentFragmentDoc}`;
export const EventAddonsDocument = gql`
    query eventAddons($eventId: String!) {
  eventAddons(eventId: $eventId) {
    id
    createdAt
    updatedAt
    name
    enableNaming
    quantity
    isActive
    price
    description
    restrictions
    namingFields {
      ...NamingFields
    }
    addonImage {
      ...FileFragment
    }
    insideFee
  }
}
    ${NamingFieldsFragmentDoc}
${FileFragmentFragmentDoc}`;
export const EventForecastDocument = gql`
    query eventForecast($eventId: String!) {
  eventForecast(eventId: $eventId) {
    id
    eventId
    zones {
      zoneId
      comps
      contingency
      sales {
        zoneId
        zoneName
        capacity
        available
        sellableCapacity
        totalNotForSaleCount
        totalHoldByMembershipCount
        totalMembershipTicketCount
        soldPercentage
        types {
          name
          issued
          holds
          comps
          transfers
          transfersPending
          sold
          baseRevenue
          totalWithBookingFees
        }
      }
    }
    scenarios {
      id
      zones {
        zoneId
        ticketTypes {
          ticketTypeId
          price
          splitPercentage
        }
      }
    }
  }
}
    `;
export const EventMultiBuyPromotionsDocument = gql`
    query eventMultiBuyPromotions($eventId: String!) {
  eventMultiBuyPromotions(eventId: $eventId) {
    id
    createdAt
    updatedAt
    name
    buyQuantity
    getQuantity
    buyTicketType {
      id
      name
    }
    getTicketType {
      id
      name
    }
    price
  }
}
    `;
export const EventOrdersOnlineDocument = gql`
    query eventOrdersOnline($id: String!) {
  eventOrdersOnline(id: $id) {
    totalCount
    baseTickets
    ticketFees
    bookingFees
    transactionFees
    deliveryFees
    refundedAmount
    addons
    creditsUsed
    orderIdsOnline {
      orderId
    }
  }
}
    `;
export const EventPromoCodesDocument = gql`
    query eventPromoCodes($eventId: String!) {
  eventPromoCodes(eventId: $eventId) {
    id
    code
    discountType
    discountAmount
    used
    maxUsage
    startDate
    endDate
    minOrderAmount
    maxOrderAmount
    type
    ticketTypes
    createdAt
    updatedAt
  }
}
    `;
export const EventsDocument = gql`
    query events($before: String, $after: String, $first: Int, $last: Int, $where: EventWhereInput, $orderBy: EventOrderByInput) {
  events(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        season {
          id
          name
        }
        dates {
          id
          startDate
          endDate
        }
        id
        startDate
        endDate
        eventKind
        title
        soldTicketsCount
        isActive
        logo {
          ...FileFragment
        }
        venue {
          name
          address {
            city
          }
        }
        ticketTypes {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${FileFragmentFragmentDoc}`;
export const EventsSelectDocument = gql`
    query eventsSelect($before: String, $after: String, $first: Int, $last: Int, $where: EventWhereInput, $orderBy: EventOrderByInput) {
  events(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        startDate
        title
        isActive
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const FacebookPageListsDocument = gql`
    query facebookPageLists($input: FacebookPageListsInput!) {
  facebookPageLists(input: $input) {
    id
    name
    access_token
  }
}
    `;
export const FinancialGatewaysDocument = gql`
    query financialGateways($source: PointReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String) {
  financialGateways(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release) {
    transactions
    integrations {
      name
      transactions
    }
  }
}
    `;
export const FinancialGraphDocument = gql`
    query financialGraph($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String) {
  financialGraph(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release) {
    dates {
      date
      items {
        name
        value
      }
    }
  }
}
    `;
export const FinancialOverviewDocument = gql`
    query financialOverview($source: PointReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String) {
  financialOverview(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release) {
    grossSales
    netSales
    discounts
    avgOrderAmount
    avgOrderItemsCount
    transactionFees
    shippingCosts
    transferFees
    ticketCoverCost
    ticketCoverMargin
  }
}
    `;
export const FinancialSalesBreakdownDocument = gql`
    query financialSalesBreakdown($source: ReportingFinancialSalesBreakdownSource!, $sourceId: String!, $channel: OrderChannel, $startDate: DateTime, $endDate: DateTime, $release: String) {
  financialSalesBreakdown(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release) {
    zoneId
    zoneName
    capacity
    available
    sellableCapacity
    totalNotForSaleCount
    totalHoldByMembershipCount
    totalMembershipTicketCount
    soldPercentage
    types {
      name
      issued
      holds
      transfers
      transfersPending
      comps
      sold
      baseRevenue
      totalWithBookingFees
    }
  }
}
    `;
export const FullIntegrationsDocument = gql`
    query fullIntegrations($input: IntegrationWhereInput) {
  integrations(input: $input) {
    ...FullIntegrationFragment
  }
}
    ${FullIntegrationFragmentFragmentDoc}`;
export const InsightsGenderBreakDownDocument = gql`
    query insightsGenderBreakDown($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String, $tagId: String) {
  insightsGenderBreakDown(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release, tagId: $tagId) {
    male
    female
    other
  }
}
    `;
export const GetEventPurchaseRestrictionsDocument = gql`
    query getEventPurchaseRestrictions($eventId: String!) {
  getEventPurchaseRestrictions(eventId: $eventId) {
    id
    restrictedType
    restrictedId
    requiredEntities {
      requiredId
      requiredType
    }
    quantity
    isExclusive
    isAlwaysVisible
    createdAt
    updatedAt
  }
}
    `;
export const GetHistoryByCustomerIdDocument = gql`
    query getHistoryByCustomerId($input: GetHistoryByCustomerIdInput!) {
  getHistoryByCustomerId(input: $input) {
    ...History
  }
}
    ${HistoryFragmentDoc}`;
export const GetMembershipOrderOptionsDocument = gql`
    query getMembershipOrderOptions($first: Int, $last: Int, $before: String, $after: String, $where: MembershipWhereInput) {
  memberships(first: $first, last: $last, before: $before, after: $after, where: $where) {
    edges {
      node {
        id
        name
        season {
          id
          name
        }
      }
    }
  }
}
    `;
export const GetMembershipPurchaseRestrictionsDocument = gql`
    query getMembershipPurchaseRestrictions($membershipId: String!) {
  getMembershipPurchaseRestrictions(membershipId: $membershipId) {
    id
    restrictedType
    restrictedId
    requiredEntities {
      requiredId
      requiredType
    }
    quantity
    isExclusive
    isAlwaysVisible
    createdAt
    updatedAt
  }
}
    `;
export const GetMembershipRenewalDocument = gql`
    query getMembershipRenewal($id: String!) {
  membership(id: $id) {
    id
    multiBuyPromotions {
      id
      name
      getQuantity
      getMembershipType {
        id
        name
        description
        restrictions
        kind
      }
      buyQuantity
      buyMembershipType {
        id
        name
        description
        restrictions
        kind
      }
    }
    membershipZones {
      id
      zone {
        id
        name
      }
      pricingLevel
      isActive
      membershipTypes {
        price
        sections {
          name
          price
        }
        isActive
        membershipTypeId
      }
    }
    types {
      id
      name
      kind
      ticketFeeType
      ticketFeeType
    }
  }
}
    `;
export const GetReferralCampaignByEventIdDocument = gql`
    query getReferralCampaignByEventId($id: String!) {
  getReferralCampaignByEventId(id: $id) {
    isActive
    referralRelease {
      id
    }
    referralOwnerRewardType
    referralOwnerRewardQuantityType
    referralOwnerRewardQuantity
    referralUserRewardType
    referralUserRewardQuantityType
    referralUserRewardQuantity
  }
}
    `;
export const GetReferralCampaignByOrderIdDocument = gql`
    query getReferralCampaignByOrderId($id: String!) {
  getReferralCampaignByOrderId(id: $id) {
    id
    isActive
    referralOwnerRewardType
    referralOwnerRewardQuantityType
    referralOwnerRewardQuantity
    referralUserRewardType
    referralUserRewardQuantityType
    referralUserRewardQuantity
  }
}
    `;
export const GetReferralCampaignStatsDocument = gql`
    query getReferralCampaignStats($id: String!, $eventId: String!) {
  getReferralCampaignStats(id: $id, eventId: $eventId) {
    numberOfOrders
    userRewards
    ownerRewards
    referralLinksCreated
    referralLinksClicked
    tickets
    revenueGenerated
    customersAccquired
  }
}
    `;
export const GetReferralCampaignsDocument = gql`
    query getReferralCampaigns {
  getReferralCampaigns {
    id
    createdAt
    updatedAt
    isActive
    referralRelease {
      id
    }
    referralOwnerRewardType
    referralOwnerRewardQuantityType
    referralOwnerRewardQuantity
    referralUserRewardType
    referralUserRewardQuantityType
    referralUserRewardQuantity
  }
}
    `;
export const GetReferralRewardByOrderIdDocument = gql`
    query getReferralRewardByOrderId($id: String!) {
  getReferralRewardByOrderId(id: $id) {
    id
    referralCampaign {
      id
    }
    rewardType
    rewardQuantityType
    rewardQuantity
  }
}
    `;
export const GetReferralCampaignsByEventIdDocument = gql`
    query getReferralCampaignsByEventId($id: String!) {
  getReferralCampaignsByEventId(id: $id) {
    id
    createdAt
    updatedAt
    isActive
    referralRelease {
      id
    }
    referralOwnerRewardType
    referralOwnerRewardQuantityType
    referralOwnerRewardQuantity
    referralUserRewardType
    referralUserRewardQuantityType
    referralUserRewardQuantity
  }
}
    `;
export const GetTicketSoldTimeForEventDocument = gql`
    query getTicketSoldTimeForEvent($id: String!) {
  event(id: $id) {
    id
    ticketSoldTime {
      startTime
      endTime
      sourceId
    }
  }
}
    `;
export const GetTicketSoldTimeForMembershipDocument = gql`
    query getTicketSoldTimeForMembership($id: String!) {
  membership(id: $id) {
    id
    ticketSoldTime {
      startTime
      endTime
      sourceId
    }
  }
}
    `;
export const GetZonesByEventIdDocument = gql`
    query getZonesByEventId($eventId: String!) {
  getZonesByEventId(eventId: $eventId) {
    id
    name
  }
}
    `;
export const HasSeatedEventDocument = gql`
    query hasSeatedEvent {
  hasSeatedEvent
}
    `;
export const HighestValueCustomersDocument = gql`
    query highestValueCustomers($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String, $tagId: String) {
  highestValueCustomers(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release, tagId: $tagId) {
    name
    value
    userId
  }
}
    `;
export const InsightsHeardAboutUsBreakDownDocument = gql`
    query insightsHeardAboutUsBreakDown($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String, $tagId: String) {
  insightsHeardAboutUsBreakDown(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release, tagId: $tagId) {
    heardAboutUs
    count
  }
}
    `;
export const InsightsOverviewDocument = gql`
    query insightsOverview($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String, $tagId: String) {
  insightsOverview(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release, tagId: $tagId) {
    customers
    addressableAudience
    customerValue
    numberOfOrders
    returningCustomers
    referralLinksCreated
    newReferredCustomers
  }
}
    `;
export const IntegrationsDocument = gql`
    query integrations($input: IntegrationWhereInput) {
  integrations(input: $input) {
    ...IntegrationFragment
  }
}
    ${IntegrationFragmentFragmentDoc}`;
export const MailchimpDomainsDocument = gql`
    query mailchimpDomains {
  mailchimpDomains
}
    `;
export const MailchimpListsDocument = gql`
    query mailchimpLists {
  mailchimpLists
}
    `;
export const MailchimpTemplatesDocument = gql`
    query mailchimpTemplates {
  mailchimpTemplates
}
    `;
export const MeDocument = gql`
    query me {
  me {
    id
    createdAt
    updatedAt
    firstName
    lastName
    fullName
    email
    roles
    permissions
    credits
    phoneNumber
    birthDate
    isTwoFactorAuthenticationEnabled
    isLoggedInWithLinkedAccount
    shippingAddress {
      ...PartialAddressFragment
    }
    billingAddress {
      ...PartialAddressFragment
    }
    shippingAddressMatchesBillingAddress
    usableForMarketing
    accessEventIds
    accessMembershipIds
    hasPassword
  }
}
    ${PartialAddressFragmentFragmentDoc}`;
export const MembershipDocument = gql`
    query membership($id: String!) {
  membership(id: $id) {
    ...MembershipFragment
  }
}
    ${MembershipFragmentFragmentDoc}`;
export const MembershipAddonsDocument = gql`
    query membershipAddons($membershipId: String!) {
  membershipAddons(membershipId: $membershipId) {
    id
    createdAt
    updatedAt
    name
    enableNaming
    quantity
    isActive
    price
    description
    restrictions
    addonImage {
      ...FileFragment
    }
    namingFields {
      ...NamingFields
    }
  }
}
    ${FileFragmentFragmentDoc}
${NamingFieldsFragmentDoc}`;
export const MembershipMultiBuyPromotionsDocument = gql`
    query membershipMultiBuyPromotions($membershipId: String!) {
  membershipMultiBuyPromotions(membershipId: $membershipId) {
    id
    createdAt
    updatedAt
    name
    buyQuantity
    getQuantity
    buyMembershipType {
      id
      name
    }
    getMembershipType {
      id
      name
    }
    price
  }
}
    `;
export const MembershipPromoCodesDocument = gql`
    query membershipPromoCodes($membershipId: String!) {
  membershipPromoCodes(membershipId: $membershipId) {
    id
    code
    discountType
    discountAmount
    used
    maxUsage
    startDate
    endDate
    minOrderAmount
    maxOrderAmount
    type
    membershipTypes
    createdAt
    updatedAt
  }
}
    `;
export const MembershipTypeEventTransferPricesDocument = gql`
    query membershipTypeEventTransferPrices($id: String!) {
  membershipTypeEventTransferPrices(id: $id) {
    ...MembershipTypeEventTransferPricesFragment
  }
}
    ${MembershipTypeEventTransferPricesFragmentFragmentDoc}`;
export const MembershipTypesDocument = gql`
    query membershipTypes($membership: String!) {
  membershipTypes(membership: $membership) {
    ...MembershipTypeFragment
  }
}
    ${MembershipTypeFragmentFragmentDoc}`;
export const MembershipsDocument = gql`
    query memberships($first: Int, $last: Int, $before: String, $after: String, $where: MembershipWhereInput, $orderBy: MembershipOrderByInput) {
  memberships(first: $first, last: $last, before: $before, after: $after, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        name
        startDate
        endDate
        isActive
        venue {
          id
          name
        }
      }
    }
  }
}
    `;
export const MentionOverviewDocument = gql`
    query mentionOverview($input: MentionOverviewInput!) {
  mentionOverview(input: $input) {
    commentMentionCount
    mediaMentionCount
    storyMentionCount
  }
}
    `;
export const OrderDocument = gql`
    query order($id: String!) {
  order(id: $id) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export const OrderIdsOnlineDocument = gql`
    query orderIdsOnline($id: String!) {
  orderIdsOnline(id: $id) {
    orderId
  }
}
    `;
export const OrderRefundDetailsDocument = gql`
    query orderRefundDetails($orderId: String!, $eventId: String!) {
  orderRefundDetails(orderId: $orderId, eventId: $eventId) {
    orderId
    baseTickets
    ticketFees
    bookingFees
    transactionFees
    deliveryFees
    refundedAmount
    addons
    creditsUsed
  }
}
    `;
export const OrdersDocument = gql`
    query orders($before: String, $after: String, $first: Int, $last: Int, $where: OrderWhereInput, $orderBy: OrderOrderByInput) {
  orders(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        orderNumber
        createdAt
        total
        refundedAmount
        transactionStatus
        status
        isComp
        orderType
        event {
          title
        }
        membership {
          name
        }
        buyerInformation {
          firstName
          lastName
        }
        deliveryMethod
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const OrganizationDocument = gql`
    query organization($id: String!) {
  organization(id: $id) {
    id
    slug
    name
    address {
      ...AddressFragment
    }
    email
    phone
  }
}
    ${AddressFragmentFragmentDoc}`;
export const OrganizationsDocument = gql`
    query organizations($before: String, $after: String, $first: Int, $last: Int, $where: OrganizationWhereInput, $orderBy: OrganizationOrderByInput) {
  organizations(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        createdAt
        updatedAt
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const ParamsEventsDocument = gql`
    query paramsEvents($before: String, $after: String, $first: Int, $last: Int, $where: EventWhereInput, $orderBy: EventOrderByInput) {
  events(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        startDate
        title
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const ParamsMembershipsDocument = gql`
    query paramsMemberships($first: Int, $last: Int, $before: String, $after: String, $where: MembershipWhereInput, $orderBy: MembershipOrderByInput) {
  memberships(first: $first, last: $last, before: $before, after: $after, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        name
        startDate
      }
    }
  }
}
    `;
export const ParamsReleasesDocument = gql`
    query paramsReleases($event: String!) {
  releases(event: $event) {
    id
    name
    type
  }
}
    `;
export const PaymentOptionsDocument = gql`
    query paymentOptions {
  integrations(input: {group: PAYMENT}) {
    id
    name
  }
}
    `;
export const PosDocument = gql`
    query pos($id: String!) {
  pos(id: $id) {
    id
    name
    bookingFeeType
    bookingFee
    enableReceipts
    createdAt
    updatedAt
    paymentOptions {
      cash {
        feeType
        feeAmount
      }
      eftpos {
        feeType
        feeAmount
      }
      cc {
        feeType
        feeAmount
      }
      MPAiSA {
        feeType
        feeAmount
      }
    }
    deliveryOptions
    cashAmount
    event {
      title
      id
      startDate
      endDate
      venue {
        name
      }
    }
    release {
      name
      id
    }
    users {
      id
      fullName
      email
    }
  }
}
    `;
export const PosEventsDocument = gql`
    query posEvents($before: String, $after: String, $first: Int, $last: Int, $where: EventWhereInput, $orderBy: EventOrderByInput) {
  events(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        title
        bookingFee
        bookingFeeType
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const PosFinancialOverviewDocument = gql`
    query posFinancialOverview($eventId: String!, $posId: String, $sessionId: String) {
  posFinancialOverview(eventId: $eventId, posId: $posId, sessionId: $sessionId) {
    name
    value
  }
}
    `;
export const PosFloatOfChangeDocument = gql`
    query posFloatOfChange($eventId: String!, $posId: String, $sessionId: String) {
  posFloatOfChange(eventId: $eventId, posId: $posId, sessionId: $sessionId) {
    name
    value
  }
}
    `;
export const PosOrderDocument = gql`
    query posOrder($id: String!) {
  order(id: $id) {
    id
    orderNumber
    user {
      id
      firstName
      lastName
      fullName
      birthDate
      email
      phoneNumber
    }
    deliveryMethod
    usedCredits
    isComp
    buyerInformation {
      firstName
      lastName
      email
      phoneNumber
      postalCode
      taxNumber
      companyName
    }
    billingAddress {
      ...AddressFragment
    }
    shippingAddress {
      ...AddressFragment
    }
    shippingAddressMatchesBillingAddress
    event {
      id
      title
      startDate
      endDate
      venue {
        name
        seating
      }
    }
    membership {
      id
      name
      venue {
        seating
      }
    }
    status
    channel
    clientIp
    paymentGateway
    gateway {
      name
    }
    transactionStatus
    deliveryFee
    bookingFee
    bookingFeeAmount
    transactionFee
    transactionFeeAmount
    transactionFeeType
    subtotal
    totalTax
    total
    refundedAmount
    refunds {
      id
      createdAt
      updatedAt
      amount
    }
    tickets {
      id
      status
      ticketNumber
      lineItem {
        id
        price
        name
        type
      }
      shouldBeNamed
      seatSection
      seatZone
      seatLabel
      seatTags
      isNamed
      firstName
      lastName
      ticketType {
        dates {
          alternateEntryTime
        }
      }
    }
    lineItems {
      edges {
        node {
          id
          createdAt
          updatedAt
          type
          seatLabel
          seatZone
          seatSection
          seatTags
          price
          originalPrice
          taxRate
          taxAmount
          quantity
          name
          type
          ticketFeeAmount
          ticketType {
            name
            id
          }
          membershipType {
            id
            membership {
              name
            }
          }
        }
      }
    }
    promoCode {
      ... on EventPromoCode {
        __typename
        id
        code
        discountType
        discountAmount
        eventType: type
      }
      ... on MembershipPromoCode {
        __typename
        id
        code
        discountType
        discountAmount
        membershipType: type
      }
    }
    createdAt
    updatedAt
  }
}
    ${AddressFragmentFragmentDoc}`;
export const PosSalesOverviewDocument = gql`
    query posSalesOverview($eventId: String!, $posId: String, $sessionId: String) {
  posSalesOverview(eventId: $eventId, posId: $posId, sessionId: $sessionId) {
    soldAtTheDoor
    soldOnline
    scannedPercentage
    average
    perHour
    orders
  }
}
    `;
export const PosSessionsDocument = gql`
    query posSessions($posId: String!) {
  posSessions(posId: $posId) {
    id
    startedAt
    endedAt
    startCash
    endCash
    operator {
      fullName
    }
  }
}
    `;
export const PosUsersDocument = gql`
    query posUsers($eventId: String!) {
  posUsers(eventId: $eventId) {
    id
    firstName
    lastName
    fullName
    companyName
    email
    createdAt
    updatedAt
  }
}
    `;
export const TerminalsDocument = gql`
    query terminals($eventId: String!) {
  poses(eventId: $eventId) {
    id
    name
  }
}
    `;
export const PreviousMembershipCountDocument = gql`
    query previousMembershipCount($id: String!) {
  previousMembershipCount(id: $id)
}
    `;
export const PurchasingDaysBreakdownDocument = gql`
    query purchasingDaysBreakdown($source: ReportingFilterSource!, $sourceId: String, $release: String, $startDate: DateTime!, $endDate: DateTime!, $tagId: String) {
  purchasingDaysBreakdown(source: $source, sourceId: $sourceId, release: $release, startDate: $startDate, endDate: $endDate, tagId: $tagId) {
    range
    value
  }
}
    `;
export const ReleaseDocument = gql`
    query release($id: String!) {
  release(id: $id) {
    ...ReleaseFragment
  }
}
    ${ReleaseFragmentFragmentDoc}`;
export const ReleasesDocument = gql`
    query releases($event: String!) {
  releases(event: $event) {
    id
    name
    type
    isActive
    startCondition
    startConditionDate
    endCondition
    endConditionDate
    endConditionQuantity
    slug
    canBeHardDeleted
    allowHoldOrders
  }
}
    `;
export const SalesChannelGraphDocument = gql`
    query salesChannelGraph($source: PointReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String) {
  salesChannelGraph(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release) {
    transactions
    online
    backOffice
    pos
  }
}
    `;
export const SalesGraphDocument = gql`
    query salesGraph($source: PointReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $type: GraphFilterType, $release: String) {
  salesGraph(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, type: $type, release: $release) {
    dates {
      date
      items {
        name
        value
      }
    }
  }
}
    `;
export const SalesOverviewDocument = gql`
    query salesOverview($source: PointReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String) {
  salesOverview(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release) {
    ticketsSold
    membershipsSold
    addonsSold
    orders
    cartAbandonment
    returningCustomers
    ticketsPaid
    ticketsComp
    ticketsTransferred
    packagesSold
    pointsDistributed
    membershipsRenewed
    ticketCoverOrdersSold
    ticketCoverTicketsSold
  }
}
    `;
export const ScanTicketTypesDocument = gql`
    query scanTicketTypes($eventId: String!) {
  scanTicketTypes(eventId: $eventId) {
    identifier
    items {
      name
      value
    }
  }
}
    `;
export const ScanVisitorsDocument = gql`
    query scanVisitors($eventId: String!) {
  scanVisitors(eventId: $eventId) {
    identifier
    items {
      name
      value
    }
  }
}
    `;
export const ScanVisitorsOverTimeDocument = gql`
    query scanVisitorsOverTime($eventId: String!) {
  scanVisitorsOverTime(eventId: $eventId) {
    start
    end
    value
  }
}
    `;
export const ScoutDocument = gql`
    query scout($id: String!) {
  scout(id: $id) {
    id
    isActive
    name
    purpose
    createdAt
    updatedAt
    trackSource
    trackSourceId
    trackReleaseId
    promoteTo {
      ...ScoutFilterSelection
    }
    exclude {
      ...ScoutFilterSelection
    }
    includeOptedOutOfMarketing
  }
}
    ${ScoutFilterSelectionFragmentDoc}`;
export const ScoutAgentsDocument = gql`
    query scoutAgents {
  users(where: {roles: [Admin, Sales]}) {
    edges {
      node {
        id
        fullName
      }
    }
  }
}
    `;
export const ScoutCampaignCustomerLocationsDocument = gql`
    query scoutCampaignCustomerLocations($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $scoutCommunicationId: String) {
  scoutCampaignCustomerLocations(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, scoutCommunicationId: $scoutCommunicationId) {
    city
    count
    amount
  }
}
    `;
export const ScoutCampaignGenderBreakdownDocument = gql`
    query scoutCampaignGenderBreakdown($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $scoutCommunicationId: String) {
  scoutCampaignGenderBreakdown(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, scoutCommunicationId: $scoutCommunicationId) {
    male
    female
    other
  }
}
    `;
export const ScoutCampaignHighestValueCustomersDocument = gql`
    query scoutCampaignHighestValueCustomers($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $scoutCommunicationId: String) {
  scoutCampaignHighestValueCustomers(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, scoutCommunicationId: $scoutCommunicationId) {
    name
    value
    userId
  }
}
    `;
export const ScoutCampaignOverviewDocument = gql`
    query scoutCampaignOverview($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $scoutCommunicationId: String) {
  scoutCampaignOverview(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, scoutCommunicationId: $scoutCommunicationId) {
    ticketsSold
    membershipsSold
    addonsSold
    orders
    cartAbandonment
    returningCustomers
    ticketsPaid
    ticketsComp
    campaignSize
    contactRate
    conversionRate
    totalRevenue
    todayRevenue
    emailOpenRate
    emailClickRate
  }
}
    `;
export const ScoutCampaignTopTagsDocument = gql`
    query scoutCampaignTopTags($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $scoutCommunicationId: String) {
  scoutCampaignTopTags(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, scoutCommunicationId: $scoutCommunicationId) {
    tag
    count
  }
}
    `;
export const ScoutCommunicationDocument = gql`
    query scoutCommunication($id: String!) {
  scoutCommunication(id: $id) {
    id
    createdAt
    scout {
      id
      name
    }
    campaign {
      id
      name
    }
    type
    data
    name
    purpose
    includeOptedOutOfMarketing
    trackSource
    trackSourceId
    trackReleaseId
    scheduledAt
    shouldUpdate
    isActive
    count
    message
    listId
    templateId
    subject
    link
  }
}
    `;
export const ScoutCommunicationUserDocument = gql`
    query scoutCommunicationUser($id: String!) {
  scoutCommunicationUser(id: $id) {
    id
    stage
    remindAt
    createdAt
    updatedAt
    user {
      ...UserFragment
      tags {
        id
        name
      }
      scoutCommunications {
        id
        name
        purpose
        createdAt
        updatedAt
      }
    }
    history {
      ...HistoryConnection
    }
  }
}
    ${UserFragmentFragmentDoc}
${HistoryConnectionFragmentDoc}`;
export const ScoutCommunicationUsersDocument = gql`
    query scoutCommunicationUsers($before: String, $after: String, $first: Int, $last: Int, $id: String!, $hasPhoneNumber: Boolean, $where: UserWhereInput, $stage: [ScoutStage!], $agentUserId: String) {
  scoutCommunicationUsers(before: $before, after: $after, first: $first, last: $last, id: $id, hasPhoneNumber: $hasPhoneNumber, where: $where, stage: $stage, agentUserId: $agentUserId) {
    edges {
      node {
        id
        createdAt
        stage
        user {
          id
          fullName
          email
        }
        agentUser {
          id
          fullName
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const ScoutCommunicationsDocument = gql`
    query scoutCommunications($input: ScoutCommunicationsInput!) {
  scoutCommunications(input: $input) {
    id
    type
    createdAt
    scheduledAt
    processedAt
    count
    name
    conversions
    data
    isActive
  }
}
    `;
export const InitScoutDocument = gql`
    query initScout {
  initScout {
    seasons {
      id
      name
    }
    membershipTypes {
      id
      name
    }
    events {
      id
      title
      releases {
        id
        name
      }
    }
    userTags {
      id
      name
    }
    zones {
      id
      name
    }
  }
}
    `;
export const ScoutUserRemindersDocument = gql`
    query scoutUserReminders {
  scoutUserReminders {
    id
    stage
    scoutCommunication {
      id
      name
    }
    user {
      fullName
    }
    remindAt
  }
}
    `;
export const ScoutUsersDocument = gql`
    query scoutUsers($id: String!, $stage: [ScoutStage!], $before: String, $after: String, $first: Int, $last: Int, $where: UserWhereInput, $hasPhoneNumber: Boolean, $agentUserId: String) {
  scoutUsers(id: $id, stage: $stage, before: $before, after: $after, first: $first, last: $last, where: $where, hasPhoneNumber: $hasPhoneNumber, agentUserId: $agentUserId) {
    edges {
      node {
        id
        stage
        user {
          id
          firstName
          lastName
          fullName
          companyName
          email
          createdAt
          updatedAt
        }
        agentUser {
          id
          fullName
          email
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const ScoutsDocument = gql`
    query scouts($input: FindScoutsInput) {
  scouts(input: $input) {
    id
    isActive
    name
    purpose
    total
    createdAt
    updatedAt
  }
}
    `;
export const SeasonDocument = gql`
    query season($id: String!) {
  season(id: $id) {
    ...SeasonFragment
  }
}
    ${SeasonFragmentFragmentDoc}`;
export const SeasonsDocument = gql`
    query seasons {
  seasons {
    ...SeasonFragment
  }
}
    ${SeasonFragmentFragmentDoc}`;
export const SeatsEventKeyDocument = gql`
    query seatsEventKey($id: String!) {
  event(id: $id) {
    seatsEventKey
  }
}
    `;
export const SocialMentionsDocument = gql`
    query socialMentions($before: String, $after: String, $first: Int, $last: Int, $where: SocialWhereInput) {
  socialMentions(before: $before, after: $after, first: $first, last: $last, where: $where) {
    edges {
      node {
        id
        createdAt
        type
        content
        url
        user {
          id
          firstName
          lastName
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const SummaryOverviewDocument = gql`
    query summaryOverview($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String) {
  summaryOverview(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release) {
    ticketsSold
    membershipsSold
    addonsSold
    orders
    cartAbandonment
    returningCustomers
    ticketsPaid
    ticketsComp
    totalRevenue
    todayRevenue
    yesterdayRevenue
    ticketsSoldToday
    ticketsSoldYesterday
    membershipsRenewed
  }
}
    `;
export const TagsDocument = gql`
    query tags {
  tags {
    ...TagFragment
  }
}
    ${TagFragmentFragmentDoc}`;
export const TicketDocument = gql`
    query ticket($id: String!) {
  ticket(id: $id) {
    ...Ticket
    addon {
      __typename
      ... on EventAddon {
        name
        id
        namingFields {
          field
          isRequired
        }
      }
      ... on MembershipAddon {
        id
        name
        namingFields {
          field
          isRequired
        }
      }
    }
    membershipType {
      membership {
        id
        membershipKind
        endDate
        renewalMembership {
          id
        }
      }
      namingFields {
        field
        isRequired
      }
    }
    ticketType {
      namingFields {
        field
        isRequired
      }
    }
    event {
      title
      eventKind
      startDate
      ticketsViewableFromDate
      venue {
        name
        address {
          city
        }
        zones {
          name
          stand
        }
        gates {
          name
          id
        }
      }
      zonesAllocatedGates {
        name
      }
    }
    membership {
      name
      membershipKind
      startDate
      venue {
        name
        address {
          city
        }
        zones {
          name
          stand
        }
        gates {
          name
          id
        }
      }
    }
  }
}
    ${TicketFragmentDoc}`;
export const TicketTypesDocument = gql`
    query ticketTypes($eventId: String!) {
  ticketTypes(eventId: $eventId) {
    id
    name
  }
}
    `;
export const TimeOfDayBreakdownDocument = gql`
    query timeOfDayBreakdown($source: ReportingFilterSource!, $sourceId: String, $release: String, $startDate: DateTime!, $endDate: DateTime!, $tagId: String) {
  timeOfDayBreakdown(source: $source, sourceId: $sourceId, release: $release, startDate: $startDate, endDate: $endDate, tagId: $tagId) {
    range
    value
  }
}
    `;
export const TopReferrersDocument = gql`
    query topReferrers($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String, $tagId: String) {
  topReferrers(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release, tagId: $tagId) {
    name
    count
    userId
  }
}
    `;
export const TopRepeatPurchasersDocument = gql`
    query topRepeatPurchasers($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String, $tagId: String) {
  topRepeatPurchasers(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release, tagId: $tagId) {
    name
    count
    userId
  }
}
    `;
export const TopTagsDocument = gql`
    query topTags($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String, $tagId: String) {
  topTags(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release, tagId: $tagId) {
    tag
    count
  }
}
    `;
export const TransferredMembershipTicketsForOrderDocument = gql`
    query transferredMembershipTicketsForOrder($id: String!) {
  transferredMembershipTicketsForOrder(orderId: $id) {
    id
    lineItem {
      id
    }
    transferFee {
      type
      fee
    }
  }
}
    `;
export const UploadImageDocument = gql`
    mutation uploadImage($file: ImportInput!) {
  uploadImage(file: $file)
}
    `;
export const UserDocument = gql`
    query user($id: String!) {
  user(id: $id) {
    ...UserFragment
    orders {
      edges {
        node {
          id
          createdAt
          orderNumber
          status
          isComp
          total
          membership {
            name
          }
          event {
            title
          }
          user {
            fullName
          }
        }
      }
    }
    tags {
      id
      name
    }
    accessEventIds
    accessMembershipIds
  }
}
    ${UserFragmentFragmentDoc}`;
export const UserEventTicketsDocument = gql`
    query userEventTickets($id: String!) {
  user(id: $id) {
    id
    firstName
    lastName
    fullName
    eventTickets {
      id
      seatLabel
      seatZone
      seatSection
      seatTags
      isNamed
      firstName
      lastName
      birthDate
      email
      phoneNumber
      postalCode
      gender
      event {
        title
      }
      shouldBeNamed
    }
  }
}
    `;
export const UserMembershipTicketsDocument = gql`
    query userMembershipTickets($id: String!) {
  user(id: $id) {
    membershipTickets {
      id
      seatLabel
      seatZone
      seatSection
      seatTags
      isNamed
      firstName
      lastName
      birthDate
      email
      phoneNumber
      postalCode
      gender
      hasRenewedMembership
      hasReleasedNextMembershipClaim
      shouldBeNamed
      membershipType {
        id
        name
      }
      membership {
        name
        startDate
        endDate
        renewalMembership {
          id
          name
          addons {
            id
            name
            price
          }
        }
      }
    }
  }
}
    `;
export const UsersDocument = gql`
    query users($before: String, $after: String, $first: Int, $last: Int, $where: UserWhereInput, $orderBy: UserOrderByInput) {
  users(before: $before, after: $after, first: $first, last: $last, where: $where, orderBy: $orderBy) {
    edges {
      node {
        id
        firstName
        lastName
        fullName
        companyName
        email
        phoneNumber
        createdAt
        updatedAt
        roles
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;
export const UserOrdersDocument = gql`
    query userOrders($id: String!) {
  user(id: $id) {
    id
    firstName
    lastName
    fullName
    orders {
      edges {
        node {
          id
          orderNumber
          status
          transactionStatus
          total
          refundedAmount
          createdAt
          hardCopyTicketsPrinted
          status
          isComp
          buyerInformation {
            firstName
            lastName
          }
          event {
            title
          }
          membership {
            name
          }
        }
      }
    }
  }
}
    `;
export const VenueDocument = gql`
    query venue($id: String!) {
  venue(id: $id) {
    ...VenueFragment
  }
}
    ${VenueFragmentFragmentDoc}`;
export const VenueSeatsThumbnailDocument = gql`
    query venueSeatsThumbnail($id: String!) {
  venueSeatsThumbnail(id: $id)
}
    `;
export const VenuesDocument = gql`
    query venues {
  venues {
    id
    name
    seating
  }
}
    `;
export const WaitlistOverviewDocument = gql`
    query waitlistOverview($source: ReportingFilterSource!, $sourceId: String, $channel: OrderChannel, $startDate: DateTime!, $endDate: DateTime!, $release: String) {
  waitlistOverview(source: $source, sourceId: $sourceId, channel: $channel, startDate: $startDate, endDate: $endDate, release: $release) {
    totalCustomers
    totalNewCustomers
    totalReturningCustomers
    customersOptedIntoMarketing
    totalRevenue
    numberOfOrders
    numberOfSuccesfulUsers
    numberOfTickets
    yetToConvert
  }
}
    `;
export const ShopifyDisableIntegrationDocument = gql`
    query shopifyDisableIntegration {
  disableShopifyIntegration
}
    `;
export const ShopifyCustomerOrdersDocument = gql`
    query shopifyCustomerOrders($customerId: String!) {
  customerOrders(customerId: $customerId) {
    id
    total
    currencyCode
    lineItems {
      id
      title
      quantity
    }
  }
}
    `;
export const CompleteShopifySetupDocument = gql`
    mutation completeShopifySetup($input: ShopifySetupInput!) {
  completeShopifySetup(input: $input)
}
    `;
export const MyLoggedInOrganizationsDocument = gql`
    query myLoggedInOrganizations {
  myLoggedInOrganizations {
    slug
    logoUrl
    isLinked
  }
}
    `;
export const XeroConsentUrlQueryDocument = gql`
    query xeroConsentUrlQuery {
  getConsentUrl
}
    `;
export const XeroEnableIntegrationMutationDocument = gql`
    mutation xeroEnableIntegrationMutation($input: XeroCallbackInput!) {
  enableXeroIntegration(input: $input)
}
    `;
export const XeroDisableIntegrationQueryDocument = gql`
    query xeroDisableIntegrationQuery {
  disableXeroIntegration
}
    `;
export const GetXeroCurrentAccountCodeQueryDocument = gql`
    query getXeroCurrentAccountCodeQuery {
  getCurrentAccountCode
}
    `;
export const GetXeroAccountsQueryDocument = gql`
    query getXeroAccountsQuery {
  getXeroAccounts {
    currentAccountCode
    availableAccounts {
      accountId
      name
      code
    }
  }
}
    `;
export const SetXeroAccountCodeMutationDocument = gql`
    mutation setXeroAccountCodeMutation($accountCode: String!) {
  setXeroAccountCode(accountCode: $accountCode)
}
    `;

export type SdkFunctionWrapper = <T>(action: () => Promise<T>) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = sdkFunction => sdkFunction();
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    audienceCount(variables: AudienceCountQueryVariables): Promise<AudienceCountQuery> {
      return withWrapper(() => client.request<AudienceCountQuery>(print(AudienceCountDocument), variables));
    },
    broadcast(variables: BroadcastQueryVariables): Promise<BroadcastQuery> {
      return withWrapper(() => client.request<BroadcastQuery>(print(BroadcastDocument), variables));
    },
    broadcastBounces(variables: BroadcastBouncesQueryVariables): Promise<BroadcastBouncesQuery> {
      return withWrapper(() => client.request<BroadcastBouncesQuery>(print(BroadcastBouncesDocument), variables));
    },
    broadcastReportStats(variables: BroadcastReportStatsQueryVariables): Promise<BroadcastReportStatsQuery> {
      return withWrapper(() => client.request<BroadcastReportStatsQuery>(print(BroadcastReportStatsDocument), variables));
    },
    broadcasts(variables?: BroadcastsQueryVariables): Promise<BroadcastsQuery> {
      return withWrapper(() => client.request<BroadcastsQuery>(print(BroadcastsDocument), variables));
    },
    deleteBroadcast(variables: DeleteBroadcastMutationVariables): Promise<DeleteBroadcastMutation> {
      return withWrapper(() => client.request<DeleteBroadcastMutation>(print(DeleteBroadcastDocument), variables));
    },
    marketingUserCount(variables: MarketingUserCountQueryVariables): Promise<MarketingUserCountQuery> {
      return withWrapper(() => client.request<MarketingUserCountQuery>(print(MarketingUserCountDocument), variables));
    },
    sendBroadcast(variables: SendBroadcastMutationVariables): Promise<SendBroadcastMutation> {
      return withWrapper(() => client.request<SendBroadcastMutation>(print(SendBroadcastDocument), variables));
    },
    competition(variables: CompetitionQueryVariables): Promise<CompetitionQuery> {
      return withWrapper(() => client.request<CompetitionQuery>(print(CompetitionDocument), variables));
    },
    competitions(variables: CompetitionsQueryVariables): Promise<CompetitionsQuery> {
      return withWrapper(() => client.request<CompetitionsQuery>(print(CompetitionsDocument), variables));
    },
    createCompetition(variables: CreateCompetitionMutationVariables): Promise<CreateCompetitionMutation> {
      return withWrapper(() => client.request<CreateCompetitionMutation>(print(CreateCompetitionDocument), variables));
    },
    deleteCompetition(variables: DeleteCompetitionMutationVariables): Promise<DeleteCompetitionMutation> {
      return withWrapper(() => client.request<DeleteCompetitionMutation>(print(DeleteCompetitionDocument), variables));
    },
    unpublishCompetition(variables: UnpublishCompetitionMutationVariables): Promise<UnpublishCompetitionMutation> {
      return withWrapper(() => client.request<UnpublishCompetitionMutation>(print(UnpublishCompetitionDocument), variables));
    },
    updateAndPublishCompetition(variables: UpdateAndPublishCompetitionMutationVariables): Promise<UpdateAndPublishCompetitionMutation> {
      return withWrapper(() => client.request<UpdateAndPublishCompetitionMutation>(print(UpdateAndPublishCompetitionDocument), variables));
    },
    updateCompetition(variables: UpdateCompetitionMutationVariables): Promise<UpdateCompetitionMutation> {
      return withWrapper(() => client.request<UpdateCompetitionMutation>(print(UpdateCompetitionDocument), variables));
    },
    eventDetails(variables: EventDetailsQueryVariables): Promise<EventDetailsQuery> {
      return withWrapper(() => client.request<EventDetailsQuery>(print(EventDetailsDocument), variables));
    },
    eventsList(variables?: EventsListQueryVariables): Promise<EventsListQuery> {
      return withWrapper(() => client.request<EventsListQuery>(print(EventsListDocument), variables));
    },
    createReleaseZone(variables: CreateReleaseZoneMutationVariables): Promise<CreateReleaseZoneMutation> {
      return withWrapper(() => client.request<CreateReleaseZoneMutation>(print(CreateReleaseZoneDocument), variables));
    },
    updateReleaseZone(variables: UpdateReleaseZoneMutationVariables): Promise<UpdateReleaseZoneMutation> {
      return withWrapper(() => client.request<UpdateReleaseZoneMutation>(print(UpdateReleaseZoneDocument), variables));
    },
    eventWithListedRelease(variables: EventWithListedReleaseQueryVariables): Promise<EventWithListedReleaseQuery> {
      return withWrapper(() => client.request<EventWithListedReleaseQuery>(print(EventWithListedReleaseDocument), variables));
    },
    dashboardEvents(variables?: DashboardEventsQueryVariables): Promise<DashboardEventsQuery> {
      return withWrapper(() => client.request<DashboardEventsQuery>(print(DashboardEventsDocument), variables));
    },
    membershipDetails(variables: MembershipDetailsQueryVariables): Promise<MembershipDetailsQuery> {
      return withWrapper(() => client.request<MembershipDetailsQuery>(print(MembershipDetailsDocument), variables));
    },
    membershipsList(variables?: MembershipsListQueryVariables): Promise<MembershipsListQuery> {
      return withWrapper(() => client.request<MembershipsListQuery>(print(MembershipsListDocument), variables));
    },
    eventsListWithSeasons(variables?: EventsListWithSeasonsQueryVariables): Promise<EventsListWithSeasonsQuery> {
      return withWrapper(() => client.request<EventsListWithSeasonsQuery>(print(EventsListWithSeasonsDocument), variables));
    },
    createPointItem(variables: CreatePointItemMutationVariables): Promise<CreatePointItemMutation> {
      return withWrapper(() => client.request<CreatePointItemMutation>(print(CreatePointItemDocument), variables));
    },
    updatePoint(variables: UpdatePointMutationVariables): Promise<UpdatePointMutation> {
      return withWrapper(() => client.request<UpdatePointMutation>(print(UpdatePointDocument), variables));
    },
    updatePointItem(variables: UpdatePointItemMutationVariables): Promise<UpdatePointItemMutation> {
      return withWrapper(() => client.request<UpdatePointItemMutation>(print(UpdatePointItemDocument), variables));
    },
    updatePoints(variables: UpdatePointsMutationVariables): Promise<UpdatePointsMutation> {
      return withWrapper(() => client.request<UpdatePointsMutation>(print(UpdatePointsDocument), variables));
    },
    pointWithItems(variables?: PointWithItemsQueryVariables): Promise<PointWithItemsQuery> {
      return withWrapper(() => client.request<PointWithItemsQuery>(print(PointWithItemsDocument), variables));
    },
    referralPromotionReportStats(variables: ReferralPromotionReportStatsQueryVariables): Promise<ReferralPromotionReportStatsQuery> {
      return withWrapper(() => client.request<ReferralPromotionReportStatsQuery>(print(ReferralPromotionReportStatsDocument), variables));
    },
    eventsListUseParams(variables?: EventsListUseParamsQueryVariables): Promise<EventsListUseParamsQuery> {
      return withWrapper(() => client.request<EventsListUseParamsQuery>(print(EventsListUseParamsDocument), variables));
    },
    membershipsListUseParams(variables?: MembershipsListUseParamsQueryVariables): Promise<MembershipsListUseParamsQuery> {
      return withWrapper(() => client.request<MembershipsListUseParamsQuery>(print(MembershipsListUseParamsDocument), variables));
    },
    releasesListUseParamas(variables: ReleasesListUseParamasQueryVariables): Promise<ReleasesListUseParamasQuery> {
      return withWrapper(() => client.request<ReleasesListUseParamasQuery>(print(ReleasesListUseParamasDocument), variables));
    },
    upsertAdobeIntegration(variables: UpsertAdobeIntegrationMutationVariables): Promise<UpsertAdobeIntegrationMutation> {
      return withWrapper(() => client.request<UpsertAdobeIntegrationMutation>(print(UpsertAdobeIntegrationDocument), variables));
    },
    deleteAdobeIntegration(variables?: DeleteAdobeIntegrationQueryVariables): Promise<DeleteAdobeIntegrationQuery> {
      return withWrapper(() => client.request<DeleteAdobeIntegrationQuery>(print(DeleteAdobeIntegrationDocument), variables));
    },
    adobeIntegration(variables?: AdobeIntegrationQueryVariables): Promise<AdobeIntegrationQuery> {
      return withWrapper(() => client.request<AdobeIntegrationQuery>(print(AdobeIntegrationDocument), variables));
    },
    addForecastScenario(variables: AddForecastScenarioMutationVariables): Promise<AddForecastScenarioMutation> {
      return withWrapper(() => client.request<AddForecastScenarioMutation>(print(AddForecastScenarioDocument), variables));
    },
    assignScoutCommunicationUsersToAgent(variables: AssignScoutCommunicationUsersToAgentMutationVariables): Promise<AssignScoutCommunicationUsersToAgentMutation> {
      return withWrapper(() => client.request<AssignScoutCommunicationUsersToAgentMutation>(print(AssignScoutCommunicationUsersToAgentDocument), variables));
    },
    assignTwoFactorAuthenticationSecret(variables?: AssignTwoFactorAuthenticationSecretMutationVariables): Promise<AssignTwoFactorAuthenticationSecretMutation> {
      return withWrapper(() => client.request<AssignTwoFactorAuthenticationSecretMutation>(print(AssignTwoFactorAuthenticationSecretDocument), variables));
    },
    authenticateWithTwoFactor(variables: AuthenticateWithTwoFactorMutationVariables): Promise<AuthenticateWithTwoFactorMutation> {
      return withWrapper(() => client.request<AuthenticateWithTwoFactorMutation>(print(AuthenticateWithTwoFactorDocument), variables));
    },
    cancelOrder(variables: CancelOrderMutationVariables): Promise<CancelOrderMutation> {
      return withWrapper(() => client.request<CancelOrderMutation>(print(CancelOrderDocument), variables));
    },
    completePreprintTicketOrder(variables: CompletePreprintTicketOrderMutationVariables): Promise<CompletePreprintTicketOrderMutation> {
      return withWrapper(() => client.request<CompletePreprintTicketOrderMutation>(print(CompletePreprintTicketOrderDocument), variables));
    },
    createAutomation(variables: CreateAutomationMutationVariables): Promise<CreateAutomationMutation> {
      return withWrapper(() => client.request<CreateAutomationMutation>(print(CreateAutomationDocument), variables));
    },
    createBulkOrders(variables: CreateBulkOrdersMutationVariables): Promise<CreateBulkOrdersMutation> {
      return withWrapper(() => client.request<CreateBulkOrdersMutation>(print(CreateBulkOrdersDocument), variables));
    },
    createEvent(variables: CreateEventMutationVariables): Promise<CreateEventMutation> {
      return withWrapper(() => client.request<CreateEventMutation>(print(CreateEventDocument), variables));
    },
    createEventAddon(variables: CreateEventAddonMutationVariables): Promise<CreateEventAddonMutation> {
      return withWrapper(() => client.request<CreateEventAddonMutation>(print(CreateEventAddonDocument), variables));
    },
    createEventMultiBuyPromotion(variables: CreateEventMultiBuyPromotionMutationVariables): Promise<CreateEventMultiBuyPromotionMutation> {
      return withWrapper(() => client.request<CreateEventMultiBuyPromotionMutation>(print(CreateEventMultiBuyPromotionDocument), variables));
    },
    createEventPromoCode(variables: CreateEventPromoCodeMutationVariables): Promise<CreateEventPromoCodeMutation> {
      return withWrapper(() => client.request<CreateEventPromoCodeMutation>(print(CreateEventPromoCodeDocument), variables));
    },
    createHistory(variables: CreateHistoryMutationVariables): Promise<CreateHistoryMutation> {
      return withWrapper(() => client.request<CreateHistoryMutation>(print(CreateHistoryDocument), variables));
    },
    createIntegration(variables: CreateIntegrationMutationVariables): Promise<CreateIntegrationMutation> {
      return withWrapper(() => client.request<CreateIntegrationMutation>(print(CreateIntegrationDocument), variables));
    },
    createMembership(variables: CreateMembershipMutationVariables): Promise<CreateMembershipMutation> {
      return withWrapper(() => client.request<CreateMembershipMutation>(print(CreateMembershipDocument), variables));
    },
    createMembershipAddon(variables: CreateMembershipAddonMutationVariables): Promise<CreateMembershipAddonMutation> {
      return withWrapper(() => client.request<CreateMembershipAddonMutation>(print(CreateMembershipAddonDocument), variables));
    },
    createMembershipMultiBuyPromotion(variables: CreateMembershipMultiBuyPromotionMutationVariables): Promise<CreateMembershipMultiBuyPromotionMutation> {
      return withWrapper(() => client.request<CreateMembershipMultiBuyPromotionMutation>(print(CreateMembershipMultiBuyPromotionDocument), variables));
    },
    createMembershipPromoCode(variables: CreateMembershipPromoCodeMutationVariables): Promise<CreateMembershipPromoCodeMutation> {
      return withWrapper(() => client.request<CreateMembershipPromoCodeMutation>(print(CreateMembershipPromoCodeDocument), variables));
    },
    createMembershipType(variables: CreateMembershipTypeMutationVariables): Promise<CreateMembershipTypeMutation> {
      return withWrapper(() => client.request<CreateMembershipTypeMutation>(print(CreateMembershipTypeDocument), variables));
    },
    createOrder(variables: CreateOrderMutationVariables): Promise<CreateOrderMutation> {
      return withWrapper(() => client.request<CreateOrderMutation>(print(CreateOrderDocument), variables));
    },
    createOrganization(variables: CreateOrganizationMutationVariables): Promise<CreateOrganizationMutation> {
      return withWrapper(() => client.request<CreateOrganizationMutation>(print(CreateOrganizationDocument), variables));
    },
    createPos(variables: CreatePosMutationVariables): Promise<CreatePosMutation> {
      return withWrapper(() => client.request<CreatePosMutation>(print(CreatePosDocument), variables));
    },
    createPosUser(variables: CreatePosUserMutationVariables): Promise<CreatePosUserMutation> {
      return withWrapper(() => client.request<CreatePosUserMutation>(print(CreatePosUserDocument), variables));
    },
    createPurchaseRestriction(variables: CreatePurchaseRestrictionMutationVariables): Promise<CreatePurchaseRestrictionMutation> {
      return withWrapper(() => client.request<CreatePurchaseRestrictionMutation>(print(CreatePurchaseRestrictionDocument), variables));
    },
    createReferralCampaign(variables: CreateReferralCampaignMutationVariables): Promise<CreateReferralCampaignMutation> {
      return withWrapper(() => client.request<CreateReferralCampaignMutation>(print(CreateReferralCampaignDocument), variables));
    },
    createRefund(variables: CreateRefundMutationVariables): Promise<CreateRefundMutation> {
      return withWrapper(() => client.request<CreateRefundMutation>(print(CreateRefundDocument), variables));
    },
    createRelease(variables: CreateReleaseMutationVariables): Promise<CreateReleaseMutation> {
      return withWrapper(() => client.request<CreateReleaseMutation>(print(CreateReleaseDocument), variables));
    },
    createScout(variables: CreateScoutMutationVariables): Promise<CreateScoutMutation> {
      return withWrapper(() => client.request<CreateScoutMutation>(print(CreateScoutDocument), variables));
    },
    createScoutCommunication(variables: CreateScoutCommunicationMutationVariables): Promise<CreateScoutCommunicationMutation> {
      return withWrapper(() => client.request<CreateScoutCommunicationMutation>(print(CreateScoutCommunicationDocument), variables));
    },
    createSeason(variables: CreateSeasonMutationVariables): Promise<CreateSeasonMutation> {
      return withWrapper(() => client.request<CreateSeasonMutation>(print(CreateSeasonDocument), variables));
    },
    createTag(variables: CreateTagMutationVariables): Promise<CreateTagMutation> {
      return withWrapper(() => client.request<CreateTagMutation>(print(CreateTagDocument), variables));
    },
    createTemporaryPosUser(variables: CreateTemporaryPosUserMutationVariables): Promise<CreateTemporaryPosUserMutation> {
      return withWrapper(() => client.request<CreateTemporaryPosUserMutation>(print(CreateTemporaryPosUserDocument), variables));
    },
    createTicketType(variables: CreateTicketTypeMutationVariables): Promise<CreateTicketTypeMutation> {
      return withWrapper(() => client.request<CreateTicketTypeMutation>(print(CreateTicketTypeDocument), variables));
    },
    createUser(variables: CreateUserMutationVariables): Promise<CreateUserMutation> {
      return withWrapper(() => client.request<CreateUserMutation>(print(CreateUserDocument), variables));
    },
    createVenue(variables: CreateVenueMutationVariables): Promise<CreateVenueMutation> {
      return withWrapper(() => client.request<CreateVenueMutation>(print(CreateVenueDocument), variables));
    },
    deleteEventAddon(variables: DeleteEventAddonMutationVariables): Promise<DeleteEventAddonMutation> {
      return withWrapper(() => client.request<DeleteEventAddonMutation>(print(DeleteEventAddonDocument), variables));
    },
    deleteEventMultiBuyPromotion(variables: DeleteEventMultiBuyPromotionMutationVariables): Promise<DeleteEventMultiBuyPromotionMutation> {
      return withWrapper(() => client.request<DeleteEventMultiBuyPromotionMutation>(print(DeleteEventMultiBuyPromotionDocument), variables));
    },
    deleteEventPromoCode(variables: DeleteEventPromoCodeMutationVariables): Promise<DeleteEventPromoCodeMutation> {
      return withWrapper(() => client.request<DeleteEventPromoCodeMutation>(print(DeleteEventPromoCodeDocument), variables));
    },
    deleteForecastScenario(variables: DeleteForecastScenarioMutationVariables): Promise<DeleteForecastScenarioMutation> {
      return withWrapper(() => client.request<DeleteForecastScenarioMutation>(print(DeleteForecastScenarioDocument), variables));
    },
    deleteMembershipAddon(variables: DeleteMembershipAddonMutationVariables): Promise<DeleteMembershipAddonMutation> {
      return withWrapper(() => client.request<DeleteMembershipAddonMutation>(print(DeleteMembershipAddonDocument), variables));
    },
    deleteMembershipMultiBuyPromotion(variables: DeleteMembershipMultiBuyPromotionMutationVariables): Promise<DeleteMembershipMultiBuyPromotionMutation> {
      return withWrapper(() => client.request<DeleteMembershipMultiBuyPromotionMutation>(print(DeleteMembershipMultiBuyPromotionDocument), variables));
    },
    deleteMembershipPromoCode(variables: DeleteMembershipPromoCodeMutationVariables): Promise<DeleteMembershipPromoCodeMutation> {
      return withWrapper(() => client.request<DeleteMembershipPromoCodeMutation>(print(DeleteMembershipPromoCodeDocument), variables));
    },
    deleteMembershipType(variables: DeleteMembershipTypeMutationVariables): Promise<DeleteMembershipTypeMutation> {
      return withWrapper(() => client.request<DeleteMembershipTypeMutation>(print(DeleteMembershipTypeDocument), variables));
    },
    deletePurchaseRestriction(variables: DeletePurchaseRestrictionMutationVariables): Promise<DeletePurchaseRestrictionMutation> {
      return withWrapper(() => client.request<DeletePurchaseRestrictionMutation>(print(DeletePurchaseRestrictionDocument), variables));
    },
    deleteRelease(variables: DeleteReleaseMutationVariables): Promise<DeleteReleaseMutation> {
      return withWrapper(() => client.request<DeleteReleaseMutation>(print(DeleteReleaseDocument), variables));
    },
    deleteScoutUsers(variables: DeleteScoutUsersMutationVariables): Promise<DeleteScoutUsersMutation> {
      return withWrapper(() => client.request<DeleteScoutUsersMutation>(print(DeleteScoutUsersDocument), variables));
    },
    deleteTag(variables: DeleteTagMutationVariables): Promise<DeleteTagMutation> {
      return withWrapper(() => client.request<DeleteTagMutation>(print(DeleteTagDocument), variables));
    },
    deleteTicketType(variables: DeleteTicketTypeMutationVariables): Promise<DeleteTicketTypeMutation> {
      return withWrapper(() => client.request<DeleteTicketTypeMutation>(print(DeleteTicketTypeDocument), variables));
    },
    deleteUser(variables: DeleteUserMutationVariables): Promise<DeleteUserMutation> {
      return withWrapper(() => client.request<DeleteUserMutation>(print(DeleteUserDocument), variables));
    },
    deleteVenue(variables: DeleteVenueMutationVariables): Promise<DeleteVenueMutation> {
      return withWrapper(() => client.request<DeleteVenueMutation>(print(DeleteVenueDocument), variables));
    },
    duplicateEvent(variables: DuplicateEventMutationVariables): Promise<DuplicateEventMutation> {
      return withWrapper(() => client.request<DuplicateEventMutation>(print(DuplicateEventDocument), variables));
    },
    duplicateMembership(variables: DuplicateMembershipMutationVariables): Promise<DuplicateMembershipMutation> {
      return withWrapper(() => client.request<DuplicateMembershipMutation>(print(DuplicateMembershipDocument), variables));
    },
    duplicateSingleRelease(variables: DuplicateSingleReleaseMutationVariables): Promise<DuplicateSingleReleaseMutation> {
      return withWrapper(() => client.request<DuplicateSingleReleaseMutation>(print(DuplicateSingleReleaseDocument), variables));
    },
    enableTwoFactorAuthentication(variables: EnableTwoFactorAuthenticationMutationVariables): Promise<EnableTwoFactorAuthenticationMutation> {
      return withWrapper(() => client.request<EnableTwoFactorAuthenticationMutation>(print(EnableTwoFactorAuthenticationDocument), variables));
    },
    importDigitalPassCodesForEvent(variables: ImportDigitalPassCodesForEventMutationVariables): Promise<ImportDigitalPassCodesForEventMutation> {
      return withWrapper(() => client.request<ImportDigitalPassCodesForEventMutation>(print(ImportDigitalPassCodesForEventDocument), variables));
    },
    importDigitalPassCodesForMembership(variables: ImportDigitalPassCodesForMembershipMutationVariables): Promise<ImportDigitalPassCodesForMembershipMutation> {
      return withWrapper(() => client.request<ImportDigitalPassCodesForMembershipMutation>(print(ImportDigitalPassCodesForMembershipDocument), variables));
    },
    importReleasePasswords(variables: ImportReleasePasswordsMutationVariables): Promise<ImportReleasePasswordsMutation> {
      return withWrapper(() => client.request<ImportReleasePasswordsMutation>(print(ImportReleasePasswordsDocument), variables));
    },
    login(variables: LoginMutationVariables): Promise<LoginMutation> {
      return withWrapper(() => client.request<LoginMutation>(print(LoginDocument), variables));
    },
    logout(variables?: LogoutMutationVariables): Promise<LogoutMutation> {
      return withWrapper(() => client.request<LogoutMutation>(print(LogoutDocument), variables));
    },
    releaseClaimsForNextMembership(variables: ReleaseClaimsForNextMembershipMutationVariables): Promise<ReleaseClaimsForNextMembershipMutation> {
      return withWrapper(() => client.request<ReleaseClaimsForNextMembershipMutation>(print(ReleaseClaimsForNextMembershipDocument), variables));
    },
    releaseSeats(variables: ReleaseSeatsMutationVariables): Promise<ReleaseSeatsMutation> {
      return withWrapper(() => client.request<ReleaseSeatsMutation>(print(ReleaseSeatsDocument), variables));
    },
    removeTwoFactorAuthenticationSecret(variables?: RemoveTwoFactorAuthenticationSecretMutationVariables): Promise<RemoveTwoFactorAuthenticationSecretMutation> {
      return withWrapper(() => client.request<RemoveTwoFactorAuthenticationSecretMutation>(print(RemoveTwoFactorAuthenticationSecretDocument), variables));
    },
    requestMagicLink(variables: RequestMagicLinkMutationVariables): Promise<RequestMagicLinkMutation> {
      return withWrapper(() => client.request<RequestMagicLinkMutation>(print(RequestMagicLinkDocument), variables));
    },
    requestResetPassword(variables: RequestResetPasswordMutationVariables): Promise<RequestResetPasswordMutation> {
      return withWrapper(() => client.request<RequestResetPasswordMutation>(print(RequestResetPasswordDocument), variables));
    },
    resetPassword(variables: ResetPasswordMutationVariables): Promise<ResetPasswordMutation> {
      return withWrapper(() => client.request<ResetPasswordMutation>(print(ResetPasswordDocument), variables));
    },
    addReminderToScoutCommunicationUser(variables: AddReminderToScoutCommunicationUserMutationVariables): Promise<AddReminderToScoutCommunicationUserMutation> {
      return withWrapper(() => client.request<AddReminderToScoutCommunicationUserMutation>(print(AddReminderToScoutCommunicationUserDocument), variables));
    },
    clearReminderFromScoutCommunicationUser(variables: ClearReminderFromScoutCommunicationUserMutationVariables): Promise<ClearReminderFromScoutCommunicationUserMutation> {
      return withWrapper(() => client.request<ClearReminderFromScoutCommunicationUserMutation>(print(ClearReminderFromScoutCommunicationUserDocument), variables));
    },
    sendMemberRenewalEmail(variables: SendMemberRenewalEmailMutationVariables): Promise<SendMemberRenewalEmailMutation> {
      return withWrapper(() => client.request<SendMemberRenewalEmailMutation>(print(SendMemberRenewalEmailDocument), variables));
    },
    sendOrderConfirmation(variables: SendOrderConfirmationMutationVariables): Promise<SendOrderConfirmationMutation> {
      return withWrapper(() => client.request<SendOrderConfirmationMutation>(print(SendOrderConfirmationDocument), variables));
    },
    createTestEmail(variables: CreateTestEmailMutationVariables): Promise<CreateTestEmailMutation> {
      return withWrapper(() => client.request<CreateTestEmailMutation>(print(CreateTestEmailDocument), variables));
    },
    sendTwoFactorCodeViaSMSMessage(variables?: SendTwoFactorCodeViaSmsMessageMutationVariables): Promise<SendTwoFactorCodeViaSmsMessageMutation> {
      return withWrapper(() => client.request<SendTwoFactorCodeViaSmsMessageMutation>(print(SendTwoFactorCodeViaSmsMessageDocument), variables));
    },
    sendUserInvite(variables: SendUserInviteMutationVariables): Promise<SendUserInviteMutation> {
      return withWrapper(() => client.request<SendUserInviteMutation>(print(SendUserInviteDocument), variables));
    },
    setPasswordForNewUser(variables: SetPasswordForNewUserMutationVariables): Promise<SetPasswordForNewUserMutation> {
      return withWrapper(() => client.request<SetPasswordForNewUserMutation>(print(SetPasswordForNewUserDocument), variables));
    },
    splitOrder(variables: SplitOrderMutationVariables): Promise<SplitOrderMutation> {
      return withWrapper(() => client.request<SplitOrderMutation>(print(SplitOrderDocument), variables));
    },
    syncTicketWithSeatsIo(variables: SyncTicketWithSeatsIoMutationVariables): Promise<SyncTicketWithSeatsIoMutation> {
      return withWrapper(() => client.request<SyncTicketWithSeatsIoMutation>(print(SyncTicketWithSeatsIoDocument), variables));
    },
    tagEntities(variables: TagEntitiesMutationVariables): Promise<TagEntitiesMutation> {
      return withWrapper(() => client.request<TagEntitiesMutation>(print(TagEntitiesDocument), variables));
    },
    updateAutomation(variables: UpdateAutomationMutationVariables): Promise<UpdateAutomationMutation> {
      return withWrapper(() => client.request<UpdateAutomationMutation>(print(UpdateAutomationDocument), variables));
    },
    updateCreditsForUser(variables: UpdateCreditsForUserMutationVariables): Promise<UpdateCreditsForUserMutation> {
      return withWrapper(() => client.request<UpdateCreditsForUserMutation>(print(UpdateCreditsForUserDocument), variables));
    },
    updateEvent(variables: UpdateEventMutationVariables): Promise<UpdateEventMutation> {
      return withWrapper(() => client.request<UpdateEventMutation>(print(UpdateEventDocument), variables));
    },
    updateEventAddon(variables: UpdateEventAddonMutationVariables): Promise<UpdateEventAddonMutation> {
      return withWrapper(() => client.request<UpdateEventAddonMutation>(print(UpdateEventAddonDocument), variables));
    },
    updateEventMultiBuyPromotion(variables: UpdateEventMultiBuyPromotionMutationVariables): Promise<UpdateEventMultiBuyPromotionMutation> {
      return withWrapper(() => client.request<UpdateEventMultiBuyPromotionMutation>(print(UpdateEventMultiBuyPromotionDocument), variables));
    },
    updateEventPromoCode(variables: UpdateEventPromoCodeMutationVariables): Promise<UpdateEventPromoCodeMutation> {
      return withWrapper(() => client.request<UpdateEventPromoCodeMutation>(print(UpdateEventPromoCodeDocument), variables));
    },
    updateForecast(variables: UpdateForecastMutationVariables): Promise<UpdateForecastMutation> {
      return withWrapper(() => client.request<UpdateForecastMutation>(print(UpdateForecastDocument), variables));
    },
    updateHoldOrder(variables: UpdateHoldOrderMutationVariables): Promise<UpdateHoldOrderMutation> {
      return withWrapper(() => client.request<UpdateHoldOrderMutation>(print(UpdateHoldOrderDocument), variables));
    },
    updateIntegration(variables: UpdateIntegrationMutationVariables): Promise<UpdateIntegrationMutation> {
      return withWrapper(() => client.request<UpdateIntegrationMutation>(print(UpdateIntegrationDocument), variables));
    },
    updateMembership(variables: UpdateMembershipMutationVariables): Promise<UpdateMembershipMutation> {
      return withWrapper(() => client.request<UpdateMembershipMutation>(print(UpdateMembershipDocument), variables));
    },
    updateMembershipAddon(variables: UpdateMembershipAddonMutationVariables): Promise<UpdateMembershipAddonMutation> {
      return withWrapper(() => client.request<UpdateMembershipAddonMutation>(print(UpdateMembershipAddonDocument), variables));
    },
    updateMembershipMultiBuyPromotion(variables: UpdateMembershipMultiBuyPromotionMutationVariables): Promise<UpdateMembershipMultiBuyPromotionMutation> {
      return withWrapper(() => client.request<UpdateMembershipMultiBuyPromotionMutation>(print(UpdateMembershipMultiBuyPromotionDocument), variables));
    },
    updateMembershipPromoCode(variables: UpdateMembershipPromoCodeMutationVariables): Promise<UpdateMembershipPromoCodeMutation> {
      return withWrapper(() => client.request<UpdateMembershipPromoCodeMutation>(print(UpdateMembershipPromoCodeDocument), variables));
    },
    updateMembershipTicketTransferPrices(variables: UpdateMembershipTicketTransferPricesMutationVariables): Promise<UpdateMembershipTicketTransferPricesMutation> {
      return withWrapper(() => client.request<UpdateMembershipTicketTransferPricesMutation>(print(UpdateMembershipTicketTransferPricesDocument), variables));
    },
    updateMembershipType(variables: UpdateMembershipTypeMutationVariables): Promise<UpdateMembershipTypeMutation> {
      return withWrapper(() => client.request<UpdateMembershipTypeMutation>(print(UpdateMembershipTypeDocument), variables));
    },
    updateOrder(variables: UpdateOrderMutationVariables): Promise<UpdateOrderMutation> {
      return withWrapper(() => client.request<UpdateOrderMutation>(print(UpdateOrderDocument), variables));
    },
    updateOrderStatus(variables: UpdateOrderStatusMutationVariables): Promise<UpdateOrderStatusMutation> {
      return withWrapper(() => client.request<UpdateOrderStatusMutation>(print(UpdateOrderStatusDocument), variables));
    },
    updateOrganization(variables: UpdateOrganizationMutationVariables): Promise<UpdateOrganizationMutation> {
      return withWrapper(() => client.request<UpdateOrganizationMutation>(print(UpdateOrganizationDocument), variables));
    },
    updateOrganizationById(variables: UpdateOrganizationByIdMutationVariables): Promise<UpdateOrganizationByIdMutation> {
      return withWrapper(() => client.request<UpdateOrganizationByIdMutation>(print(UpdateOrganizationByIdDocument), variables));
    },
    updatePosUser(variables: UpdatePosUserMutationVariables): Promise<UpdatePosUserMutation> {
      return withWrapper(() => client.request<UpdatePosUserMutation>(print(UpdatePosUserDocument), variables));
    },
    updatePromoCode(variables: UpdatePromoCodeMutationVariables): Promise<UpdatePromoCodeMutation> {
      return withWrapper(() => client.request<UpdatePromoCodeMutation>(print(UpdatePromoCodeDocument), variables));
    },
    updatePurchaseRestriction(variables: UpdatePurchaseRestrictionMutationVariables): Promise<UpdatePurchaseRestrictionMutation> {
      return withWrapper(() => client.request<UpdatePurchaseRestrictionMutation>(print(UpdatePurchaseRestrictionDocument), variables));
    },
    updateReferralCampaign(variables: UpdateReferralCampaignMutationVariables): Promise<UpdateReferralCampaignMutation> {
      return withWrapper(() => client.request<UpdateReferralCampaignMutation>(print(UpdateReferralCampaignDocument), variables));
    },
    updateRelease(variables: UpdateReleaseMutationVariables): Promise<UpdateReleaseMutation> {
      return withWrapper(() => client.request<UpdateReleaseMutation>(print(UpdateReleaseDocument), variables));
    },
    updateScout(variables: UpdateScoutMutationVariables): Promise<UpdateScoutMutation> {
      return withWrapper(() => client.request<UpdateScoutMutation>(print(UpdateScoutDocument), variables));
    },
    updateScoutCommunication(variables: UpdateScoutCommunicationMutationVariables): Promise<UpdateScoutCommunicationMutation> {
      return withWrapper(() => client.request<UpdateScoutCommunicationMutation>(print(UpdateScoutCommunicationDocument), variables));
    },
    updateScoutCommunicationUser(variables: UpdateScoutCommunicationUserMutationVariables): Promise<UpdateScoutCommunicationUserMutation> {
      return withWrapper(() => client.request<UpdateScoutCommunicationUserMutation>(print(UpdateScoutCommunicationUserDocument), variables));
    },
    updateScoutUsers(variables: UpdateScoutUsersMutationVariables): Promise<UpdateScoutUsersMutation> {
      return withWrapper(() => client.request<UpdateScoutUsersMutation>(print(UpdateScoutUsersDocument), variables));
    },
    updateSeason(variables: UpdateSeasonMutationVariables): Promise<UpdateSeasonMutation> {
      return withWrapper(() => client.request<UpdateSeasonMutation>(print(UpdateSeasonDocument), variables));
    },
    updateTag(variables: UpdateTagMutationVariables): Promise<UpdateTagMutation> {
      return withWrapper(() => client.request<UpdateTagMutation>(print(UpdateTagDocument), variables));
    },
    updateTicketHolder(variables: UpdateTicketHolderMutationVariables): Promise<UpdateTicketHolderMutation> {
      return withWrapper(() => client.request<UpdateTicketHolderMutation>(print(UpdateTicketHolderDocument), variables));
    },
    updateTicketType(variables: UpdateTicketTypeMutationVariables): Promise<UpdateTicketTypeMutation> {
      return withWrapper(() => client.request<UpdateTicketTypeMutation>(print(UpdateTicketTypeDocument), variables));
    },
    updateUser(variables: UpdateUserMutationVariables): Promise<UpdateUserMutation> {
      return withWrapper(() => client.request<UpdateUserMutation>(print(UpdateUserDocument), variables));
    },
    updateVenue(variables: UpdateVenueMutationVariables): Promise<UpdateVenueMutation> {
      return withWrapper(() => client.request<UpdateVenueMutation>(print(UpdateVenueDocument), variables));
    },
    updateVenueZones(variables: UpdateVenueZonesMutationVariables): Promise<UpdateVenueZonesMutation> {
      return withWrapper(() => client.request<UpdateVenueZonesMutation>(print(UpdateVenueZonesDocument), variables));
    },
    verifyMagicLink(variables: VerifyMagicLinkMutationVariables): Promise<VerifyMagicLinkMutation> {
      return withWrapper(() => client.request<VerifyMagicLinkMutation>(print(VerifyMagicLinkDocument), variables));
    },
    getPromoterSettings(variables: GetPromoterSettingsQueryVariables): Promise<GetPromoterSettingsQuery> {
      return withWrapper(() => client.request<GetPromoterSettingsQuery>(print(GetPromoterSettingsDocument), variables));
    },
    setPromoterSettings(variables: SetPromoterSettingsMutationVariables): Promise<SetPromoterSettingsMutation> {
      return withWrapper(() => client.request<SetPromoterSettingsMutation>(print(SetPromoterSettingsDocument), variables));
    },
    activities(variables?: ActivitiesQueryVariables): Promise<ActivitiesQuery> {
      return withWrapper(() => client.request<ActivitiesQuery>(print(ActivitiesDocument), variables));
    },
    insightsAgeBreakDown(variables: InsightsAgeBreakDownQueryVariables): Promise<InsightsAgeBreakDownQuery> {
      return withWrapper(() => client.request<InsightsAgeBreakDownQuery>(print(InsightsAgeBreakDownDocument), variables));
    },
    automation(variables: AutomationQueryVariables): Promise<AutomationQuery> {
      return withWrapper(() => client.request<AutomationQuery>(print(AutomationDocument), variables));
    },
    automations(variables: AutomationsQueryVariables): Promise<AutomationsQuery> {
      return withWrapper(() => client.request<AutomationsQuery>(print(AutomationsDocument), variables));
    },
    capacityOverview(variables: CapacityOverviewQueryVariables): Promise<CapacityOverviewQuery> {
      return withWrapper(() => client.request<CapacityOverviewQuery>(print(CapacityOverviewDocument), variables));
    },
    capacitySeatingMap(variables: CapacitySeatingMapQueryVariables): Promise<CapacitySeatingMapQuery> {
      return withWrapper(() => client.request<CapacitySeatingMapQuery>(print(CapacitySeatingMapDocument), variables));
    },
    capacitySeatingMapTooltips(variables: CapacitySeatingMapTooltipsQueryVariables): Promise<CapacitySeatingMapTooltipsQuery> {
      return withWrapper(() => client.request<CapacitySeatingMapTooltipsQuery>(print(CapacitySeatingMapTooltipsDocument), variables));
    },
    createOrderEvents(variables?: CreateOrderEventsQueryVariables): Promise<CreateOrderEventsQuery> {
      return withWrapper(() => client.request<CreateOrderEventsQuery>(print(CreateOrderEventsDocument), variables));
    },
    currentOrganization(variables?: CurrentOrganizationQueryVariables): Promise<CurrentOrganizationQuery> {
      return withWrapper(() => client.request<CurrentOrganizationQuery>(print(CurrentOrganizationDocument), variables));
    },
    customerLocations(variables: CustomerLocationsQueryVariables): Promise<CustomerLocationsQuery> {
      return withWrapper(() => client.request<CustomerLocationsQuery>(print(CustomerLocationsDocument), variables));
    },
    event(variables: EventQueryVariables): Promise<EventQuery> {
      return withWrapper(() => client.request<EventQuery>(print(EventDocument), variables));
    },
    eventAddons(variables: EventAddonsQueryVariables): Promise<EventAddonsQuery> {
      return withWrapper(() => client.request<EventAddonsQuery>(print(EventAddonsDocument), variables));
    },
    eventForecast(variables: EventForecastQueryVariables): Promise<EventForecastQuery> {
      return withWrapper(() => client.request<EventForecastQuery>(print(EventForecastDocument), variables));
    },
    eventMultiBuyPromotions(variables: EventMultiBuyPromotionsQueryVariables): Promise<EventMultiBuyPromotionsQuery> {
      return withWrapper(() => client.request<EventMultiBuyPromotionsQuery>(print(EventMultiBuyPromotionsDocument), variables));
    },
    eventOrdersOnline(variables: EventOrdersOnlineQueryVariables): Promise<EventOrdersOnlineQuery> {
      return withWrapper(() => client.request<EventOrdersOnlineQuery>(print(EventOrdersOnlineDocument), variables));
    },
    eventPromoCodes(variables: EventPromoCodesQueryVariables): Promise<EventPromoCodesQuery> {
      return withWrapper(() => client.request<EventPromoCodesQuery>(print(EventPromoCodesDocument), variables));
    },
    events(variables?: EventsQueryVariables): Promise<EventsQuery> {
      return withWrapper(() => client.request<EventsQuery>(print(EventsDocument), variables));
    },
    eventsSelect(variables?: EventsSelectQueryVariables): Promise<EventsSelectQuery> {
      return withWrapper(() => client.request<EventsSelectQuery>(print(EventsSelectDocument), variables));
    },
    facebookPageLists(variables: FacebookPageListsQueryVariables): Promise<FacebookPageListsQuery> {
      return withWrapper(() => client.request<FacebookPageListsQuery>(print(FacebookPageListsDocument), variables));
    },
    financialGateways(variables: FinancialGatewaysQueryVariables): Promise<FinancialGatewaysQuery> {
      return withWrapper(() => client.request<FinancialGatewaysQuery>(print(FinancialGatewaysDocument), variables));
    },
    financialGraph(variables: FinancialGraphQueryVariables): Promise<FinancialGraphQuery> {
      return withWrapper(() => client.request<FinancialGraphQuery>(print(FinancialGraphDocument), variables));
    },
    financialOverview(variables: FinancialOverviewQueryVariables): Promise<FinancialOverviewQuery> {
      return withWrapper(() => client.request<FinancialOverviewQuery>(print(FinancialOverviewDocument), variables));
    },
    financialSalesBreakdown(variables: FinancialSalesBreakdownQueryVariables): Promise<FinancialSalesBreakdownQuery> {
      return withWrapper(() => client.request<FinancialSalesBreakdownQuery>(print(FinancialSalesBreakdownDocument), variables));
    },
    fullIntegrations(variables?: FullIntegrationsQueryVariables): Promise<FullIntegrationsQuery> {
      return withWrapper(() => client.request<FullIntegrationsQuery>(print(FullIntegrationsDocument), variables));
    },
    insightsGenderBreakDown(variables: InsightsGenderBreakDownQueryVariables): Promise<InsightsGenderBreakDownQuery> {
      return withWrapper(() => client.request<InsightsGenderBreakDownQuery>(print(InsightsGenderBreakDownDocument), variables));
    },
    getEventPurchaseRestrictions(variables: GetEventPurchaseRestrictionsQueryVariables): Promise<GetEventPurchaseRestrictionsQuery> {
      return withWrapper(() => client.request<GetEventPurchaseRestrictionsQuery>(print(GetEventPurchaseRestrictionsDocument), variables));
    },
    getHistoryByCustomerId(variables: GetHistoryByCustomerIdQueryVariables): Promise<GetHistoryByCustomerIdQuery> {
      return withWrapper(() => client.request<GetHistoryByCustomerIdQuery>(print(GetHistoryByCustomerIdDocument), variables));
    },
    getMembershipOrderOptions(variables?: GetMembershipOrderOptionsQueryVariables): Promise<GetMembershipOrderOptionsQuery> {
      return withWrapper(() => client.request<GetMembershipOrderOptionsQuery>(print(GetMembershipOrderOptionsDocument), variables));
    },
    getMembershipPurchaseRestrictions(variables: GetMembershipPurchaseRestrictionsQueryVariables): Promise<GetMembershipPurchaseRestrictionsQuery> {
      return withWrapper(() => client.request<GetMembershipPurchaseRestrictionsQuery>(print(GetMembershipPurchaseRestrictionsDocument), variables));
    },
    getMembershipRenewal(variables: GetMembershipRenewalQueryVariables): Promise<GetMembershipRenewalQuery> {
      return withWrapper(() => client.request<GetMembershipRenewalQuery>(print(GetMembershipRenewalDocument), variables));
    },
    getReferralCampaignByEventId(variables: GetReferralCampaignByEventIdQueryVariables): Promise<GetReferralCampaignByEventIdQuery> {
      return withWrapper(() => client.request<GetReferralCampaignByEventIdQuery>(print(GetReferralCampaignByEventIdDocument), variables));
    },
    getReferralCampaignByOrderId(variables: GetReferralCampaignByOrderIdQueryVariables): Promise<GetReferralCampaignByOrderIdQuery> {
      return withWrapper(() => client.request<GetReferralCampaignByOrderIdQuery>(print(GetReferralCampaignByOrderIdDocument), variables));
    },
    getReferralCampaignStats(variables: GetReferralCampaignStatsQueryVariables): Promise<GetReferralCampaignStatsQuery> {
      return withWrapper(() => client.request<GetReferralCampaignStatsQuery>(print(GetReferralCampaignStatsDocument), variables));
    },
    getReferralCampaigns(variables?: GetReferralCampaignsQueryVariables): Promise<GetReferralCampaignsQuery> {
      return withWrapper(() => client.request<GetReferralCampaignsQuery>(print(GetReferralCampaignsDocument), variables));
    },
    getReferralRewardByOrderId(variables: GetReferralRewardByOrderIdQueryVariables): Promise<GetReferralRewardByOrderIdQuery> {
      return withWrapper(() => client.request<GetReferralRewardByOrderIdQuery>(print(GetReferralRewardByOrderIdDocument), variables));
    },
    getReferralCampaignsByEventId(variables: GetReferralCampaignsByEventIdQueryVariables): Promise<GetReferralCampaignsByEventIdQuery> {
      return withWrapper(() => client.request<GetReferralCampaignsByEventIdQuery>(print(GetReferralCampaignsByEventIdDocument), variables));
    },
    getTicketSoldTimeForEvent(variables: GetTicketSoldTimeForEventQueryVariables): Promise<GetTicketSoldTimeForEventQuery> {
      return withWrapper(() => client.request<GetTicketSoldTimeForEventQuery>(print(GetTicketSoldTimeForEventDocument), variables));
    },
    getTicketSoldTimeForMembership(variables: GetTicketSoldTimeForMembershipQueryVariables): Promise<GetTicketSoldTimeForMembershipQuery> {
      return withWrapper(() => client.request<GetTicketSoldTimeForMembershipQuery>(print(GetTicketSoldTimeForMembershipDocument), variables));
    },
    getZonesByEventId(variables: GetZonesByEventIdQueryVariables): Promise<GetZonesByEventIdQuery> {
      return withWrapper(() => client.request<GetZonesByEventIdQuery>(print(GetZonesByEventIdDocument), variables));
    },
    hasSeatedEvent(variables?: HasSeatedEventQueryVariables): Promise<HasSeatedEventQuery> {
      return withWrapper(() => client.request<HasSeatedEventQuery>(print(HasSeatedEventDocument), variables));
    },
    highestValueCustomers(variables: HighestValueCustomersQueryVariables): Promise<HighestValueCustomersQuery> {
      return withWrapper(() => client.request<HighestValueCustomersQuery>(print(HighestValueCustomersDocument), variables));
    },
    insightsHeardAboutUsBreakDown(variables: InsightsHeardAboutUsBreakDownQueryVariables): Promise<InsightsHeardAboutUsBreakDownQuery> {
      return withWrapper(() => client.request<InsightsHeardAboutUsBreakDownQuery>(print(InsightsHeardAboutUsBreakDownDocument), variables));
    },
    insightsOverview(variables: InsightsOverviewQueryVariables): Promise<InsightsOverviewQuery> {
      return withWrapper(() => client.request<InsightsOverviewQuery>(print(InsightsOverviewDocument), variables));
    },
    integrations(variables?: IntegrationsQueryVariables): Promise<IntegrationsQuery> {
      return withWrapper(() => client.request<IntegrationsQuery>(print(IntegrationsDocument), variables));
    },
    mailchimpDomains(variables?: MailchimpDomainsQueryVariables): Promise<MailchimpDomainsQuery> {
      return withWrapper(() => client.request<MailchimpDomainsQuery>(print(MailchimpDomainsDocument), variables));
    },
    mailchimpLists(variables?: MailchimpListsQueryVariables): Promise<MailchimpListsQuery> {
      return withWrapper(() => client.request<MailchimpListsQuery>(print(MailchimpListsDocument), variables));
    },
    mailchimpTemplates(variables?: MailchimpTemplatesQueryVariables): Promise<MailchimpTemplatesQuery> {
      return withWrapper(() => client.request<MailchimpTemplatesQuery>(print(MailchimpTemplatesDocument), variables));
    },
    me(variables?: MeQueryVariables): Promise<MeQuery> {
      return withWrapper(() => client.request<MeQuery>(print(MeDocument), variables));
    },
    membership(variables: MembershipQueryVariables): Promise<MembershipQuery> {
      return withWrapper(() => client.request<MembershipQuery>(print(MembershipDocument), variables));
    },
    membershipAddons(variables: MembershipAddonsQueryVariables): Promise<MembershipAddonsQuery> {
      return withWrapper(() => client.request<MembershipAddonsQuery>(print(MembershipAddonsDocument), variables));
    },
    membershipMultiBuyPromotions(variables: MembershipMultiBuyPromotionsQueryVariables): Promise<MembershipMultiBuyPromotionsQuery> {
      return withWrapper(() => client.request<MembershipMultiBuyPromotionsQuery>(print(MembershipMultiBuyPromotionsDocument), variables));
    },
    membershipPromoCodes(variables: MembershipPromoCodesQueryVariables): Promise<MembershipPromoCodesQuery> {
      return withWrapper(() => client.request<MembershipPromoCodesQuery>(print(MembershipPromoCodesDocument), variables));
    },
    membershipTypeEventTransferPrices(variables: MembershipTypeEventTransferPricesQueryVariables): Promise<MembershipTypeEventTransferPricesQuery> {
      return withWrapper(() => client.request<MembershipTypeEventTransferPricesQuery>(print(MembershipTypeEventTransferPricesDocument), variables));
    },
    membershipTypes(variables: MembershipTypesQueryVariables): Promise<MembershipTypesQuery> {
      return withWrapper(() => client.request<MembershipTypesQuery>(print(MembershipTypesDocument), variables));
    },
    memberships(variables?: MembershipsQueryVariables): Promise<MembershipsQuery> {
      return withWrapper(() => client.request<MembershipsQuery>(print(MembershipsDocument), variables));
    },
    mentionOverview(variables: MentionOverviewQueryVariables): Promise<MentionOverviewQuery> {
      return withWrapper(() => client.request<MentionOverviewQuery>(print(MentionOverviewDocument), variables));
    },
    order(variables: OrderQueryVariables): Promise<OrderQuery> {
      return withWrapper(() => client.request<OrderQuery>(print(OrderDocument), variables));
    },
    orderIdsOnline(variables: OrderIdsOnlineQueryVariables): Promise<OrderIdsOnlineQuery> {
      return withWrapper(() => client.request<OrderIdsOnlineQuery>(print(OrderIdsOnlineDocument), variables));
    },
    orderRefundDetails(variables: OrderRefundDetailsQueryVariables): Promise<OrderRefundDetailsQuery> {
      return withWrapper(() => client.request<OrderRefundDetailsQuery>(print(OrderRefundDetailsDocument), variables));
    },
    orders(variables?: OrdersQueryVariables): Promise<OrdersQuery> {
      return withWrapper(() => client.request<OrdersQuery>(print(OrdersDocument), variables));
    },
    organization(variables: OrganizationQueryVariables): Promise<OrganizationQuery> {
      return withWrapper(() => client.request<OrganizationQuery>(print(OrganizationDocument), variables));
    },
    organizations(variables?: OrganizationsQueryVariables): Promise<OrganizationsQuery> {
      return withWrapper(() => client.request<OrganizationsQuery>(print(OrganizationsDocument), variables));
    },
    paramsEvents(variables?: ParamsEventsQueryVariables): Promise<ParamsEventsQuery> {
      return withWrapper(() => client.request<ParamsEventsQuery>(print(ParamsEventsDocument), variables));
    },
    paramsMemberships(variables?: ParamsMembershipsQueryVariables): Promise<ParamsMembershipsQuery> {
      return withWrapper(() => client.request<ParamsMembershipsQuery>(print(ParamsMembershipsDocument), variables));
    },
    paramsReleases(variables: ParamsReleasesQueryVariables): Promise<ParamsReleasesQuery> {
      return withWrapper(() => client.request<ParamsReleasesQuery>(print(ParamsReleasesDocument), variables));
    },
    paymentOptions(variables?: PaymentOptionsQueryVariables): Promise<PaymentOptionsQuery> {
      return withWrapper(() => client.request<PaymentOptionsQuery>(print(PaymentOptionsDocument), variables));
    },
    pos(variables: PosQueryVariables): Promise<PosQuery> {
      return withWrapper(() => client.request<PosQuery>(print(PosDocument), variables));
    },
    posEvents(variables?: PosEventsQueryVariables): Promise<PosEventsQuery> {
      return withWrapper(() => client.request<PosEventsQuery>(print(PosEventsDocument), variables));
    },
    posFinancialOverview(variables: PosFinancialOverviewQueryVariables): Promise<PosFinancialOverviewQuery> {
      return withWrapper(() => client.request<PosFinancialOverviewQuery>(print(PosFinancialOverviewDocument), variables));
    },
    posFloatOfChange(variables: PosFloatOfChangeQueryVariables): Promise<PosFloatOfChangeQuery> {
      return withWrapper(() => client.request<PosFloatOfChangeQuery>(print(PosFloatOfChangeDocument), variables));
    },
    posOrder(variables: PosOrderQueryVariables): Promise<PosOrderQuery> {
      return withWrapper(() => client.request<PosOrderQuery>(print(PosOrderDocument), variables));
    },
    posSalesOverview(variables: PosSalesOverviewQueryVariables): Promise<PosSalesOverviewQuery> {
      return withWrapper(() => client.request<PosSalesOverviewQuery>(print(PosSalesOverviewDocument), variables));
    },
    posSessions(variables: PosSessionsQueryVariables): Promise<PosSessionsQuery> {
      return withWrapper(() => client.request<PosSessionsQuery>(print(PosSessionsDocument), variables));
    },
    posUsers(variables: PosUsersQueryVariables): Promise<PosUsersQuery> {
      return withWrapper(() => client.request<PosUsersQuery>(print(PosUsersDocument), variables));
    },
    terminals(variables: TerminalsQueryVariables): Promise<TerminalsQuery> {
      return withWrapper(() => client.request<TerminalsQuery>(print(TerminalsDocument), variables));
    },
    previousMembershipCount(variables: PreviousMembershipCountQueryVariables): Promise<PreviousMembershipCountQuery> {
      return withWrapper(() => client.request<PreviousMembershipCountQuery>(print(PreviousMembershipCountDocument), variables));
    },
    purchasingDaysBreakdown(variables: PurchasingDaysBreakdownQueryVariables): Promise<PurchasingDaysBreakdownQuery> {
      return withWrapper(() => client.request<PurchasingDaysBreakdownQuery>(print(PurchasingDaysBreakdownDocument), variables));
    },
    release(variables: ReleaseQueryVariables): Promise<ReleaseQuery> {
      return withWrapper(() => client.request<ReleaseQuery>(print(ReleaseDocument), variables));
    },
    releases(variables: ReleasesQueryVariables): Promise<ReleasesQuery> {
      return withWrapper(() => client.request<ReleasesQuery>(print(ReleasesDocument), variables));
    },
    salesChannelGraph(variables: SalesChannelGraphQueryVariables): Promise<SalesChannelGraphQuery> {
      return withWrapper(() => client.request<SalesChannelGraphQuery>(print(SalesChannelGraphDocument), variables));
    },
    salesGraph(variables: SalesGraphQueryVariables): Promise<SalesGraphQuery> {
      return withWrapper(() => client.request<SalesGraphQuery>(print(SalesGraphDocument), variables));
    },
    salesOverview(variables: SalesOverviewQueryVariables): Promise<SalesOverviewQuery> {
      return withWrapper(() => client.request<SalesOverviewQuery>(print(SalesOverviewDocument), variables));
    },
    scanTicketTypes(variables: ScanTicketTypesQueryVariables): Promise<ScanTicketTypesQuery> {
      return withWrapper(() => client.request<ScanTicketTypesQuery>(print(ScanTicketTypesDocument), variables));
    },
    scanVisitors(variables: ScanVisitorsQueryVariables): Promise<ScanVisitorsQuery> {
      return withWrapper(() => client.request<ScanVisitorsQuery>(print(ScanVisitorsDocument), variables));
    },
    scanVisitorsOverTime(variables: ScanVisitorsOverTimeQueryVariables): Promise<ScanVisitorsOverTimeQuery> {
      return withWrapper(() => client.request<ScanVisitorsOverTimeQuery>(print(ScanVisitorsOverTimeDocument), variables));
    },
    scout(variables: ScoutQueryVariables): Promise<ScoutQuery> {
      return withWrapper(() => client.request<ScoutQuery>(print(ScoutDocument), variables));
    },
    scoutAgents(variables?: ScoutAgentsQueryVariables): Promise<ScoutAgentsQuery> {
      return withWrapper(() => client.request<ScoutAgentsQuery>(print(ScoutAgentsDocument), variables));
    },
    scoutCampaignCustomerLocations(variables: ScoutCampaignCustomerLocationsQueryVariables): Promise<ScoutCampaignCustomerLocationsQuery> {
      return withWrapper(() => client.request<ScoutCampaignCustomerLocationsQuery>(print(ScoutCampaignCustomerLocationsDocument), variables));
    },
    scoutCampaignGenderBreakdown(variables: ScoutCampaignGenderBreakdownQueryVariables): Promise<ScoutCampaignGenderBreakdownQuery> {
      return withWrapper(() => client.request<ScoutCampaignGenderBreakdownQuery>(print(ScoutCampaignGenderBreakdownDocument), variables));
    },
    scoutCampaignHighestValueCustomers(variables: ScoutCampaignHighestValueCustomersQueryVariables): Promise<ScoutCampaignHighestValueCustomersQuery> {
      return withWrapper(() => client.request<ScoutCampaignHighestValueCustomersQuery>(print(ScoutCampaignHighestValueCustomersDocument), variables));
    },
    scoutCampaignOverview(variables: ScoutCampaignOverviewQueryVariables): Promise<ScoutCampaignOverviewQuery> {
      return withWrapper(() => client.request<ScoutCampaignOverviewQuery>(print(ScoutCampaignOverviewDocument), variables));
    },
    scoutCampaignTopTags(variables: ScoutCampaignTopTagsQueryVariables): Promise<ScoutCampaignTopTagsQuery> {
      return withWrapper(() => client.request<ScoutCampaignTopTagsQuery>(print(ScoutCampaignTopTagsDocument), variables));
    },
    scoutCommunication(variables: ScoutCommunicationQueryVariables): Promise<ScoutCommunicationQuery> {
      return withWrapper(() => client.request<ScoutCommunicationQuery>(print(ScoutCommunicationDocument), variables));
    },
    scoutCommunicationUser(variables: ScoutCommunicationUserQueryVariables): Promise<ScoutCommunicationUserQuery> {
      return withWrapper(() => client.request<ScoutCommunicationUserQuery>(print(ScoutCommunicationUserDocument), variables));
    },
    scoutCommunicationUsers(variables: ScoutCommunicationUsersQueryVariables): Promise<ScoutCommunicationUsersQuery> {
      return withWrapper(() => client.request<ScoutCommunicationUsersQuery>(print(ScoutCommunicationUsersDocument), variables));
    },
    scoutCommunications(variables: ScoutCommunicationsQueryVariables): Promise<ScoutCommunicationsQuery> {
      return withWrapper(() => client.request<ScoutCommunicationsQuery>(print(ScoutCommunicationsDocument), variables));
    },
    initScout(variables?: InitScoutQueryVariables): Promise<InitScoutQuery> {
      return withWrapper(() => client.request<InitScoutQuery>(print(InitScoutDocument), variables));
    },
    scoutUserReminders(variables?: ScoutUserRemindersQueryVariables): Promise<ScoutUserRemindersQuery> {
      return withWrapper(() => client.request<ScoutUserRemindersQuery>(print(ScoutUserRemindersDocument), variables));
    },
    scoutUsers(variables: ScoutUsersQueryVariables): Promise<ScoutUsersQuery> {
      return withWrapper(() => client.request<ScoutUsersQuery>(print(ScoutUsersDocument), variables));
    },
    scouts(variables?: ScoutsQueryVariables): Promise<ScoutsQuery> {
      return withWrapper(() => client.request<ScoutsQuery>(print(ScoutsDocument), variables));
    },
    season(variables: SeasonQueryVariables): Promise<SeasonQuery> {
      return withWrapper(() => client.request<SeasonQuery>(print(SeasonDocument), variables));
    },
    seasons(variables?: SeasonsQueryVariables): Promise<SeasonsQuery> {
      return withWrapper(() => client.request<SeasonsQuery>(print(SeasonsDocument), variables));
    },
    seatsEventKey(variables: SeatsEventKeyQueryVariables): Promise<SeatsEventKeyQuery> {
      return withWrapper(() => client.request<SeatsEventKeyQuery>(print(SeatsEventKeyDocument), variables));
    },
    socialMentions(variables?: SocialMentionsQueryVariables): Promise<SocialMentionsQuery> {
      return withWrapper(() => client.request<SocialMentionsQuery>(print(SocialMentionsDocument), variables));
    },
    summaryOverview(variables: SummaryOverviewQueryVariables): Promise<SummaryOverviewQuery> {
      return withWrapper(() => client.request<SummaryOverviewQuery>(print(SummaryOverviewDocument), variables));
    },
    tags(variables?: TagsQueryVariables): Promise<TagsQuery> {
      return withWrapper(() => client.request<TagsQuery>(print(TagsDocument), variables));
    },
    ticket(variables: TicketQueryVariables): Promise<TicketQuery> {
      return withWrapper(() => client.request<TicketQuery>(print(TicketDocument), variables));
    },
    ticketTypes(variables: TicketTypesQueryVariables): Promise<TicketTypesQuery> {
      return withWrapper(() => client.request<TicketTypesQuery>(print(TicketTypesDocument), variables));
    },
    timeOfDayBreakdown(variables: TimeOfDayBreakdownQueryVariables): Promise<TimeOfDayBreakdownQuery> {
      return withWrapper(() => client.request<TimeOfDayBreakdownQuery>(print(TimeOfDayBreakdownDocument), variables));
    },
    topReferrers(variables: TopReferrersQueryVariables): Promise<TopReferrersQuery> {
      return withWrapper(() => client.request<TopReferrersQuery>(print(TopReferrersDocument), variables));
    },
    topRepeatPurchasers(variables: TopRepeatPurchasersQueryVariables): Promise<TopRepeatPurchasersQuery> {
      return withWrapper(() => client.request<TopRepeatPurchasersQuery>(print(TopRepeatPurchasersDocument), variables));
    },
    topTags(variables: TopTagsQueryVariables): Promise<TopTagsQuery> {
      return withWrapper(() => client.request<TopTagsQuery>(print(TopTagsDocument), variables));
    },
    transferredMembershipTicketsForOrder(variables: TransferredMembershipTicketsForOrderQueryVariables): Promise<TransferredMembershipTicketsForOrderQuery> {
      return withWrapper(() => client.request<TransferredMembershipTicketsForOrderQuery>(print(TransferredMembershipTicketsForOrderDocument), variables));
    },
    uploadImage(variables: UploadImageMutationVariables): Promise<UploadImageMutation> {
      return withWrapper(() => client.request<UploadImageMutation>(print(UploadImageDocument), variables));
    },
    user(variables: UserQueryVariables): Promise<UserQuery> {
      return withWrapper(() => client.request<UserQuery>(print(UserDocument), variables));
    },
    userEventTickets(variables: UserEventTicketsQueryVariables): Promise<UserEventTicketsQuery> {
      return withWrapper(() => client.request<UserEventTicketsQuery>(print(UserEventTicketsDocument), variables));
    },
    userMembershipTickets(variables: UserMembershipTicketsQueryVariables): Promise<UserMembershipTicketsQuery> {
      return withWrapper(() => client.request<UserMembershipTicketsQuery>(print(UserMembershipTicketsDocument), variables));
    },
    users(variables?: UsersQueryVariables): Promise<UsersQuery> {
      return withWrapper(() => client.request<UsersQuery>(print(UsersDocument), variables));
    },
    userOrders(variables: UserOrdersQueryVariables): Promise<UserOrdersQuery> {
      return withWrapper(() => client.request<UserOrdersQuery>(print(UserOrdersDocument), variables));
    },
    venue(variables: VenueQueryVariables): Promise<VenueQuery> {
      return withWrapper(() => client.request<VenueQuery>(print(VenueDocument), variables));
    },
    venueSeatsThumbnail(variables: VenueSeatsThumbnailQueryVariables): Promise<VenueSeatsThumbnailQuery> {
      return withWrapper(() => client.request<VenueSeatsThumbnailQuery>(print(VenueSeatsThumbnailDocument), variables));
    },
    venues(variables?: VenuesQueryVariables): Promise<VenuesQuery> {
      return withWrapper(() => client.request<VenuesQuery>(print(VenuesDocument), variables));
    },
    waitlistOverview(variables: WaitlistOverviewQueryVariables): Promise<WaitlistOverviewQuery> {
      return withWrapper(() => client.request<WaitlistOverviewQuery>(print(WaitlistOverviewDocument), variables));
    },
    shopifyDisableIntegration(variables?: ShopifyDisableIntegrationQueryVariables): Promise<ShopifyDisableIntegrationQuery> {
      return withWrapper(() => client.request<ShopifyDisableIntegrationQuery>(print(ShopifyDisableIntegrationDocument), variables));
    },
    shopifyCustomerOrders(variables: ShopifyCustomerOrdersQueryVariables): Promise<ShopifyCustomerOrdersQuery> {
      return withWrapper(() => client.request<ShopifyCustomerOrdersQuery>(print(ShopifyCustomerOrdersDocument), variables));
    },
    completeShopifySetup(variables: CompleteShopifySetupMutationVariables): Promise<CompleteShopifySetupMutation> {
      return withWrapper(() => client.request<CompleteShopifySetupMutation>(print(CompleteShopifySetupDocument), variables));
    },
    myLoggedInOrganizations(variables?: MyLoggedInOrganizationsQueryVariables): Promise<MyLoggedInOrganizationsQuery> {
      return withWrapper(() => client.request<MyLoggedInOrganizationsQuery>(print(MyLoggedInOrganizationsDocument), variables));
    },
    xeroConsentUrlQuery(variables?: XeroConsentUrlQueryQueryVariables): Promise<XeroConsentUrlQueryQuery> {
      return withWrapper(() => client.request<XeroConsentUrlQueryQuery>(print(XeroConsentUrlQueryDocument), variables));
    },
    xeroEnableIntegrationMutation(variables: XeroEnableIntegrationMutationMutationVariables): Promise<XeroEnableIntegrationMutationMutation> {
      return withWrapper(() => client.request<XeroEnableIntegrationMutationMutation>(print(XeroEnableIntegrationMutationDocument), variables));
    },
    xeroDisableIntegrationQuery(variables?: XeroDisableIntegrationQueryQueryVariables): Promise<XeroDisableIntegrationQueryQuery> {
      return withWrapper(() => client.request<XeroDisableIntegrationQueryQuery>(print(XeroDisableIntegrationQueryDocument), variables));
    },
    getXeroCurrentAccountCodeQuery(variables?: GetXeroCurrentAccountCodeQueryQueryVariables): Promise<GetXeroCurrentAccountCodeQueryQuery> {
      return withWrapper(() => client.request<GetXeroCurrentAccountCodeQueryQuery>(print(GetXeroCurrentAccountCodeQueryDocument), variables));
    },
    getXeroAccountsQuery(variables?: GetXeroAccountsQueryQueryVariables): Promise<GetXeroAccountsQueryQuery> {
      return withWrapper(() => client.request<GetXeroAccountsQueryQuery>(print(GetXeroAccountsQueryDocument), variables));
    },
    setXeroAccountCodeMutation(variables: SetXeroAccountCodeMutationMutationVariables): Promise<SetXeroAccountCodeMutationMutation> {
      return withWrapper(() => client.request<SetXeroAccountCodeMutationMutation>(print(SetXeroAccountCodeMutationDocument), variables));
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;